"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var uploadUncertainImageWith = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(size, data, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        args = {
                            size: size || 0,
                            data: data.toString("base64")
                        };
                        _context.next = 3;
                        return makeRequest({ name: "uploadUncertainImageWith", args: args, progress: progress });

                    case 3:
                        ret = _context.sent;
                        return _context.abrupt("return", {
                            width: ret.width || 0,
                            height: ret.height || 0,
                            url: ret.url
                        });

                    case 5:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function uploadUncertainImageWith(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var getProfileStats = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(userId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        args = {
                            userId: userId === null || userId === undefined ? null : userId
                        };
                        _context2.next = 3;
                        return makeRequest({ name: "getProfileStats", args: args, progress: progress });

                    case 3:
                        ret = _context2.sent;
                        return _context2.abrupt("return", {
                            numberOfItems: ret.numberOfItems || 0,
                            numberOfRents: ret.numberOfRents || 0,
                            numberOfMyRents: ret.numberOfMyRents || 0,
                            rating: ret.rating,
                            numberOfSales: ret.numberOfSales || 0,
                            numberOfFollowing: ret.numberOfFollowing || 0,
                            numberOfFollowers: ret.numberOfFollowers || 0,
                            numberOfLockerLikes: ret.numberOfLockerLikes || 0
                        });

                    case 5:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function getProfileStats(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

var uploadImage = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(image, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        args = {
                            image: image.toString("base64")
                        };
                        _context3.next = 3;
                        return makeRequest({ name: "uploadImage", args: args, progress: progress });

                    case 3:
                        ret = _context3.sent;
                        return _context3.abrupt("return", {
                            width: ret.width || 0,
                            height: ret.height || 0,
                            url: ret.url
                        });

                    case 5:
                    case "end":
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function uploadImage(_x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}();

var uploadThumb = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(image, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        args = {
                            image: image.toString("base64")
                        };
                        _context4.next = 3;
                        return makeRequest({ name: "uploadThumb", args: args, progress: progress });

                    case 3:
                        ret = _context4.sent;
                        return _context4.abrupt("return", {
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            }
                        });

                    case 5:
                    case "end":
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function uploadThumb(_x8, _x9) {
        return _ref4.apply(this, arguments);
    };
}();

var getAddressFromCep = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(zip, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        args = {
                            zip: zip
                        };
                        _context5.next = 3;
                        return makeRequest({ name: "getAddressFromCep", args: args, progress: progress });

                    case 3:
                        ret = _context5.sent;
                        return _context5.abrupt("return", ret === null || ret === undefined ? null : {
                            street: ret.street,
                            neighborhood: ret.neighborhood,
                            city: ret.city,
                            state: ret.state,
                            uf: ret.uf,
                            country: ret.country,
                            zip: ret.zip,
                            location: {
                                lat: ret.location.lat,
                                lon: ret.location.lon
                            }
                        });

                    case 5:
                    case "end":
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function getAddressFromCep(_x10, _x11) {
        return _ref5.apply(this, arguments);
    };
}();

var getCpfValidate = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(cpf, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        args = {
                            cpf: cpf
                        };
                        _context6.next = 3;
                        return makeRequest({ name: "getCpfValidate", args: args, progress: progress });

                    case 3:
                        return _context6.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function getCpfValidate(_x12, _x13) {
        return _ref6.apply(this, arguments);
    };
}();

var getMyLocation = function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return makeRequest({ name: "getMyLocation", args: {}, progress: progress });

                    case 2:
                        ret = _context7.sent;
                        return _context7.abrupt("return", ret === null || ret === undefined ? null : {
                            lat: ret.lat,
                            lon: ret.lon
                        });

                    case 4:
                    case "end":
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function getMyLocation(_x14) {
        return _ref7.apply(this, arguments);
    };
}();

var getCity = function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(cityId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        args = {
                            cityId: cityId
                        };
                        _context8.next = 3;
                        return makeRequest({ name: "getCity", args: args, progress: progress });

                    case 3:
                        ret = _context8.sent;
                        return _context8.abrupt("return", {
                            id: ret.id,
                            name: ret.name,
                            uf: ret.uf
                        });

                    case 5:
                    case "end":
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function getCity(_x15, _x16) {
        return _ref8.apply(this, arguments);
    };
}();

var getStateCities = function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(uf, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        args = {
                            uf: uf
                        };
                        _context9.next = 3;
                        return makeRequest({ name: "getStateCities", args: args, progress: progress });

                    case 3:
                        ret = _context9.sent;
                        return _context9.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                name: e.name,
                                uf: e.uf
                            };
                        }));

                    case 5:
                    case "end":
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function getStateCities(_x17, _x18) {
        return _ref9.apply(this, arguments);
    };
}();

var getCityFromSlug = function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(citySlug, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        args = {
                            citySlug: citySlug
                        };
                        _context10.next = 3;
                        return makeRequest({ name: "getCityFromSlug", args: args, progress: progress });

                    case 3:
                        ret = _context10.sent;
                        return _context10.abrupt("return", {
                            id: ret.id,
                            name: ret.name,
                            uf: ret.uf
                        });

                    case 5:
                    case "end":
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function getCityFromSlug(_x19, _x20) {
        return _ref10.apply(this, arguments);
    };
}();

var createAdminUser = function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(newAdminUser, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        args = {
                            newAdminUser: {
                                password: newAdminUser.password,
                                licensedInfo: newAdminUser.licensedInfo === null || newAdminUser.licensedInfo === undefined ? null : {
                                    document: newAdminUser.licensedInfo.document,
                                    bankAccount: {
                                        documentNumber: newAdminUser.licensedInfo.bankAccount.documentNumber,
                                        bankName: newAdminUser.licensedInfo.bankAccount.bankName,
                                        bankCode: newAdminUser.licensedInfo.bankAccount.bankCode,
                                        agency: newAdminUser.licensedInfo.bankAccount.agency,
                                        agencyDv: newAdminUser.licensedInfo.bankAccount.agencyDv === null || newAdminUser.licensedInfo.bankAccount.agencyDv === undefined ? null : newAdminUser.licensedInfo.bankAccount.agencyDv,
                                        account: newAdminUser.licensedInfo.bankAccount.account,
                                        accountDv: newAdminUser.licensedInfo.bankAccount.accountDv,
                                        type: newAdminUser.licensedInfo.bankAccount.type,
                                        legalName: newAdminUser.licensedInfo.bankAccount.legalName
                                    },
                                    licenses: newAdminUser.licensedInfo.licenses.map(function (e) {
                                        return {
                                            cityId: e.cityId,
                                            percentage: e.percentage || 0,
                                            expirationDate: typeof e.expirationDate === "string" ? new Date(new Date(e.expirationDate).getTime() - new Date(e.expirationDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(e.expirationDate.getTime() - e.expirationDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                        };
                                    })
                                },
                                type: newAdminUser.type,
                                name: newAdminUser.name,
                                email: newAdminUser.email
                            }
                        };
                        _context11.next = 3;
                        return makeRequest({ name: "createAdminUser", args: args, progress: progress });

                    case 3:
                        ret = _context11.sent;
                        return _context11.abrupt("return", {
                            id: ret.id,
                            licensedInfo: ret.licensedInfo === null || ret.licensedInfo === undefined ? null : {
                                document: ret.licensedInfo.document,
                                bankAccount: {
                                    documentNumber: ret.licensedInfo.bankAccount.documentNumber,
                                    bankName: ret.licensedInfo.bankAccount.bankName,
                                    bankCode: ret.licensedInfo.bankAccount.bankCode,
                                    agency: ret.licensedInfo.bankAccount.agency,
                                    agencyDv: ret.licensedInfo.bankAccount.agencyDv === null || ret.licensedInfo.bankAccount.agencyDv === undefined ? null : ret.licensedInfo.bankAccount.agencyDv,
                                    account: ret.licensedInfo.bankAccount.account,
                                    accountDv: ret.licensedInfo.bankAccount.accountDv,
                                    type: ret.licensedInfo.bankAccount.type,
                                    legalName: ret.licensedInfo.bankAccount.legalName
                                },
                                licenses: ret.licensedInfo.licenses.map(function (e) {
                                    return {
                                        city: {
                                            id: e.city.id,
                                            name: e.city.name,
                                            uf: e.city.uf
                                        },
                                        percentage: e.percentage || 0,
                                        expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                    };
                                })
                            },
                            type: ret.type,
                            name: ret.name,
                            email: ret.email
                        });

                    case 5:
                    case "end":
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function createAdminUser(_x21, _x22) {
        return _ref11.apply(this, arguments);
    };
}();

var editAdminUser = function () {
    var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(adminUserId, editAdminUser, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        args = {
                            adminUserId: adminUserId,
                            editAdminUser: {
                                password: editAdminUser.password,
                                licensedInfo: editAdminUser.licensedInfo === null || editAdminUser.licensedInfo === undefined ? null : {
                                    bankAccount: {
                                        documentNumber: editAdminUser.licensedInfo.bankAccount.documentNumber,
                                        bankName: editAdminUser.licensedInfo.bankAccount.bankName,
                                        bankCode: editAdminUser.licensedInfo.bankAccount.bankCode,
                                        agency: editAdminUser.licensedInfo.bankAccount.agency,
                                        agencyDv: editAdminUser.licensedInfo.bankAccount.agencyDv === null || editAdminUser.licensedInfo.bankAccount.agencyDv === undefined ? null : editAdminUser.licensedInfo.bankAccount.agencyDv,
                                        account: editAdminUser.licensedInfo.bankAccount.account,
                                        accountDv: editAdminUser.licensedInfo.bankAccount.accountDv,
                                        type: editAdminUser.licensedInfo.bankAccount.type,
                                        legalName: editAdminUser.licensedInfo.bankAccount.legalName
                                    },
                                    licenses: editAdminUser.licensedInfo.licenses.map(function (e) {
                                        return {
                                            cityId: e.cityId,
                                            percentage: e.percentage || 0,
                                            expirationDate: typeof e.expirationDate === "string" ? new Date(new Date(e.expirationDate).getTime() - new Date(e.expirationDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(e.expirationDate.getTime() - e.expirationDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                        };
                                    })
                                },
                                type: editAdminUser.type,
                                name: editAdminUser.name,
                                email: editAdminUser.email
                            }
                        };
                        _context12.next = 3;
                        return makeRequest({ name: "editAdminUser", args: args, progress: progress });

                    case 3:
                        ret = _context12.sent;
                        return _context12.abrupt("return", {
                            id: ret.id,
                            licensedInfo: ret.licensedInfo === null || ret.licensedInfo === undefined ? null : {
                                document: ret.licensedInfo.document,
                                bankAccount: {
                                    documentNumber: ret.licensedInfo.bankAccount.documentNumber,
                                    bankName: ret.licensedInfo.bankAccount.bankName,
                                    bankCode: ret.licensedInfo.bankAccount.bankCode,
                                    agency: ret.licensedInfo.bankAccount.agency,
                                    agencyDv: ret.licensedInfo.bankAccount.agencyDv === null || ret.licensedInfo.bankAccount.agencyDv === undefined ? null : ret.licensedInfo.bankAccount.agencyDv,
                                    account: ret.licensedInfo.bankAccount.account,
                                    accountDv: ret.licensedInfo.bankAccount.accountDv,
                                    type: ret.licensedInfo.bankAccount.type,
                                    legalName: ret.licensedInfo.bankAccount.legalName
                                },
                                licenses: ret.licensedInfo.licenses.map(function (e) {
                                    return {
                                        city: {
                                            id: e.city.id,
                                            name: e.city.name,
                                            uf: e.city.uf
                                        },
                                        percentage: e.percentage || 0,
                                        expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                    };
                                })
                            },
                            type: ret.type,
                            name: ret.name,
                            email: ret.email
                        });

                    case 5:
                    case "end":
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function editAdminUser(_x23, _x24, _x25) {
        return _ref12.apply(this, arguments);
    };
}();

var getAdminUser = function () {
    var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(adminUserId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        args = {
                            adminUserId: adminUserId
                        };
                        _context13.next = 3;
                        return makeRequest({ name: "getAdminUser", args: args, progress: progress });

                    case 3:
                        ret = _context13.sent;
                        return _context13.abrupt("return", {
                            id: ret.id,
                            licensedInfo: ret.licensedInfo === null || ret.licensedInfo === undefined ? null : {
                                document: ret.licensedInfo.document,
                                bankAccount: {
                                    documentNumber: ret.licensedInfo.bankAccount.documentNumber,
                                    bankName: ret.licensedInfo.bankAccount.bankName,
                                    bankCode: ret.licensedInfo.bankAccount.bankCode,
                                    agency: ret.licensedInfo.bankAccount.agency,
                                    agencyDv: ret.licensedInfo.bankAccount.agencyDv === null || ret.licensedInfo.bankAccount.agencyDv === undefined ? null : ret.licensedInfo.bankAccount.agencyDv,
                                    account: ret.licensedInfo.bankAccount.account,
                                    accountDv: ret.licensedInfo.bankAccount.accountDv,
                                    type: ret.licensedInfo.bankAccount.type,
                                    legalName: ret.licensedInfo.bankAccount.legalName
                                },
                                licenses: ret.licensedInfo.licenses.map(function (e) {
                                    return {
                                        city: {
                                            id: e.city.id,
                                            name: e.city.name,
                                            uf: e.city.uf
                                        },
                                        percentage: e.percentage || 0,
                                        expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                    };
                                })
                            },
                            type: ret.type,
                            name: ret.name,
                            email: ret.email
                        });

                    case 5:
                    case "end":
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function getAdminUser(_x26, _x27) {
        return _ref13.apply(this, arguments);
    };
}();

var getLicenseds = function () {
    var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(pageOffset, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        args = {
                            pageOffset: pageOffset || 0
                        };
                        _context14.next = 3;
                        return makeRequest({ name: "getLicenseds", args: args, progress: progress });

                    case 3:
                        ret = _context14.sent;
                        return _context14.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                licensedInfo: e.licensedInfo === null || e.licensedInfo === undefined ? null : {
                                    document: e.licensedInfo.document,
                                    bankAccount: {
                                        documentNumber: e.licensedInfo.bankAccount.documentNumber,
                                        bankName: e.licensedInfo.bankAccount.bankName,
                                        bankCode: e.licensedInfo.bankAccount.bankCode,
                                        agency: e.licensedInfo.bankAccount.agency,
                                        agencyDv: e.licensedInfo.bankAccount.agencyDv === null || e.licensedInfo.bankAccount.agencyDv === undefined ? null : e.licensedInfo.bankAccount.agencyDv,
                                        account: e.licensedInfo.bankAccount.account,
                                        accountDv: e.licensedInfo.bankAccount.accountDv,
                                        type: e.licensedInfo.bankAccount.type,
                                        legalName: e.licensedInfo.bankAccount.legalName
                                    },
                                    licenses: e.licensedInfo.licenses.map(function (e) {
                                        return {
                                            city: {
                                                id: e.city.id,
                                                name: e.city.name,
                                                uf: e.city.uf
                                            },
                                            percentage: e.percentage || 0,
                                            expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                        };
                                    })
                                },
                                type: e.type,
                                name: e.name,
                                email: e.email
                            };
                        }));

                    case 5:
                    case "end":
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function getLicenseds(_x28, _x29) {
        return _ref14.apply(this, arguments);
    };
}();

var getAvailableAdminFilterCities = function () {
    var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        _context15.next = 2;
                        return makeRequest({ name: "getAvailableAdminFilterCities", args: {}, progress: progress });

                    case 2:
                        ret = _context15.sent;
                        return _context15.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                name: e.name
                            };
                        }));

                    case 4:
                    case "end":
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function getAvailableAdminFilterCities(_x30) {
        return _ref15.apply(this, arguments);
    };
}();

var createOrEditBankAccount = function () {
    var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(bankAccount, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        args = {
                            bankAccount: {
                                documentNumber: bankAccount.documentNumber,
                                bankName: bankAccount.bankName,
                                bankCode: bankAccount.bankCode,
                                agency: bankAccount.agency,
                                agencyDv: bankAccount.agencyDv === null || bankAccount.agencyDv === undefined ? null : bankAccount.agencyDv,
                                account: bankAccount.account,
                                accountDv: bankAccount.accountDv,
                                type: bankAccount.type,
                                legalName: bankAccount.legalName
                            }
                        };
                        _context16.next = 3;
                        return makeRequest({ name: "createOrEditBankAccount", args: args, progress: progress });

                    case 3:
                        ret = _context16.sent;
                        return _context16.abrupt("return", {
                            id: ret.id,
                            licensedInfo: ret.licensedInfo === null || ret.licensedInfo === undefined ? null : {
                                document: ret.licensedInfo.document,
                                bankAccount: {
                                    documentNumber: ret.licensedInfo.bankAccount.documentNumber,
                                    bankName: ret.licensedInfo.bankAccount.bankName,
                                    bankCode: ret.licensedInfo.bankAccount.bankCode,
                                    agency: ret.licensedInfo.bankAccount.agency,
                                    agencyDv: ret.licensedInfo.bankAccount.agencyDv === null || ret.licensedInfo.bankAccount.agencyDv === undefined ? null : ret.licensedInfo.bankAccount.agencyDv,
                                    account: ret.licensedInfo.bankAccount.account,
                                    accountDv: ret.licensedInfo.bankAccount.accountDv,
                                    type: ret.licensedInfo.bankAccount.type,
                                    legalName: ret.licensedInfo.bankAccount.legalName
                                },
                                licenses: ret.licensedInfo.licenses.map(function (e) {
                                    return {
                                        city: {
                                            id: e.city.id,
                                            name: e.city.name,
                                            uf: e.city.uf
                                        },
                                        percentage: e.percentage || 0,
                                        expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                    };
                                })
                            },
                            type: ret.type,
                            name: ret.name,
                            email: ret.email
                        });

                    case 5:
                    case "end":
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function createOrEditBankAccount(_x31, _x32) {
        return _ref16.apply(this, arguments);
    };
}();

var getBalance = function () {
    var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.next = 2;
                        return makeRequest({ name: "getBalance", args: {}, progress: progress });

                    case 2:
                        ret = _context17.sent;
                        return _context17.abrupt("return", {
                            object: ret.object,
                            waitingFunds: {
                                amount: ret.waitingFunds.amount || 0
                            },
                            available: {
                                amount: ret.available.amount || 0
                            },
                            transferred: {
                                amount: ret.transferred.amount || 0
                            }
                        });

                    case 4:
                    case "end":
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function getBalance(_x33) {
        return _ref17.apply(this, arguments);
    };
}();

var withDraw = function () {
    var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(amount, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        args = {
                            amount: amount || 0
                        };
                        _context18.next = 3;
                        return makeRequest({ name: "withDraw", args: args, progress: progress });

                    case 3:
                        ret = _context18.sent;
                        return _context18.abrupt("return", {
                            waitingFunds: {
                                amount: ret.waitingFunds.amount || 0
                            },
                            available: {
                                amount: ret.available.amount || 0
                            },
                            transferred: {
                                amount: ret.transferred.amount || 0
                            }
                        });

                    case 5:
                    case "end":
                        return _context18.stop();
                }
            }
        }, _callee18, this);
    }));

    return function withDraw(_x34, _x35) {
        return _ref18.apply(this, arguments);
    };
}();

var resetPasswordAdminUser = function () {
    var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(token, newPassword, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        args = {
                            token: token,
                            newPassword: newPassword
                        };
                        _context19.next = 3;
                        return makeRequest({ name: "resetPasswordAdminUser", args: args, progress: progress });

                    case 3:
                        return _context19.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context19.stop();
                }
            }
        }, _callee19, this);
    }));

    return function resetPasswordAdminUser(_x36, _x37, _x38) {
        return _ref19.apply(this, arguments);
    };
}();

var getBanners = function () {
    var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(pageOffset, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        args = {
                            pageOffset: pageOffset || 0
                        };
                        _context20.next = 3;
                        return makeRequest({ name: "getBanners", args: args, progress: progress });

                    case 3:
                        ret = _context20.sent;
                        return _context20.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                image: {
                                    width: e.image.width || 0,
                                    height: e.image.height || 0,
                                    url: e.image.url
                                },
                                mobileImage: e.mobileImage === null || e.mobileImage === undefined ? null : {
                                    width: e.mobileImage.width || 0,
                                    height: e.mobileImage.height || 0,
                                    url: e.mobileImage.url
                                },
                                contentType: e.contentType === null || e.contentType === undefined ? null : e.contentType,
                                type: e.type,
                                slug: e.slug,
                                title: e.title,
                                url: e.url === null || e.url === undefined ? null : e.url,
                                content: {
                                    query: e.content.query === null || e.content.query === undefined ? null : {
                                        search: e.content.query.search === null || e.content.query.search === undefined ? null : e.content.query.search,
                                        filter: {
                                            distance: e.content.query.filter.distance,
                                            sizes: e.content.query.filter.sizes.map(function (e) {
                                                return e;
                                            }),
                                            gender: e.content.query.filter.gender.map(function (e) {
                                                return e;
                                            }),
                                            categories: e.content.query.filter.categories.map(function (e) {
                                                return e;
                                            }),
                                            ocasions: e.content.query.filter.ocasions.map(function (e) {
                                                return e;
                                            }),
                                            colors: e.content.query.filter.colors.map(function (e) {
                                                return e;
                                            }),
                                            orderBy: e.content.query.filter.orderBy === null || e.content.query.filter.orderBy === undefined ? null : e.content.query.filter.orderBy,
                                            itemOfferType: e.content.query.filter.itemOfferType === null || e.content.query.filter.itemOfferType === undefined ? null : e.content.query.filter.itemOfferType
                                        }
                                    },
                                    url: e.content.url === null || e.content.url === undefined ? null : e.content.url,
                                    group: e.content.group === null || e.content.group === undefined ? null : {
                                        userIds: e.content.group.userIds.map(function (e) {
                                            return e;
                                        }),
                                        sections: e.content.group.sections.map(function (e) {
                                            return {
                                                title: e.title,
                                                itemIds: e.itemIds.map(function (e) {
                                                    return e;
                                                })
                                            };
                                        }),
                                        innerBanner: e.content.group.innerBanner === null || e.content.group.innerBanner === undefined ? null : {
                                            image: {
                                                width: e.content.group.innerBanner.image.width || 0,
                                                height: e.content.group.innerBanner.image.height || 0,
                                                url: e.content.group.innerBanner.image.url
                                            },
                                            url: e.content.group.innerBanner.url
                                        }
                                    }
                                }
                            };
                        }));

                    case 5:
                    case "end":
                        return _context20.stop();
                }
            }
        }, _callee20, this);
    }));

    return function getBanners(_x39, _x40) {
        return _ref20.apply(this, arguments);
    };
}();

var getBanner = function () {
    var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(bannerId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        args = {
                            bannerId: bannerId
                        };
                        _context21.next = 3;
                        return makeRequest({ name: "getBanner", args: args, progress: progress });

                    case 3:
                        ret = _context21.sent;
                        return _context21.abrupt("return", {
                            id: ret.id,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            mobileImage: ret.mobileImage === null || ret.mobileImage === undefined ? null : {
                                width: ret.mobileImage.width || 0,
                                height: ret.mobileImage.height || 0,
                                url: ret.mobileImage.url
                            },
                            contentType: ret.contentType === null || ret.contentType === undefined ? null : ret.contentType,
                            type: ret.type,
                            slug: ret.slug,
                            title: ret.title,
                            url: ret.url === null || ret.url === undefined ? null : ret.url,
                            content: {
                                query: ret.content.query === null || ret.content.query === undefined ? null : {
                                    search: ret.content.query.search === null || ret.content.query.search === undefined ? null : ret.content.query.search,
                                    filter: {
                                        distance: ret.content.query.filter.distance,
                                        sizes: ret.content.query.filter.sizes.map(function (e) {
                                            return e;
                                        }),
                                        gender: ret.content.query.filter.gender.map(function (e) {
                                            return e;
                                        }),
                                        categories: ret.content.query.filter.categories.map(function (e) {
                                            return e;
                                        }),
                                        ocasions: ret.content.query.filter.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        colors: ret.content.query.filter.colors.map(function (e) {
                                            return e;
                                        }),
                                        orderBy: ret.content.query.filter.orderBy === null || ret.content.query.filter.orderBy === undefined ? null : ret.content.query.filter.orderBy,
                                        itemOfferType: ret.content.query.filter.itemOfferType === null || ret.content.query.filter.itemOfferType === undefined ? null : ret.content.query.filter.itemOfferType
                                    }
                                },
                                url: ret.content.url === null || ret.content.url === undefined ? null : ret.content.url,
                                group: ret.content.group === null || ret.content.group === undefined ? null : {
                                    userIds: ret.content.group.userIds.map(function (e) {
                                        return e;
                                    }),
                                    sections: ret.content.group.sections.map(function (e) {
                                        return {
                                            title: e.title,
                                            itemIds: e.itemIds.map(function (e) {
                                                return e;
                                            })
                                        };
                                    }),
                                    innerBanner: ret.content.group.innerBanner === null || ret.content.group.innerBanner === undefined ? null : {
                                        image: {
                                            width: ret.content.group.innerBanner.image.width || 0,
                                            height: ret.content.group.innerBanner.image.height || 0,
                                            url: ret.content.group.innerBanner.image.url
                                        },
                                        url: ret.content.group.innerBanner.url
                                    }
                                }
                            }
                        });

                    case 5:
                    case "end":
                        return _context21.stop();
                }
            }
        }, _callee21, this);
    }));

    return function getBanner(_x41, _x42) {
        return _ref21.apply(this, arguments);
    };
}();

var createBanner = function () {
    var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(newBanner, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee22$(_context22) {
            while (1) {
                switch (_context22.prev = _context22.next) {
                    case 0:
                        args = {
                            newBanner: {
                                image: {
                                    bytes: newBanner.image.bytes === null || newBanner.image.bytes === undefined ? null : newBanner.image.bytes.toString("base64"),
                                    image: newBanner.image.image === null || newBanner.image.image === undefined ? null : {
                                        width: newBanner.image.image.width || 0,
                                        height: newBanner.image.image.height || 0,
                                        url: newBanner.image.image.url
                                    }
                                },
                                mobileImage: newBanner.mobileImage === null || newBanner.mobileImage === undefined ? null : {
                                    bytes: newBanner.mobileImage.bytes === null || newBanner.mobileImage.bytes === undefined ? null : newBanner.mobileImage.bytes.toString("base64"),
                                    image: newBanner.mobileImage.image === null || newBanner.mobileImage.image === undefined ? null : {
                                        width: newBanner.mobileImage.image.width || 0,
                                        height: newBanner.mobileImage.image.height || 0,
                                        url: newBanner.mobileImage.image.url
                                    }
                                },
                                innerBanner: newBanner.innerBanner === null || newBanner.innerBanner === undefined ? null : {
                                    innerImage: {
                                        bytes: newBanner.innerBanner.innerImage.bytes === null || newBanner.innerBanner.innerImage.bytes === undefined ? null : newBanner.innerBanner.innerImage.bytes.toString("base64"),
                                        image: newBanner.innerBanner.innerImage.image === null || newBanner.innerBanner.innerImage.image === undefined ? null : {
                                            width: newBanner.innerBanner.innerImage.image.width || 0,
                                            height: newBanner.innerBanner.innerImage.image.height || 0,
                                            url: newBanner.innerBanner.innerImage.image.url
                                        }
                                    },
                                    innerUrl: newBanner.innerBanner.innerUrl
                                },
                                contentType: newBanner.contentType === null || newBanner.contentType === undefined ? null : newBanner.contentType,
                                type: newBanner.type,
                                slug: newBanner.slug,
                                title: newBanner.title,
                                url: newBanner.url === null || newBanner.url === undefined ? null : newBanner.url,
                                content: {
                                    query: newBanner.content.query === null || newBanner.content.query === undefined ? null : {
                                        search: newBanner.content.query.search === null || newBanner.content.query.search === undefined ? null : newBanner.content.query.search,
                                        filter: {
                                            distance: newBanner.content.query.filter.distance,
                                            sizes: newBanner.content.query.filter.sizes.map(function (e) {
                                                return e;
                                            }),
                                            gender: newBanner.content.query.filter.gender.map(function (e) {
                                                return e;
                                            }),
                                            categories: newBanner.content.query.filter.categories.map(function (e) {
                                                return e;
                                            }),
                                            ocasions: newBanner.content.query.filter.ocasions.map(function (e) {
                                                return e;
                                            }),
                                            colors: newBanner.content.query.filter.colors.map(function (e) {
                                                return e;
                                            }),
                                            orderBy: newBanner.content.query.filter.orderBy === null || newBanner.content.query.filter.orderBy === undefined ? null : newBanner.content.query.filter.orderBy,
                                            itemOfferType: newBanner.content.query.filter.itemOfferType === null || newBanner.content.query.filter.itemOfferType === undefined ? null : newBanner.content.query.filter.itemOfferType
                                        }
                                    },
                                    url: newBanner.content.url === null || newBanner.content.url === undefined ? null : newBanner.content.url,
                                    group: newBanner.content.group === null || newBanner.content.group === undefined ? null : {
                                        userIds: newBanner.content.group.userIds.map(function (e) {
                                            return e;
                                        }),
                                        sections: newBanner.content.group.sections.map(function (e) {
                                            return {
                                                title: e.title,
                                                itemIds: e.itemIds.map(function (e) {
                                                    return e;
                                                })
                                            };
                                        }),
                                        innerBanner: newBanner.content.group.innerBanner === null || newBanner.content.group.innerBanner === undefined ? null : {
                                            image: {
                                                width: newBanner.content.group.innerBanner.image.width || 0,
                                                height: newBanner.content.group.innerBanner.image.height || 0,
                                                url: newBanner.content.group.innerBanner.image.url
                                            },
                                            url: newBanner.content.group.innerBanner.url
                                        }
                                    }
                                }
                            }
                        };
                        _context22.next = 3;
                        return makeRequest({ name: "createBanner", args: args, progress: progress });

                    case 3:
                        ret = _context22.sent;
                        return _context22.abrupt("return", {
                            id: ret.id,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            mobileImage: ret.mobileImage === null || ret.mobileImage === undefined ? null : {
                                width: ret.mobileImage.width || 0,
                                height: ret.mobileImage.height || 0,
                                url: ret.mobileImage.url
                            },
                            contentType: ret.contentType === null || ret.contentType === undefined ? null : ret.contentType,
                            type: ret.type,
                            slug: ret.slug,
                            title: ret.title,
                            url: ret.url === null || ret.url === undefined ? null : ret.url,
                            content: {
                                query: ret.content.query === null || ret.content.query === undefined ? null : {
                                    search: ret.content.query.search === null || ret.content.query.search === undefined ? null : ret.content.query.search,
                                    filter: {
                                        distance: ret.content.query.filter.distance,
                                        sizes: ret.content.query.filter.sizes.map(function (e) {
                                            return e;
                                        }),
                                        gender: ret.content.query.filter.gender.map(function (e) {
                                            return e;
                                        }),
                                        categories: ret.content.query.filter.categories.map(function (e) {
                                            return e;
                                        }),
                                        ocasions: ret.content.query.filter.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        colors: ret.content.query.filter.colors.map(function (e) {
                                            return e;
                                        }),
                                        orderBy: ret.content.query.filter.orderBy === null || ret.content.query.filter.orderBy === undefined ? null : ret.content.query.filter.orderBy,
                                        itemOfferType: ret.content.query.filter.itemOfferType === null || ret.content.query.filter.itemOfferType === undefined ? null : ret.content.query.filter.itemOfferType
                                    }
                                },
                                url: ret.content.url === null || ret.content.url === undefined ? null : ret.content.url,
                                group: ret.content.group === null || ret.content.group === undefined ? null : {
                                    userIds: ret.content.group.userIds.map(function (e) {
                                        return e;
                                    }),
                                    sections: ret.content.group.sections.map(function (e) {
                                        return {
                                            title: e.title,
                                            itemIds: e.itemIds.map(function (e) {
                                                return e;
                                            })
                                        };
                                    }),
                                    innerBanner: ret.content.group.innerBanner === null || ret.content.group.innerBanner === undefined ? null : {
                                        image: {
                                            width: ret.content.group.innerBanner.image.width || 0,
                                            height: ret.content.group.innerBanner.image.height || 0,
                                            url: ret.content.group.innerBanner.image.url
                                        },
                                        url: ret.content.group.innerBanner.url
                                    }
                                }
                            }
                        });

                    case 5:
                    case "end":
                        return _context22.stop();
                }
            }
        }, _callee22, this);
    }));

    return function createBanner(_x43, _x44) {
        return _ref22.apply(this, arguments);
    };
}();

var editBanner = function () {
    var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(bannerId, editedBanner, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee23$(_context23) {
            while (1) {
                switch (_context23.prev = _context23.next) {
                    case 0:
                        args = {
                            bannerId: bannerId,
                            editedBanner: {
                                image: {
                                    bytes: editedBanner.image.bytes === null || editedBanner.image.bytes === undefined ? null : editedBanner.image.bytes.toString("base64"),
                                    image: editedBanner.image.image === null || editedBanner.image.image === undefined ? null : {
                                        width: editedBanner.image.image.width || 0,
                                        height: editedBanner.image.image.height || 0,
                                        url: editedBanner.image.image.url
                                    }
                                },
                                mobileImage: editedBanner.mobileImage === null || editedBanner.mobileImage === undefined ? null : {
                                    bytes: editedBanner.mobileImage.bytes === null || editedBanner.mobileImage.bytes === undefined ? null : editedBanner.mobileImage.bytes.toString("base64"),
                                    image: editedBanner.mobileImage.image === null || editedBanner.mobileImage.image === undefined ? null : {
                                        width: editedBanner.mobileImage.image.width || 0,
                                        height: editedBanner.mobileImage.image.height || 0,
                                        url: editedBanner.mobileImage.image.url
                                    }
                                },
                                innerBanner: editedBanner.innerBanner === null || editedBanner.innerBanner === undefined ? null : {
                                    innerImage: {
                                        bytes: editedBanner.innerBanner.innerImage.bytes === null || editedBanner.innerBanner.innerImage.bytes === undefined ? null : editedBanner.innerBanner.innerImage.bytes.toString("base64"),
                                        image: editedBanner.innerBanner.innerImage.image === null || editedBanner.innerBanner.innerImage.image === undefined ? null : {
                                            width: editedBanner.innerBanner.innerImage.image.width || 0,
                                            height: editedBanner.innerBanner.innerImage.image.height || 0,
                                            url: editedBanner.innerBanner.innerImage.image.url
                                        }
                                    },
                                    innerUrl: editedBanner.innerBanner.innerUrl
                                },
                                contentType: editedBanner.contentType === null || editedBanner.contentType === undefined ? null : editedBanner.contentType,
                                type: editedBanner.type,
                                slug: editedBanner.slug,
                                title: editedBanner.title,
                                url: editedBanner.url === null || editedBanner.url === undefined ? null : editedBanner.url,
                                content: {
                                    query: editedBanner.content.query === null || editedBanner.content.query === undefined ? null : {
                                        search: editedBanner.content.query.search === null || editedBanner.content.query.search === undefined ? null : editedBanner.content.query.search,
                                        filter: {
                                            distance: editedBanner.content.query.filter.distance,
                                            sizes: editedBanner.content.query.filter.sizes.map(function (e) {
                                                return e;
                                            }),
                                            gender: editedBanner.content.query.filter.gender.map(function (e) {
                                                return e;
                                            }),
                                            categories: editedBanner.content.query.filter.categories.map(function (e) {
                                                return e;
                                            }),
                                            ocasions: editedBanner.content.query.filter.ocasions.map(function (e) {
                                                return e;
                                            }),
                                            colors: editedBanner.content.query.filter.colors.map(function (e) {
                                                return e;
                                            }),
                                            orderBy: editedBanner.content.query.filter.orderBy === null || editedBanner.content.query.filter.orderBy === undefined ? null : editedBanner.content.query.filter.orderBy,
                                            itemOfferType: editedBanner.content.query.filter.itemOfferType === null || editedBanner.content.query.filter.itemOfferType === undefined ? null : editedBanner.content.query.filter.itemOfferType
                                        }
                                    },
                                    url: editedBanner.content.url === null || editedBanner.content.url === undefined ? null : editedBanner.content.url,
                                    group: editedBanner.content.group === null || editedBanner.content.group === undefined ? null : {
                                        userIds: editedBanner.content.group.userIds.map(function (e) {
                                            return e;
                                        }),
                                        sections: editedBanner.content.group.sections.map(function (e) {
                                            return {
                                                title: e.title,
                                                itemIds: e.itemIds.map(function (e) {
                                                    return e;
                                                })
                                            };
                                        }),
                                        innerBanner: editedBanner.content.group.innerBanner === null || editedBanner.content.group.innerBanner === undefined ? null : {
                                            image: {
                                                width: editedBanner.content.group.innerBanner.image.width || 0,
                                                height: editedBanner.content.group.innerBanner.image.height || 0,
                                                url: editedBanner.content.group.innerBanner.image.url
                                            },
                                            url: editedBanner.content.group.innerBanner.url
                                        }
                                    }
                                }
                            }
                        };
                        _context23.next = 3;
                        return makeRequest({ name: "editBanner", args: args, progress: progress });

                    case 3:
                        ret = _context23.sent;
                        return _context23.abrupt("return", {
                            id: ret.id,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            mobileImage: ret.mobileImage === null || ret.mobileImage === undefined ? null : {
                                width: ret.mobileImage.width || 0,
                                height: ret.mobileImage.height || 0,
                                url: ret.mobileImage.url
                            },
                            contentType: ret.contentType === null || ret.contentType === undefined ? null : ret.contentType,
                            type: ret.type,
                            slug: ret.slug,
                            title: ret.title,
                            url: ret.url === null || ret.url === undefined ? null : ret.url,
                            content: {
                                query: ret.content.query === null || ret.content.query === undefined ? null : {
                                    search: ret.content.query.search === null || ret.content.query.search === undefined ? null : ret.content.query.search,
                                    filter: {
                                        distance: ret.content.query.filter.distance,
                                        sizes: ret.content.query.filter.sizes.map(function (e) {
                                            return e;
                                        }),
                                        gender: ret.content.query.filter.gender.map(function (e) {
                                            return e;
                                        }),
                                        categories: ret.content.query.filter.categories.map(function (e) {
                                            return e;
                                        }),
                                        ocasions: ret.content.query.filter.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        colors: ret.content.query.filter.colors.map(function (e) {
                                            return e;
                                        }),
                                        orderBy: ret.content.query.filter.orderBy === null || ret.content.query.filter.orderBy === undefined ? null : ret.content.query.filter.orderBy,
                                        itemOfferType: ret.content.query.filter.itemOfferType === null || ret.content.query.filter.itemOfferType === undefined ? null : ret.content.query.filter.itemOfferType
                                    }
                                },
                                url: ret.content.url === null || ret.content.url === undefined ? null : ret.content.url,
                                group: ret.content.group === null || ret.content.group === undefined ? null : {
                                    userIds: ret.content.group.userIds.map(function (e) {
                                        return e;
                                    }),
                                    sections: ret.content.group.sections.map(function (e) {
                                        return {
                                            title: e.title,
                                            itemIds: e.itemIds.map(function (e) {
                                                return e;
                                            })
                                        };
                                    }),
                                    innerBanner: ret.content.group.innerBanner === null || ret.content.group.innerBanner === undefined ? null : {
                                        image: {
                                            width: ret.content.group.innerBanner.image.width || 0,
                                            height: ret.content.group.innerBanner.image.height || 0,
                                            url: ret.content.group.innerBanner.image.url
                                        },
                                        url: ret.content.group.innerBanner.url
                                    }
                                }
                            }
                        });

                    case 5:
                    case "end":
                        return _context23.stop();
                }
            }
        }, _callee23, this);
    }));

    return function editBanner(_x45, _x46, _x47) {
        return _ref23.apply(this, arguments);
    };
}();

var deleteBanner = function () {
    var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(bannerId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee24$(_context24) {
            while (1) {
                switch (_context24.prev = _context24.next) {
                    case 0:
                        args = {
                            bannerId: bannerId
                        };
                        _context24.next = 3;
                        return makeRequest({ name: "deleteBanner", args: args, progress: progress });

                    case 3:
                        return _context24.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context24.stop();
                }
            }
        }, _callee24, this);
    }));

    return function deleteBanner(_x48, _x49) {
        return _ref24.apply(this, arguments);
    };
}();

var getSlugOption = function () {
    var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(title, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee25$(_context25) {
            while (1) {
                switch (_context25.prev = _context25.next) {
                    case 0:
                        args = {
                            title: title
                        };
                        _context25.next = 3;
                        return makeRequest({ name: "getSlugOption", args: args, progress: progress });

                    case 3:
                        ret = _context25.sent;
                        return _context25.abrupt("return", ret);

                    case 5:
                    case "end":
                        return _context25.stop();
                }
            }
        }, _callee25, this);
    }));

    return function getSlugOption(_x50, _x51) {
        return _ref25.apply(this, arguments);
    };
}();

var createPost = function () {
    var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(newPost, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        args = {
                            newPost: {
                                image: {
                                    bytes: newPost.image.bytes === null || newPost.image.bytes === undefined ? null : newPost.image.bytes.toString("base64"),
                                    image: newPost.image.image === null || newPost.image.image === undefined ? null : {
                                        width: newPost.image.image.width || 0,
                                        height: newPost.image.image.height || 0,
                                        url: newPost.image.image.url
                                    }
                                },
                                slug: newPost.slug,
                                title: newPost.title,
                                body: newPost.body,
                                bodyHtml: newPost.bodyHtml
                            }
                        };
                        _context26.next = 3;
                        return makeRequest({ name: "createPost", args: args, progress: progress });

                    case 3:
                        ret = _context26.sent;
                        return _context26.abrupt("return", {
                            id: ret.id,
                            user: ret.user === null || ret.user === undefined ? null : {
                                id: ret.user.id,
                                avatar: ret.user.avatar === null || ret.user.avatar === undefined ? null : {
                                    width: ret.user.avatar.width || 0,
                                    height: ret.user.avatar.height || 0,
                                    url: ret.user.avatar.url
                                },
                                name: ret.user.name,
                                nick: ret.user.nick,
                                rate: ret.user.rate,
                                height: ret.user.height === null || ret.user.height === undefined ? null : ret.user.height || 0,
                                deleted: !!ret.user.deleted,
                                isLockerLiked: !!ret.user.isLockerLiked,
                                isFollowing: !!ret.user.isFollowing,
                                ownerName: ret.user.ownerName === null || ret.user.ownerName === undefined ? null : ret.user.ownerName
                            },
                            approved: !!ret.approved,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            slug: ret.slug,
                            title: ret.title,
                            body: ret.body,
                            bodyHtml: ret.bodyHtml
                        });

                    case 5:
                    case "end":
                        return _context26.stop();
                }
            }
        }, _callee26, this);
    }));

    return function createPost(_x52, _x53) {
        return _ref26.apply(this, arguments);
    };
}();

var editPost = function () {
    var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(postId, editedPost, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee27$(_context27) {
            while (1) {
                switch (_context27.prev = _context27.next) {
                    case 0:
                        args = {
                            postId: postId,
                            editedPost: {
                                image: {
                                    bytes: editedPost.image.bytes === null || editedPost.image.bytes === undefined ? null : editedPost.image.bytes.toString("base64"),
                                    image: editedPost.image.image === null || editedPost.image.image === undefined ? null : {
                                        width: editedPost.image.image.width || 0,
                                        height: editedPost.image.image.height || 0,
                                        url: editedPost.image.image.url
                                    }
                                },
                                slug: editedPost.slug,
                                title: editedPost.title,
                                body: editedPost.body,
                                bodyHtml: editedPost.bodyHtml
                            }
                        };
                        _context27.next = 3;
                        return makeRequest({ name: "editPost", args: args, progress: progress });

                    case 3:
                        ret = _context27.sent;
                        return _context27.abrupt("return", {
                            id: ret.id,
                            user: ret.user === null || ret.user === undefined ? null : {
                                id: ret.user.id,
                                avatar: ret.user.avatar === null || ret.user.avatar === undefined ? null : {
                                    width: ret.user.avatar.width || 0,
                                    height: ret.user.avatar.height || 0,
                                    url: ret.user.avatar.url
                                },
                                name: ret.user.name,
                                nick: ret.user.nick,
                                rate: ret.user.rate,
                                height: ret.user.height === null || ret.user.height === undefined ? null : ret.user.height || 0,
                                deleted: !!ret.user.deleted,
                                isLockerLiked: !!ret.user.isLockerLiked,
                                isFollowing: !!ret.user.isFollowing,
                                ownerName: ret.user.ownerName === null || ret.user.ownerName === undefined ? null : ret.user.ownerName
                            },
                            approved: !!ret.approved,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            slug: ret.slug,
                            title: ret.title,
                            body: ret.body,
                            bodyHtml: ret.bodyHtml
                        });

                    case 5:
                    case "end":
                        return _context27.stop();
                }
            }
        }, _callee27, this);
    }));

    return function editPost(_x54, _x55, _x56) {
        return _ref27.apply(this, arguments);
    };
}();

var deletePost = function () {
    var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(postId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee28$(_context28) {
            while (1) {
                switch (_context28.prev = _context28.next) {
                    case 0:
                        args = {
                            postId: postId
                        };
                        _context28.next = 3;
                        return makeRequest({ name: "deletePost", args: args, progress: progress });

                    case 3:
                        return _context28.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context28.stop();
                }
            }
        }, _callee28, this);
    }));

    return function deletePost(_x57, _x58) {
        return _ref28.apply(this, arguments);
    };
}();

var getPost = function () {
    var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(postId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee29$(_context29) {
            while (1) {
                switch (_context29.prev = _context29.next) {
                    case 0:
                        args = {
                            postId: postId
                        };
                        _context29.next = 3;
                        return makeRequest({ name: "getPost", args: args, progress: progress });

                    case 3:
                        ret = _context29.sent;
                        return _context29.abrupt("return", {
                            id: ret.id,
                            user: ret.user === null || ret.user === undefined ? null : {
                                id: ret.user.id,
                                avatar: ret.user.avatar === null || ret.user.avatar === undefined ? null : {
                                    width: ret.user.avatar.width || 0,
                                    height: ret.user.avatar.height || 0,
                                    url: ret.user.avatar.url
                                },
                                name: ret.user.name,
                                nick: ret.user.nick,
                                rate: ret.user.rate,
                                height: ret.user.height === null || ret.user.height === undefined ? null : ret.user.height || 0,
                                deleted: !!ret.user.deleted,
                                isLockerLiked: !!ret.user.isLockerLiked,
                                isFollowing: !!ret.user.isFollowing,
                                ownerName: ret.user.ownerName === null || ret.user.ownerName === undefined ? null : ret.user.ownerName
                            },
                            approved: !!ret.approved,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            slug: ret.slug,
                            title: ret.title,
                            body: ret.body,
                            bodyHtml: ret.bodyHtml
                        });

                    case 5:
                    case "end":
                        return _context29.stop();
                }
            }
        }, _callee29, this);
    }));

    return function getPost(_x59, _x60) {
        return _ref29.apply(this, arguments);
    };
}();

var getPosts = function () {
    var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(pageOffset, approved, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee30$(_context30) {
            while (1) {
                switch (_context30.prev = _context30.next) {
                    case 0:
                        args = {
                            pageOffset: pageOffset || 0,
                            approved: !!approved
                        };
                        _context30.next = 3;
                        return makeRequest({ name: "getPosts", args: args, progress: progress });

                    case 3:
                        ret = _context30.sent;
                        return _context30.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                user: e.user === null || e.user === undefined ? null : {
                                    id: e.user.id,
                                    avatar: e.user.avatar === null || e.user.avatar === undefined ? null : {
                                        width: e.user.avatar.width || 0,
                                        height: e.user.avatar.height || 0,
                                        url: e.user.avatar.url
                                    },
                                    name: e.user.name,
                                    nick: e.user.nick,
                                    rate: e.user.rate,
                                    height: e.user.height === null || e.user.height === undefined ? null : e.user.height || 0,
                                    deleted: !!e.user.deleted,
                                    isLockerLiked: !!e.user.isLockerLiked,
                                    isFollowing: !!e.user.isFollowing,
                                    ownerName: e.user.ownerName === null || e.user.ownerName === undefined ? null : e.user.ownerName
                                },
                                approved: !!e.approved,
                                image: {
                                    width: e.image.width || 0,
                                    height: e.image.height || 0,
                                    url: e.image.url
                                },
                                slug: e.slug,
                                title: e.title,
                                body: e.body,
                                bodyHtml: e.bodyHtml
                            };
                        }));

                    case 5:
                    case "end":
                        return _context30.stop();
                }
            }
        }, _callee30, this);
    }));

    return function getPosts(_x61, _x62, _x63) {
        return _ref30.apply(this, arguments);
    };
}();

var setPostApproved = function () {
    var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(postId, approved, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee31$(_context31) {
            while (1) {
                switch (_context31.prev = _context31.next) {
                    case 0:
                        args = {
                            postId: postId,
                            approved: !!approved
                        };
                        _context31.next = 3;
                        return makeRequest({ name: "setPostApproved", args: args, progress: progress });

                    case 3:
                        ret = _context31.sent;
                        return _context31.abrupt("return", {
                            id: ret.id,
                            user: ret.user === null || ret.user === undefined ? null : {
                                id: ret.user.id,
                                avatar: ret.user.avatar === null || ret.user.avatar === undefined ? null : {
                                    width: ret.user.avatar.width || 0,
                                    height: ret.user.avatar.height || 0,
                                    url: ret.user.avatar.url
                                },
                                name: ret.user.name,
                                nick: ret.user.nick,
                                rate: ret.user.rate,
                                height: ret.user.height === null || ret.user.height === undefined ? null : ret.user.height || 0,
                                deleted: !!ret.user.deleted,
                                isLockerLiked: !!ret.user.isLockerLiked,
                                isFollowing: !!ret.user.isFollowing,
                                ownerName: ret.user.ownerName === null || ret.user.ownerName === undefined ? null : ret.user.ownerName
                            },
                            approved: !!ret.approved,
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            },
                            slug: ret.slug,
                            title: ret.title,
                            body: ret.body,
                            bodyHtml: ret.bodyHtml
                        });

                    case 5:
                    case "end":
                        return _context31.stop();
                }
            }
        }, _callee31, this);
    }));

    return function setPostApproved(_x64, _x65, _x66) {
        return _ref31.apply(this, arguments);
    };
}();

var sendEmailForFranchise = function () {
    var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(dataUser, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee32$(_context32) {
            while (1) {
                switch (_context32.prev = _context32.next) {
                    case 0:
                        args = {
                            dataUser: {
                                name: dataUser.name,
                                email: dataUser.email,
                                phone: dataUser.phone,
                                instagram: dataUser.instagram,
                                city: dataUser.city,
                                state: dataUser.state
                            }
                        };
                        _context32.next = 3;
                        return makeRequest({ name: "sendEmailForFranchise", args: args, progress: progress });

                    case 3:
                        return _context32.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context32.stop();
                }
            }
        }, _callee32, this);
    }));

    return function sendEmailForFranchise(_x67, _x68) {
        return _ref32.apply(this, arguments);
    };
}();

var getHomeData = function () {
    var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(startDate, endDate, cityIds, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee33$(_context33) {
            while (1) {
                switch (_context33.prev = _context33.next) {
                    case 0:
                        args = {
                            startDate: typeof startDate === "string" && startDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? startDate.replace("Z", "") : startDate.toISOString().replace("Z", ""),
                            endDate: typeof endDate === "string" && endDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? endDate.replace("Z", "") : endDate.toISOString().replace("Z", ""),
                            cityIds: cityIds.map(function (e) {
                                return e;
                            })
                        };
                        _context33.next = 3;
                        return makeRequest({ name: "getHomeData", args: args, progress: progress });

                    case 3:
                        ret = _context33.sent;
                        return _context33.abrupt("return", {
                            sales: {
                                amount: ret.sales.amount || 0,
                                ticket: ret.sales.ticket || 0,
                                totalPrice: ret.sales.totalPrice || 0
                            },
                            rents: {
                                amount: ret.rents.amount || 0,
                                ticket: ret.rents.ticket || 0,
                                totalPrice: ret.rents.totalPrice || 0
                            },
                            rentsAndSales: {
                                amount: ret.rentsAndSales.amount || 0,
                                ticket: ret.rentsAndSales.ticket || 0,
                                totalPrice: ret.rentsAndSales.totalPrice || 0
                            },
                            createdUsers: ret.createdUsers || 0,
                            createdItems: ret.createdItems || 0
                        });

                    case 5:
                    case "end":
                        return _context33.stop();
                }
            }
        }, _callee33, this);
    }));

    return function getHomeData(_x69, _x70, _x71, _x72) {
        return _ref33.apply(this, arguments);
    };
}();

var getGraphicDataPerDate = function () {
    var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(startDate, endDate, cityIds, type, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee34$(_context34) {
            while (1) {
                switch (_context34.prev = _context34.next) {
                    case 0:
                        args = {
                            startDate: typeof startDate === "string" && startDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? startDate.replace("Z", "") : startDate.toISOString().replace("Z", ""),
                            endDate: typeof endDate === "string" && endDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? endDate.replace("Z", "") : endDate.toISOString().replace("Z", ""),
                            cityIds: cityIds.map(function (e) {
                                return e;
                            }),
                            type: type
                        };
                        _context34.next = 3;
                        return makeRequest({ name: "getGraphicDataPerDate", args: args, progress: progress });

                    case 3:
                        ret = _context34.sent;
                        return _context34.abrupt("return", {
                            sales: ret.sales.map(function (e) {
                                return {
                                    value: e.value || 0,
                                    date: new Date(parseInt(e.date.split("-")[0], 10), parseInt(e.date.split("-")[1], 10) - 1, parseInt(e.date.split("-")[2], 10))
                                };
                            }),
                            rents: ret.rents.map(function (e) {
                                return {
                                    value: e.value || 0,
                                    date: new Date(parseInt(e.date.split("-")[0], 10), parseInt(e.date.split("-")[1], 10) - 1, parseInt(e.date.split("-")[2], 10))
                                };
                            })
                        });

                    case 5:
                    case "end":
                        return _context34.stop();
                }
            }
        }, _callee34, this);
    }));

    return function getGraphicDataPerDate(_x73, _x74, _x75, _x76, _x77) {
        return _ref34.apply(this, arguments);
    };
}();

var getGraphicDataPerDateHour = function () {
    var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(startDate, endDate, cityIds, type, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee35$(_context35) {
            while (1) {
                switch (_context35.prev = _context35.next) {
                    case 0:
                        args = {
                            startDate: typeof startDate === "string" && startDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? startDate.replace("Z", "") : startDate.toISOString().replace("Z", ""),
                            endDate: typeof endDate === "string" && endDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? endDate.replace("Z", "") : endDate.toISOString().replace("Z", ""),
                            cityIds: cityIds.map(function (e) {
                                return e;
                            }),
                            type: type
                        };
                        _context35.next = 3;
                        return makeRequest({ name: "getGraphicDataPerDateHour", args: args, progress: progress });

                    case 3:
                        ret = _context35.sent;
                        return _context35.abrupt("return", {
                            sales: ret.sales.map(function (e) {
                                return {
                                    value: e.value || 0,
                                    dateHour: new Date(e.dateHour + "Z")
                                };
                            }),
                            rents: ret.rents.map(function (e) {
                                return {
                                    value: e.value || 0,
                                    dateHour: new Date(e.dateHour + "Z")
                                };
                            })
                        });

                    case 5:
                    case "end":
                        return _context35.stop();
                }
            }
        }, _callee35, this);
    }));

    return function getGraphicDataPerDateHour(_x78, _x79, _x80, _x81, _x82) {
        return _ref35.apply(this, arguments);
    };
}();

var getGraphicDataPerHour = function () {
    var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36(startDate, endDate, cityIds, type, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee36$(_context36) {
            while (1) {
                switch (_context36.prev = _context36.next) {
                    case 0:
                        args = {
                            startDate: typeof startDate === "string" && startDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? startDate.replace("Z", "") : startDate.toISOString().replace("Z", ""),
                            endDate: typeof endDate === "string" && endDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? endDate.replace("Z", "") : endDate.toISOString().replace("Z", ""),
                            cityIds: cityIds.map(function (e) {
                                return e;
                            }),
                            type: type
                        };
                        _context36.next = 3;
                        return makeRequest({ name: "getGraphicDataPerHour", args: args, progress: progress });

                    case 3:
                        ret = _context36.sent;
                        return _context36.abrupt("return", {
                            sales: ret.sales.map(function (e) {
                                return {
                                    value: e.value || 0,
                                    hour: e.hour || 0
                                };
                            }),
                            rents: ret.rents.map(function (e) {
                                return {
                                    value: e.value || 0,
                                    hour: e.hour || 0
                                };
                            })
                        });

                    case 5:
                    case "end":
                        return _context36.stop();
                }
            }
        }, _callee36, this);
    }));

    return function getGraphicDataPerHour(_x83, _x84, _x85, _x86, _x87) {
        return _ref36.apply(this, arguments);
    };
}();

var getItem = function () {
    var _ref37 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee37(itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee37$(_context37) {
            while (1) {
                switch (_context37.prev = _context37.next) {
                    case 0:
                        args = {
                            itemId: itemId
                        };
                        _context37.next = 3;
                        return makeRequest({ name: "getItem", args: args, progress: progress });

                    case 3:
                        ret = _context37.sent;
                        return _context37.abrupt("return", ret === null || ret === undefined ? null : {
                            id: ret.id,
                            owner: {
                                id: ret.owner.id,
                                gender: ret.owner.gender === null || ret.owner.gender === undefined ? null : ret.owner.gender,
                                birthday: ret.owner.birthday === null || ret.owner.birthday === undefined ? null : new Date(parseInt(ret.owner.birthday.split("-")[0], 10), parseInt(ret.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.owner.birthday.split("-")[2], 10)),
                                name: ret.owner.name,
                                nick: ret.owner.nick,
                                cpf: ret.owner.cpf,
                                email: ret.owner.email,
                                phone: {
                                    ddd: ret.owner.phone.ddd,
                                    ddi: ret.owner.phone.ddi,
                                    number: ret.owner.phone.number
                                },
                                avatar: ret.owner.avatar === null || ret.owner.avatar === undefined ? null : {
                                    width: ret.owner.avatar.width || 0,
                                    height: ret.owner.avatar.height || 0,
                                    url: ret.owner.avatar.url
                                },
                                address: ret.owner.address === null || ret.owner.address === undefined ? null : {
                                    street: ret.owner.address.street,
                                    neighborhood: ret.owner.address.neighborhood,
                                    city: ret.owner.address.city,
                                    uf: ret.owner.address.uf,
                                    country: ret.owner.address.country,
                                    number: ret.owner.address.number,
                                    zip: ret.owner.address.zip,
                                    adicionalInfo: ret.owner.address.adicionalInfo,
                                    reference: ret.owner.address.reference,
                                    location: {
                                        lat: ret.owner.address.location.lat,
                                        lon: ret.owner.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.owner.createdAt + "Z"),
                                deletedAt: ret.owner.deletedAt === null || ret.owner.deletedAt === undefined ? null : new Date(ret.owner.deletedAt + "Z")
                            },
                            calendar: ret.calendar.map(function (e) {
                                return {
                                    start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                };
                            }),
                            createdAt: new Date(ret.createdAt + "Z"),
                            department: ret.department,
                            adjustment: !!ret.adjustment,
                            category: ret.category === null || ret.category === undefined ? null : ret.category,
                            color: ret.color === null || ret.color === undefined ? null : ret.color,
                            details: ret.details,
                            gender: ret.gender,
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            images: ret.images.map(function (e) {
                                return {
                                    width: e.width || 0,
                                    height: e.height || 0,
                                    url: e.url
                                };
                            }),
                            brand: ret.brand === null || ret.brand === undefined ? null : ret.brand,
                            ocasions: ret.ocasions.map(function (e) {
                                return e === null || e === undefined ? null : e;
                            }),
                            size: ret.size === null || ret.size === undefined ? null : ret.size,
                            rentPrice: ret.rentPrice === null || ret.rentPrice === undefined ? null : ret.rentPrice || 0,
                            salePrice: ret.salePrice === null || ret.salePrice === undefined ? null : ret.salePrice || 0,
                            originalPrice: ret.originalPrice || 0
                        });

                    case 5:
                    case "end":
                        return _context37.stop();
                }
            }
        }, _callee37, this);
    }));

    return function getItem(_x88, _x89) {
        return _ref37.apply(this, arguments);
    };
}();

var getUser = function () {
    var _ref38 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee38(userId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee38$(_context38) {
            while (1) {
                switch (_context38.prev = _context38.next) {
                    case 0:
                        args = {
                            userId: userId
                        };
                        _context38.next = 3;
                        return makeRequest({ name: "getUser", args: args, progress: progress });

                    case 3:
                        ret = _context38.sent;
                        return _context38.abrupt("return", {
                            id: ret.id,
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            name: ret.name,
                            nick: ret.nick,
                            cpf: ret.cpf,
                            email: ret.email,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            address: ret.address === null || ret.address === undefined ? null : {
                                street: ret.address.street,
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                number: ret.address.number,
                                zip: ret.address.zip,
                                adicionalInfo: ret.address.adicionalInfo,
                                reference: ret.address.reference,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            deletedAt: ret.deletedAt === null || ret.deletedAt === undefined ? null : new Date(ret.deletedAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context38.stop();
                }
            }
        }, _callee38, this);
    }));

    return function getUser(_x90, _x91) {
        return _ref38.apply(this, arguments);
    };
}();

var getUsersReportForAdmin = function () {
    var _ref39 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee39(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee39$(_context39) {
            while (1) {
                switch (_context39.prev = _context39.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                createdAtUserDate: filter.createdAtUserDate === null || filter.createdAtUserDate === undefined ? null : {
                                    startDate: filter.createdAtUserDate.startDate === null || filter.createdAtUserDate.startDate === undefined ? null : typeof filter.createdAtUserDate.startDate === "string" ? new Date(new Date(filter.createdAtUserDate.startDate).getTime() - new Date(filter.createdAtUserDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtUserDate.startDate.getTime() - filter.createdAtUserDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtUserDate.endDate === null || filter.createdAtUserDate.endDate === undefined ? null : typeof filter.createdAtUserDate.endDate === "string" ? new Date(new Date(filter.createdAtUserDate.endDate).getTime() - new Date(filter.createdAtUserDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtUserDate.endDate.getTime() - filter.createdAtUserDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                },
                                search: filter.search === null || filter.search === undefined ? null : filter.search
                            }
                        };
                        _context39.next = 3;
                        return makeRequest({ name: "getUsersReportForAdmin", args: args, progress: progress });

                    case 3:
                        ret = _context39.sent;
                        return _context39.abrupt("return", ret);

                    case 5:
                    case "end":
                        return _context39.stop();
                }
            }
        }, _callee39, this);
    }));

    return function getUsersReportForAdmin(_x92, _x93) {
        return _ref39.apply(this, arguments);
    };
}();

var getUsersForAdmin = function () {
    var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee40(page, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee40$(_context40) {
            while (1) {
                switch (_context40.prev = _context40.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0,
                            filter: filter === null || filter === undefined ? null : {
                                createdAtUserDate: filter.createdAtUserDate === null || filter.createdAtUserDate === undefined ? null : {
                                    startDate: filter.createdAtUserDate.startDate === null || filter.createdAtUserDate.startDate === undefined ? null : typeof filter.createdAtUserDate.startDate === "string" ? new Date(new Date(filter.createdAtUserDate.startDate).getTime() - new Date(filter.createdAtUserDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtUserDate.startDate.getTime() - filter.createdAtUserDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtUserDate.endDate === null || filter.createdAtUserDate.endDate === undefined ? null : typeof filter.createdAtUserDate.endDate === "string" ? new Date(new Date(filter.createdAtUserDate.endDate).getTime() - new Date(filter.createdAtUserDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtUserDate.endDate.getTime() - filter.createdAtUserDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                },
                                search: filter.search === null || filter.search === undefined ? null : filter.search
                            }
                        };
                        _context40.next = 3;
                        return makeRequest({ name: "getUsersForAdmin", args: args, progress: progress });

                    case 3:
                        ret = _context40.sent;
                        return _context40.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                gender: e.gender === null || e.gender === undefined ? null : e.gender,
                                birthday: e.birthday === null || e.birthday === undefined ? null : new Date(parseInt(e.birthday.split("-")[0], 10), parseInt(e.birthday.split("-")[1], 10) - 1, parseInt(e.birthday.split("-")[2], 10)),
                                name: e.name,
                                nick: e.nick,
                                cpf: e.cpf,
                                email: e.email,
                                phone: {
                                    ddd: e.phone.ddd,
                                    ddi: e.phone.ddi,
                                    number: e.phone.number
                                },
                                avatar: e.avatar === null || e.avatar === undefined ? null : {
                                    width: e.avatar.width || 0,
                                    height: e.avatar.height || 0,
                                    url: e.avatar.url
                                },
                                address: e.address === null || e.address === undefined ? null : {
                                    street: e.address.street,
                                    neighborhood: e.address.neighborhood,
                                    city: e.address.city,
                                    uf: e.address.uf,
                                    country: e.address.country,
                                    number: e.address.number,
                                    zip: e.address.zip,
                                    adicionalInfo: e.address.adicionalInfo,
                                    reference: e.address.reference,
                                    location: {
                                        lat: e.address.location.lat,
                                        lon: e.address.location.lon
                                    }
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                deletedAt: e.deletedAt === null || e.deletedAt === undefined ? null : new Date(e.deletedAt + "Z")
                            };
                        }));

                    case 5:
                    case "end":
                        return _context40.stop();
                }
            }
        }, _callee40, this);
    }));

    return function getUsersForAdmin(_x94, _x95, _x96) {
        return _ref40.apply(this, arguments);
    };
}();

var getUsersStats = function () {
    var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee41(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee41$(_context41) {
            while (1) {
                switch (_context41.prev = _context41.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                createdAtUserDate: filter.createdAtUserDate === null || filter.createdAtUserDate === undefined ? null : {
                                    startDate: filter.createdAtUserDate.startDate === null || filter.createdAtUserDate.startDate === undefined ? null : typeof filter.createdAtUserDate.startDate === "string" ? new Date(new Date(filter.createdAtUserDate.startDate).getTime() - new Date(filter.createdAtUserDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtUserDate.startDate.getTime() - filter.createdAtUserDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtUserDate.endDate === null || filter.createdAtUserDate.endDate === undefined ? null : typeof filter.createdAtUserDate.endDate === "string" ? new Date(new Date(filter.createdAtUserDate.endDate).getTime() - new Date(filter.createdAtUserDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtUserDate.endDate.getTime() - filter.createdAtUserDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                },
                                search: filter.search === null || filter.search === undefined ? null : filter.search
                            }
                        };
                        _context41.next = 3;
                        return makeRequest({ name: "getUsersStats", args: args, progress: progress });

                    case 3:
                        ret = _context41.sent;
                        return _context41.abrupt("return", {
                            total: ret.total || 0
                        });

                    case 5:
                    case "end":
                        return _context41.stop();
                }
            }
        }, _callee41, this);
    }));

    return function getUsersStats(_x97, _x98) {
        return _ref41.apply(this, arguments);
    };
}();

var getTopTeenUsers = function () {
    var _ref42 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee42(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee42$(_context42) {
            while (1) {
                switch (_context42.prev = _context42.next) {
                    case 0:
                        _context42.next = 2;
                        return makeRequest({ name: "getTopTeenUsers", args: {}, progress: progress });

                    case 2:
                        ret = _context42.sent;
                        return _context42.abrupt("return", {
                            topRent: ret.topRent.map(function (e) {
                                return {
                                    user: {
                                        id: e.user.id,
                                        gender: e.user.gender === null || e.user.gender === undefined ? null : e.user.gender,
                                        birthday: e.user.birthday === null || e.user.birthday === undefined ? null : new Date(parseInt(e.user.birthday.split("-")[0], 10), parseInt(e.user.birthday.split("-")[1], 10) - 1, parseInt(e.user.birthday.split("-")[2], 10)),
                                        name: e.user.name,
                                        nick: e.user.nick,
                                        cpf: e.user.cpf,
                                        email: e.user.email,
                                        phone: {
                                            ddd: e.user.phone.ddd,
                                            ddi: e.user.phone.ddi,
                                            number: e.user.phone.number
                                        },
                                        avatar: e.user.avatar === null || e.user.avatar === undefined ? null : {
                                            width: e.user.avatar.width || 0,
                                            height: e.user.avatar.height || 0,
                                            url: e.user.avatar.url
                                        },
                                        address: e.user.address === null || e.user.address === undefined ? null : {
                                            street: e.user.address.street,
                                            neighborhood: e.user.address.neighborhood,
                                            city: e.user.address.city,
                                            uf: e.user.address.uf,
                                            country: e.user.address.country,
                                            number: e.user.address.number,
                                            zip: e.user.address.zip,
                                            adicionalInfo: e.user.address.adicionalInfo,
                                            reference: e.user.address.reference,
                                            location: {
                                                lat: e.user.address.location.lat,
                                                lon: e.user.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.user.createdAt + "Z"),
                                        deletedAt: e.user.deletedAt === null || e.user.deletedAt === undefined ? null : new Date(e.user.deletedAt + "Z")
                                    },
                                    amount: e.amount || 0
                                };
                            }),
                            topRented: ret.topRented.map(function (e) {
                                return {
                                    user: {
                                        id: e.user.id,
                                        gender: e.user.gender === null || e.user.gender === undefined ? null : e.user.gender,
                                        birthday: e.user.birthday === null || e.user.birthday === undefined ? null : new Date(parseInt(e.user.birthday.split("-")[0], 10), parseInt(e.user.birthday.split("-")[1], 10) - 1, parseInt(e.user.birthday.split("-")[2], 10)),
                                        name: e.user.name,
                                        nick: e.user.nick,
                                        cpf: e.user.cpf,
                                        email: e.user.email,
                                        phone: {
                                            ddd: e.user.phone.ddd,
                                            ddi: e.user.phone.ddi,
                                            number: e.user.phone.number
                                        },
                                        avatar: e.user.avatar === null || e.user.avatar === undefined ? null : {
                                            width: e.user.avatar.width || 0,
                                            height: e.user.avatar.height || 0,
                                            url: e.user.avatar.url
                                        },
                                        address: e.user.address === null || e.user.address === undefined ? null : {
                                            street: e.user.address.street,
                                            neighborhood: e.user.address.neighborhood,
                                            city: e.user.address.city,
                                            uf: e.user.address.uf,
                                            country: e.user.address.country,
                                            number: e.user.address.number,
                                            zip: e.user.address.zip,
                                            adicionalInfo: e.user.address.adicionalInfo,
                                            reference: e.user.address.reference,
                                            location: {
                                                lat: e.user.address.location.lat,
                                                lon: e.user.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.user.createdAt + "Z"),
                                        deletedAt: e.user.deletedAt === null || e.user.deletedAt === undefined ? null : new Date(e.user.deletedAt + "Z")
                                    },
                                    amount: e.amount || 0
                                };
                            }),
                            topSeller: ret.topSeller.map(function (e) {
                                return {
                                    user: {
                                        id: e.user.id,
                                        gender: e.user.gender === null || e.user.gender === undefined ? null : e.user.gender,
                                        birthday: e.user.birthday === null || e.user.birthday === undefined ? null : new Date(parseInt(e.user.birthday.split("-")[0], 10), parseInt(e.user.birthday.split("-")[1], 10) - 1, parseInt(e.user.birthday.split("-")[2], 10)),
                                        name: e.user.name,
                                        nick: e.user.nick,
                                        cpf: e.user.cpf,
                                        email: e.user.email,
                                        phone: {
                                            ddd: e.user.phone.ddd,
                                            ddi: e.user.phone.ddi,
                                            number: e.user.phone.number
                                        },
                                        avatar: e.user.avatar === null || e.user.avatar === undefined ? null : {
                                            width: e.user.avatar.width || 0,
                                            height: e.user.avatar.height || 0,
                                            url: e.user.avatar.url
                                        },
                                        address: e.user.address === null || e.user.address === undefined ? null : {
                                            street: e.user.address.street,
                                            neighborhood: e.user.address.neighborhood,
                                            city: e.user.address.city,
                                            uf: e.user.address.uf,
                                            country: e.user.address.country,
                                            number: e.user.address.number,
                                            zip: e.user.address.zip,
                                            adicionalInfo: e.user.address.adicionalInfo,
                                            reference: e.user.address.reference,
                                            location: {
                                                lat: e.user.address.location.lat,
                                                lon: e.user.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.user.createdAt + "Z"),
                                        deletedAt: e.user.deletedAt === null || e.user.deletedAt === undefined ? null : new Date(e.user.deletedAt + "Z")
                                    },
                                    amount: e.amount || 0
                                };
                            }),
                            topBuyer: ret.topBuyer.map(function (e) {
                                return {
                                    user: {
                                        id: e.user.id,
                                        gender: e.user.gender === null || e.user.gender === undefined ? null : e.user.gender,
                                        birthday: e.user.birthday === null || e.user.birthday === undefined ? null : new Date(parseInt(e.user.birthday.split("-")[0], 10), parseInt(e.user.birthday.split("-")[1], 10) - 1, parseInt(e.user.birthday.split("-")[2], 10)),
                                        name: e.user.name,
                                        nick: e.user.nick,
                                        cpf: e.user.cpf,
                                        email: e.user.email,
                                        phone: {
                                            ddd: e.user.phone.ddd,
                                            ddi: e.user.phone.ddi,
                                            number: e.user.phone.number
                                        },
                                        avatar: e.user.avatar === null || e.user.avatar === undefined ? null : {
                                            width: e.user.avatar.width || 0,
                                            height: e.user.avatar.height || 0,
                                            url: e.user.avatar.url
                                        },
                                        address: e.user.address === null || e.user.address === undefined ? null : {
                                            street: e.user.address.street,
                                            neighborhood: e.user.address.neighborhood,
                                            city: e.user.address.city,
                                            uf: e.user.address.uf,
                                            country: e.user.address.country,
                                            number: e.user.address.number,
                                            zip: e.user.address.zip,
                                            adicionalInfo: e.user.address.adicionalInfo,
                                            reference: e.user.address.reference,
                                            location: {
                                                lat: e.user.address.location.lat,
                                                lon: e.user.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.user.createdAt + "Z"),
                                        deletedAt: e.user.deletedAt === null || e.user.deletedAt === undefined ? null : new Date(e.user.deletedAt + "Z")
                                    },
                                    amount: e.amount || 0
                                };
                            })
                        });

                    case 4:
                    case "end":
                        return _context42.stop();
                }
            }
        }, _callee42, this);
    }));

    return function getTopTeenUsers(_x99) {
        return _ref42.apply(this, arguments);
    };
}();

var getItems = function () {
    var _ref43 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee43(page, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee43$(_context43) {
            while (1) {
                switch (_context43.prev = _context43.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0,
                            filter: filter === null || filter === undefined ? null : {
                                createdAtRentDate: filter.createdAtRentDate === null || filter.createdAtRentDate === undefined ? null : {
                                    startDate: filter.createdAtRentDate.startDate === null || filter.createdAtRentDate.startDate === undefined ? null : typeof filter.createdAtRentDate.startDate === "string" ? new Date(new Date(filter.createdAtRentDate.startDate).getTime() - new Date(filter.createdAtRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.startDate.getTime() - filter.createdAtRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtRentDate.endDate === null || filter.createdAtRentDate.endDate === undefined ? null : typeof filter.createdAtRentDate.endDate === "string" ? new Date(new Date(filter.createdAtRentDate.endDate).getTime() - new Date(filter.createdAtRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.endDate.getTime() - filter.createdAtRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context43.next = 3;
                        return makeRequest({ name: "getItems", args: args, progress: progress });

                    case 3:
                        ret = _context43.sent;
                        return _context43.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                owner: {
                                    id: e.owner.id,
                                    gender: e.owner.gender === null || e.owner.gender === undefined ? null : e.owner.gender,
                                    birthday: e.owner.birthday === null || e.owner.birthday === undefined ? null : new Date(parseInt(e.owner.birthday.split("-")[0], 10), parseInt(e.owner.birthday.split("-")[1], 10) - 1, parseInt(e.owner.birthday.split("-")[2], 10)),
                                    name: e.owner.name,
                                    nick: e.owner.nick,
                                    cpf: e.owner.cpf,
                                    email: e.owner.email,
                                    phone: {
                                        ddd: e.owner.phone.ddd,
                                        ddi: e.owner.phone.ddi,
                                        number: e.owner.phone.number
                                    },
                                    avatar: e.owner.avatar === null || e.owner.avatar === undefined ? null : {
                                        width: e.owner.avatar.width || 0,
                                        height: e.owner.avatar.height || 0,
                                        url: e.owner.avatar.url
                                    },
                                    address: e.owner.address === null || e.owner.address === undefined ? null : {
                                        street: e.owner.address.street,
                                        neighborhood: e.owner.address.neighborhood,
                                        city: e.owner.address.city,
                                        uf: e.owner.address.uf,
                                        country: e.owner.address.country,
                                        number: e.owner.address.number,
                                        zip: e.owner.address.zip,
                                        adicionalInfo: e.owner.address.adicionalInfo,
                                        reference: e.owner.address.reference,
                                        location: {
                                            lat: e.owner.address.location.lat,
                                            lon: e.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.owner.createdAt + "Z"),
                                    deletedAt: e.owner.deletedAt === null || e.owner.deletedAt === undefined ? null : new Date(e.owner.deletedAt + "Z")
                                },
                                calendar: e.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                createdAt: new Date(e.createdAt + "Z"),
                                department: e.department,
                                adjustment: !!e.adjustment,
                                category: e.category === null || e.category === undefined ? null : e.category,
                                color: e.color === null || e.color === undefined ? null : e.color,
                                details: e.details,
                                gender: e.gender,
                                thumbImage: {
                                    width: e.thumbImage.width || 0,
                                    height: e.thumbImage.height || 0,
                                    url: e.thumbImage.url
                                },
                                images: e.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                ocasions: e.ocasions.map(function (e) {
                                    return e === null || e === undefined ? null : e;
                                }),
                                size: e.size === null || e.size === undefined ? null : e.size,
                                rentPrice: e.rentPrice === null || e.rentPrice === undefined ? null : e.rentPrice || 0,
                                salePrice: e.salePrice === null || e.salePrice === undefined ? null : e.salePrice || 0,
                                originalPrice: e.originalPrice || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context43.stop();
                }
            }
        }, _callee43, this);
    }));

    return function getItems(_x100, _x101, _x102) {
        return _ref43.apply(this, arguments);
    };
}();

var getItemsStats = function () {
    var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee44(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee44$(_context44) {
            while (1) {
                switch (_context44.prev = _context44.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                createdAtRentDate: filter.createdAtRentDate === null || filter.createdAtRentDate === undefined ? null : {
                                    startDate: filter.createdAtRentDate.startDate === null || filter.createdAtRentDate.startDate === undefined ? null : typeof filter.createdAtRentDate.startDate === "string" ? new Date(new Date(filter.createdAtRentDate.startDate).getTime() - new Date(filter.createdAtRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.startDate.getTime() - filter.createdAtRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtRentDate.endDate === null || filter.createdAtRentDate.endDate === undefined ? null : typeof filter.createdAtRentDate.endDate === "string" ? new Date(new Date(filter.createdAtRentDate.endDate).getTime() - new Date(filter.createdAtRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.endDate.getTime() - filter.createdAtRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context44.next = 3;
                        return makeRequest({ name: "getItemsStats", args: args, progress: progress });

                    case 3:
                        ret = _context44.sent;
                        return _context44.abrupt("return", {
                            totalAmount: ret.totalAmount || 0,
                            averageRentPrice: ret.averageRentPrice || 0,
                            averageSalePrice: ret.averageSalePrice || 0
                        });

                    case 5:
                    case "end":
                        return _context44.stop();
                }
            }
        }, _callee44, this);
    }));

    return function getItemsStats(_x103, _x104) {
        return _ref44.apply(this, arguments);
    };
}();

var getCurrentAdminUser = function () {
    var _ref45 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee45(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee45$(_context45) {
            while (1) {
                switch (_context45.prev = _context45.next) {
                    case 0:
                        _context45.next = 2;
                        return makeRequest({ name: "getCurrentAdminUser", args: {}, progress: progress });

                    case 2:
                        ret = _context45.sent;
                        return _context45.abrupt("return", {
                            id: ret.id,
                            licensedInfo: ret.licensedInfo === null || ret.licensedInfo === undefined ? null : {
                                document: ret.licensedInfo.document,
                                bankAccount: {
                                    documentNumber: ret.licensedInfo.bankAccount.documentNumber,
                                    bankName: ret.licensedInfo.bankAccount.bankName,
                                    bankCode: ret.licensedInfo.bankAccount.bankCode,
                                    agency: ret.licensedInfo.bankAccount.agency,
                                    agencyDv: ret.licensedInfo.bankAccount.agencyDv === null || ret.licensedInfo.bankAccount.agencyDv === undefined ? null : ret.licensedInfo.bankAccount.agencyDv,
                                    account: ret.licensedInfo.bankAccount.account,
                                    accountDv: ret.licensedInfo.bankAccount.accountDv,
                                    type: ret.licensedInfo.bankAccount.type,
                                    legalName: ret.licensedInfo.bankAccount.legalName
                                },
                                licenses: ret.licensedInfo.licenses.map(function (e) {
                                    return {
                                        city: {
                                            id: e.city.id,
                                            name: e.city.name,
                                            uf: e.city.uf
                                        },
                                        percentage: e.percentage || 0,
                                        expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                    };
                                })
                            },
                            type: ret.type,
                            name: ret.name,
                            email: ret.email
                        });

                    case 4:
                    case "end":
                        return _context45.stop();
                }
            }
        }, _callee45, this);
    }));

    return function getCurrentAdminUser(_x105) {
        return _ref45.apply(this, arguments);
    };
}();

var login = function () {
    var _ref46 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee46(email, password, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee46$(_context46) {
            while (1) {
                switch (_context46.prev = _context46.next) {
                    case 0:
                        args = {
                            email: email,
                            password: password
                        };
                        _context46.next = 3;
                        return makeRequest({ name: "login", args: args, progress: progress });

                    case 3:
                        ret = _context46.sent;
                        return _context46.abrupt("return", {
                            id: ret.id,
                            licensedInfo: ret.licensedInfo === null || ret.licensedInfo === undefined ? null : {
                                document: ret.licensedInfo.document,
                                bankAccount: {
                                    documentNumber: ret.licensedInfo.bankAccount.documentNumber,
                                    bankName: ret.licensedInfo.bankAccount.bankName,
                                    bankCode: ret.licensedInfo.bankAccount.bankCode,
                                    agency: ret.licensedInfo.bankAccount.agency,
                                    agencyDv: ret.licensedInfo.bankAccount.agencyDv === null || ret.licensedInfo.bankAccount.agencyDv === undefined ? null : ret.licensedInfo.bankAccount.agencyDv,
                                    account: ret.licensedInfo.bankAccount.account,
                                    accountDv: ret.licensedInfo.bankAccount.accountDv,
                                    type: ret.licensedInfo.bankAccount.type,
                                    legalName: ret.licensedInfo.bankAccount.legalName
                                },
                                licenses: ret.licensedInfo.licenses.map(function (e) {
                                    return {
                                        city: {
                                            id: e.city.id,
                                            name: e.city.name,
                                            uf: e.city.uf
                                        },
                                        percentage: e.percentage || 0,
                                        expirationDate: new Date(parseInt(e.expirationDate.split("-")[0], 10), parseInt(e.expirationDate.split("-")[1], 10) - 1, parseInt(e.expirationDate.split("-")[2], 10))
                                    };
                                })
                            },
                            type: ret.type,
                            name: ret.name,
                            email: ret.email
                        });

                    case 5:
                    case "end":
                        return _context46.stop();
                }
            }
        }, _callee46, this);
    }));

    return function login(_x106, _x107, _x108) {
        return _ref46.apply(this, arguments);
    };
}();

var logout = function () {
    var _ref47 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee47(progress) {
        return _regenerator2.default.wrap(function _callee47$(_context47) {
            while (1) {
                switch (_context47.prev = _context47.next) {
                    case 0:
                        _context47.next = 2;
                        return makeRequest({ name: "logout", args: {}, progress: progress });

                    case 2:
                        return _context47.abrupt("return", undefined);

                    case 3:
                    case "end":
                        return _context47.stop();
                }
            }
        }, _callee47, this);
    }));

    return function logout(_x109) {
        return _ref47.apply(this, arguments);
    };
}();

var getUsers = function () {
    var _ref48 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee48(search, deviceType, page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee48$(_context48) {
            while (1) {
                switch (_context48.prev = _context48.next) {
                    case 0:
                        args = {
                            search: search === null || search === undefined ? null : search,
                            deviceType: deviceType === null || deviceType === undefined ? null : deviceType,
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context48.next = 3;
                        return makeRequest({ name: "getUsers", args: args, progress: progress });

                    case 3:
                        ret = _context48.sent;
                        return _context48.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                gender: e.gender === null || e.gender === undefined ? null : e.gender,
                                birthday: e.birthday === null || e.birthday === undefined ? null : new Date(parseInt(e.birthday.split("-")[0], 10), parseInt(e.birthday.split("-")[1], 10) - 1, parseInt(e.birthday.split("-")[2], 10)),
                                name: e.name,
                                nick: e.nick,
                                cpf: e.cpf,
                                email: e.email,
                                phone: {
                                    ddd: e.phone.ddd,
                                    ddi: e.phone.ddi,
                                    number: e.phone.number
                                },
                                avatar: e.avatar === null || e.avatar === undefined ? null : {
                                    width: e.avatar.width || 0,
                                    height: e.avatar.height || 0,
                                    url: e.avatar.url
                                },
                                address: e.address === null || e.address === undefined ? null : {
                                    street: e.address.street,
                                    neighborhood: e.address.neighborhood,
                                    city: e.address.city,
                                    uf: e.address.uf,
                                    country: e.address.country,
                                    number: e.address.number,
                                    zip: e.address.zip,
                                    adicionalInfo: e.address.adicionalInfo,
                                    reference: e.address.reference,
                                    location: {
                                        lat: e.address.location.lat,
                                        lon: e.address.location.lon
                                    }
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                deletedAt: e.deletedAt === null || e.deletedAt === undefined ? null : new Date(e.deletedAt + "Z")
                            };
                        }));

                    case 5:
                    case "end":
                        return _context48.stop();
                }
            }
        }, _callee48, this);
    }));

    return function getUsers(_x110, _x111, _x112, _x113) {
        return _ref48.apply(this, arguments);
    };
}();

var getUsersForAdminUser = function () {
    var _ref49 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee49(search, page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee49$(_context49) {
            while (1) {
                switch (_context49.prev = _context49.next) {
                    case 0:
                        args = {
                            search: search === null || search === undefined ? null : search,
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context49.next = 3;
                        return makeRequest({ name: "getUsersForAdminUser", args: args, progress: progress });

                    case 3:
                        ret = _context49.sent;
                        return _context49.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                gender: e.gender === null || e.gender === undefined ? null : e.gender,
                                birthday: e.birthday === null || e.birthday === undefined ? null : new Date(parseInt(e.birthday.split("-")[0], 10), parseInt(e.birthday.split("-")[1], 10) - 1, parseInt(e.birthday.split("-")[2], 10)),
                                name: e.name,
                                nick: e.nick,
                                cpf: e.cpf,
                                email: e.email,
                                phone: {
                                    ddd: e.phone.ddd,
                                    ddi: e.phone.ddi,
                                    number: e.phone.number
                                },
                                avatar: e.avatar === null || e.avatar === undefined ? null : {
                                    width: e.avatar.width || 0,
                                    height: e.avatar.height || 0,
                                    url: e.avatar.url
                                },
                                address: e.address === null || e.address === undefined ? null : {
                                    street: e.address.street,
                                    neighborhood: e.address.neighborhood,
                                    city: e.address.city,
                                    uf: e.address.uf,
                                    country: e.address.country,
                                    number: e.address.number,
                                    zip: e.address.zip,
                                    adicionalInfo: e.address.adicionalInfo,
                                    reference: e.address.reference,
                                    location: {
                                        lat: e.address.location.lat,
                                        lon: e.address.location.lon
                                    }
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                deletedAt: e.deletedAt === null || e.deletedAt === undefined ? null : new Date(e.deletedAt + "Z")
                            };
                        }));

                    case 5:
                    case "end":
                        return _context49.stop();
                }
            }
        }, _callee49, this);
    }));

    return function getUsersForAdminUser(_x114, _x115, _x116) {
        return _ref49.apply(this, arguments);
    };
}();

var getCurrentUser = function () {
    var _ref50 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee50(search, deviceType, page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee50$(_context50) {
            while (1) {
                switch (_context50.prev = _context50.next) {
                    case 0:
                        args = {
                            search: search === null || search === undefined ? null : search,
                            deviceType: deviceType === null || deviceType === undefined ? null : deviceType,
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context50.next = 3;
                        return makeRequest({ name: "getCurrentUser", args: args, progress: progress });

                    case 3:
                        ret = _context50.sent;
                        return _context50.abrupt("return", {
                            id: ret.id,
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            name: ret.name,
                            nick: ret.nick,
                            cpf: ret.cpf,
                            email: ret.email,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            address: ret.address === null || ret.address === undefined ? null : {
                                street: ret.address.street,
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                number: ret.address.number,
                                zip: ret.address.zip,
                                adicionalInfo: ret.address.adicionalInfo,
                                reference: ret.address.reference,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            deletedAt: ret.deletedAt === null || ret.deletedAt === undefined ? null : new Date(ret.deletedAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context50.stop();
                }
            }
        }, _callee50, this);
    }));

    return function getCurrentUser(_x117, _x118, _x119, _x120) {
        return _ref50.apply(this, arguments);
    };
}();

var deleteUser = function () {
    var _ref51 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee51(userId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee51$(_context51) {
            while (1) {
                switch (_context51.prev = _context51.next) {
                    case 0:
                        args = {
                            userId: userId
                        };
                        _context51.next = 3;
                        return makeRequest({ name: "deleteUser", args: args, progress: progress });

                    case 3:
                        return _context51.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context51.stop();
                }
            }
        }, _callee51, this);
    }));

    return function deleteUser(_x121, _x122) {
        return _ref51.apply(this, arguments);
    };
}();

var verifyUser = function () {
    var _ref52 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee52(userId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee52$(_context52) {
            while (1) {
                switch (_context52.prev = _context52.next) {
                    case 0:
                        args = {
                            userId: userId
                        };
                        _context52.next = 3;
                        return makeRequest({ name: "verifyUser", args: args, progress: progress });

                    case 3:
                        return _context52.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context52.stop();
                }
            }
        }, _callee52, this);
    }));

    return function verifyUser(_x123, _x124) {
        return _ref52.apply(this, arguments);
    };
}();

var getRequest = function () {
    var _ref53 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee53(requestId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee53$(_context53) {
            while (1) {
                switch (_context53.prev = _context53.next) {
                    case 0:
                        args = {
                            requestId: requestId
                        };
                        _context53.next = 3;
                        return makeRequest({ name: "getRequest", args: args, progress: progress });

                    case 3:
                        ret = _context53.sent;
                        return _context53.abrupt("return", {
                            id: ret.id,
                            numId: ret.numId,
                            owner: {
                                id: ret.owner.id,
                                gender: ret.owner.gender === null || ret.owner.gender === undefined ? null : ret.owner.gender,
                                birthday: ret.owner.birthday === null || ret.owner.birthday === undefined ? null : new Date(parseInt(ret.owner.birthday.split("-")[0], 10), parseInt(ret.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.owner.birthday.split("-")[2], 10)),
                                name: ret.owner.name,
                                nick: ret.owner.nick,
                                cpf: ret.owner.cpf,
                                email: ret.owner.email,
                                phone: {
                                    ddd: ret.owner.phone.ddd,
                                    ddi: ret.owner.phone.ddi,
                                    number: ret.owner.phone.number
                                },
                                avatar: ret.owner.avatar === null || ret.owner.avatar === undefined ? null : {
                                    width: ret.owner.avatar.width || 0,
                                    height: ret.owner.avatar.height || 0,
                                    url: ret.owner.avatar.url
                                },
                                address: ret.owner.address === null || ret.owner.address === undefined ? null : {
                                    street: ret.owner.address.street,
                                    neighborhood: ret.owner.address.neighborhood,
                                    city: ret.owner.address.city,
                                    uf: ret.owner.address.uf,
                                    country: ret.owner.address.country,
                                    number: ret.owner.address.number,
                                    zip: ret.owner.address.zip,
                                    adicionalInfo: ret.owner.address.adicionalInfo,
                                    reference: ret.owner.address.reference,
                                    location: {
                                        lat: ret.owner.address.location.lat,
                                        lon: ret.owner.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.owner.createdAt + "Z"),
                                deletedAt: ret.owner.deletedAt === null || ret.owner.deletedAt === undefined ? null : new Date(ret.owner.deletedAt + "Z")
                            },
                            requester: {
                                id: ret.requester.id,
                                gender: ret.requester.gender === null || ret.requester.gender === undefined ? null : ret.requester.gender,
                                birthday: ret.requester.birthday === null || ret.requester.birthday === undefined ? null : new Date(parseInt(ret.requester.birthday.split("-")[0], 10), parseInt(ret.requester.birthday.split("-")[1], 10) - 1, parseInt(ret.requester.birthday.split("-")[2], 10)),
                                name: ret.requester.name,
                                nick: ret.requester.nick,
                                cpf: ret.requester.cpf,
                                email: ret.requester.email,
                                phone: {
                                    ddd: ret.requester.phone.ddd,
                                    ddi: ret.requester.phone.ddi,
                                    number: ret.requester.phone.number
                                },
                                avatar: ret.requester.avatar === null || ret.requester.avatar === undefined ? null : {
                                    width: ret.requester.avatar.width || 0,
                                    height: ret.requester.avatar.height || 0,
                                    url: ret.requester.avatar.url
                                },
                                address: ret.requester.address === null || ret.requester.address === undefined ? null : {
                                    street: ret.requester.address.street,
                                    neighborhood: ret.requester.address.neighborhood,
                                    city: ret.requester.address.city,
                                    uf: ret.requester.address.uf,
                                    country: ret.requester.address.country,
                                    number: ret.requester.address.number,
                                    zip: ret.requester.address.zip,
                                    adicionalInfo: ret.requester.address.adicionalInfo,
                                    reference: ret.requester.address.reference,
                                    location: {
                                        lat: ret.requester.address.location.lat,
                                        lon: ret.requester.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.requester.createdAt + "Z"),
                                deletedAt: ret.requester.deletedAt === null || ret.requester.deletedAt === undefined ? null : new Date(ret.requester.deletedAt + "Z")
                            },
                            item: {
                                thumbImage: {
                                    width: ret.item.thumbImage.width || 0,
                                    height: ret.item.thumbImage.height || 0,
                                    url: ret.item.thumbImage.url
                                },
                                calendar: ret.item.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                adjustment: !!ret.item.adjustment,
                                category: ret.item.category,
                                color: ret.item.color,
                                details: ret.item.details,
                                gender: ret.item.gender,
                                images: ret.item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: ret.item.brand === null || ret.item.brand === undefined ? null : ret.item.brand,
                                ocasions: ret.item.ocasions.map(function (e) {
                                    return e;
                                }),
                                size: ret.item.size,
                                salePrice: ret.item.salePrice === null || ret.item.salePrice === undefined ? null : ret.item.salePrice || 0,
                                rentPrice: ret.item.rentPrice === null || ret.item.rentPrice === undefined ? null : ret.item.rentPrice || 0,
                                originalPrice: ret.item.originalPrice || 0
                            },
                            transport: ret.transport === null || ret.transport === undefined ? null : {
                                requester: {
                                    street: ret.transport.requester.street,
                                    neighborhood: ret.transport.requester.neighborhood,
                                    city: ret.transport.requester.city,
                                    uf: ret.transport.requester.uf,
                                    country: ret.transport.requester.country,
                                    number: ret.transport.requester.number,
                                    zip: ret.transport.requester.zip,
                                    adicionalInfo: ret.transport.requester.adicionalInfo,
                                    reference: ret.transport.requester.reference,
                                    location: {
                                        lat: ret.transport.requester.location.lat,
                                        lon: ret.transport.requester.location.lon
                                    }
                                },
                                owner: {
                                    street: ret.transport.owner.street,
                                    neighborhood: ret.transport.owner.neighborhood,
                                    city: ret.transport.owner.city,
                                    uf: ret.transport.owner.uf,
                                    country: ret.transport.owner.country,
                                    number: ret.transport.owner.number,
                                    zip: ret.transport.owner.zip,
                                    adicionalInfo: ret.transport.owner.adicionalInfo,
                                    reference: ret.transport.owner.reference,
                                    location: {
                                        lat: ret.transport.owner.location.lat,
                                        lon: ret.transport.owner.location.lon
                                    }
                                },
                                price: ret.transport.price || 0
                            },
                            period: {
                                start: new Date(parseInt(ret.period.start.split("-")[0], 10), parseInt(ret.period.start.split("-")[1], 10) - 1, parseInt(ret.period.start.split("-")[2], 10)),
                                end: new Date(parseInt(ret.period.end.split("-")[0], 10), parseInt(ret.period.end.split("-")[1], 10) - 1, parseInt(ret.period.end.split("-")[2], 10))
                            },
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            statusList: ret.statusList.map(function (e) {
                                return {
                                    status: e.status,
                                    changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                    actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                    pending: !!e.pending
                                };
                            }),
                            currentStatus: {
                                status: ret.currentStatus.status,
                                changeDate: new Date(parseInt(ret.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.currentStatus.changeDate.split("-")[2], 10)),
                                actionBy: ret.currentStatus.actionBy === null || ret.currentStatus.actionBy === undefined ? null : ret.currentStatus.actionBy,
                                pending: !!ret.currentStatus.pending
                            },
                            payment: ret.payment === null || ret.payment === undefined ? null : {
                                transactionId: ret.payment.transactionId || 0,
                                lastDigits: ret.payment.lastDigits,
                                brand: ret.payment.brand,
                                paidAmount: ret.payment.paidAmount || 0,
                                status: ret.payment.status,
                                locSplit: {
                                    id: ret.payment.locSplit.id,
                                    recipientId: ret.payment.locSplit.recipientId,
                                    amount: ret.payment.locSplit.amount || 0
                                },
                                ownerSplit: {
                                    id: ret.payment.ownerSplit.id,
                                    recipientId: ret.payment.ownerSplit.recipientId,
                                    amount: ret.payment.ownerSplit.amount || 0
                                }
                            },
                            promotion: {
                                card: ret.promotion.card === null || ret.promotion.card === undefined ? null : {
                                    transactionId: ret.promotion.card.transactionId || 0,
                                    lastDigits: ret.promotion.card.lastDigits,
                                    brand: ret.promotion.card.brand,
                                    paidAmount: ret.promotion.card.paidAmount || 0,
                                    status: ret.promotion.card.status,
                                    locSplit: {
                                        id: ret.promotion.card.locSplit.id,
                                        recipientId: ret.promotion.card.locSplit.recipientId,
                                        amount: ret.promotion.card.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: ret.promotion.card.ownerSplit.id,
                                        recipientId: ret.promotion.card.ownerSplit.recipientId,
                                        amount: ret.promotion.card.ownerSplit.amount || 0
                                    }
                                },
                                type: ret.promotion.type === null || ret.promotion.type === undefined ? null : ret.promotion.type,
                                total: ret.promotion.total || 0,
                                id: ret.promotion.id === null || ret.promotion.id === undefined ? null : ret.promotion.id
                            },
                            nfe: {
                                id: ret.nfe.id === null || ret.nfe.id === undefined ? null : ret.nfe.id,
                                number: ret.nfe.number === null || ret.nfe.number === undefined ? null : ret.nfe.number || 0,
                                emitedAt: ret.nfe.emitedAt === null || ret.nfe.emitedAt === undefined ? null : new Date(ret.nfe.emitedAt + "Z"),
                                canceledAt: ret.nfe.canceledAt === null || ret.nfe.canceledAt === undefined ? null : new Date(ret.nfe.canceledAt + "Z"),
                                status: ret.nfe.status === null || ret.nfe.status === undefined ? null : ret.nfe.status
                            },
                            createdAt: new Date(ret.createdAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context53.stop();
                }
            }
        }, _callee53, this);
    }));

    return function getRequest(_x125, _x126) {
        return _ref53.apply(this, arguments);
    };
}();

var getRequests = function () {
    var _ref54 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee54(page, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee54$(_context54) {
            while (1) {
                switch (_context54.prev = _context54.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0,
                            filter: filter === null || filter === undefined ? null : {
                                startRentDate: filter.startRentDate === null || filter.startRentDate === undefined ? null : {
                                    startDate: filter.startRentDate.startDate === null || filter.startRentDate.startDate === undefined ? null : typeof filter.startRentDate.startDate === "string" ? new Date(new Date(filter.startRentDate.startDate).getTime() - new Date(filter.startRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.startDate.getTime() - filter.startRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.startRentDate.endDate === null || filter.startRentDate.endDate === undefined ? null : typeof filter.startRentDate.endDate === "string" ? new Date(new Date(filter.startRentDate.endDate).getTime() - new Date(filter.startRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.endDate.getTime() - filter.startRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                endRentDate: filter.endRentDate === null || filter.endRentDate === undefined ? null : {
                                    startDate: filter.endRentDate.startDate === null || filter.endRentDate.startDate === undefined ? null : typeof filter.endRentDate.startDate === "string" ? new Date(new Date(filter.endRentDate.startDate).getTime() - new Date(filter.endRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.startDate.getTime() - filter.endRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.endRentDate.endDate === null || filter.endRentDate.endDate === undefined ? null : typeof filter.endRentDate.endDate === "string" ? new Date(new Date(filter.endRentDate.endDate).getTime() - new Date(filter.endRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.endDate.getTime() - filter.endRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                createdAtRentDate: filter.createdAtRentDate === null || filter.createdAtRentDate === undefined ? null : {
                                    startDate: filter.createdAtRentDate.startDate === null || filter.createdAtRentDate.startDate === undefined ? null : typeof filter.createdAtRentDate.startDate === "string" ? new Date(new Date(filter.createdAtRentDate.startDate).getTime() - new Date(filter.createdAtRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.startDate.getTime() - filter.createdAtRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtRentDate.endDate === null || filter.createdAtRentDate.endDate === undefined ? null : typeof filter.createdAtRentDate.endDate === "string" ? new Date(new Date(filter.createdAtRentDate.endDate).getTime() - new Date(filter.createdAtRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.endDate.getTime() - filter.createdAtRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context54.next = 3;
                        return makeRequest({ name: "getRequests", args: args, progress: progress });

                    case 3:
                        ret = _context54.sent;
                        return _context54.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                numId: e.numId,
                                owner: {
                                    id: e.owner.id,
                                    gender: e.owner.gender === null || e.owner.gender === undefined ? null : e.owner.gender,
                                    birthday: e.owner.birthday === null || e.owner.birthday === undefined ? null : new Date(parseInt(e.owner.birthday.split("-")[0], 10), parseInt(e.owner.birthday.split("-")[1], 10) - 1, parseInt(e.owner.birthday.split("-")[2], 10)),
                                    name: e.owner.name,
                                    nick: e.owner.nick,
                                    cpf: e.owner.cpf,
                                    email: e.owner.email,
                                    phone: {
                                        ddd: e.owner.phone.ddd,
                                        ddi: e.owner.phone.ddi,
                                        number: e.owner.phone.number
                                    },
                                    avatar: e.owner.avatar === null || e.owner.avatar === undefined ? null : {
                                        width: e.owner.avatar.width || 0,
                                        height: e.owner.avatar.height || 0,
                                        url: e.owner.avatar.url
                                    },
                                    address: e.owner.address === null || e.owner.address === undefined ? null : {
                                        street: e.owner.address.street,
                                        neighborhood: e.owner.address.neighborhood,
                                        city: e.owner.address.city,
                                        uf: e.owner.address.uf,
                                        country: e.owner.address.country,
                                        number: e.owner.address.number,
                                        zip: e.owner.address.zip,
                                        adicionalInfo: e.owner.address.adicionalInfo,
                                        reference: e.owner.address.reference,
                                        location: {
                                            lat: e.owner.address.location.lat,
                                            lon: e.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.owner.createdAt + "Z"),
                                    deletedAt: e.owner.deletedAt === null || e.owner.deletedAt === undefined ? null : new Date(e.owner.deletedAt + "Z")
                                },
                                requester: {
                                    id: e.requester.id,
                                    gender: e.requester.gender === null || e.requester.gender === undefined ? null : e.requester.gender,
                                    birthday: e.requester.birthday === null || e.requester.birthday === undefined ? null : new Date(parseInt(e.requester.birthday.split("-")[0], 10), parseInt(e.requester.birthday.split("-")[1], 10) - 1, parseInt(e.requester.birthday.split("-")[2], 10)),
                                    name: e.requester.name,
                                    nick: e.requester.nick,
                                    cpf: e.requester.cpf,
                                    email: e.requester.email,
                                    phone: {
                                        ddd: e.requester.phone.ddd,
                                        ddi: e.requester.phone.ddi,
                                        number: e.requester.phone.number
                                    },
                                    avatar: e.requester.avatar === null || e.requester.avatar === undefined ? null : {
                                        width: e.requester.avatar.width || 0,
                                        height: e.requester.avatar.height || 0,
                                        url: e.requester.avatar.url
                                    },
                                    address: e.requester.address === null || e.requester.address === undefined ? null : {
                                        street: e.requester.address.street,
                                        neighborhood: e.requester.address.neighborhood,
                                        city: e.requester.address.city,
                                        uf: e.requester.address.uf,
                                        country: e.requester.address.country,
                                        number: e.requester.address.number,
                                        zip: e.requester.address.zip,
                                        adicionalInfo: e.requester.address.adicionalInfo,
                                        reference: e.requester.address.reference,
                                        location: {
                                            lat: e.requester.address.location.lat,
                                            lon: e.requester.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.requester.createdAt + "Z"),
                                    deletedAt: e.requester.deletedAt === null || e.requester.deletedAt === undefined ? null : new Date(e.requester.deletedAt + "Z")
                                },
                                item: {
                                    thumbImage: {
                                        width: e.item.thumbImage.width || 0,
                                        height: e.item.thumbImage.height || 0,
                                        url: e.item.thumbImage.url
                                    },
                                    calendar: e.item.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    adjustment: !!e.item.adjustment,
                                    category: e.item.category,
                                    color: e.item.color,
                                    details: e.item.details,
                                    gender: e.item.gender,
                                    images: e.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.item.brand === null || e.item.brand === undefined ? null : e.item.brand,
                                    ocasions: e.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    size: e.item.size,
                                    salePrice: e.item.salePrice === null || e.item.salePrice === undefined ? null : e.item.salePrice || 0,
                                    rentPrice: e.item.rentPrice === null || e.item.rentPrice === undefined ? null : e.item.rentPrice || 0,
                                    originalPrice: e.item.originalPrice || 0
                                },
                                transport: e.transport === null || e.transport === undefined ? null : {
                                    requester: {
                                        street: e.transport.requester.street,
                                        neighborhood: e.transport.requester.neighborhood,
                                        city: e.transport.requester.city,
                                        uf: e.transport.requester.uf,
                                        country: e.transport.requester.country,
                                        number: e.transport.requester.number,
                                        zip: e.transport.requester.zip,
                                        adicionalInfo: e.transport.requester.adicionalInfo,
                                        reference: e.transport.requester.reference,
                                        location: {
                                            lat: e.transport.requester.location.lat,
                                            lon: e.transport.requester.location.lon
                                        }
                                    },
                                    owner: {
                                        street: e.transport.owner.street,
                                        neighborhood: e.transport.owner.neighborhood,
                                        city: e.transport.owner.city,
                                        uf: e.transport.owner.uf,
                                        country: e.transport.owner.country,
                                        number: e.transport.owner.number,
                                        zip: e.transport.owner.zip,
                                        adicionalInfo: e.transport.owner.adicionalInfo,
                                        reference: e.transport.owner.reference,
                                        location: {
                                            lat: e.transport.owner.location.lat,
                                            lon: e.transport.owner.location.lon
                                        }
                                    },
                                    price: e.transport.price || 0
                                },
                                period: {
                                    start: new Date(parseInt(e.period.start.split("-")[0], 10), parseInt(e.period.start.split("-")[1], 10) - 1, parseInt(e.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.period.end.split("-")[0], 10), parseInt(e.period.end.split("-")[1], 10) - 1, parseInt(e.period.end.split("-")[2], 10))
                                },
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                statusList: e.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: e.currentStatus.status,
                                    changeDate: new Date(parseInt(e.currentStatus.changeDate.split("-")[0], 10), parseInt(e.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: e.currentStatus.actionBy === null || e.currentStatus.actionBy === undefined ? null : e.currentStatus.actionBy,
                                    pending: !!e.currentStatus.pending
                                },
                                payment: e.payment === null || e.payment === undefined ? null : {
                                    transactionId: e.payment.transactionId || 0,
                                    lastDigits: e.payment.lastDigits,
                                    brand: e.payment.brand,
                                    paidAmount: e.payment.paidAmount || 0,
                                    status: e.payment.status,
                                    locSplit: {
                                        id: e.payment.locSplit.id,
                                        recipientId: e.payment.locSplit.recipientId,
                                        amount: e.payment.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: e.payment.ownerSplit.id,
                                        recipientId: e.payment.ownerSplit.recipientId,
                                        amount: e.payment.ownerSplit.amount || 0
                                    }
                                },
                                promotion: {
                                    card: e.promotion.card === null || e.promotion.card === undefined ? null : {
                                        transactionId: e.promotion.card.transactionId || 0,
                                        lastDigits: e.promotion.card.lastDigits,
                                        brand: e.promotion.card.brand,
                                        paidAmount: e.promotion.card.paidAmount || 0,
                                        status: e.promotion.card.status,
                                        locSplit: {
                                            id: e.promotion.card.locSplit.id,
                                            recipientId: e.promotion.card.locSplit.recipientId,
                                            amount: e.promotion.card.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: e.promotion.card.ownerSplit.id,
                                            recipientId: e.promotion.card.ownerSplit.recipientId,
                                            amount: e.promotion.card.ownerSplit.amount || 0
                                        }
                                    },
                                    type: e.promotion.type === null || e.promotion.type === undefined ? null : e.promotion.type,
                                    total: e.promotion.total || 0,
                                    id: e.promotion.id === null || e.promotion.id === undefined ? null : e.promotion.id
                                },
                                nfe: {
                                    id: e.nfe.id === null || e.nfe.id === undefined ? null : e.nfe.id,
                                    number: e.nfe.number === null || e.nfe.number === undefined ? null : e.nfe.number || 0,
                                    emitedAt: e.nfe.emitedAt === null || e.nfe.emitedAt === undefined ? null : new Date(e.nfe.emitedAt + "Z"),
                                    canceledAt: e.nfe.canceledAt === null || e.nfe.canceledAt === undefined ? null : new Date(e.nfe.canceledAt + "Z"),
                                    status: e.nfe.status === null || e.nfe.status === undefined ? null : e.nfe.status
                                },
                                createdAt: new Date(e.createdAt + "Z")
                            };
                        }));

                    case 5:
                    case "end":
                        return _context54.stop();
                }
            }
        }, _callee54, this);
    }));

    return function getRequests(_x127, _x128, _x129) {
        return _ref54.apply(this, arguments);
    };
}();

var changeDatesRequest = function () {
    var _ref55 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee55(requestId, period, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee55$(_context55) {
            while (1) {
                switch (_context55.prev = _context55.next) {
                    case 0:
                        args = {
                            requestId: requestId,
                            period: {
                                start: typeof period.start === "string" ? new Date(new Date(period.start).getTime() - new Date(period.start).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(period.start.getTime() - period.start.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                end: typeof period.end === "string" ? new Date(new Date(period.end).getTime() - new Date(period.end).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(period.end.getTime() - period.end.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                            }
                        };
                        _context55.next = 3;
                        return makeRequest({ name: "changeDatesRequest", args: args, progress: progress });

                    case 3:
                        ret = _context55.sent;
                        return _context55.abrupt("return", {
                            id: ret.id,
                            numId: ret.numId,
                            owner: {
                                id: ret.owner.id,
                                gender: ret.owner.gender === null || ret.owner.gender === undefined ? null : ret.owner.gender,
                                birthday: ret.owner.birthday === null || ret.owner.birthday === undefined ? null : new Date(parseInt(ret.owner.birthday.split("-")[0], 10), parseInt(ret.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.owner.birthday.split("-")[2], 10)),
                                name: ret.owner.name,
                                nick: ret.owner.nick,
                                cpf: ret.owner.cpf,
                                email: ret.owner.email,
                                phone: {
                                    ddd: ret.owner.phone.ddd,
                                    ddi: ret.owner.phone.ddi,
                                    number: ret.owner.phone.number
                                },
                                avatar: ret.owner.avatar === null || ret.owner.avatar === undefined ? null : {
                                    width: ret.owner.avatar.width || 0,
                                    height: ret.owner.avatar.height || 0,
                                    url: ret.owner.avatar.url
                                },
                                address: ret.owner.address === null || ret.owner.address === undefined ? null : {
                                    street: ret.owner.address.street,
                                    neighborhood: ret.owner.address.neighborhood,
                                    city: ret.owner.address.city,
                                    uf: ret.owner.address.uf,
                                    country: ret.owner.address.country,
                                    number: ret.owner.address.number,
                                    zip: ret.owner.address.zip,
                                    adicionalInfo: ret.owner.address.adicionalInfo,
                                    reference: ret.owner.address.reference,
                                    location: {
                                        lat: ret.owner.address.location.lat,
                                        lon: ret.owner.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.owner.createdAt + "Z"),
                                deletedAt: ret.owner.deletedAt === null || ret.owner.deletedAt === undefined ? null : new Date(ret.owner.deletedAt + "Z")
                            },
                            requester: {
                                id: ret.requester.id,
                                gender: ret.requester.gender === null || ret.requester.gender === undefined ? null : ret.requester.gender,
                                birthday: ret.requester.birthday === null || ret.requester.birthday === undefined ? null : new Date(parseInt(ret.requester.birthday.split("-")[0], 10), parseInt(ret.requester.birthday.split("-")[1], 10) - 1, parseInt(ret.requester.birthday.split("-")[2], 10)),
                                name: ret.requester.name,
                                nick: ret.requester.nick,
                                cpf: ret.requester.cpf,
                                email: ret.requester.email,
                                phone: {
                                    ddd: ret.requester.phone.ddd,
                                    ddi: ret.requester.phone.ddi,
                                    number: ret.requester.phone.number
                                },
                                avatar: ret.requester.avatar === null || ret.requester.avatar === undefined ? null : {
                                    width: ret.requester.avatar.width || 0,
                                    height: ret.requester.avatar.height || 0,
                                    url: ret.requester.avatar.url
                                },
                                address: ret.requester.address === null || ret.requester.address === undefined ? null : {
                                    street: ret.requester.address.street,
                                    neighborhood: ret.requester.address.neighborhood,
                                    city: ret.requester.address.city,
                                    uf: ret.requester.address.uf,
                                    country: ret.requester.address.country,
                                    number: ret.requester.address.number,
                                    zip: ret.requester.address.zip,
                                    adicionalInfo: ret.requester.address.adicionalInfo,
                                    reference: ret.requester.address.reference,
                                    location: {
                                        lat: ret.requester.address.location.lat,
                                        lon: ret.requester.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.requester.createdAt + "Z"),
                                deletedAt: ret.requester.deletedAt === null || ret.requester.deletedAt === undefined ? null : new Date(ret.requester.deletedAt + "Z")
                            },
                            item: {
                                thumbImage: {
                                    width: ret.item.thumbImage.width || 0,
                                    height: ret.item.thumbImage.height || 0,
                                    url: ret.item.thumbImage.url
                                },
                                calendar: ret.item.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                adjustment: !!ret.item.adjustment,
                                category: ret.item.category,
                                color: ret.item.color,
                                details: ret.item.details,
                                gender: ret.item.gender,
                                images: ret.item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: ret.item.brand === null || ret.item.brand === undefined ? null : ret.item.brand,
                                ocasions: ret.item.ocasions.map(function (e) {
                                    return e;
                                }),
                                size: ret.item.size,
                                salePrice: ret.item.salePrice === null || ret.item.salePrice === undefined ? null : ret.item.salePrice || 0,
                                rentPrice: ret.item.rentPrice === null || ret.item.rentPrice === undefined ? null : ret.item.rentPrice || 0,
                                originalPrice: ret.item.originalPrice || 0
                            },
                            transport: ret.transport === null || ret.transport === undefined ? null : {
                                requester: {
                                    street: ret.transport.requester.street,
                                    neighborhood: ret.transport.requester.neighborhood,
                                    city: ret.transport.requester.city,
                                    uf: ret.transport.requester.uf,
                                    country: ret.transport.requester.country,
                                    number: ret.transport.requester.number,
                                    zip: ret.transport.requester.zip,
                                    adicionalInfo: ret.transport.requester.adicionalInfo,
                                    reference: ret.transport.requester.reference,
                                    location: {
                                        lat: ret.transport.requester.location.lat,
                                        lon: ret.transport.requester.location.lon
                                    }
                                },
                                owner: {
                                    street: ret.transport.owner.street,
                                    neighborhood: ret.transport.owner.neighborhood,
                                    city: ret.transport.owner.city,
                                    uf: ret.transport.owner.uf,
                                    country: ret.transport.owner.country,
                                    number: ret.transport.owner.number,
                                    zip: ret.transport.owner.zip,
                                    adicionalInfo: ret.transport.owner.adicionalInfo,
                                    reference: ret.transport.owner.reference,
                                    location: {
                                        lat: ret.transport.owner.location.lat,
                                        lon: ret.transport.owner.location.lon
                                    }
                                },
                                price: ret.transport.price || 0
                            },
                            period: {
                                start: new Date(parseInt(ret.period.start.split("-")[0], 10), parseInt(ret.period.start.split("-")[1], 10) - 1, parseInt(ret.period.start.split("-")[2], 10)),
                                end: new Date(parseInt(ret.period.end.split("-")[0], 10), parseInt(ret.period.end.split("-")[1], 10) - 1, parseInt(ret.period.end.split("-")[2], 10))
                            },
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            statusList: ret.statusList.map(function (e) {
                                return {
                                    status: e.status,
                                    changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                    actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                    pending: !!e.pending
                                };
                            }),
                            currentStatus: {
                                status: ret.currentStatus.status,
                                changeDate: new Date(parseInt(ret.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.currentStatus.changeDate.split("-")[2], 10)),
                                actionBy: ret.currentStatus.actionBy === null || ret.currentStatus.actionBy === undefined ? null : ret.currentStatus.actionBy,
                                pending: !!ret.currentStatus.pending
                            },
                            payment: ret.payment === null || ret.payment === undefined ? null : {
                                transactionId: ret.payment.transactionId || 0,
                                lastDigits: ret.payment.lastDigits,
                                brand: ret.payment.brand,
                                paidAmount: ret.payment.paidAmount || 0,
                                status: ret.payment.status,
                                locSplit: {
                                    id: ret.payment.locSplit.id,
                                    recipientId: ret.payment.locSplit.recipientId,
                                    amount: ret.payment.locSplit.amount || 0
                                },
                                ownerSplit: {
                                    id: ret.payment.ownerSplit.id,
                                    recipientId: ret.payment.ownerSplit.recipientId,
                                    amount: ret.payment.ownerSplit.amount || 0
                                }
                            },
                            promotion: {
                                card: ret.promotion.card === null || ret.promotion.card === undefined ? null : {
                                    transactionId: ret.promotion.card.transactionId || 0,
                                    lastDigits: ret.promotion.card.lastDigits,
                                    brand: ret.promotion.card.brand,
                                    paidAmount: ret.promotion.card.paidAmount || 0,
                                    status: ret.promotion.card.status,
                                    locSplit: {
                                        id: ret.promotion.card.locSplit.id,
                                        recipientId: ret.promotion.card.locSplit.recipientId,
                                        amount: ret.promotion.card.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: ret.promotion.card.ownerSplit.id,
                                        recipientId: ret.promotion.card.ownerSplit.recipientId,
                                        amount: ret.promotion.card.ownerSplit.amount || 0
                                    }
                                },
                                type: ret.promotion.type === null || ret.promotion.type === undefined ? null : ret.promotion.type,
                                total: ret.promotion.total || 0,
                                id: ret.promotion.id === null || ret.promotion.id === undefined ? null : ret.promotion.id
                            },
                            nfe: {
                                id: ret.nfe.id === null || ret.nfe.id === undefined ? null : ret.nfe.id,
                                number: ret.nfe.number === null || ret.nfe.number === undefined ? null : ret.nfe.number || 0,
                                emitedAt: ret.nfe.emitedAt === null || ret.nfe.emitedAt === undefined ? null : new Date(ret.nfe.emitedAt + "Z"),
                                canceledAt: ret.nfe.canceledAt === null || ret.nfe.canceledAt === undefined ? null : new Date(ret.nfe.canceledAt + "Z"),
                                status: ret.nfe.status === null || ret.nfe.status === undefined ? null : ret.nfe.status
                            },
                            createdAt: new Date(ret.createdAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context55.stop();
                }
            }
        }, _callee55, this);
    }));

    return function changeDatesRequest(_x130, _x131, _x132) {
        return _ref55.apply(this, arguments);
    };
}();

var cancelRequest = function () {
    var _ref56 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee56(requestId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee56$(_context56) {
            while (1) {
                switch (_context56.prev = _context56.next) {
                    case 0:
                        args = {
                            requestId: requestId
                        };
                        _context56.next = 3;
                        return makeRequest({ name: "cancelRequest", args: args, progress: progress });

                    case 3:
                        ret = _context56.sent;
                        return _context56.abrupt("return", {
                            id: ret.id,
                            numId: ret.numId,
                            owner: {
                                id: ret.owner.id,
                                gender: ret.owner.gender === null || ret.owner.gender === undefined ? null : ret.owner.gender,
                                birthday: ret.owner.birthday === null || ret.owner.birthday === undefined ? null : new Date(parseInt(ret.owner.birthday.split("-")[0], 10), parseInt(ret.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.owner.birthday.split("-")[2], 10)),
                                name: ret.owner.name,
                                nick: ret.owner.nick,
                                cpf: ret.owner.cpf,
                                email: ret.owner.email,
                                phone: {
                                    ddd: ret.owner.phone.ddd,
                                    ddi: ret.owner.phone.ddi,
                                    number: ret.owner.phone.number
                                },
                                avatar: ret.owner.avatar === null || ret.owner.avatar === undefined ? null : {
                                    width: ret.owner.avatar.width || 0,
                                    height: ret.owner.avatar.height || 0,
                                    url: ret.owner.avatar.url
                                },
                                address: ret.owner.address === null || ret.owner.address === undefined ? null : {
                                    street: ret.owner.address.street,
                                    neighborhood: ret.owner.address.neighborhood,
                                    city: ret.owner.address.city,
                                    uf: ret.owner.address.uf,
                                    country: ret.owner.address.country,
                                    number: ret.owner.address.number,
                                    zip: ret.owner.address.zip,
                                    adicionalInfo: ret.owner.address.adicionalInfo,
                                    reference: ret.owner.address.reference,
                                    location: {
                                        lat: ret.owner.address.location.lat,
                                        lon: ret.owner.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.owner.createdAt + "Z"),
                                deletedAt: ret.owner.deletedAt === null || ret.owner.deletedAt === undefined ? null : new Date(ret.owner.deletedAt + "Z")
                            },
                            requester: {
                                id: ret.requester.id,
                                gender: ret.requester.gender === null || ret.requester.gender === undefined ? null : ret.requester.gender,
                                birthday: ret.requester.birthday === null || ret.requester.birthday === undefined ? null : new Date(parseInt(ret.requester.birthday.split("-")[0], 10), parseInt(ret.requester.birthday.split("-")[1], 10) - 1, parseInt(ret.requester.birthday.split("-")[2], 10)),
                                name: ret.requester.name,
                                nick: ret.requester.nick,
                                cpf: ret.requester.cpf,
                                email: ret.requester.email,
                                phone: {
                                    ddd: ret.requester.phone.ddd,
                                    ddi: ret.requester.phone.ddi,
                                    number: ret.requester.phone.number
                                },
                                avatar: ret.requester.avatar === null || ret.requester.avatar === undefined ? null : {
                                    width: ret.requester.avatar.width || 0,
                                    height: ret.requester.avatar.height || 0,
                                    url: ret.requester.avatar.url
                                },
                                address: ret.requester.address === null || ret.requester.address === undefined ? null : {
                                    street: ret.requester.address.street,
                                    neighborhood: ret.requester.address.neighborhood,
                                    city: ret.requester.address.city,
                                    uf: ret.requester.address.uf,
                                    country: ret.requester.address.country,
                                    number: ret.requester.address.number,
                                    zip: ret.requester.address.zip,
                                    adicionalInfo: ret.requester.address.adicionalInfo,
                                    reference: ret.requester.address.reference,
                                    location: {
                                        lat: ret.requester.address.location.lat,
                                        lon: ret.requester.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.requester.createdAt + "Z"),
                                deletedAt: ret.requester.deletedAt === null || ret.requester.deletedAt === undefined ? null : new Date(ret.requester.deletedAt + "Z")
                            },
                            item: {
                                thumbImage: {
                                    width: ret.item.thumbImage.width || 0,
                                    height: ret.item.thumbImage.height || 0,
                                    url: ret.item.thumbImage.url
                                },
                                calendar: ret.item.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                adjustment: !!ret.item.adjustment,
                                category: ret.item.category,
                                color: ret.item.color,
                                details: ret.item.details,
                                gender: ret.item.gender,
                                images: ret.item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: ret.item.brand === null || ret.item.brand === undefined ? null : ret.item.brand,
                                ocasions: ret.item.ocasions.map(function (e) {
                                    return e;
                                }),
                                size: ret.item.size,
                                salePrice: ret.item.salePrice === null || ret.item.salePrice === undefined ? null : ret.item.salePrice || 0,
                                rentPrice: ret.item.rentPrice === null || ret.item.rentPrice === undefined ? null : ret.item.rentPrice || 0,
                                originalPrice: ret.item.originalPrice || 0
                            },
                            transport: ret.transport === null || ret.transport === undefined ? null : {
                                requester: {
                                    street: ret.transport.requester.street,
                                    neighborhood: ret.transport.requester.neighborhood,
                                    city: ret.transport.requester.city,
                                    uf: ret.transport.requester.uf,
                                    country: ret.transport.requester.country,
                                    number: ret.transport.requester.number,
                                    zip: ret.transport.requester.zip,
                                    adicionalInfo: ret.transport.requester.adicionalInfo,
                                    reference: ret.transport.requester.reference,
                                    location: {
                                        lat: ret.transport.requester.location.lat,
                                        lon: ret.transport.requester.location.lon
                                    }
                                },
                                owner: {
                                    street: ret.transport.owner.street,
                                    neighborhood: ret.transport.owner.neighborhood,
                                    city: ret.transport.owner.city,
                                    uf: ret.transport.owner.uf,
                                    country: ret.transport.owner.country,
                                    number: ret.transport.owner.number,
                                    zip: ret.transport.owner.zip,
                                    adicionalInfo: ret.transport.owner.adicionalInfo,
                                    reference: ret.transport.owner.reference,
                                    location: {
                                        lat: ret.transport.owner.location.lat,
                                        lon: ret.transport.owner.location.lon
                                    }
                                },
                                price: ret.transport.price || 0
                            },
                            period: {
                                start: new Date(parseInt(ret.period.start.split("-")[0], 10), parseInt(ret.period.start.split("-")[1], 10) - 1, parseInt(ret.period.start.split("-")[2], 10)),
                                end: new Date(parseInt(ret.period.end.split("-")[0], 10), parseInt(ret.period.end.split("-")[1], 10) - 1, parseInt(ret.period.end.split("-")[2], 10))
                            },
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            statusList: ret.statusList.map(function (e) {
                                return {
                                    status: e.status,
                                    changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                    actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                    pending: !!e.pending
                                };
                            }),
                            currentStatus: {
                                status: ret.currentStatus.status,
                                changeDate: new Date(parseInt(ret.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.currentStatus.changeDate.split("-")[2], 10)),
                                actionBy: ret.currentStatus.actionBy === null || ret.currentStatus.actionBy === undefined ? null : ret.currentStatus.actionBy,
                                pending: !!ret.currentStatus.pending
                            },
                            payment: ret.payment === null || ret.payment === undefined ? null : {
                                transactionId: ret.payment.transactionId || 0,
                                lastDigits: ret.payment.lastDigits,
                                brand: ret.payment.brand,
                                paidAmount: ret.payment.paidAmount || 0,
                                status: ret.payment.status,
                                locSplit: {
                                    id: ret.payment.locSplit.id,
                                    recipientId: ret.payment.locSplit.recipientId,
                                    amount: ret.payment.locSplit.amount || 0
                                },
                                ownerSplit: {
                                    id: ret.payment.ownerSplit.id,
                                    recipientId: ret.payment.ownerSplit.recipientId,
                                    amount: ret.payment.ownerSplit.amount || 0
                                }
                            },
                            promotion: {
                                card: ret.promotion.card === null || ret.promotion.card === undefined ? null : {
                                    transactionId: ret.promotion.card.transactionId || 0,
                                    lastDigits: ret.promotion.card.lastDigits,
                                    brand: ret.promotion.card.brand,
                                    paidAmount: ret.promotion.card.paidAmount || 0,
                                    status: ret.promotion.card.status,
                                    locSplit: {
                                        id: ret.promotion.card.locSplit.id,
                                        recipientId: ret.promotion.card.locSplit.recipientId,
                                        amount: ret.promotion.card.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: ret.promotion.card.ownerSplit.id,
                                        recipientId: ret.promotion.card.ownerSplit.recipientId,
                                        amount: ret.promotion.card.ownerSplit.amount || 0
                                    }
                                },
                                type: ret.promotion.type === null || ret.promotion.type === undefined ? null : ret.promotion.type,
                                total: ret.promotion.total || 0,
                                id: ret.promotion.id === null || ret.promotion.id === undefined ? null : ret.promotion.id
                            },
                            nfe: {
                                id: ret.nfe.id === null || ret.nfe.id === undefined ? null : ret.nfe.id,
                                number: ret.nfe.number === null || ret.nfe.number === undefined ? null : ret.nfe.number || 0,
                                emitedAt: ret.nfe.emitedAt === null || ret.nfe.emitedAt === undefined ? null : new Date(ret.nfe.emitedAt + "Z"),
                                canceledAt: ret.nfe.canceledAt === null || ret.nfe.canceledAt === undefined ? null : new Date(ret.nfe.canceledAt + "Z"),
                                status: ret.nfe.status === null || ret.nfe.status === undefined ? null : ret.nfe.status
                            },
                            createdAt: new Date(ret.createdAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context56.stop();
                }
            }
        }, _callee56, this);
    }));

    return function cancelRequest(_x133, _x134) {
        return _ref56.apply(this, arguments);
    };
}();

var getLocker = function () {
    var _ref57 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee57(ownerId, pagination, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee57$(_context57) {
            while (1) {
                switch (_context57.prev = _context57.next) {
                    case 0:
                        args = {
                            ownerId: ownerId === null || ownerId === undefined ? null : ownerId,
                            pagination: pagination === null || pagination === undefined ? null : {
                                pageNumber: pagination.pageNumber || 0
                            }
                        };
                        _context57.next = 3;
                        return makeRequest({ name: "getLocker", args: args, progress: progress });

                    case 3:
                        ret = _context57.sent;
                        return _context57.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                owner: {
                                    id: e.owner.id,
                                    gender: e.owner.gender === null || e.owner.gender === undefined ? null : e.owner.gender,
                                    birthday: e.owner.birthday === null || e.owner.birthday === undefined ? null : new Date(parseInt(e.owner.birthday.split("-")[0], 10), parseInt(e.owner.birthday.split("-")[1], 10) - 1, parseInt(e.owner.birthday.split("-")[2], 10)),
                                    name: e.owner.name,
                                    nick: e.owner.nick,
                                    cpf: e.owner.cpf,
                                    email: e.owner.email,
                                    phone: {
                                        ddd: e.owner.phone.ddd,
                                        ddi: e.owner.phone.ddi,
                                        number: e.owner.phone.number
                                    },
                                    avatar: e.owner.avatar === null || e.owner.avatar === undefined ? null : {
                                        width: e.owner.avatar.width || 0,
                                        height: e.owner.avatar.height || 0,
                                        url: e.owner.avatar.url
                                    },
                                    address: e.owner.address === null || e.owner.address === undefined ? null : {
                                        street: e.owner.address.street,
                                        neighborhood: e.owner.address.neighborhood,
                                        city: e.owner.address.city,
                                        uf: e.owner.address.uf,
                                        country: e.owner.address.country,
                                        number: e.owner.address.number,
                                        zip: e.owner.address.zip,
                                        adicionalInfo: e.owner.address.adicionalInfo,
                                        reference: e.owner.address.reference,
                                        location: {
                                            lat: e.owner.address.location.lat,
                                            lon: e.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.owner.createdAt + "Z"),
                                    deletedAt: e.owner.deletedAt === null || e.owner.deletedAt === undefined ? null : new Date(e.owner.deletedAt + "Z")
                                },
                                calendar: e.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                createdAt: new Date(e.createdAt + "Z"),
                                department: e.department,
                                adjustment: !!e.adjustment,
                                category: e.category === null || e.category === undefined ? null : e.category,
                                color: e.color === null || e.color === undefined ? null : e.color,
                                details: e.details,
                                gender: e.gender,
                                thumbImage: {
                                    width: e.thumbImage.width || 0,
                                    height: e.thumbImage.height || 0,
                                    url: e.thumbImage.url
                                },
                                images: e.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                ocasions: e.ocasions.map(function (e) {
                                    return e === null || e === undefined ? null : e;
                                }),
                                size: e.size === null || e.size === undefined ? null : e.size,
                                rentPrice: e.rentPrice === null || e.rentPrice === undefined ? null : e.rentPrice || 0,
                                salePrice: e.salePrice === null || e.salePrice === undefined ? null : e.salePrice || 0,
                                originalPrice: e.originalPrice || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context57.stop();
                }
            }
        }, _callee57, this);
    }));

    return function getLocker(_x135, _x136, _x137) {
        return _ref57.apply(this, arguments);
    };
}();

var editItem = function () {
    var _ref58 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee58(itemId, itemDetails, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee58$(_context58) {
            while (1) {
                switch (_context58.prev = _context58.next) {
                    case 0:
                        args = {
                            itemId: itemId,
                            itemDetails: {
                                adjustment: !!itemDetails.adjustment,
                                category: itemDetails.category,
                                color: itemDetails.color,
                                details: itemDetails.details,
                                gender: itemDetails.gender,
                                images: itemDetails.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: itemDetails.brand === null || itemDetails.brand === undefined ? null : itemDetails.brand,
                                ocasions: itemDetails.ocasions.map(function (e) {
                                    return e;
                                }),
                                size: itemDetails.size,
                                salePrice: itemDetails.salePrice === null || itemDetails.salePrice === undefined ? null : itemDetails.salePrice || 0,
                                rentPrice: itemDetails.rentPrice === null || itemDetails.rentPrice === undefined ? null : itemDetails.rentPrice || 0,
                                originalPrice: itemDetails.originalPrice || 0
                            }
                        };
                        _context58.next = 3;
                        return makeRequest({ name: "editItem", args: args, progress: progress });

                    case 3:
                        ret = _context58.sent;
                        return _context58.abrupt("return", {
                            id: ret.id,
                            owner: {
                                id: ret.owner.id,
                                gender: ret.owner.gender === null || ret.owner.gender === undefined ? null : ret.owner.gender,
                                birthday: ret.owner.birthday === null || ret.owner.birthday === undefined ? null : new Date(parseInt(ret.owner.birthday.split("-")[0], 10), parseInt(ret.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.owner.birthday.split("-")[2], 10)),
                                name: ret.owner.name,
                                nick: ret.owner.nick,
                                cpf: ret.owner.cpf,
                                email: ret.owner.email,
                                phone: {
                                    ddd: ret.owner.phone.ddd,
                                    ddi: ret.owner.phone.ddi,
                                    number: ret.owner.phone.number
                                },
                                avatar: ret.owner.avatar === null || ret.owner.avatar === undefined ? null : {
                                    width: ret.owner.avatar.width || 0,
                                    height: ret.owner.avatar.height || 0,
                                    url: ret.owner.avatar.url
                                },
                                address: ret.owner.address === null || ret.owner.address === undefined ? null : {
                                    street: ret.owner.address.street,
                                    neighborhood: ret.owner.address.neighborhood,
                                    city: ret.owner.address.city,
                                    uf: ret.owner.address.uf,
                                    country: ret.owner.address.country,
                                    number: ret.owner.address.number,
                                    zip: ret.owner.address.zip,
                                    adicionalInfo: ret.owner.address.adicionalInfo,
                                    reference: ret.owner.address.reference,
                                    location: {
                                        lat: ret.owner.address.location.lat,
                                        lon: ret.owner.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.owner.createdAt + "Z"),
                                deletedAt: ret.owner.deletedAt === null || ret.owner.deletedAt === undefined ? null : new Date(ret.owner.deletedAt + "Z")
                            },
                            calendar: ret.calendar.map(function (e) {
                                return {
                                    start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                };
                            }),
                            createdAt: new Date(ret.createdAt + "Z"),
                            department: ret.department,
                            adjustment: !!ret.adjustment,
                            category: ret.category === null || ret.category === undefined ? null : ret.category,
                            color: ret.color === null || ret.color === undefined ? null : ret.color,
                            details: ret.details,
                            gender: ret.gender,
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            images: ret.images.map(function (e) {
                                return {
                                    width: e.width || 0,
                                    height: e.height || 0,
                                    url: e.url
                                };
                            }),
                            brand: ret.brand === null || ret.brand === undefined ? null : ret.brand,
                            ocasions: ret.ocasions.map(function (e) {
                                return e === null || e === undefined ? null : e;
                            }),
                            size: ret.size === null || ret.size === undefined ? null : ret.size,
                            rentPrice: ret.rentPrice === null || ret.rentPrice === undefined ? null : ret.rentPrice || 0,
                            salePrice: ret.salePrice === null || ret.salePrice === undefined ? null : ret.salePrice || 0,
                            originalPrice: ret.originalPrice || 0
                        });

                    case 5:
                    case "end":
                        return _context58.stop();
                }
            }
        }, _callee58, this);
    }));

    return function editItem(_x138, _x139, _x140) {
        return _ref58.apply(this, arguments);
    };
}();

var deleteItem = function () {
    var _ref59 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee59(itemId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee59$(_context59) {
            while (1) {
                switch (_context59.prev = _context59.next) {
                    case 0:
                        args = {
                            itemId: itemId
                        };
                        _context59.next = 3;
                        return makeRequest({ name: "deleteItem", args: args, progress: progress });

                    case 3:
                        return _context59.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context59.stop();
                }
            }
        }, _callee59, this);
    }));

    return function deleteItem(_x141, _x142) {
        return _ref59.apply(this, arguments);
    };
}();

var sendNotification = function () {
    var _ref60 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee60(contentId, notificationType, message, userIds, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee60$(_context60) {
            while (1) {
                switch (_context60.prev = _context60.next) {
                    case 0:
                        args = {
                            contentId: contentId === null || contentId === undefined ? null : contentId,
                            notificationType: notificationType,
                            message: message,
                            userIds: userIds.map(function (e) {
                                return e;
                            })
                        };
                        _context60.next = 3;
                        return makeRequest({ name: "sendNotification", args: args, progress: progress });

                    case 3:
                        ret = _context60.sent;
                        return _context60.abrupt("return", ret || 0);

                    case 5:
                    case "end":
                        return _context60.stop();
                }
            }
        }, _callee60, this);
    }));

    return function sendNotification(_x143, _x144, _x145, _x146, _x147) {
        return _ref60.apply(this, arguments);
    };
}();

var sendNotificationToDeviceType = function () {
    var _ref61 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee61(contentId, notificationType, message, deviceType, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee61$(_context61) {
            while (1) {
                switch (_context61.prev = _context61.next) {
                    case 0:
                        args = {
                            contentId: contentId === null || contentId === undefined ? null : contentId,
                            notificationType: notificationType,
                            message: message,
                            deviceType: deviceType
                        };
                        _context61.next = 3;
                        return makeRequest({ name: "sendNotificationToDeviceType", args: args, progress: progress });

                    case 3:
                        ret = _context61.sent;
                        return _context61.abrupt("return", ret || 0);

                    case 5:
                    case "end":
                        return _context61.stop();
                }
            }
        }, _callee61, this);
    }));

    return function sendNotificationToDeviceType(_x148, _x149, _x150, _x151, _x152) {
        return _ref61.apply(this, arguments);
    };
}();

var sendReportEmail = function () {
    var _ref62 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee62(reportType, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee62$(_context62) {
            while (1) {
                switch (_context62.prev = _context62.next) {
                    case 0:
                        args = {
                            reportType: reportType
                        };
                        _context62.next = 3;
                        return makeRequest({ name: "sendReportEmail", args: args, progress: progress });

                    case 3:
                        return _context62.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context62.stop();
                }
            }
        }, _callee62, this);
    }));

    return function sendReportEmail(_x153, _x154) {
        return _ref62.apply(this, arguments);
    };
}();

var getFine = function () {
    var _ref63 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee63(fineId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee63$(_context63) {
            while (1) {
                switch (_context63.prev = _context63.next) {
                    case 0:
                        args = {
                            fineId: fineId
                        };
                        _context63.next = 3;
                        return makeRequest({ name: "getFine", args: args, progress: progress });

                    case 3:
                        ret = _context63.sent;
                        return _context63.abrupt("return", {
                            id: ret.id,
                            transactionId: ret.transactionId || 0,
                            payedBy: ret.payedBy === null || ret.payedBy === undefined ? null : {
                                id: ret.payedBy.id,
                                gender: ret.payedBy.gender === null || ret.payedBy.gender === undefined ? null : ret.payedBy.gender,
                                birthday: ret.payedBy.birthday === null || ret.payedBy.birthday === undefined ? null : new Date(parseInt(ret.payedBy.birthday.split("-")[0], 10), parseInt(ret.payedBy.birthday.split("-")[1], 10) - 1, parseInt(ret.payedBy.birthday.split("-")[2], 10)),
                                name: ret.payedBy.name,
                                nick: ret.payedBy.nick,
                                cpf: ret.payedBy.cpf,
                                email: ret.payedBy.email,
                                phone: {
                                    ddd: ret.payedBy.phone.ddd,
                                    ddi: ret.payedBy.phone.ddi,
                                    number: ret.payedBy.phone.number
                                },
                                avatar: ret.payedBy.avatar === null || ret.payedBy.avatar === undefined ? null : {
                                    width: ret.payedBy.avatar.width || 0,
                                    height: ret.payedBy.avatar.height || 0,
                                    url: ret.payedBy.avatar.url
                                },
                                address: ret.payedBy.address === null || ret.payedBy.address === undefined ? null : {
                                    street: ret.payedBy.address.street,
                                    neighborhood: ret.payedBy.address.neighborhood,
                                    city: ret.payedBy.address.city,
                                    uf: ret.payedBy.address.uf,
                                    country: ret.payedBy.address.country,
                                    number: ret.payedBy.address.number,
                                    zip: ret.payedBy.address.zip,
                                    adicionalInfo: ret.payedBy.address.adicionalInfo,
                                    reference: ret.payedBy.address.reference,
                                    location: {
                                        lat: ret.payedBy.address.location.lat,
                                        lon: ret.payedBy.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.payedBy.createdAt + "Z"),
                                deletedAt: ret.payedBy.deletedAt === null || ret.payedBy.deletedAt === undefined ? null : new Date(ret.payedBy.deletedAt + "Z")
                            },
                            payedTo: ret.payedTo === null || ret.payedTo === undefined ? null : {
                                id: ret.payedTo.id,
                                gender: ret.payedTo.gender === null || ret.payedTo.gender === undefined ? null : ret.payedTo.gender,
                                birthday: ret.payedTo.birthday === null || ret.payedTo.birthday === undefined ? null : new Date(parseInt(ret.payedTo.birthday.split("-")[0], 10), parseInt(ret.payedTo.birthday.split("-")[1], 10) - 1, parseInt(ret.payedTo.birthday.split("-")[2], 10)),
                                name: ret.payedTo.name,
                                nick: ret.payedTo.nick,
                                cpf: ret.payedTo.cpf,
                                email: ret.payedTo.email,
                                phone: {
                                    ddd: ret.payedTo.phone.ddd,
                                    ddi: ret.payedTo.phone.ddi,
                                    number: ret.payedTo.phone.number
                                },
                                avatar: ret.payedTo.avatar === null || ret.payedTo.avatar === undefined ? null : {
                                    width: ret.payedTo.avatar.width || 0,
                                    height: ret.payedTo.avatar.height || 0,
                                    url: ret.payedTo.avatar.url
                                },
                                address: ret.payedTo.address === null || ret.payedTo.address === undefined ? null : {
                                    street: ret.payedTo.address.street,
                                    neighborhood: ret.payedTo.address.neighborhood,
                                    city: ret.payedTo.address.city,
                                    uf: ret.payedTo.address.uf,
                                    country: ret.payedTo.address.country,
                                    number: ret.payedTo.address.number,
                                    zip: ret.payedTo.address.zip,
                                    adicionalInfo: ret.payedTo.address.adicionalInfo,
                                    reference: ret.payedTo.address.reference,
                                    location: {
                                        lat: ret.payedTo.address.location.lat,
                                        lon: ret.payedTo.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.payedTo.createdAt + "Z"),
                                deletedAt: ret.payedTo.deletedAt === null || ret.payedTo.deletedAt === undefined ? null : new Date(ret.payedTo.deletedAt + "Z")
                            },
                            request: ret.request === null || ret.request === undefined ? null : {
                                id: ret.request.id,
                                numId: ret.request.numId,
                                owner: {
                                    id: ret.request.owner.id,
                                    gender: ret.request.owner.gender === null || ret.request.owner.gender === undefined ? null : ret.request.owner.gender,
                                    birthday: ret.request.owner.birthday === null || ret.request.owner.birthday === undefined ? null : new Date(parseInt(ret.request.owner.birthday.split("-")[0], 10), parseInt(ret.request.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.request.owner.birthday.split("-")[2], 10)),
                                    name: ret.request.owner.name,
                                    nick: ret.request.owner.nick,
                                    cpf: ret.request.owner.cpf,
                                    email: ret.request.owner.email,
                                    phone: {
                                        ddd: ret.request.owner.phone.ddd,
                                        ddi: ret.request.owner.phone.ddi,
                                        number: ret.request.owner.phone.number
                                    },
                                    avatar: ret.request.owner.avatar === null || ret.request.owner.avatar === undefined ? null : {
                                        width: ret.request.owner.avatar.width || 0,
                                        height: ret.request.owner.avatar.height || 0,
                                        url: ret.request.owner.avatar.url
                                    },
                                    address: ret.request.owner.address === null || ret.request.owner.address === undefined ? null : {
                                        street: ret.request.owner.address.street,
                                        neighborhood: ret.request.owner.address.neighborhood,
                                        city: ret.request.owner.address.city,
                                        uf: ret.request.owner.address.uf,
                                        country: ret.request.owner.address.country,
                                        number: ret.request.owner.address.number,
                                        zip: ret.request.owner.address.zip,
                                        adicionalInfo: ret.request.owner.address.adicionalInfo,
                                        reference: ret.request.owner.address.reference,
                                        location: {
                                            lat: ret.request.owner.address.location.lat,
                                            lon: ret.request.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.request.owner.createdAt + "Z"),
                                    deletedAt: ret.request.owner.deletedAt === null || ret.request.owner.deletedAt === undefined ? null : new Date(ret.request.owner.deletedAt + "Z")
                                },
                                requester: {
                                    id: ret.request.requester.id,
                                    gender: ret.request.requester.gender === null || ret.request.requester.gender === undefined ? null : ret.request.requester.gender,
                                    birthday: ret.request.requester.birthday === null || ret.request.requester.birthday === undefined ? null : new Date(parseInt(ret.request.requester.birthday.split("-")[0], 10), parseInt(ret.request.requester.birthday.split("-")[1], 10) - 1, parseInt(ret.request.requester.birthday.split("-")[2], 10)),
                                    name: ret.request.requester.name,
                                    nick: ret.request.requester.nick,
                                    cpf: ret.request.requester.cpf,
                                    email: ret.request.requester.email,
                                    phone: {
                                        ddd: ret.request.requester.phone.ddd,
                                        ddi: ret.request.requester.phone.ddi,
                                        number: ret.request.requester.phone.number
                                    },
                                    avatar: ret.request.requester.avatar === null || ret.request.requester.avatar === undefined ? null : {
                                        width: ret.request.requester.avatar.width || 0,
                                        height: ret.request.requester.avatar.height || 0,
                                        url: ret.request.requester.avatar.url
                                    },
                                    address: ret.request.requester.address === null || ret.request.requester.address === undefined ? null : {
                                        street: ret.request.requester.address.street,
                                        neighborhood: ret.request.requester.address.neighborhood,
                                        city: ret.request.requester.address.city,
                                        uf: ret.request.requester.address.uf,
                                        country: ret.request.requester.address.country,
                                        number: ret.request.requester.address.number,
                                        zip: ret.request.requester.address.zip,
                                        adicionalInfo: ret.request.requester.address.adicionalInfo,
                                        reference: ret.request.requester.address.reference,
                                        location: {
                                            lat: ret.request.requester.address.location.lat,
                                            lon: ret.request.requester.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.request.requester.createdAt + "Z"),
                                    deletedAt: ret.request.requester.deletedAt === null || ret.request.requester.deletedAt === undefined ? null : new Date(ret.request.requester.deletedAt + "Z")
                                },
                                item: {
                                    thumbImage: {
                                        width: ret.request.item.thumbImage.width || 0,
                                        height: ret.request.item.thumbImage.height || 0,
                                        url: ret.request.item.thumbImage.url
                                    },
                                    calendar: ret.request.item.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    adjustment: !!ret.request.item.adjustment,
                                    category: ret.request.item.category,
                                    color: ret.request.item.color,
                                    details: ret.request.item.details,
                                    gender: ret.request.item.gender,
                                    images: ret.request.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: ret.request.item.brand === null || ret.request.item.brand === undefined ? null : ret.request.item.brand,
                                    ocasions: ret.request.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    size: ret.request.item.size,
                                    salePrice: ret.request.item.salePrice === null || ret.request.item.salePrice === undefined ? null : ret.request.item.salePrice || 0,
                                    rentPrice: ret.request.item.rentPrice === null || ret.request.item.rentPrice === undefined ? null : ret.request.item.rentPrice || 0,
                                    originalPrice: ret.request.item.originalPrice || 0
                                },
                                transport: ret.request.transport === null || ret.request.transport === undefined ? null : {
                                    requester: {
                                        street: ret.request.transport.requester.street,
                                        neighborhood: ret.request.transport.requester.neighborhood,
                                        city: ret.request.transport.requester.city,
                                        uf: ret.request.transport.requester.uf,
                                        country: ret.request.transport.requester.country,
                                        number: ret.request.transport.requester.number,
                                        zip: ret.request.transport.requester.zip,
                                        adicionalInfo: ret.request.transport.requester.adicionalInfo,
                                        reference: ret.request.transport.requester.reference,
                                        location: {
                                            lat: ret.request.transport.requester.location.lat,
                                            lon: ret.request.transport.requester.location.lon
                                        }
                                    },
                                    owner: {
                                        street: ret.request.transport.owner.street,
                                        neighborhood: ret.request.transport.owner.neighborhood,
                                        city: ret.request.transport.owner.city,
                                        uf: ret.request.transport.owner.uf,
                                        country: ret.request.transport.owner.country,
                                        number: ret.request.transport.owner.number,
                                        zip: ret.request.transport.owner.zip,
                                        adicionalInfo: ret.request.transport.owner.adicionalInfo,
                                        reference: ret.request.transport.owner.reference,
                                        location: {
                                            lat: ret.request.transport.owner.location.lat,
                                            lon: ret.request.transport.owner.location.lon
                                        }
                                    },
                                    price: ret.request.transport.price || 0
                                },
                                period: {
                                    start: new Date(parseInt(ret.request.period.start.split("-")[0], 10), parseInt(ret.request.period.start.split("-")[1], 10) - 1, parseInt(ret.request.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(ret.request.period.end.split("-")[0], 10), parseInt(ret.request.period.end.split("-")[1], 10) - 1, parseInt(ret.request.period.end.split("-")[2], 10))
                                },
                                rentPrice: ret.request.rentPrice || 0,
                                originalPrice: ret.request.originalPrice || 0,
                                statusList: ret.request.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: ret.request.currentStatus.status,
                                    changeDate: new Date(parseInt(ret.request.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.request.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.request.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: ret.request.currentStatus.actionBy === null || ret.request.currentStatus.actionBy === undefined ? null : ret.request.currentStatus.actionBy,
                                    pending: !!ret.request.currentStatus.pending
                                },
                                payment: ret.request.payment === null || ret.request.payment === undefined ? null : {
                                    transactionId: ret.request.payment.transactionId || 0,
                                    lastDigits: ret.request.payment.lastDigits,
                                    brand: ret.request.payment.brand,
                                    paidAmount: ret.request.payment.paidAmount || 0,
                                    status: ret.request.payment.status,
                                    locSplit: {
                                        id: ret.request.payment.locSplit.id,
                                        recipientId: ret.request.payment.locSplit.recipientId,
                                        amount: ret.request.payment.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: ret.request.payment.ownerSplit.id,
                                        recipientId: ret.request.payment.ownerSplit.recipientId,
                                        amount: ret.request.payment.ownerSplit.amount || 0
                                    }
                                },
                                promotion: {
                                    card: ret.request.promotion.card === null || ret.request.promotion.card === undefined ? null : {
                                        transactionId: ret.request.promotion.card.transactionId || 0,
                                        lastDigits: ret.request.promotion.card.lastDigits,
                                        brand: ret.request.promotion.card.brand,
                                        paidAmount: ret.request.promotion.card.paidAmount || 0,
                                        status: ret.request.promotion.card.status,
                                        locSplit: {
                                            id: ret.request.promotion.card.locSplit.id,
                                            recipientId: ret.request.promotion.card.locSplit.recipientId,
                                            amount: ret.request.promotion.card.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: ret.request.promotion.card.ownerSplit.id,
                                            recipientId: ret.request.promotion.card.ownerSplit.recipientId,
                                            amount: ret.request.promotion.card.ownerSplit.amount || 0
                                        }
                                    },
                                    type: ret.request.promotion.type === null || ret.request.promotion.type === undefined ? null : ret.request.promotion.type,
                                    total: ret.request.promotion.total || 0,
                                    id: ret.request.promotion.id === null || ret.request.promotion.id === undefined ? null : ret.request.promotion.id
                                },
                                nfe: {
                                    id: ret.request.nfe.id === null || ret.request.nfe.id === undefined ? null : ret.request.nfe.id,
                                    number: ret.request.nfe.number === null || ret.request.nfe.number === undefined ? null : ret.request.nfe.number || 0,
                                    emitedAt: ret.request.nfe.emitedAt === null || ret.request.nfe.emitedAt === undefined ? null : new Date(ret.request.nfe.emitedAt + "Z"),
                                    canceledAt: ret.request.nfe.canceledAt === null || ret.request.nfe.canceledAt === undefined ? null : new Date(ret.request.nfe.canceledAt + "Z"),
                                    status: ret.request.nfe.status === null || ret.request.nfe.status === undefined ? null : ret.request.nfe.status
                                },
                                createdAt: new Date(ret.request.createdAt + "Z")
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            reason: ret.reason,
                            amount: ret.amount || 0
                        });

                    case 5:
                    case "end":
                        return _context63.stop();
                }
            }
        }, _callee63, this);
    }));

    return function getFine(_x155, _x156) {
        return _ref63.apply(this, arguments);
    };
}();

var getFines = function () {
    var _ref64 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee64(page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee64$(_context64) {
            while (1) {
                switch (_context64.prev = _context64.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context64.next = 3;
                        return makeRequest({ name: "getFines", args: args, progress: progress });

                    case 3:
                        ret = _context64.sent;
                        return _context64.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                transactionId: e.transactionId || 0,
                                payedBy: e.payedBy === null || e.payedBy === undefined ? null : {
                                    id: e.payedBy.id,
                                    gender: e.payedBy.gender === null || e.payedBy.gender === undefined ? null : e.payedBy.gender,
                                    birthday: e.payedBy.birthday === null || e.payedBy.birthday === undefined ? null : new Date(parseInt(e.payedBy.birthday.split("-")[0], 10), parseInt(e.payedBy.birthday.split("-")[1], 10) - 1, parseInt(e.payedBy.birthday.split("-")[2], 10)),
                                    name: e.payedBy.name,
                                    nick: e.payedBy.nick,
                                    cpf: e.payedBy.cpf,
                                    email: e.payedBy.email,
                                    phone: {
                                        ddd: e.payedBy.phone.ddd,
                                        ddi: e.payedBy.phone.ddi,
                                        number: e.payedBy.phone.number
                                    },
                                    avatar: e.payedBy.avatar === null || e.payedBy.avatar === undefined ? null : {
                                        width: e.payedBy.avatar.width || 0,
                                        height: e.payedBy.avatar.height || 0,
                                        url: e.payedBy.avatar.url
                                    },
                                    address: e.payedBy.address === null || e.payedBy.address === undefined ? null : {
                                        street: e.payedBy.address.street,
                                        neighborhood: e.payedBy.address.neighborhood,
                                        city: e.payedBy.address.city,
                                        uf: e.payedBy.address.uf,
                                        country: e.payedBy.address.country,
                                        number: e.payedBy.address.number,
                                        zip: e.payedBy.address.zip,
                                        adicionalInfo: e.payedBy.address.adicionalInfo,
                                        reference: e.payedBy.address.reference,
                                        location: {
                                            lat: e.payedBy.address.location.lat,
                                            lon: e.payedBy.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedBy.createdAt + "Z"),
                                    deletedAt: e.payedBy.deletedAt === null || e.payedBy.deletedAt === undefined ? null : new Date(e.payedBy.deletedAt + "Z")
                                },
                                payedTo: e.payedTo === null || e.payedTo === undefined ? null : {
                                    id: e.payedTo.id,
                                    gender: e.payedTo.gender === null || e.payedTo.gender === undefined ? null : e.payedTo.gender,
                                    birthday: e.payedTo.birthday === null || e.payedTo.birthday === undefined ? null : new Date(parseInt(e.payedTo.birthday.split("-")[0], 10), parseInt(e.payedTo.birthday.split("-")[1], 10) - 1, parseInt(e.payedTo.birthday.split("-")[2], 10)),
                                    name: e.payedTo.name,
                                    nick: e.payedTo.nick,
                                    cpf: e.payedTo.cpf,
                                    email: e.payedTo.email,
                                    phone: {
                                        ddd: e.payedTo.phone.ddd,
                                        ddi: e.payedTo.phone.ddi,
                                        number: e.payedTo.phone.number
                                    },
                                    avatar: e.payedTo.avatar === null || e.payedTo.avatar === undefined ? null : {
                                        width: e.payedTo.avatar.width || 0,
                                        height: e.payedTo.avatar.height || 0,
                                        url: e.payedTo.avatar.url
                                    },
                                    address: e.payedTo.address === null || e.payedTo.address === undefined ? null : {
                                        street: e.payedTo.address.street,
                                        neighborhood: e.payedTo.address.neighborhood,
                                        city: e.payedTo.address.city,
                                        uf: e.payedTo.address.uf,
                                        country: e.payedTo.address.country,
                                        number: e.payedTo.address.number,
                                        zip: e.payedTo.address.zip,
                                        adicionalInfo: e.payedTo.address.adicionalInfo,
                                        reference: e.payedTo.address.reference,
                                        location: {
                                            lat: e.payedTo.address.location.lat,
                                            lon: e.payedTo.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedTo.createdAt + "Z"),
                                    deletedAt: e.payedTo.deletedAt === null || e.payedTo.deletedAt === undefined ? null : new Date(e.payedTo.deletedAt + "Z")
                                },
                                request: e.request === null || e.request === undefined ? null : {
                                    id: e.request.id,
                                    numId: e.request.numId,
                                    owner: {
                                        id: e.request.owner.id,
                                        gender: e.request.owner.gender === null || e.request.owner.gender === undefined ? null : e.request.owner.gender,
                                        birthday: e.request.owner.birthday === null || e.request.owner.birthday === undefined ? null : new Date(parseInt(e.request.owner.birthday.split("-")[0], 10), parseInt(e.request.owner.birthday.split("-")[1], 10) - 1, parseInt(e.request.owner.birthday.split("-")[2], 10)),
                                        name: e.request.owner.name,
                                        nick: e.request.owner.nick,
                                        cpf: e.request.owner.cpf,
                                        email: e.request.owner.email,
                                        phone: {
                                            ddd: e.request.owner.phone.ddd,
                                            ddi: e.request.owner.phone.ddi,
                                            number: e.request.owner.phone.number
                                        },
                                        avatar: e.request.owner.avatar === null || e.request.owner.avatar === undefined ? null : {
                                            width: e.request.owner.avatar.width || 0,
                                            height: e.request.owner.avatar.height || 0,
                                            url: e.request.owner.avatar.url
                                        },
                                        address: e.request.owner.address === null || e.request.owner.address === undefined ? null : {
                                            street: e.request.owner.address.street,
                                            neighborhood: e.request.owner.address.neighborhood,
                                            city: e.request.owner.address.city,
                                            uf: e.request.owner.address.uf,
                                            country: e.request.owner.address.country,
                                            number: e.request.owner.address.number,
                                            zip: e.request.owner.address.zip,
                                            adicionalInfo: e.request.owner.address.adicionalInfo,
                                            reference: e.request.owner.address.reference,
                                            location: {
                                                lat: e.request.owner.address.location.lat,
                                                lon: e.request.owner.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.request.owner.createdAt + "Z"),
                                        deletedAt: e.request.owner.deletedAt === null || e.request.owner.deletedAt === undefined ? null : new Date(e.request.owner.deletedAt + "Z")
                                    },
                                    requester: {
                                        id: e.request.requester.id,
                                        gender: e.request.requester.gender === null || e.request.requester.gender === undefined ? null : e.request.requester.gender,
                                        birthday: e.request.requester.birthday === null || e.request.requester.birthday === undefined ? null : new Date(parseInt(e.request.requester.birthday.split("-")[0], 10), parseInt(e.request.requester.birthday.split("-")[1], 10) - 1, parseInt(e.request.requester.birthday.split("-")[2], 10)),
                                        name: e.request.requester.name,
                                        nick: e.request.requester.nick,
                                        cpf: e.request.requester.cpf,
                                        email: e.request.requester.email,
                                        phone: {
                                            ddd: e.request.requester.phone.ddd,
                                            ddi: e.request.requester.phone.ddi,
                                            number: e.request.requester.phone.number
                                        },
                                        avatar: e.request.requester.avatar === null || e.request.requester.avatar === undefined ? null : {
                                            width: e.request.requester.avatar.width || 0,
                                            height: e.request.requester.avatar.height || 0,
                                            url: e.request.requester.avatar.url
                                        },
                                        address: e.request.requester.address === null || e.request.requester.address === undefined ? null : {
                                            street: e.request.requester.address.street,
                                            neighborhood: e.request.requester.address.neighborhood,
                                            city: e.request.requester.address.city,
                                            uf: e.request.requester.address.uf,
                                            country: e.request.requester.address.country,
                                            number: e.request.requester.address.number,
                                            zip: e.request.requester.address.zip,
                                            adicionalInfo: e.request.requester.address.adicionalInfo,
                                            reference: e.request.requester.address.reference,
                                            location: {
                                                lat: e.request.requester.address.location.lat,
                                                lon: e.request.requester.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.request.requester.createdAt + "Z"),
                                        deletedAt: e.request.requester.deletedAt === null || e.request.requester.deletedAt === undefined ? null : new Date(e.request.requester.deletedAt + "Z")
                                    },
                                    item: {
                                        thumbImage: {
                                            width: e.request.item.thumbImage.width || 0,
                                            height: e.request.item.thumbImage.height || 0,
                                            url: e.request.item.thumbImage.url
                                        },
                                        calendar: e.request.item.calendar.map(function (e) {
                                            return {
                                                start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                                end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                            };
                                        }),
                                        adjustment: !!e.request.item.adjustment,
                                        category: e.request.item.category,
                                        color: e.request.item.color,
                                        details: e.request.item.details,
                                        gender: e.request.item.gender,
                                        images: e.request.item.images.map(function (e) {
                                            return {
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                url: e.url
                                            };
                                        }),
                                        brand: e.request.item.brand === null || e.request.item.brand === undefined ? null : e.request.item.brand,
                                        ocasions: e.request.item.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        size: e.request.item.size,
                                        salePrice: e.request.item.salePrice === null || e.request.item.salePrice === undefined ? null : e.request.item.salePrice || 0,
                                        rentPrice: e.request.item.rentPrice === null || e.request.item.rentPrice === undefined ? null : e.request.item.rentPrice || 0,
                                        originalPrice: e.request.item.originalPrice || 0
                                    },
                                    transport: e.request.transport === null || e.request.transport === undefined ? null : {
                                        requester: {
                                            street: e.request.transport.requester.street,
                                            neighborhood: e.request.transport.requester.neighborhood,
                                            city: e.request.transport.requester.city,
                                            uf: e.request.transport.requester.uf,
                                            country: e.request.transport.requester.country,
                                            number: e.request.transport.requester.number,
                                            zip: e.request.transport.requester.zip,
                                            adicionalInfo: e.request.transport.requester.adicionalInfo,
                                            reference: e.request.transport.requester.reference,
                                            location: {
                                                lat: e.request.transport.requester.location.lat,
                                                lon: e.request.transport.requester.location.lon
                                            }
                                        },
                                        owner: {
                                            street: e.request.transport.owner.street,
                                            neighborhood: e.request.transport.owner.neighborhood,
                                            city: e.request.transport.owner.city,
                                            uf: e.request.transport.owner.uf,
                                            country: e.request.transport.owner.country,
                                            number: e.request.transport.owner.number,
                                            zip: e.request.transport.owner.zip,
                                            adicionalInfo: e.request.transport.owner.adicionalInfo,
                                            reference: e.request.transport.owner.reference,
                                            location: {
                                                lat: e.request.transport.owner.location.lat,
                                                lon: e.request.transport.owner.location.lon
                                            }
                                        },
                                        price: e.request.transport.price || 0
                                    },
                                    period: {
                                        start: new Date(parseInt(e.request.period.start.split("-")[0], 10), parseInt(e.request.period.start.split("-")[1], 10) - 1, parseInt(e.request.period.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.request.period.end.split("-")[0], 10), parseInt(e.request.period.end.split("-")[1], 10) - 1, parseInt(e.request.period.end.split("-")[2], 10))
                                    },
                                    rentPrice: e.request.rentPrice || 0,
                                    originalPrice: e.request.originalPrice || 0,
                                    statusList: e.request.statusList.map(function (e) {
                                        return {
                                            status: e.status,
                                            changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                            actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                            pending: !!e.pending
                                        };
                                    }),
                                    currentStatus: {
                                        status: e.request.currentStatus.status,
                                        changeDate: new Date(parseInt(e.request.currentStatus.changeDate.split("-")[0], 10), parseInt(e.request.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.request.currentStatus.changeDate.split("-")[2], 10)),
                                        actionBy: e.request.currentStatus.actionBy === null || e.request.currentStatus.actionBy === undefined ? null : e.request.currentStatus.actionBy,
                                        pending: !!e.request.currentStatus.pending
                                    },
                                    payment: e.request.payment === null || e.request.payment === undefined ? null : {
                                        transactionId: e.request.payment.transactionId || 0,
                                        lastDigits: e.request.payment.lastDigits,
                                        brand: e.request.payment.brand,
                                        paidAmount: e.request.payment.paidAmount || 0,
                                        status: e.request.payment.status,
                                        locSplit: {
                                            id: e.request.payment.locSplit.id,
                                            recipientId: e.request.payment.locSplit.recipientId,
                                            amount: e.request.payment.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: e.request.payment.ownerSplit.id,
                                            recipientId: e.request.payment.ownerSplit.recipientId,
                                            amount: e.request.payment.ownerSplit.amount || 0
                                        }
                                    },
                                    promotion: {
                                        card: e.request.promotion.card === null || e.request.promotion.card === undefined ? null : {
                                            transactionId: e.request.promotion.card.transactionId || 0,
                                            lastDigits: e.request.promotion.card.lastDigits,
                                            brand: e.request.promotion.card.brand,
                                            paidAmount: e.request.promotion.card.paidAmount || 0,
                                            status: e.request.promotion.card.status,
                                            locSplit: {
                                                id: e.request.promotion.card.locSplit.id,
                                                recipientId: e.request.promotion.card.locSplit.recipientId,
                                                amount: e.request.promotion.card.locSplit.amount || 0
                                            },
                                            ownerSplit: {
                                                id: e.request.promotion.card.ownerSplit.id,
                                                recipientId: e.request.promotion.card.ownerSplit.recipientId,
                                                amount: e.request.promotion.card.ownerSplit.amount || 0
                                            }
                                        },
                                        type: e.request.promotion.type === null || e.request.promotion.type === undefined ? null : e.request.promotion.type,
                                        total: e.request.promotion.total || 0,
                                        id: e.request.promotion.id === null || e.request.promotion.id === undefined ? null : e.request.promotion.id
                                    },
                                    nfe: {
                                        id: e.request.nfe.id === null || e.request.nfe.id === undefined ? null : e.request.nfe.id,
                                        number: e.request.nfe.number === null || e.request.nfe.number === undefined ? null : e.request.nfe.number || 0,
                                        emitedAt: e.request.nfe.emitedAt === null || e.request.nfe.emitedAt === undefined ? null : new Date(e.request.nfe.emitedAt + "Z"),
                                        canceledAt: e.request.nfe.canceledAt === null || e.request.nfe.canceledAt === undefined ? null : new Date(e.request.nfe.canceledAt + "Z"),
                                        status: e.request.nfe.status === null || e.request.nfe.status === undefined ? null : e.request.nfe.status
                                    },
                                    createdAt: new Date(e.request.createdAt + "Z")
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                reason: e.reason,
                                amount: e.amount || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context64.stop();
                }
            }
        }, _callee64, this);
    }));

    return function getFines(_x157, _x158) {
        return _ref64.apply(this, arguments);
    };
}();

var getFinesForRequest = function () {
    var _ref65 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee65(requestId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee65$(_context65) {
            while (1) {
                switch (_context65.prev = _context65.next) {
                    case 0:
                        args = {
                            requestId: requestId
                        };
                        _context65.next = 3;
                        return makeRequest({ name: "getFinesForRequest", args: args, progress: progress });

                    case 3:
                        ret = _context65.sent;
                        return _context65.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                transactionId: e.transactionId || 0,
                                payedBy: e.payedBy === null || e.payedBy === undefined ? null : {
                                    id: e.payedBy.id,
                                    gender: e.payedBy.gender === null || e.payedBy.gender === undefined ? null : e.payedBy.gender,
                                    birthday: e.payedBy.birthday === null || e.payedBy.birthday === undefined ? null : new Date(parseInt(e.payedBy.birthday.split("-")[0], 10), parseInt(e.payedBy.birthday.split("-")[1], 10) - 1, parseInt(e.payedBy.birthday.split("-")[2], 10)),
                                    name: e.payedBy.name,
                                    nick: e.payedBy.nick,
                                    cpf: e.payedBy.cpf,
                                    email: e.payedBy.email,
                                    phone: {
                                        ddd: e.payedBy.phone.ddd,
                                        ddi: e.payedBy.phone.ddi,
                                        number: e.payedBy.phone.number
                                    },
                                    avatar: e.payedBy.avatar === null || e.payedBy.avatar === undefined ? null : {
                                        width: e.payedBy.avatar.width || 0,
                                        height: e.payedBy.avatar.height || 0,
                                        url: e.payedBy.avatar.url
                                    },
                                    address: e.payedBy.address === null || e.payedBy.address === undefined ? null : {
                                        street: e.payedBy.address.street,
                                        neighborhood: e.payedBy.address.neighborhood,
                                        city: e.payedBy.address.city,
                                        uf: e.payedBy.address.uf,
                                        country: e.payedBy.address.country,
                                        number: e.payedBy.address.number,
                                        zip: e.payedBy.address.zip,
                                        adicionalInfo: e.payedBy.address.adicionalInfo,
                                        reference: e.payedBy.address.reference,
                                        location: {
                                            lat: e.payedBy.address.location.lat,
                                            lon: e.payedBy.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedBy.createdAt + "Z"),
                                    deletedAt: e.payedBy.deletedAt === null || e.payedBy.deletedAt === undefined ? null : new Date(e.payedBy.deletedAt + "Z")
                                },
                                payedTo: {
                                    id: e.payedTo.id,
                                    gender: e.payedTo.gender === null || e.payedTo.gender === undefined ? null : e.payedTo.gender,
                                    birthday: e.payedTo.birthday === null || e.payedTo.birthday === undefined ? null : new Date(parseInt(e.payedTo.birthday.split("-")[0], 10), parseInt(e.payedTo.birthday.split("-")[1], 10) - 1, parseInt(e.payedTo.birthday.split("-")[2], 10)),
                                    name: e.payedTo.name,
                                    nick: e.payedTo.nick,
                                    cpf: e.payedTo.cpf,
                                    email: e.payedTo.email,
                                    phone: {
                                        ddd: e.payedTo.phone.ddd,
                                        ddi: e.payedTo.phone.ddi,
                                        number: e.payedTo.phone.number
                                    },
                                    avatar: e.payedTo.avatar === null || e.payedTo.avatar === undefined ? null : {
                                        width: e.payedTo.avatar.width || 0,
                                        height: e.payedTo.avatar.height || 0,
                                        url: e.payedTo.avatar.url
                                    },
                                    address: e.payedTo.address === null || e.payedTo.address === undefined ? null : {
                                        street: e.payedTo.address.street,
                                        neighborhood: e.payedTo.address.neighborhood,
                                        city: e.payedTo.address.city,
                                        uf: e.payedTo.address.uf,
                                        country: e.payedTo.address.country,
                                        number: e.payedTo.address.number,
                                        zip: e.payedTo.address.zip,
                                        adicionalInfo: e.payedTo.address.adicionalInfo,
                                        reference: e.payedTo.address.reference,
                                        location: {
                                            lat: e.payedTo.address.location.lat,
                                            lon: e.payedTo.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedTo.createdAt + "Z"),
                                    deletedAt: e.payedTo.deletedAt === null || e.payedTo.deletedAt === undefined ? null : new Date(e.payedTo.deletedAt + "Z")
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                reason: e.reason,
                                amount: e.amount || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context65.stop();
                }
            }
        }, _callee65, this);
    }));

    return function getFinesForRequest(_x159, _x160) {
        return _ref65.apply(this, arguments);
    };
}();

var getFinesPayedByUser = function () {
    var _ref66 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee66(userId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee66$(_context66) {
            while (1) {
                switch (_context66.prev = _context66.next) {
                    case 0:
                        args = {
                            userId: userId
                        };
                        _context66.next = 3;
                        return makeRequest({ name: "getFinesPayedByUser", args: args, progress: progress });

                    case 3:
                        ret = _context66.sent;
                        return _context66.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                transactionId: e.transactionId || 0,
                                payedBy: e.payedBy === null || e.payedBy === undefined ? null : {
                                    id: e.payedBy.id,
                                    gender: e.payedBy.gender === null || e.payedBy.gender === undefined ? null : e.payedBy.gender,
                                    birthday: e.payedBy.birthday === null || e.payedBy.birthday === undefined ? null : new Date(parseInt(e.payedBy.birthday.split("-")[0], 10), parseInt(e.payedBy.birthday.split("-")[1], 10) - 1, parseInt(e.payedBy.birthday.split("-")[2], 10)),
                                    name: e.payedBy.name,
                                    nick: e.payedBy.nick,
                                    cpf: e.payedBy.cpf,
                                    email: e.payedBy.email,
                                    phone: {
                                        ddd: e.payedBy.phone.ddd,
                                        ddi: e.payedBy.phone.ddi,
                                        number: e.payedBy.phone.number
                                    },
                                    avatar: e.payedBy.avatar === null || e.payedBy.avatar === undefined ? null : {
                                        width: e.payedBy.avatar.width || 0,
                                        height: e.payedBy.avatar.height || 0,
                                        url: e.payedBy.avatar.url
                                    },
                                    address: e.payedBy.address === null || e.payedBy.address === undefined ? null : {
                                        street: e.payedBy.address.street,
                                        neighborhood: e.payedBy.address.neighborhood,
                                        city: e.payedBy.address.city,
                                        uf: e.payedBy.address.uf,
                                        country: e.payedBy.address.country,
                                        number: e.payedBy.address.number,
                                        zip: e.payedBy.address.zip,
                                        adicionalInfo: e.payedBy.address.adicionalInfo,
                                        reference: e.payedBy.address.reference,
                                        location: {
                                            lat: e.payedBy.address.location.lat,
                                            lon: e.payedBy.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedBy.createdAt + "Z"),
                                    deletedAt: e.payedBy.deletedAt === null || e.payedBy.deletedAt === undefined ? null : new Date(e.payedBy.deletedAt + "Z")
                                },
                                payedTo: e.payedTo === null || e.payedTo === undefined ? null : {
                                    id: e.payedTo.id,
                                    gender: e.payedTo.gender === null || e.payedTo.gender === undefined ? null : e.payedTo.gender,
                                    birthday: e.payedTo.birthday === null || e.payedTo.birthday === undefined ? null : new Date(parseInt(e.payedTo.birthday.split("-")[0], 10), parseInt(e.payedTo.birthday.split("-")[1], 10) - 1, parseInt(e.payedTo.birthday.split("-")[2], 10)),
                                    name: e.payedTo.name,
                                    nick: e.payedTo.nick,
                                    cpf: e.payedTo.cpf,
                                    email: e.payedTo.email,
                                    phone: {
                                        ddd: e.payedTo.phone.ddd,
                                        ddi: e.payedTo.phone.ddi,
                                        number: e.payedTo.phone.number
                                    },
                                    avatar: e.payedTo.avatar === null || e.payedTo.avatar === undefined ? null : {
                                        width: e.payedTo.avatar.width || 0,
                                        height: e.payedTo.avatar.height || 0,
                                        url: e.payedTo.avatar.url
                                    },
                                    address: e.payedTo.address === null || e.payedTo.address === undefined ? null : {
                                        street: e.payedTo.address.street,
                                        neighborhood: e.payedTo.address.neighborhood,
                                        city: e.payedTo.address.city,
                                        uf: e.payedTo.address.uf,
                                        country: e.payedTo.address.country,
                                        number: e.payedTo.address.number,
                                        zip: e.payedTo.address.zip,
                                        adicionalInfo: e.payedTo.address.adicionalInfo,
                                        reference: e.payedTo.address.reference,
                                        location: {
                                            lat: e.payedTo.address.location.lat,
                                            lon: e.payedTo.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedTo.createdAt + "Z"),
                                    deletedAt: e.payedTo.deletedAt === null || e.payedTo.deletedAt === undefined ? null : new Date(e.payedTo.deletedAt + "Z")
                                },
                                request: e.request === null || e.request === undefined ? null : {
                                    id: e.request.id,
                                    numId: e.request.numId,
                                    owner: {
                                        id: e.request.owner.id,
                                        gender: e.request.owner.gender === null || e.request.owner.gender === undefined ? null : e.request.owner.gender,
                                        birthday: e.request.owner.birthday === null || e.request.owner.birthday === undefined ? null : new Date(parseInt(e.request.owner.birthday.split("-")[0], 10), parseInt(e.request.owner.birthday.split("-")[1], 10) - 1, parseInt(e.request.owner.birthday.split("-")[2], 10)),
                                        name: e.request.owner.name,
                                        nick: e.request.owner.nick,
                                        cpf: e.request.owner.cpf,
                                        email: e.request.owner.email,
                                        phone: {
                                            ddd: e.request.owner.phone.ddd,
                                            ddi: e.request.owner.phone.ddi,
                                            number: e.request.owner.phone.number
                                        },
                                        avatar: e.request.owner.avatar === null || e.request.owner.avatar === undefined ? null : {
                                            width: e.request.owner.avatar.width || 0,
                                            height: e.request.owner.avatar.height || 0,
                                            url: e.request.owner.avatar.url
                                        },
                                        address: e.request.owner.address === null || e.request.owner.address === undefined ? null : {
                                            street: e.request.owner.address.street,
                                            neighborhood: e.request.owner.address.neighborhood,
                                            city: e.request.owner.address.city,
                                            uf: e.request.owner.address.uf,
                                            country: e.request.owner.address.country,
                                            number: e.request.owner.address.number,
                                            zip: e.request.owner.address.zip,
                                            adicionalInfo: e.request.owner.address.adicionalInfo,
                                            reference: e.request.owner.address.reference,
                                            location: {
                                                lat: e.request.owner.address.location.lat,
                                                lon: e.request.owner.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.request.owner.createdAt + "Z"),
                                        deletedAt: e.request.owner.deletedAt === null || e.request.owner.deletedAt === undefined ? null : new Date(e.request.owner.deletedAt + "Z")
                                    },
                                    requester: {
                                        id: e.request.requester.id,
                                        gender: e.request.requester.gender === null || e.request.requester.gender === undefined ? null : e.request.requester.gender,
                                        birthday: e.request.requester.birthday === null || e.request.requester.birthday === undefined ? null : new Date(parseInt(e.request.requester.birthday.split("-")[0], 10), parseInt(e.request.requester.birthday.split("-")[1], 10) - 1, parseInt(e.request.requester.birthday.split("-")[2], 10)),
                                        name: e.request.requester.name,
                                        nick: e.request.requester.nick,
                                        cpf: e.request.requester.cpf,
                                        email: e.request.requester.email,
                                        phone: {
                                            ddd: e.request.requester.phone.ddd,
                                            ddi: e.request.requester.phone.ddi,
                                            number: e.request.requester.phone.number
                                        },
                                        avatar: e.request.requester.avatar === null || e.request.requester.avatar === undefined ? null : {
                                            width: e.request.requester.avatar.width || 0,
                                            height: e.request.requester.avatar.height || 0,
                                            url: e.request.requester.avatar.url
                                        },
                                        address: e.request.requester.address === null || e.request.requester.address === undefined ? null : {
                                            street: e.request.requester.address.street,
                                            neighborhood: e.request.requester.address.neighborhood,
                                            city: e.request.requester.address.city,
                                            uf: e.request.requester.address.uf,
                                            country: e.request.requester.address.country,
                                            number: e.request.requester.address.number,
                                            zip: e.request.requester.address.zip,
                                            adicionalInfo: e.request.requester.address.adicionalInfo,
                                            reference: e.request.requester.address.reference,
                                            location: {
                                                lat: e.request.requester.address.location.lat,
                                                lon: e.request.requester.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.request.requester.createdAt + "Z"),
                                        deletedAt: e.request.requester.deletedAt === null || e.request.requester.deletedAt === undefined ? null : new Date(e.request.requester.deletedAt + "Z")
                                    },
                                    item: {
                                        thumbImage: {
                                            width: e.request.item.thumbImage.width || 0,
                                            height: e.request.item.thumbImage.height || 0,
                                            url: e.request.item.thumbImage.url
                                        },
                                        calendar: e.request.item.calendar.map(function (e) {
                                            return {
                                                start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                                end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                            };
                                        }),
                                        adjustment: !!e.request.item.adjustment,
                                        category: e.request.item.category,
                                        color: e.request.item.color,
                                        details: e.request.item.details,
                                        gender: e.request.item.gender,
                                        images: e.request.item.images.map(function (e) {
                                            return {
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                url: e.url
                                            };
                                        }),
                                        brand: e.request.item.brand === null || e.request.item.brand === undefined ? null : e.request.item.brand,
                                        ocasions: e.request.item.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        size: e.request.item.size,
                                        salePrice: e.request.item.salePrice === null || e.request.item.salePrice === undefined ? null : e.request.item.salePrice || 0,
                                        rentPrice: e.request.item.rentPrice === null || e.request.item.rentPrice === undefined ? null : e.request.item.rentPrice || 0,
                                        originalPrice: e.request.item.originalPrice || 0
                                    },
                                    transport: e.request.transport === null || e.request.transport === undefined ? null : {
                                        requester: {
                                            street: e.request.transport.requester.street,
                                            neighborhood: e.request.transport.requester.neighborhood,
                                            city: e.request.transport.requester.city,
                                            uf: e.request.transport.requester.uf,
                                            country: e.request.transport.requester.country,
                                            number: e.request.transport.requester.number,
                                            zip: e.request.transport.requester.zip,
                                            adicionalInfo: e.request.transport.requester.adicionalInfo,
                                            reference: e.request.transport.requester.reference,
                                            location: {
                                                lat: e.request.transport.requester.location.lat,
                                                lon: e.request.transport.requester.location.lon
                                            }
                                        },
                                        owner: {
                                            street: e.request.transport.owner.street,
                                            neighborhood: e.request.transport.owner.neighborhood,
                                            city: e.request.transport.owner.city,
                                            uf: e.request.transport.owner.uf,
                                            country: e.request.transport.owner.country,
                                            number: e.request.transport.owner.number,
                                            zip: e.request.transport.owner.zip,
                                            adicionalInfo: e.request.transport.owner.adicionalInfo,
                                            reference: e.request.transport.owner.reference,
                                            location: {
                                                lat: e.request.transport.owner.location.lat,
                                                lon: e.request.transport.owner.location.lon
                                            }
                                        },
                                        price: e.request.transport.price || 0
                                    },
                                    period: {
                                        start: new Date(parseInt(e.request.period.start.split("-")[0], 10), parseInt(e.request.period.start.split("-")[1], 10) - 1, parseInt(e.request.period.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.request.period.end.split("-")[0], 10), parseInt(e.request.period.end.split("-")[1], 10) - 1, parseInt(e.request.period.end.split("-")[2], 10))
                                    },
                                    rentPrice: e.request.rentPrice || 0,
                                    originalPrice: e.request.originalPrice || 0,
                                    statusList: e.request.statusList.map(function (e) {
                                        return {
                                            status: e.status,
                                            changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                            actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                            pending: !!e.pending
                                        };
                                    }),
                                    currentStatus: {
                                        status: e.request.currentStatus.status,
                                        changeDate: new Date(parseInt(e.request.currentStatus.changeDate.split("-")[0], 10), parseInt(e.request.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.request.currentStatus.changeDate.split("-")[2], 10)),
                                        actionBy: e.request.currentStatus.actionBy === null || e.request.currentStatus.actionBy === undefined ? null : e.request.currentStatus.actionBy,
                                        pending: !!e.request.currentStatus.pending
                                    },
                                    payment: e.request.payment === null || e.request.payment === undefined ? null : {
                                        transactionId: e.request.payment.transactionId || 0,
                                        lastDigits: e.request.payment.lastDigits,
                                        brand: e.request.payment.brand,
                                        paidAmount: e.request.payment.paidAmount || 0,
                                        status: e.request.payment.status,
                                        locSplit: {
                                            id: e.request.payment.locSplit.id,
                                            recipientId: e.request.payment.locSplit.recipientId,
                                            amount: e.request.payment.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: e.request.payment.ownerSplit.id,
                                            recipientId: e.request.payment.ownerSplit.recipientId,
                                            amount: e.request.payment.ownerSplit.amount || 0
                                        }
                                    },
                                    promotion: {
                                        card: e.request.promotion.card === null || e.request.promotion.card === undefined ? null : {
                                            transactionId: e.request.promotion.card.transactionId || 0,
                                            lastDigits: e.request.promotion.card.lastDigits,
                                            brand: e.request.promotion.card.brand,
                                            paidAmount: e.request.promotion.card.paidAmount || 0,
                                            status: e.request.promotion.card.status,
                                            locSplit: {
                                                id: e.request.promotion.card.locSplit.id,
                                                recipientId: e.request.promotion.card.locSplit.recipientId,
                                                amount: e.request.promotion.card.locSplit.amount || 0
                                            },
                                            ownerSplit: {
                                                id: e.request.promotion.card.ownerSplit.id,
                                                recipientId: e.request.promotion.card.ownerSplit.recipientId,
                                                amount: e.request.promotion.card.ownerSplit.amount || 0
                                            }
                                        },
                                        type: e.request.promotion.type === null || e.request.promotion.type === undefined ? null : e.request.promotion.type,
                                        total: e.request.promotion.total || 0,
                                        id: e.request.promotion.id === null || e.request.promotion.id === undefined ? null : e.request.promotion.id
                                    },
                                    nfe: {
                                        id: e.request.nfe.id === null || e.request.nfe.id === undefined ? null : e.request.nfe.id,
                                        number: e.request.nfe.number === null || e.request.nfe.number === undefined ? null : e.request.nfe.number || 0,
                                        emitedAt: e.request.nfe.emitedAt === null || e.request.nfe.emitedAt === undefined ? null : new Date(e.request.nfe.emitedAt + "Z"),
                                        canceledAt: e.request.nfe.canceledAt === null || e.request.nfe.canceledAt === undefined ? null : new Date(e.request.nfe.canceledAt + "Z"),
                                        status: e.request.nfe.status === null || e.request.nfe.status === undefined ? null : e.request.nfe.status
                                    },
                                    createdAt: new Date(e.request.createdAt + "Z")
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                reason: e.reason,
                                amount: e.amount || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context66.stop();
                }
            }
        }, _callee66, this);
    }));

    return function getFinesPayedByUser(_x161, _x162) {
        return _ref66.apply(this, arguments);
    };
}();

var getFinesPayedToUser = function () {
    var _ref67 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee67(userId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee67$(_context67) {
            while (1) {
                switch (_context67.prev = _context67.next) {
                    case 0:
                        args = {
                            userId: userId
                        };
                        _context67.next = 3;
                        return makeRequest({ name: "getFinesPayedToUser", args: args, progress: progress });

                    case 3:
                        ret = _context67.sent;
                        return _context67.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                transactionId: e.transactionId || 0,
                                payedBy: e.payedBy === null || e.payedBy === undefined ? null : {
                                    id: e.payedBy.id,
                                    gender: e.payedBy.gender === null || e.payedBy.gender === undefined ? null : e.payedBy.gender,
                                    birthday: e.payedBy.birthday === null || e.payedBy.birthday === undefined ? null : new Date(parseInt(e.payedBy.birthday.split("-")[0], 10), parseInt(e.payedBy.birthday.split("-")[1], 10) - 1, parseInt(e.payedBy.birthday.split("-")[2], 10)),
                                    name: e.payedBy.name,
                                    nick: e.payedBy.nick,
                                    cpf: e.payedBy.cpf,
                                    email: e.payedBy.email,
                                    phone: {
                                        ddd: e.payedBy.phone.ddd,
                                        ddi: e.payedBy.phone.ddi,
                                        number: e.payedBy.phone.number
                                    },
                                    avatar: e.payedBy.avatar === null || e.payedBy.avatar === undefined ? null : {
                                        width: e.payedBy.avatar.width || 0,
                                        height: e.payedBy.avatar.height || 0,
                                        url: e.payedBy.avatar.url
                                    },
                                    address: e.payedBy.address === null || e.payedBy.address === undefined ? null : {
                                        street: e.payedBy.address.street,
                                        neighborhood: e.payedBy.address.neighborhood,
                                        city: e.payedBy.address.city,
                                        uf: e.payedBy.address.uf,
                                        country: e.payedBy.address.country,
                                        number: e.payedBy.address.number,
                                        zip: e.payedBy.address.zip,
                                        adicionalInfo: e.payedBy.address.adicionalInfo,
                                        reference: e.payedBy.address.reference,
                                        location: {
                                            lat: e.payedBy.address.location.lat,
                                            lon: e.payedBy.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedBy.createdAt + "Z"),
                                    deletedAt: e.payedBy.deletedAt === null || e.payedBy.deletedAt === undefined ? null : new Date(e.payedBy.deletedAt + "Z")
                                },
                                payedTo: e.payedTo === null || e.payedTo === undefined ? null : {
                                    id: e.payedTo.id,
                                    gender: e.payedTo.gender === null || e.payedTo.gender === undefined ? null : e.payedTo.gender,
                                    birthday: e.payedTo.birthday === null || e.payedTo.birthday === undefined ? null : new Date(parseInt(e.payedTo.birthday.split("-")[0], 10), parseInt(e.payedTo.birthday.split("-")[1], 10) - 1, parseInt(e.payedTo.birthday.split("-")[2], 10)),
                                    name: e.payedTo.name,
                                    nick: e.payedTo.nick,
                                    cpf: e.payedTo.cpf,
                                    email: e.payedTo.email,
                                    phone: {
                                        ddd: e.payedTo.phone.ddd,
                                        ddi: e.payedTo.phone.ddi,
                                        number: e.payedTo.phone.number
                                    },
                                    avatar: e.payedTo.avatar === null || e.payedTo.avatar === undefined ? null : {
                                        width: e.payedTo.avatar.width || 0,
                                        height: e.payedTo.avatar.height || 0,
                                        url: e.payedTo.avatar.url
                                    },
                                    address: e.payedTo.address === null || e.payedTo.address === undefined ? null : {
                                        street: e.payedTo.address.street,
                                        neighborhood: e.payedTo.address.neighborhood,
                                        city: e.payedTo.address.city,
                                        uf: e.payedTo.address.uf,
                                        country: e.payedTo.address.country,
                                        number: e.payedTo.address.number,
                                        zip: e.payedTo.address.zip,
                                        adicionalInfo: e.payedTo.address.adicionalInfo,
                                        reference: e.payedTo.address.reference,
                                        location: {
                                            lat: e.payedTo.address.location.lat,
                                            lon: e.payedTo.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.payedTo.createdAt + "Z"),
                                    deletedAt: e.payedTo.deletedAt === null || e.payedTo.deletedAt === undefined ? null : new Date(e.payedTo.deletedAt + "Z")
                                },
                                request: e.request === null || e.request === undefined ? null : {
                                    id: e.request.id,
                                    numId: e.request.numId,
                                    owner: {
                                        id: e.request.owner.id,
                                        gender: e.request.owner.gender === null || e.request.owner.gender === undefined ? null : e.request.owner.gender,
                                        birthday: e.request.owner.birthday === null || e.request.owner.birthday === undefined ? null : new Date(parseInt(e.request.owner.birthday.split("-")[0], 10), parseInt(e.request.owner.birthday.split("-")[1], 10) - 1, parseInt(e.request.owner.birthday.split("-")[2], 10)),
                                        name: e.request.owner.name,
                                        nick: e.request.owner.nick,
                                        cpf: e.request.owner.cpf,
                                        email: e.request.owner.email,
                                        phone: {
                                            ddd: e.request.owner.phone.ddd,
                                            ddi: e.request.owner.phone.ddi,
                                            number: e.request.owner.phone.number
                                        },
                                        avatar: e.request.owner.avatar === null || e.request.owner.avatar === undefined ? null : {
                                            width: e.request.owner.avatar.width || 0,
                                            height: e.request.owner.avatar.height || 0,
                                            url: e.request.owner.avatar.url
                                        },
                                        address: e.request.owner.address === null || e.request.owner.address === undefined ? null : {
                                            street: e.request.owner.address.street,
                                            neighborhood: e.request.owner.address.neighborhood,
                                            city: e.request.owner.address.city,
                                            uf: e.request.owner.address.uf,
                                            country: e.request.owner.address.country,
                                            number: e.request.owner.address.number,
                                            zip: e.request.owner.address.zip,
                                            adicionalInfo: e.request.owner.address.adicionalInfo,
                                            reference: e.request.owner.address.reference,
                                            location: {
                                                lat: e.request.owner.address.location.lat,
                                                lon: e.request.owner.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.request.owner.createdAt + "Z"),
                                        deletedAt: e.request.owner.deletedAt === null || e.request.owner.deletedAt === undefined ? null : new Date(e.request.owner.deletedAt + "Z")
                                    },
                                    requester: {
                                        id: e.request.requester.id,
                                        gender: e.request.requester.gender === null || e.request.requester.gender === undefined ? null : e.request.requester.gender,
                                        birthday: e.request.requester.birthday === null || e.request.requester.birthday === undefined ? null : new Date(parseInt(e.request.requester.birthday.split("-")[0], 10), parseInt(e.request.requester.birthday.split("-")[1], 10) - 1, parseInt(e.request.requester.birthday.split("-")[2], 10)),
                                        name: e.request.requester.name,
                                        nick: e.request.requester.nick,
                                        cpf: e.request.requester.cpf,
                                        email: e.request.requester.email,
                                        phone: {
                                            ddd: e.request.requester.phone.ddd,
                                            ddi: e.request.requester.phone.ddi,
                                            number: e.request.requester.phone.number
                                        },
                                        avatar: e.request.requester.avatar === null || e.request.requester.avatar === undefined ? null : {
                                            width: e.request.requester.avatar.width || 0,
                                            height: e.request.requester.avatar.height || 0,
                                            url: e.request.requester.avatar.url
                                        },
                                        address: e.request.requester.address === null || e.request.requester.address === undefined ? null : {
                                            street: e.request.requester.address.street,
                                            neighborhood: e.request.requester.address.neighborhood,
                                            city: e.request.requester.address.city,
                                            uf: e.request.requester.address.uf,
                                            country: e.request.requester.address.country,
                                            number: e.request.requester.address.number,
                                            zip: e.request.requester.address.zip,
                                            adicionalInfo: e.request.requester.address.adicionalInfo,
                                            reference: e.request.requester.address.reference,
                                            location: {
                                                lat: e.request.requester.address.location.lat,
                                                lon: e.request.requester.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.request.requester.createdAt + "Z"),
                                        deletedAt: e.request.requester.deletedAt === null || e.request.requester.deletedAt === undefined ? null : new Date(e.request.requester.deletedAt + "Z")
                                    },
                                    item: {
                                        thumbImage: {
                                            width: e.request.item.thumbImage.width || 0,
                                            height: e.request.item.thumbImage.height || 0,
                                            url: e.request.item.thumbImage.url
                                        },
                                        calendar: e.request.item.calendar.map(function (e) {
                                            return {
                                                start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                                end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                            };
                                        }),
                                        adjustment: !!e.request.item.adjustment,
                                        category: e.request.item.category,
                                        color: e.request.item.color,
                                        details: e.request.item.details,
                                        gender: e.request.item.gender,
                                        images: e.request.item.images.map(function (e) {
                                            return {
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                url: e.url
                                            };
                                        }),
                                        brand: e.request.item.brand === null || e.request.item.brand === undefined ? null : e.request.item.brand,
                                        ocasions: e.request.item.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        size: e.request.item.size,
                                        salePrice: e.request.item.salePrice === null || e.request.item.salePrice === undefined ? null : e.request.item.salePrice || 0,
                                        rentPrice: e.request.item.rentPrice === null || e.request.item.rentPrice === undefined ? null : e.request.item.rentPrice || 0,
                                        originalPrice: e.request.item.originalPrice || 0
                                    },
                                    transport: e.request.transport === null || e.request.transport === undefined ? null : {
                                        requester: {
                                            street: e.request.transport.requester.street,
                                            neighborhood: e.request.transport.requester.neighborhood,
                                            city: e.request.transport.requester.city,
                                            uf: e.request.transport.requester.uf,
                                            country: e.request.transport.requester.country,
                                            number: e.request.transport.requester.number,
                                            zip: e.request.transport.requester.zip,
                                            adicionalInfo: e.request.transport.requester.adicionalInfo,
                                            reference: e.request.transport.requester.reference,
                                            location: {
                                                lat: e.request.transport.requester.location.lat,
                                                lon: e.request.transport.requester.location.lon
                                            }
                                        },
                                        owner: {
                                            street: e.request.transport.owner.street,
                                            neighborhood: e.request.transport.owner.neighborhood,
                                            city: e.request.transport.owner.city,
                                            uf: e.request.transport.owner.uf,
                                            country: e.request.transport.owner.country,
                                            number: e.request.transport.owner.number,
                                            zip: e.request.transport.owner.zip,
                                            adicionalInfo: e.request.transport.owner.adicionalInfo,
                                            reference: e.request.transport.owner.reference,
                                            location: {
                                                lat: e.request.transport.owner.location.lat,
                                                lon: e.request.transport.owner.location.lon
                                            }
                                        },
                                        price: e.request.transport.price || 0
                                    },
                                    period: {
                                        start: new Date(parseInt(e.request.period.start.split("-")[0], 10), parseInt(e.request.period.start.split("-")[1], 10) - 1, parseInt(e.request.period.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.request.period.end.split("-")[0], 10), parseInt(e.request.period.end.split("-")[1], 10) - 1, parseInt(e.request.period.end.split("-")[2], 10))
                                    },
                                    rentPrice: e.request.rentPrice || 0,
                                    originalPrice: e.request.originalPrice || 0,
                                    statusList: e.request.statusList.map(function (e) {
                                        return {
                                            status: e.status,
                                            changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                            actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                            pending: !!e.pending
                                        };
                                    }),
                                    currentStatus: {
                                        status: e.request.currentStatus.status,
                                        changeDate: new Date(parseInt(e.request.currentStatus.changeDate.split("-")[0], 10), parseInt(e.request.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.request.currentStatus.changeDate.split("-")[2], 10)),
                                        actionBy: e.request.currentStatus.actionBy === null || e.request.currentStatus.actionBy === undefined ? null : e.request.currentStatus.actionBy,
                                        pending: !!e.request.currentStatus.pending
                                    },
                                    payment: e.request.payment === null || e.request.payment === undefined ? null : {
                                        transactionId: e.request.payment.transactionId || 0,
                                        lastDigits: e.request.payment.lastDigits,
                                        brand: e.request.payment.brand,
                                        paidAmount: e.request.payment.paidAmount || 0,
                                        status: e.request.payment.status,
                                        locSplit: {
                                            id: e.request.payment.locSplit.id,
                                            recipientId: e.request.payment.locSplit.recipientId,
                                            amount: e.request.payment.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: e.request.payment.ownerSplit.id,
                                            recipientId: e.request.payment.ownerSplit.recipientId,
                                            amount: e.request.payment.ownerSplit.amount || 0
                                        }
                                    },
                                    promotion: {
                                        card: e.request.promotion.card === null || e.request.promotion.card === undefined ? null : {
                                            transactionId: e.request.promotion.card.transactionId || 0,
                                            lastDigits: e.request.promotion.card.lastDigits,
                                            brand: e.request.promotion.card.brand,
                                            paidAmount: e.request.promotion.card.paidAmount || 0,
                                            status: e.request.promotion.card.status,
                                            locSplit: {
                                                id: e.request.promotion.card.locSplit.id,
                                                recipientId: e.request.promotion.card.locSplit.recipientId,
                                                amount: e.request.promotion.card.locSplit.amount || 0
                                            },
                                            ownerSplit: {
                                                id: e.request.promotion.card.ownerSplit.id,
                                                recipientId: e.request.promotion.card.ownerSplit.recipientId,
                                                amount: e.request.promotion.card.ownerSplit.amount || 0
                                            }
                                        },
                                        type: e.request.promotion.type === null || e.request.promotion.type === undefined ? null : e.request.promotion.type,
                                        total: e.request.promotion.total || 0,
                                        id: e.request.promotion.id === null || e.request.promotion.id === undefined ? null : e.request.promotion.id
                                    },
                                    nfe: {
                                        id: e.request.nfe.id === null || e.request.nfe.id === undefined ? null : e.request.nfe.id,
                                        number: e.request.nfe.number === null || e.request.nfe.number === undefined ? null : e.request.nfe.number || 0,
                                        emitedAt: e.request.nfe.emitedAt === null || e.request.nfe.emitedAt === undefined ? null : new Date(e.request.nfe.emitedAt + "Z"),
                                        canceledAt: e.request.nfe.canceledAt === null || e.request.nfe.canceledAt === undefined ? null : new Date(e.request.nfe.canceledAt + "Z"),
                                        status: e.request.nfe.status === null || e.request.nfe.status === undefined ? null : e.request.nfe.status
                                    },
                                    createdAt: new Date(e.request.createdAt + "Z")
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                reason: e.reason,
                                amount: e.amount || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context67.stop();
                }
            }
        }, _callee67, this);
    }));

    return function getFinesPayedToUser(_x163, _x164) {
        return _ref67.apply(this, arguments);
    };
}();

var createRequestFine = function () {
    var _ref68 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee68(fine, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee68$(_context68) {
            while (1) {
                switch (_context68.prev = _context68.next) {
                    case 0:
                        args = {
                            fine: {
                                requestId: fine.requestId === null || fine.requestId === undefined ? null : fine.requestId,
                                payedBy: fine.payedBy === null || fine.payedBy === undefined ? null : fine.payedBy,
                                payedTo: fine.payedTo === null || fine.payedTo === undefined ? null : fine.payedTo,
                                reason: fine.reason,
                                amount: fine.amount || 0
                            }
                        };
                        _context68.next = 3;
                        return makeRequest({ name: "createRequestFine", args: args, progress: progress });

                    case 3:
                        ret = _context68.sent;
                        return _context68.abrupt("return", {
                            id: ret.id,
                            transactionId: ret.transactionId || 0,
                            payedBy: ret.payedBy === null || ret.payedBy === undefined ? null : {
                                id: ret.payedBy.id,
                                gender: ret.payedBy.gender === null || ret.payedBy.gender === undefined ? null : ret.payedBy.gender,
                                birthday: ret.payedBy.birthday === null || ret.payedBy.birthday === undefined ? null : new Date(parseInt(ret.payedBy.birthday.split("-")[0], 10), parseInt(ret.payedBy.birthday.split("-")[1], 10) - 1, parseInt(ret.payedBy.birthday.split("-")[2], 10)),
                                name: ret.payedBy.name,
                                nick: ret.payedBy.nick,
                                cpf: ret.payedBy.cpf,
                                email: ret.payedBy.email,
                                phone: {
                                    ddd: ret.payedBy.phone.ddd,
                                    ddi: ret.payedBy.phone.ddi,
                                    number: ret.payedBy.phone.number
                                },
                                avatar: ret.payedBy.avatar === null || ret.payedBy.avatar === undefined ? null : {
                                    width: ret.payedBy.avatar.width || 0,
                                    height: ret.payedBy.avatar.height || 0,
                                    url: ret.payedBy.avatar.url
                                },
                                address: ret.payedBy.address === null || ret.payedBy.address === undefined ? null : {
                                    street: ret.payedBy.address.street,
                                    neighborhood: ret.payedBy.address.neighborhood,
                                    city: ret.payedBy.address.city,
                                    uf: ret.payedBy.address.uf,
                                    country: ret.payedBy.address.country,
                                    number: ret.payedBy.address.number,
                                    zip: ret.payedBy.address.zip,
                                    adicionalInfo: ret.payedBy.address.adicionalInfo,
                                    reference: ret.payedBy.address.reference,
                                    location: {
                                        lat: ret.payedBy.address.location.lat,
                                        lon: ret.payedBy.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.payedBy.createdAt + "Z"),
                                deletedAt: ret.payedBy.deletedAt === null || ret.payedBy.deletedAt === undefined ? null : new Date(ret.payedBy.deletedAt + "Z")
                            },
                            payedTo: ret.payedTo === null || ret.payedTo === undefined ? null : {
                                id: ret.payedTo.id,
                                gender: ret.payedTo.gender === null || ret.payedTo.gender === undefined ? null : ret.payedTo.gender,
                                birthday: ret.payedTo.birthday === null || ret.payedTo.birthday === undefined ? null : new Date(parseInt(ret.payedTo.birthday.split("-")[0], 10), parseInt(ret.payedTo.birthday.split("-")[1], 10) - 1, parseInt(ret.payedTo.birthday.split("-")[2], 10)),
                                name: ret.payedTo.name,
                                nick: ret.payedTo.nick,
                                cpf: ret.payedTo.cpf,
                                email: ret.payedTo.email,
                                phone: {
                                    ddd: ret.payedTo.phone.ddd,
                                    ddi: ret.payedTo.phone.ddi,
                                    number: ret.payedTo.phone.number
                                },
                                avatar: ret.payedTo.avatar === null || ret.payedTo.avatar === undefined ? null : {
                                    width: ret.payedTo.avatar.width || 0,
                                    height: ret.payedTo.avatar.height || 0,
                                    url: ret.payedTo.avatar.url
                                },
                                address: ret.payedTo.address === null || ret.payedTo.address === undefined ? null : {
                                    street: ret.payedTo.address.street,
                                    neighborhood: ret.payedTo.address.neighborhood,
                                    city: ret.payedTo.address.city,
                                    uf: ret.payedTo.address.uf,
                                    country: ret.payedTo.address.country,
                                    number: ret.payedTo.address.number,
                                    zip: ret.payedTo.address.zip,
                                    adicionalInfo: ret.payedTo.address.adicionalInfo,
                                    reference: ret.payedTo.address.reference,
                                    location: {
                                        lat: ret.payedTo.address.location.lat,
                                        lon: ret.payedTo.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.payedTo.createdAt + "Z"),
                                deletedAt: ret.payedTo.deletedAt === null || ret.payedTo.deletedAt === undefined ? null : new Date(ret.payedTo.deletedAt + "Z")
                            },
                            request: ret.request === null || ret.request === undefined ? null : {
                                id: ret.request.id,
                                numId: ret.request.numId,
                                owner: {
                                    id: ret.request.owner.id,
                                    gender: ret.request.owner.gender === null || ret.request.owner.gender === undefined ? null : ret.request.owner.gender,
                                    birthday: ret.request.owner.birthday === null || ret.request.owner.birthday === undefined ? null : new Date(parseInt(ret.request.owner.birthday.split("-")[0], 10), parseInt(ret.request.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.request.owner.birthday.split("-")[2], 10)),
                                    name: ret.request.owner.name,
                                    nick: ret.request.owner.nick,
                                    cpf: ret.request.owner.cpf,
                                    email: ret.request.owner.email,
                                    phone: {
                                        ddd: ret.request.owner.phone.ddd,
                                        ddi: ret.request.owner.phone.ddi,
                                        number: ret.request.owner.phone.number
                                    },
                                    avatar: ret.request.owner.avatar === null || ret.request.owner.avatar === undefined ? null : {
                                        width: ret.request.owner.avatar.width || 0,
                                        height: ret.request.owner.avatar.height || 0,
                                        url: ret.request.owner.avatar.url
                                    },
                                    address: ret.request.owner.address === null || ret.request.owner.address === undefined ? null : {
                                        street: ret.request.owner.address.street,
                                        neighborhood: ret.request.owner.address.neighborhood,
                                        city: ret.request.owner.address.city,
                                        uf: ret.request.owner.address.uf,
                                        country: ret.request.owner.address.country,
                                        number: ret.request.owner.address.number,
                                        zip: ret.request.owner.address.zip,
                                        adicionalInfo: ret.request.owner.address.adicionalInfo,
                                        reference: ret.request.owner.address.reference,
                                        location: {
                                            lat: ret.request.owner.address.location.lat,
                                            lon: ret.request.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.request.owner.createdAt + "Z"),
                                    deletedAt: ret.request.owner.deletedAt === null || ret.request.owner.deletedAt === undefined ? null : new Date(ret.request.owner.deletedAt + "Z")
                                },
                                requester: {
                                    id: ret.request.requester.id,
                                    gender: ret.request.requester.gender === null || ret.request.requester.gender === undefined ? null : ret.request.requester.gender,
                                    birthday: ret.request.requester.birthday === null || ret.request.requester.birthday === undefined ? null : new Date(parseInt(ret.request.requester.birthday.split("-")[0], 10), parseInt(ret.request.requester.birthday.split("-")[1], 10) - 1, parseInt(ret.request.requester.birthday.split("-")[2], 10)),
                                    name: ret.request.requester.name,
                                    nick: ret.request.requester.nick,
                                    cpf: ret.request.requester.cpf,
                                    email: ret.request.requester.email,
                                    phone: {
                                        ddd: ret.request.requester.phone.ddd,
                                        ddi: ret.request.requester.phone.ddi,
                                        number: ret.request.requester.phone.number
                                    },
                                    avatar: ret.request.requester.avatar === null || ret.request.requester.avatar === undefined ? null : {
                                        width: ret.request.requester.avatar.width || 0,
                                        height: ret.request.requester.avatar.height || 0,
                                        url: ret.request.requester.avatar.url
                                    },
                                    address: ret.request.requester.address === null || ret.request.requester.address === undefined ? null : {
                                        street: ret.request.requester.address.street,
                                        neighborhood: ret.request.requester.address.neighborhood,
                                        city: ret.request.requester.address.city,
                                        uf: ret.request.requester.address.uf,
                                        country: ret.request.requester.address.country,
                                        number: ret.request.requester.address.number,
                                        zip: ret.request.requester.address.zip,
                                        adicionalInfo: ret.request.requester.address.adicionalInfo,
                                        reference: ret.request.requester.address.reference,
                                        location: {
                                            lat: ret.request.requester.address.location.lat,
                                            lon: ret.request.requester.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.request.requester.createdAt + "Z"),
                                    deletedAt: ret.request.requester.deletedAt === null || ret.request.requester.deletedAt === undefined ? null : new Date(ret.request.requester.deletedAt + "Z")
                                },
                                item: {
                                    thumbImage: {
                                        width: ret.request.item.thumbImage.width || 0,
                                        height: ret.request.item.thumbImage.height || 0,
                                        url: ret.request.item.thumbImage.url
                                    },
                                    calendar: ret.request.item.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    adjustment: !!ret.request.item.adjustment,
                                    category: ret.request.item.category,
                                    color: ret.request.item.color,
                                    details: ret.request.item.details,
                                    gender: ret.request.item.gender,
                                    images: ret.request.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: ret.request.item.brand === null || ret.request.item.brand === undefined ? null : ret.request.item.brand,
                                    ocasions: ret.request.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    size: ret.request.item.size,
                                    salePrice: ret.request.item.salePrice === null || ret.request.item.salePrice === undefined ? null : ret.request.item.salePrice || 0,
                                    rentPrice: ret.request.item.rentPrice === null || ret.request.item.rentPrice === undefined ? null : ret.request.item.rentPrice || 0,
                                    originalPrice: ret.request.item.originalPrice || 0
                                },
                                transport: ret.request.transport === null || ret.request.transport === undefined ? null : {
                                    requester: {
                                        street: ret.request.transport.requester.street,
                                        neighborhood: ret.request.transport.requester.neighborhood,
                                        city: ret.request.transport.requester.city,
                                        uf: ret.request.transport.requester.uf,
                                        country: ret.request.transport.requester.country,
                                        number: ret.request.transport.requester.number,
                                        zip: ret.request.transport.requester.zip,
                                        adicionalInfo: ret.request.transport.requester.adicionalInfo,
                                        reference: ret.request.transport.requester.reference,
                                        location: {
                                            lat: ret.request.transport.requester.location.lat,
                                            lon: ret.request.transport.requester.location.lon
                                        }
                                    },
                                    owner: {
                                        street: ret.request.transport.owner.street,
                                        neighborhood: ret.request.transport.owner.neighborhood,
                                        city: ret.request.transport.owner.city,
                                        uf: ret.request.transport.owner.uf,
                                        country: ret.request.transport.owner.country,
                                        number: ret.request.transport.owner.number,
                                        zip: ret.request.transport.owner.zip,
                                        adicionalInfo: ret.request.transport.owner.adicionalInfo,
                                        reference: ret.request.transport.owner.reference,
                                        location: {
                                            lat: ret.request.transport.owner.location.lat,
                                            lon: ret.request.transport.owner.location.lon
                                        }
                                    },
                                    price: ret.request.transport.price || 0
                                },
                                period: {
                                    start: new Date(parseInt(ret.request.period.start.split("-")[0], 10), parseInt(ret.request.period.start.split("-")[1], 10) - 1, parseInt(ret.request.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(ret.request.period.end.split("-")[0], 10), parseInt(ret.request.period.end.split("-")[1], 10) - 1, parseInt(ret.request.period.end.split("-")[2], 10))
                                },
                                rentPrice: ret.request.rentPrice || 0,
                                originalPrice: ret.request.originalPrice || 0,
                                statusList: ret.request.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: ret.request.currentStatus.status,
                                    changeDate: new Date(parseInt(ret.request.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.request.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.request.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: ret.request.currentStatus.actionBy === null || ret.request.currentStatus.actionBy === undefined ? null : ret.request.currentStatus.actionBy,
                                    pending: !!ret.request.currentStatus.pending
                                },
                                payment: ret.request.payment === null || ret.request.payment === undefined ? null : {
                                    transactionId: ret.request.payment.transactionId || 0,
                                    lastDigits: ret.request.payment.lastDigits,
                                    brand: ret.request.payment.brand,
                                    paidAmount: ret.request.payment.paidAmount || 0,
                                    status: ret.request.payment.status,
                                    locSplit: {
                                        id: ret.request.payment.locSplit.id,
                                        recipientId: ret.request.payment.locSplit.recipientId,
                                        amount: ret.request.payment.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: ret.request.payment.ownerSplit.id,
                                        recipientId: ret.request.payment.ownerSplit.recipientId,
                                        amount: ret.request.payment.ownerSplit.amount || 0
                                    }
                                },
                                promotion: {
                                    card: ret.request.promotion.card === null || ret.request.promotion.card === undefined ? null : {
                                        transactionId: ret.request.promotion.card.transactionId || 0,
                                        lastDigits: ret.request.promotion.card.lastDigits,
                                        brand: ret.request.promotion.card.brand,
                                        paidAmount: ret.request.promotion.card.paidAmount || 0,
                                        status: ret.request.promotion.card.status,
                                        locSplit: {
                                            id: ret.request.promotion.card.locSplit.id,
                                            recipientId: ret.request.promotion.card.locSplit.recipientId,
                                            amount: ret.request.promotion.card.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: ret.request.promotion.card.ownerSplit.id,
                                            recipientId: ret.request.promotion.card.ownerSplit.recipientId,
                                            amount: ret.request.promotion.card.ownerSplit.amount || 0
                                        }
                                    },
                                    type: ret.request.promotion.type === null || ret.request.promotion.type === undefined ? null : ret.request.promotion.type,
                                    total: ret.request.promotion.total || 0,
                                    id: ret.request.promotion.id === null || ret.request.promotion.id === undefined ? null : ret.request.promotion.id
                                },
                                nfe: {
                                    id: ret.request.nfe.id === null || ret.request.nfe.id === undefined ? null : ret.request.nfe.id,
                                    number: ret.request.nfe.number === null || ret.request.nfe.number === undefined ? null : ret.request.nfe.number || 0,
                                    emitedAt: ret.request.nfe.emitedAt === null || ret.request.nfe.emitedAt === undefined ? null : new Date(ret.request.nfe.emitedAt + "Z"),
                                    canceledAt: ret.request.nfe.canceledAt === null || ret.request.nfe.canceledAt === undefined ? null : new Date(ret.request.nfe.canceledAt + "Z"),
                                    status: ret.request.nfe.status === null || ret.request.nfe.status === undefined ? null : ret.request.nfe.status
                                },
                                createdAt: new Date(ret.request.createdAt + "Z")
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            reason: ret.reason,
                            amount: ret.amount || 0
                        });

                    case 5:
                    case "end":
                        return _context68.stop();
                }
            }
        }, _callee68, this);
    }));

    return function createRequestFine(_x165, _x166) {
        return _ref68.apply(this, arguments);
    };
}();

var createFine = function () {
    var _ref69 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee69(fine, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee69$(_context69) {
            while (1) {
                switch (_context69.prev = _context69.next) {
                    case 0:
                        args = {
                            fine: {
                                payedById: fine.payedById === null || fine.payedById === undefined ? null : fine.payedById,
                                payedToId: fine.payedToId === null || fine.payedToId === undefined ? null : fine.payedToId,
                                reason: fine.reason,
                                amount: fine.amount || 0
                            }
                        };
                        _context69.next = 3;
                        return makeRequest({ name: "createFine", args: args, progress: progress });

                    case 3:
                        ret = _context69.sent;
                        return _context69.abrupt("return", {
                            id: ret.id,
                            transactionId: ret.transactionId || 0,
                            payedBy: ret.payedBy === null || ret.payedBy === undefined ? null : {
                                id: ret.payedBy.id,
                                gender: ret.payedBy.gender === null || ret.payedBy.gender === undefined ? null : ret.payedBy.gender,
                                birthday: ret.payedBy.birthday === null || ret.payedBy.birthday === undefined ? null : new Date(parseInt(ret.payedBy.birthday.split("-")[0], 10), parseInt(ret.payedBy.birthday.split("-")[1], 10) - 1, parseInt(ret.payedBy.birthday.split("-")[2], 10)),
                                name: ret.payedBy.name,
                                nick: ret.payedBy.nick,
                                cpf: ret.payedBy.cpf,
                                email: ret.payedBy.email,
                                phone: {
                                    ddd: ret.payedBy.phone.ddd,
                                    ddi: ret.payedBy.phone.ddi,
                                    number: ret.payedBy.phone.number
                                },
                                avatar: ret.payedBy.avatar === null || ret.payedBy.avatar === undefined ? null : {
                                    width: ret.payedBy.avatar.width || 0,
                                    height: ret.payedBy.avatar.height || 0,
                                    url: ret.payedBy.avatar.url
                                },
                                address: ret.payedBy.address === null || ret.payedBy.address === undefined ? null : {
                                    street: ret.payedBy.address.street,
                                    neighborhood: ret.payedBy.address.neighborhood,
                                    city: ret.payedBy.address.city,
                                    uf: ret.payedBy.address.uf,
                                    country: ret.payedBy.address.country,
                                    number: ret.payedBy.address.number,
                                    zip: ret.payedBy.address.zip,
                                    adicionalInfo: ret.payedBy.address.adicionalInfo,
                                    reference: ret.payedBy.address.reference,
                                    location: {
                                        lat: ret.payedBy.address.location.lat,
                                        lon: ret.payedBy.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.payedBy.createdAt + "Z"),
                                deletedAt: ret.payedBy.deletedAt === null || ret.payedBy.deletedAt === undefined ? null : new Date(ret.payedBy.deletedAt + "Z")
                            },
                            payedTo: ret.payedTo === null || ret.payedTo === undefined ? null : {
                                id: ret.payedTo.id,
                                gender: ret.payedTo.gender === null || ret.payedTo.gender === undefined ? null : ret.payedTo.gender,
                                birthday: ret.payedTo.birthday === null || ret.payedTo.birthday === undefined ? null : new Date(parseInt(ret.payedTo.birthday.split("-")[0], 10), parseInt(ret.payedTo.birthday.split("-")[1], 10) - 1, parseInt(ret.payedTo.birthday.split("-")[2], 10)),
                                name: ret.payedTo.name,
                                nick: ret.payedTo.nick,
                                cpf: ret.payedTo.cpf,
                                email: ret.payedTo.email,
                                phone: {
                                    ddd: ret.payedTo.phone.ddd,
                                    ddi: ret.payedTo.phone.ddi,
                                    number: ret.payedTo.phone.number
                                },
                                avatar: ret.payedTo.avatar === null || ret.payedTo.avatar === undefined ? null : {
                                    width: ret.payedTo.avatar.width || 0,
                                    height: ret.payedTo.avatar.height || 0,
                                    url: ret.payedTo.avatar.url
                                },
                                address: ret.payedTo.address === null || ret.payedTo.address === undefined ? null : {
                                    street: ret.payedTo.address.street,
                                    neighborhood: ret.payedTo.address.neighborhood,
                                    city: ret.payedTo.address.city,
                                    uf: ret.payedTo.address.uf,
                                    country: ret.payedTo.address.country,
                                    number: ret.payedTo.address.number,
                                    zip: ret.payedTo.address.zip,
                                    adicionalInfo: ret.payedTo.address.adicionalInfo,
                                    reference: ret.payedTo.address.reference,
                                    location: {
                                        lat: ret.payedTo.address.location.lat,
                                        lon: ret.payedTo.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.payedTo.createdAt + "Z"),
                                deletedAt: ret.payedTo.deletedAt === null || ret.payedTo.deletedAt === undefined ? null : new Date(ret.payedTo.deletedAt + "Z")
                            },
                            request: ret.request === null || ret.request === undefined ? null : {
                                id: ret.request.id,
                                numId: ret.request.numId,
                                owner: {
                                    id: ret.request.owner.id,
                                    gender: ret.request.owner.gender === null || ret.request.owner.gender === undefined ? null : ret.request.owner.gender,
                                    birthday: ret.request.owner.birthday === null || ret.request.owner.birthday === undefined ? null : new Date(parseInt(ret.request.owner.birthday.split("-")[0], 10), parseInt(ret.request.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.request.owner.birthday.split("-")[2], 10)),
                                    name: ret.request.owner.name,
                                    nick: ret.request.owner.nick,
                                    cpf: ret.request.owner.cpf,
                                    email: ret.request.owner.email,
                                    phone: {
                                        ddd: ret.request.owner.phone.ddd,
                                        ddi: ret.request.owner.phone.ddi,
                                        number: ret.request.owner.phone.number
                                    },
                                    avatar: ret.request.owner.avatar === null || ret.request.owner.avatar === undefined ? null : {
                                        width: ret.request.owner.avatar.width || 0,
                                        height: ret.request.owner.avatar.height || 0,
                                        url: ret.request.owner.avatar.url
                                    },
                                    address: ret.request.owner.address === null || ret.request.owner.address === undefined ? null : {
                                        street: ret.request.owner.address.street,
                                        neighborhood: ret.request.owner.address.neighborhood,
                                        city: ret.request.owner.address.city,
                                        uf: ret.request.owner.address.uf,
                                        country: ret.request.owner.address.country,
                                        number: ret.request.owner.address.number,
                                        zip: ret.request.owner.address.zip,
                                        adicionalInfo: ret.request.owner.address.adicionalInfo,
                                        reference: ret.request.owner.address.reference,
                                        location: {
                                            lat: ret.request.owner.address.location.lat,
                                            lon: ret.request.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.request.owner.createdAt + "Z"),
                                    deletedAt: ret.request.owner.deletedAt === null || ret.request.owner.deletedAt === undefined ? null : new Date(ret.request.owner.deletedAt + "Z")
                                },
                                requester: {
                                    id: ret.request.requester.id,
                                    gender: ret.request.requester.gender === null || ret.request.requester.gender === undefined ? null : ret.request.requester.gender,
                                    birthday: ret.request.requester.birthday === null || ret.request.requester.birthday === undefined ? null : new Date(parseInt(ret.request.requester.birthday.split("-")[0], 10), parseInt(ret.request.requester.birthday.split("-")[1], 10) - 1, parseInt(ret.request.requester.birthday.split("-")[2], 10)),
                                    name: ret.request.requester.name,
                                    nick: ret.request.requester.nick,
                                    cpf: ret.request.requester.cpf,
                                    email: ret.request.requester.email,
                                    phone: {
                                        ddd: ret.request.requester.phone.ddd,
                                        ddi: ret.request.requester.phone.ddi,
                                        number: ret.request.requester.phone.number
                                    },
                                    avatar: ret.request.requester.avatar === null || ret.request.requester.avatar === undefined ? null : {
                                        width: ret.request.requester.avatar.width || 0,
                                        height: ret.request.requester.avatar.height || 0,
                                        url: ret.request.requester.avatar.url
                                    },
                                    address: ret.request.requester.address === null || ret.request.requester.address === undefined ? null : {
                                        street: ret.request.requester.address.street,
                                        neighborhood: ret.request.requester.address.neighborhood,
                                        city: ret.request.requester.address.city,
                                        uf: ret.request.requester.address.uf,
                                        country: ret.request.requester.address.country,
                                        number: ret.request.requester.address.number,
                                        zip: ret.request.requester.address.zip,
                                        adicionalInfo: ret.request.requester.address.adicionalInfo,
                                        reference: ret.request.requester.address.reference,
                                        location: {
                                            lat: ret.request.requester.address.location.lat,
                                            lon: ret.request.requester.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.request.requester.createdAt + "Z"),
                                    deletedAt: ret.request.requester.deletedAt === null || ret.request.requester.deletedAt === undefined ? null : new Date(ret.request.requester.deletedAt + "Z")
                                },
                                item: {
                                    thumbImage: {
                                        width: ret.request.item.thumbImage.width || 0,
                                        height: ret.request.item.thumbImage.height || 0,
                                        url: ret.request.item.thumbImage.url
                                    },
                                    calendar: ret.request.item.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    adjustment: !!ret.request.item.adjustment,
                                    category: ret.request.item.category,
                                    color: ret.request.item.color,
                                    details: ret.request.item.details,
                                    gender: ret.request.item.gender,
                                    images: ret.request.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: ret.request.item.brand === null || ret.request.item.brand === undefined ? null : ret.request.item.brand,
                                    ocasions: ret.request.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    size: ret.request.item.size,
                                    salePrice: ret.request.item.salePrice === null || ret.request.item.salePrice === undefined ? null : ret.request.item.salePrice || 0,
                                    rentPrice: ret.request.item.rentPrice === null || ret.request.item.rentPrice === undefined ? null : ret.request.item.rentPrice || 0,
                                    originalPrice: ret.request.item.originalPrice || 0
                                },
                                transport: ret.request.transport === null || ret.request.transport === undefined ? null : {
                                    requester: {
                                        street: ret.request.transport.requester.street,
                                        neighborhood: ret.request.transport.requester.neighborhood,
                                        city: ret.request.transport.requester.city,
                                        uf: ret.request.transport.requester.uf,
                                        country: ret.request.transport.requester.country,
                                        number: ret.request.transport.requester.number,
                                        zip: ret.request.transport.requester.zip,
                                        adicionalInfo: ret.request.transport.requester.adicionalInfo,
                                        reference: ret.request.transport.requester.reference,
                                        location: {
                                            lat: ret.request.transport.requester.location.lat,
                                            lon: ret.request.transport.requester.location.lon
                                        }
                                    },
                                    owner: {
                                        street: ret.request.transport.owner.street,
                                        neighborhood: ret.request.transport.owner.neighborhood,
                                        city: ret.request.transport.owner.city,
                                        uf: ret.request.transport.owner.uf,
                                        country: ret.request.transport.owner.country,
                                        number: ret.request.transport.owner.number,
                                        zip: ret.request.transport.owner.zip,
                                        adicionalInfo: ret.request.transport.owner.adicionalInfo,
                                        reference: ret.request.transport.owner.reference,
                                        location: {
                                            lat: ret.request.transport.owner.location.lat,
                                            lon: ret.request.transport.owner.location.lon
                                        }
                                    },
                                    price: ret.request.transport.price || 0
                                },
                                period: {
                                    start: new Date(parseInt(ret.request.period.start.split("-")[0], 10), parseInt(ret.request.period.start.split("-")[1], 10) - 1, parseInt(ret.request.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(ret.request.period.end.split("-")[0], 10), parseInt(ret.request.period.end.split("-")[1], 10) - 1, parseInt(ret.request.period.end.split("-")[2], 10))
                                },
                                rentPrice: ret.request.rentPrice || 0,
                                originalPrice: ret.request.originalPrice || 0,
                                statusList: ret.request.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: ret.request.currentStatus.status,
                                    changeDate: new Date(parseInt(ret.request.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.request.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.request.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: ret.request.currentStatus.actionBy === null || ret.request.currentStatus.actionBy === undefined ? null : ret.request.currentStatus.actionBy,
                                    pending: !!ret.request.currentStatus.pending
                                },
                                payment: ret.request.payment === null || ret.request.payment === undefined ? null : {
                                    transactionId: ret.request.payment.transactionId || 0,
                                    lastDigits: ret.request.payment.lastDigits,
                                    brand: ret.request.payment.brand,
                                    paidAmount: ret.request.payment.paidAmount || 0,
                                    status: ret.request.payment.status,
                                    locSplit: {
                                        id: ret.request.payment.locSplit.id,
                                        recipientId: ret.request.payment.locSplit.recipientId,
                                        amount: ret.request.payment.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: ret.request.payment.ownerSplit.id,
                                        recipientId: ret.request.payment.ownerSplit.recipientId,
                                        amount: ret.request.payment.ownerSplit.amount || 0
                                    }
                                },
                                promotion: {
                                    card: ret.request.promotion.card === null || ret.request.promotion.card === undefined ? null : {
                                        transactionId: ret.request.promotion.card.transactionId || 0,
                                        lastDigits: ret.request.promotion.card.lastDigits,
                                        brand: ret.request.promotion.card.brand,
                                        paidAmount: ret.request.promotion.card.paidAmount || 0,
                                        status: ret.request.promotion.card.status,
                                        locSplit: {
                                            id: ret.request.promotion.card.locSplit.id,
                                            recipientId: ret.request.promotion.card.locSplit.recipientId,
                                            amount: ret.request.promotion.card.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: ret.request.promotion.card.ownerSplit.id,
                                            recipientId: ret.request.promotion.card.ownerSplit.recipientId,
                                            amount: ret.request.promotion.card.ownerSplit.amount || 0
                                        }
                                    },
                                    type: ret.request.promotion.type === null || ret.request.promotion.type === undefined ? null : ret.request.promotion.type,
                                    total: ret.request.promotion.total || 0,
                                    id: ret.request.promotion.id === null || ret.request.promotion.id === undefined ? null : ret.request.promotion.id
                                },
                                nfe: {
                                    id: ret.request.nfe.id === null || ret.request.nfe.id === undefined ? null : ret.request.nfe.id,
                                    number: ret.request.nfe.number === null || ret.request.nfe.number === undefined ? null : ret.request.nfe.number || 0,
                                    emitedAt: ret.request.nfe.emitedAt === null || ret.request.nfe.emitedAt === undefined ? null : new Date(ret.request.nfe.emitedAt + "Z"),
                                    canceledAt: ret.request.nfe.canceledAt === null || ret.request.nfe.canceledAt === undefined ? null : new Date(ret.request.nfe.canceledAt + "Z"),
                                    status: ret.request.nfe.status === null || ret.request.nfe.status === undefined ? null : ret.request.nfe.status
                                },
                                createdAt: new Date(ret.request.createdAt + "Z")
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            reason: ret.reason,
                            amount: ret.amount || 0
                        });

                    case 5:
                    case "end":
                        return _context69.stop();
                }
            }
        }, _callee69, this);
    }));

    return function createFine(_x167, _x168) {
        return _ref69.apply(this, arguments);
    };
}();

var sendMqttMessage = function () {
    var _ref70 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee70(topic, message, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee70$(_context70) {
            while (1) {
                switch (_context70.prev = _context70.next) {
                    case 0:
                        args = {
                            topic: topic,
                            message: message
                        };
                        _context70.next = 3;
                        return makeRequest({ name: "sendMqttMessage", args: args, progress: progress });

                    case 3:
                        return _context70.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context70.stop();
                }
            }
        }, _callee70, this);
    }));

    return function sendMqttMessage(_x169, _x170, _x171) {
        return _ref70.apply(this, arguments);
    };
}();

var editUser = function () {
    var _ref71 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee71(userId, editedUser, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee71$(_context71) {
            while (1) {
                switch (_context71.prev = _context71.next) {
                    case 0:
                        args = {
                            userId: userId,
                            editedUser: {
                                nick: editedUser.nick,
                                name: editedUser.name,
                                email: editedUser.email,
                                phone: {
                                    ddd: editedUser.phone.ddd,
                                    ddi: editedUser.phone.ddi,
                                    number: editedUser.phone.number
                                },
                                gender: editedUser.gender === null || editedUser.gender === undefined ? null : editedUser.gender,
                                birthday: editedUser.birthday === null || editedUser.birthday === undefined ? null : typeof editedUser.birthday === "string" ? new Date(new Date(editedUser.birthday).getTime() - new Date(editedUser.birthday).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(editedUser.birthday.getTime() - editedUser.birthday.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                height: editedUser.height === null || editedUser.height === undefined ? null : editedUser.height || 0,
                                address: {
                                    street: editedUser.address.street,
                                    neighborhood: editedUser.address.neighborhood,
                                    city: editedUser.address.city,
                                    uf: editedUser.address.uf,
                                    country: editedUser.address.country,
                                    number: editedUser.address.number,
                                    zip: editedUser.address.zip,
                                    adicionalInfo: editedUser.address.adicionalInfo,
                                    reference: editedUser.address.reference,
                                    location: {
                                        lat: editedUser.address.location.lat,
                                        lon: editedUser.address.location.lon
                                    }
                                }
                            }
                        };
                        _context71.next = 3;
                        return makeRequest({ name: "editUser", args: args, progress: progress });

                    case 3:
                        ret = _context71.sent;
                        return _context71.abrupt("return", {
                            id: ret.id,
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            name: ret.name,
                            nick: ret.nick,
                            cpf: ret.cpf,
                            email: ret.email,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            address: ret.address === null || ret.address === undefined ? null : {
                                street: ret.address.street,
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                number: ret.address.number,
                                zip: ret.address.zip,
                                adicionalInfo: ret.address.adicionalInfo,
                                reference: ret.address.reference,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            deletedAt: ret.deletedAt === null || ret.deletedAt === undefined ? null : new Date(ret.deletedAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context71.stop();
                }
            }
        }, _callee71, this);
    }));

    return function editUser(_x172, _x173, _x174) {
        return _ref71.apply(this, arguments);
    };
}();

var sendResetPasswordEmailAdminUser = function () {
    var _ref72 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee72(email, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee72$(_context72) {
            while (1) {
                switch (_context72.prev = _context72.next) {
                    case 0:
                        args = {
                            email: email
                        };
                        _context72.next = 3;
                        return makeRequest({ name: "sendResetPasswordEmailAdminUser", args: args, progress: progress });

                    case 3:
                        return _context72.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context72.stop();
                }
            }
        }, _callee72, this);
    }));

    return function sendResetPasswordEmailAdminUser(_x175, _x176) {
        return _ref72.apply(this, arguments);
    };
}();

var getRents = function () {
    var _ref73 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee73(page, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee73$(_context73) {
            while (1) {
                switch (_context73.prev = _context73.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0,
                            filter: filter === null || filter === undefined ? null : {
                                startRentDate: filter.startRentDate === null || filter.startRentDate === undefined ? null : {
                                    startDate: filter.startRentDate.startDate === null || filter.startRentDate.startDate === undefined ? null : typeof filter.startRentDate.startDate === "string" ? new Date(new Date(filter.startRentDate.startDate).getTime() - new Date(filter.startRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.startDate.getTime() - filter.startRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.startRentDate.endDate === null || filter.startRentDate.endDate === undefined ? null : typeof filter.startRentDate.endDate === "string" ? new Date(new Date(filter.startRentDate.endDate).getTime() - new Date(filter.startRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.endDate.getTime() - filter.startRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                endRentDate: filter.endRentDate === null || filter.endRentDate === undefined ? null : {
                                    startDate: filter.endRentDate.startDate === null || filter.endRentDate.startDate === undefined ? null : typeof filter.endRentDate.startDate === "string" ? new Date(new Date(filter.endRentDate.startDate).getTime() - new Date(filter.endRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.startDate.getTime() - filter.endRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.endRentDate.endDate === null || filter.endRentDate.endDate === undefined ? null : typeof filter.endRentDate.endDate === "string" ? new Date(new Date(filter.endRentDate.endDate).getTime() - new Date(filter.endRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.endDate.getTime() - filter.endRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                createdAtRentDate: filter.createdAtRentDate === null || filter.createdAtRentDate === undefined ? null : {
                                    startDate: filter.createdAtRentDate.startDate === null || filter.createdAtRentDate.startDate === undefined ? null : typeof filter.createdAtRentDate.startDate === "string" ? new Date(new Date(filter.createdAtRentDate.startDate).getTime() - new Date(filter.createdAtRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.startDate.getTime() - filter.createdAtRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtRentDate.endDate === null || filter.createdAtRentDate.endDate === undefined ? null : typeof filter.createdAtRentDate.endDate === "string" ? new Date(new Date(filter.createdAtRentDate.endDate).getTime() - new Date(filter.createdAtRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.endDate.getTime() - filter.createdAtRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context73.next = 3;
                        return makeRequest({ name: "getRents", args: args, progress: progress });

                    case 3:
                        ret = _context73.sent;
                        return _context73.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                numId: e.numId,
                                owner: {
                                    id: e.owner.id,
                                    gender: e.owner.gender === null || e.owner.gender === undefined ? null : e.owner.gender,
                                    birthday: e.owner.birthday === null || e.owner.birthday === undefined ? null : new Date(parseInt(e.owner.birthday.split("-")[0], 10), parseInt(e.owner.birthday.split("-")[1], 10) - 1, parseInt(e.owner.birthday.split("-")[2], 10)),
                                    name: e.owner.name,
                                    nick: e.owner.nick,
                                    cpf: e.owner.cpf,
                                    email: e.owner.email,
                                    phone: {
                                        ddd: e.owner.phone.ddd,
                                        ddi: e.owner.phone.ddi,
                                        number: e.owner.phone.number
                                    },
                                    avatar: e.owner.avatar === null || e.owner.avatar === undefined ? null : {
                                        width: e.owner.avatar.width || 0,
                                        height: e.owner.avatar.height || 0,
                                        url: e.owner.avatar.url
                                    },
                                    address: e.owner.address === null || e.owner.address === undefined ? null : {
                                        street: e.owner.address.street,
                                        neighborhood: e.owner.address.neighborhood,
                                        city: e.owner.address.city,
                                        uf: e.owner.address.uf,
                                        country: e.owner.address.country,
                                        number: e.owner.address.number,
                                        zip: e.owner.address.zip,
                                        adicionalInfo: e.owner.address.adicionalInfo,
                                        reference: e.owner.address.reference,
                                        location: {
                                            lat: e.owner.address.location.lat,
                                            lon: e.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.owner.createdAt + "Z"),
                                    deletedAt: e.owner.deletedAt === null || e.owner.deletedAt === undefined ? null : new Date(e.owner.deletedAt + "Z")
                                },
                                requester: {
                                    id: e.requester.id,
                                    gender: e.requester.gender === null || e.requester.gender === undefined ? null : e.requester.gender,
                                    birthday: e.requester.birthday === null || e.requester.birthday === undefined ? null : new Date(parseInt(e.requester.birthday.split("-")[0], 10), parseInt(e.requester.birthday.split("-")[1], 10) - 1, parseInt(e.requester.birthday.split("-")[2], 10)),
                                    name: e.requester.name,
                                    nick: e.requester.nick,
                                    cpf: e.requester.cpf,
                                    email: e.requester.email,
                                    phone: {
                                        ddd: e.requester.phone.ddd,
                                        ddi: e.requester.phone.ddi,
                                        number: e.requester.phone.number
                                    },
                                    avatar: e.requester.avatar === null || e.requester.avatar === undefined ? null : {
                                        width: e.requester.avatar.width || 0,
                                        height: e.requester.avatar.height || 0,
                                        url: e.requester.avatar.url
                                    },
                                    address: e.requester.address === null || e.requester.address === undefined ? null : {
                                        street: e.requester.address.street,
                                        neighborhood: e.requester.address.neighborhood,
                                        city: e.requester.address.city,
                                        uf: e.requester.address.uf,
                                        country: e.requester.address.country,
                                        number: e.requester.address.number,
                                        zip: e.requester.address.zip,
                                        adicionalInfo: e.requester.address.adicionalInfo,
                                        reference: e.requester.address.reference,
                                        location: {
                                            lat: e.requester.address.location.lat,
                                            lon: e.requester.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.requester.createdAt + "Z"),
                                    deletedAt: e.requester.deletedAt === null || e.requester.deletedAt === undefined ? null : new Date(e.requester.deletedAt + "Z")
                                },
                                item: {
                                    thumbImage: {
                                        width: e.item.thumbImage.width || 0,
                                        height: e.item.thumbImage.height || 0,
                                        url: e.item.thumbImage.url
                                    },
                                    calendar: e.item.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    adjustment: !!e.item.adjustment,
                                    category: e.item.category,
                                    color: e.item.color,
                                    details: e.item.details,
                                    gender: e.item.gender,
                                    images: e.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.item.brand === null || e.item.brand === undefined ? null : e.item.brand,
                                    ocasions: e.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    size: e.item.size,
                                    salePrice: e.item.salePrice === null || e.item.salePrice === undefined ? null : e.item.salePrice || 0,
                                    rentPrice: e.item.rentPrice === null || e.item.rentPrice === undefined ? null : e.item.rentPrice || 0,
                                    originalPrice: e.item.originalPrice || 0
                                },
                                transport: e.transport === null || e.transport === undefined ? null : {
                                    requester: {
                                        street: e.transport.requester.street,
                                        neighborhood: e.transport.requester.neighborhood,
                                        city: e.transport.requester.city,
                                        uf: e.transport.requester.uf,
                                        country: e.transport.requester.country,
                                        number: e.transport.requester.number,
                                        zip: e.transport.requester.zip,
                                        adicionalInfo: e.transport.requester.adicionalInfo,
                                        reference: e.transport.requester.reference,
                                        location: {
                                            lat: e.transport.requester.location.lat,
                                            lon: e.transport.requester.location.lon
                                        }
                                    },
                                    owner: {
                                        street: e.transport.owner.street,
                                        neighborhood: e.transport.owner.neighborhood,
                                        city: e.transport.owner.city,
                                        uf: e.transport.owner.uf,
                                        country: e.transport.owner.country,
                                        number: e.transport.owner.number,
                                        zip: e.transport.owner.zip,
                                        adicionalInfo: e.transport.owner.adicionalInfo,
                                        reference: e.transport.owner.reference,
                                        location: {
                                            lat: e.transport.owner.location.lat,
                                            lon: e.transport.owner.location.lon
                                        }
                                    },
                                    price: e.transport.price || 0
                                },
                                period: {
                                    start: new Date(parseInt(e.period.start.split("-")[0], 10), parseInt(e.period.start.split("-")[1], 10) - 1, parseInt(e.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.period.end.split("-")[0], 10), parseInt(e.period.end.split("-")[1], 10) - 1, parseInt(e.period.end.split("-")[2], 10))
                                },
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                statusList: e.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: e.currentStatus.status,
                                    changeDate: new Date(parseInt(e.currentStatus.changeDate.split("-")[0], 10), parseInt(e.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: e.currentStatus.actionBy === null || e.currentStatus.actionBy === undefined ? null : e.currentStatus.actionBy,
                                    pending: !!e.currentStatus.pending
                                },
                                payment: e.payment === null || e.payment === undefined ? null : {
                                    transactionId: e.payment.transactionId || 0,
                                    lastDigits: e.payment.lastDigits,
                                    brand: e.payment.brand,
                                    paidAmount: e.payment.paidAmount || 0,
                                    status: e.payment.status,
                                    locSplit: {
                                        id: e.payment.locSplit.id,
                                        recipientId: e.payment.locSplit.recipientId,
                                        amount: e.payment.locSplit.amount || 0
                                    },
                                    ownerSplit: {
                                        id: e.payment.ownerSplit.id,
                                        recipientId: e.payment.ownerSplit.recipientId,
                                        amount: e.payment.ownerSplit.amount || 0
                                    }
                                },
                                promotion: {
                                    card: e.promotion.card === null || e.promotion.card === undefined ? null : {
                                        transactionId: e.promotion.card.transactionId || 0,
                                        lastDigits: e.promotion.card.lastDigits,
                                        brand: e.promotion.card.brand,
                                        paidAmount: e.promotion.card.paidAmount || 0,
                                        status: e.promotion.card.status,
                                        locSplit: {
                                            id: e.promotion.card.locSplit.id,
                                            recipientId: e.promotion.card.locSplit.recipientId,
                                            amount: e.promotion.card.locSplit.amount || 0
                                        },
                                        ownerSplit: {
                                            id: e.promotion.card.ownerSplit.id,
                                            recipientId: e.promotion.card.ownerSplit.recipientId,
                                            amount: e.promotion.card.ownerSplit.amount || 0
                                        }
                                    },
                                    type: e.promotion.type === null || e.promotion.type === undefined ? null : e.promotion.type,
                                    total: e.promotion.total || 0,
                                    id: e.promotion.id === null || e.promotion.id === undefined ? null : e.promotion.id
                                },
                                nfe: {
                                    id: e.nfe.id === null || e.nfe.id === undefined ? null : e.nfe.id,
                                    number: e.nfe.number === null || e.nfe.number === undefined ? null : e.nfe.number || 0,
                                    emitedAt: e.nfe.emitedAt === null || e.nfe.emitedAt === undefined ? null : new Date(e.nfe.emitedAt + "Z"),
                                    canceledAt: e.nfe.canceledAt === null || e.nfe.canceledAt === undefined ? null : new Date(e.nfe.canceledAt + "Z"),
                                    status: e.nfe.status === null || e.nfe.status === undefined ? null : e.nfe.status
                                },
                                createdAt: new Date(e.createdAt + "Z")
                            };
                        }));

                    case 5:
                    case "end":
                        return _context73.stop();
                }
            }
        }, _callee73, this);
    }));

    return function getRents(_x177, _x178, _x179) {
        return _ref73.apply(this, arguments);
    };
}();

var getRentsReportForAdminUser = function () {
    var _ref74 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee74(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee74$(_context74) {
            while (1) {
                switch (_context74.prev = _context74.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                startRentDate: filter.startRentDate === null || filter.startRentDate === undefined ? null : {
                                    startDate: filter.startRentDate.startDate === null || filter.startRentDate.startDate === undefined ? null : typeof filter.startRentDate.startDate === "string" ? new Date(new Date(filter.startRentDate.startDate).getTime() - new Date(filter.startRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.startDate.getTime() - filter.startRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.startRentDate.endDate === null || filter.startRentDate.endDate === undefined ? null : typeof filter.startRentDate.endDate === "string" ? new Date(new Date(filter.startRentDate.endDate).getTime() - new Date(filter.startRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.endDate.getTime() - filter.startRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                endRentDate: filter.endRentDate === null || filter.endRentDate === undefined ? null : {
                                    startDate: filter.endRentDate.startDate === null || filter.endRentDate.startDate === undefined ? null : typeof filter.endRentDate.startDate === "string" ? new Date(new Date(filter.endRentDate.startDate).getTime() - new Date(filter.endRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.startDate.getTime() - filter.endRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.endRentDate.endDate === null || filter.endRentDate.endDate === undefined ? null : typeof filter.endRentDate.endDate === "string" ? new Date(new Date(filter.endRentDate.endDate).getTime() - new Date(filter.endRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.endDate.getTime() - filter.endRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                createdAtRentDate: filter.createdAtRentDate === null || filter.createdAtRentDate === undefined ? null : {
                                    startDate: filter.createdAtRentDate.startDate === null || filter.createdAtRentDate.startDate === undefined ? null : typeof filter.createdAtRentDate.startDate === "string" ? new Date(new Date(filter.createdAtRentDate.startDate).getTime() - new Date(filter.createdAtRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.startDate.getTime() - filter.createdAtRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtRentDate.endDate === null || filter.createdAtRentDate.endDate === undefined ? null : typeof filter.createdAtRentDate.endDate === "string" ? new Date(new Date(filter.createdAtRentDate.endDate).getTime() - new Date(filter.createdAtRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.endDate.getTime() - filter.createdAtRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context74.next = 3;
                        return makeRequest({ name: "getRentsReportForAdminUser", args: args, progress: progress });

                    case 3:
                        ret = _context74.sent;
                        return _context74.abrupt("return", ret);

                    case 5:
                    case "end":
                        return _context74.stop();
                }
            }
        }, _callee74, this);
    }));

    return function getRentsReportForAdminUser(_x180, _x181) {
        return _ref74.apply(this, arguments);
    };
}();

var getRentsStats = function () {
    var _ref75 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee75(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee75$(_context75) {
            while (1) {
                switch (_context75.prev = _context75.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                startRentDate: filter.startRentDate === null || filter.startRentDate === undefined ? null : {
                                    startDate: filter.startRentDate.startDate === null || filter.startRentDate.startDate === undefined ? null : typeof filter.startRentDate.startDate === "string" ? new Date(new Date(filter.startRentDate.startDate).getTime() - new Date(filter.startRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.startDate.getTime() - filter.startRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.startRentDate.endDate === null || filter.startRentDate.endDate === undefined ? null : typeof filter.startRentDate.endDate === "string" ? new Date(new Date(filter.startRentDate.endDate).getTime() - new Date(filter.startRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.startRentDate.endDate.getTime() - filter.startRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                endRentDate: filter.endRentDate === null || filter.endRentDate === undefined ? null : {
                                    startDate: filter.endRentDate.startDate === null || filter.endRentDate.startDate === undefined ? null : typeof filter.endRentDate.startDate === "string" ? new Date(new Date(filter.endRentDate.startDate).getTime() - new Date(filter.endRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.startDate.getTime() - filter.endRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.endRentDate.endDate === null || filter.endRentDate.endDate === undefined ? null : typeof filter.endRentDate.endDate === "string" ? new Date(new Date(filter.endRentDate.endDate).getTime() - new Date(filter.endRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.endRentDate.endDate.getTime() - filter.endRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                createdAtRentDate: filter.createdAtRentDate === null || filter.createdAtRentDate === undefined ? null : {
                                    startDate: filter.createdAtRentDate.startDate === null || filter.createdAtRentDate.startDate === undefined ? null : typeof filter.createdAtRentDate.startDate === "string" ? new Date(new Date(filter.createdAtRentDate.startDate).getTime() - new Date(filter.createdAtRentDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.startDate.getTime() - filter.createdAtRentDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtRentDate.endDate === null || filter.createdAtRentDate.endDate === undefined ? null : typeof filter.createdAtRentDate.endDate === "string" ? new Date(new Date(filter.createdAtRentDate.endDate).getTime() - new Date(filter.createdAtRentDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtRentDate.endDate.getTime() - filter.createdAtRentDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context75.next = 3;
                        return makeRequest({ name: "getRentsStats", args: args, progress: progress });

                    case 3:
                        ret = _context75.sent;
                        return _context75.abrupt("return", {
                            totalAmount: ret.totalAmount || 0,
                            averageTicked: ret.averageTicked || 0,
                            totalPrice: ret.totalPrice || 0
                        });

                    case 5:
                    case "end":
                        return _context75.stop();
                }
            }
        }, _callee75, this);
    }));

    return function getRentsStats(_x182, _x183) {
        return _ref75.apply(this, arguments);
    };
}();

var getPromotion = function () {
    var _ref76 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee76(promotionId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee76$(_context76) {
            while (1) {
                switch (_context76.prev = _context76.next) {
                    case 0:
                        args = {
                            promotionId: promotionId
                        };
                        _context76.next = 3;
                        return makeRequest({ name: "getPromotion", args: args, progress: progress });

                    case 3:
                        ret = _context76.sent;
                        return _context76.abrupt("return", {
                            uses: ret.uses || 0,
                            createdAt: new Date(ret.createdAt + "Z"),
                            deletedAt: ret.deletedAt === null || ret.deletedAt === undefined ? null : new Date(ret.deletedAt + "Z"),
                            cityIds: ret.cityIds === null || ret.cityIds === undefined ? null : ret.cityIds.map(function (e) {
                                return e;
                            }),
                            id: ret.id,
                            value: ret.value === null || ret.value === undefined ? null : ret.value || 0,
                            percentage: ret.percentage === null || ret.percentage === undefined ? null : ret.percentage || 0,
                            type: ret.type,
                            usageType: ret.usageType,
                            maxUsesPerUser: ret.maxUsesPerUser === null || ret.maxUsesPerUser === undefined ? null : ret.maxUsesPerUser || 0,
                            maxUses: ret.maxUses || 0,
                            expirationDate: new Date(ret.expirationDate + "Z"),
                            userIds: ret.userIds === null || ret.userIds === undefined ? null : ret.userIds.map(function (e) {
                                return e;
                            })
                        });

                    case 5:
                    case "end":
                        return _context76.stop();
                }
            }
        }, _callee76, this);
    }));

    return function getPromotion(_x184, _x185) {
        return _ref76.apply(this, arguments);
    };
}();

var getPromotions = function () {
    var _ref77 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee77(page, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee77$(_context77) {
            while (1) {
                switch (_context77.prev = _context77.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0,
                            filter: filter === null || filter === undefined ? null : {
                                id: filter.id === null || filter.id === undefined ? null : filter.id,
                                expirationDate: filter.expirationDate === null || filter.expirationDate === undefined ? null : {
                                    startDate: filter.expirationDate.startDate === null || filter.expirationDate.startDate === undefined ? null : typeof filter.expirationDate.startDate === "string" ? new Date(new Date(filter.expirationDate.startDate).getTime() - new Date(filter.expirationDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.expirationDate.startDate.getTime() - filter.expirationDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.expirationDate.endDate === null || filter.expirationDate.endDate === undefined ? null : typeof filter.expirationDate.endDate === "string" ? new Date(new Date(filter.expirationDate.endDate).getTime() - new Date(filter.expirationDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.expirationDate.endDate.getTime() - filter.expirationDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                createdAtDate: filter.createdAtDate === null || filter.createdAtDate === undefined ? null : {
                                    startDate: filter.createdAtDate.startDate === null || filter.createdAtDate.startDate === undefined ? null : typeof filter.createdAtDate.startDate === "string" ? new Date(new Date(filter.createdAtDate.startDate).getTime() - new Date(filter.createdAtDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtDate.startDate.getTime() - filter.createdAtDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtDate.endDate === null || filter.createdAtDate.endDate === undefined ? null : typeof filter.createdAtDate.endDate === "string" ? new Date(new Date(filter.createdAtDate.endDate).getTime() - new Date(filter.createdAtDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtDate.endDate.getTime() - filter.createdAtDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                }
                            }
                        };
                        _context77.next = 3;
                        return makeRequest({ name: "getPromotions", args: args, progress: progress });

                    case 3:
                        ret = _context77.sent;
                        return _context77.abrupt("return", ret.map(function (e) {
                            return {
                                uses: e.uses || 0,
                                createdAt: new Date(e.createdAt + "Z"),
                                deletedAt: e.deletedAt === null || e.deletedAt === undefined ? null : new Date(e.deletedAt + "Z"),
                                cityIds: e.cityIds === null || e.cityIds === undefined ? null : e.cityIds.map(function (e) {
                                    return e;
                                }),
                                id: e.id,
                                value: e.value === null || e.value === undefined ? null : e.value || 0,
                                percentage: e.percentage === null || e.percentage === undefined ? null : e.percentage || 0,
                                type: e.type,
                                usageType: e.usageType,
                                maxUsesPerUser: e.maxUsesPerUser === null || e.maxUsesPerUser === undefined ? null : e.maxUsesPerUser || 0,
                                maxUses: e.maxUses || 0,
                                expirationDate: new Date(e.expirationDate + "Z"),
                                userIds: e.userIds === null || e.userIds === undefined ? null : e.userIds.map(function (e) {
                                    return e;
                                })
                            };
                        }));

                    case 5:
                    case "end":
                        return _context77.stop();
                }
            }
        }, _callee77, this);
    }));

    return function getPromotions(_x186, _x187, _x188) {
        return _ref77.apply(this, arguments);
    };
}();

var createOrEditPromotion = function () {
    var _ref78 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee78(promotionDetails, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee78$(_context78) {
            while (1) {
                switch (_context78.prev = _context78.next) {
                    case 0:
                        args = {
                            promotionDetails: {
                                id: promotionDetails.id,
                                value: promotionDetails.value === null || promotionDetails.value === undefined ? null : promotionDetails.value || 0,
                                percentage: promotionDetails.percentage === null || promotionDetails.percentage === undefined ? null : promotionDetails.percentage || 0,
                                type: promotionDetails.type,
                                usageType: promotionDetails.usageType,
                                maxUsesPerUser: promotionDetails.maxUsesPerUser === null || promotionDetails.maxUsesPerUser === undefined ? null : promotionDetails.maxUsesPerUser || 0,
                                maxUses: promotionDetails.maxUses || 0,
                                expirationDate: typeof promotionDetails.expirationDate === "string" && promotionDetails.expirationDate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? promotionDetails.expirationDate.replace("Z", "") : promotionDetails.expirationDate.toISOString().replace("Z", ""),
                                userIds: promotionDetails.userIds === null || promotionDetails.userIds === undefined ? null : promotionDetails.userIds.map(function (e) {
                                    return e;
                                })
                            }
                        };
                        _context78.next = 3;
                        return makeRequest({ name: "createOrEditPromotion", args: args, progress: progress });

                    case 3:
                        ret = _context78.sent;
                        return _context78.abrupt("return", {
                            uses: ret.uses || 0,
                            createdAt: new Date(ret.createdAt + "Z"),
                            deletedAt: ret.deletedAt === null || ret.deletedAt === undefined ? null : new Date(ret.deletedAt + "Z"),
                            cityIds: ret.cityIds === null || ret.cityIds === undefined ? null : ret.cityIds.map(function (e) {
                                return e;
                            }),
                            id: ret.id,
                            value: ret.value === null || ret.value === undefined ? null : ret.value || 0,
                            percentage: ret.percentage === null || ret.percentage === undefined ? null : ret.percentage || 0,
                            type: ret.type,
                            usageType: ret.usageType,
                            maxUsesPerUser: ret.maxUsesPerUser === null || ret.maxUsesPerUser === undefined ? null : ret.maxUsesPerUser || 0,
                            maxUses: ret.maxUses || 0,
                            expirationDate: new Date(ret.expirationDate + "Z"),
                            userIds: ret.userIds === null || ret.userIds === undefined ? null : ret.userIds.map(function (e) {
                                return e;
                            })
                        });

                    case 5:
                    case "end":
                        return _context78.stop();
                }
            }
        }, _callee78, this);
    }));

    return function createOrEditPromotion(_x189, _x190) {
        return _ref78.apply(this, arguments);
    };
}();

var getReport = function () {
    var _ref79 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee79(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee79$(_context79) {
            while (1) {
                switch (_context79.prev = _context79.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context79.next = 3;
                        return makeRequest({ name: "getReport", args: args, progress: progress });

                    case 3:
                        ret = _context79.sent;
                        return _context79.abrupt("return", {
                            numberOfUser: ret.numberOfUser || 0,
                            numberOfPieces: ret.numberOfPieces || 0,
                            piecesTotalSum: ret.piecesTotalSum || 0,
                            averageTicket: ret.averageTicket || 0,
                            averageSalesTicket: ret.averageSalesTicket || 0,
                            totalOfRents: ret.totalOfRents || 0,
                            totalOfSales: ret.totalOfSales || 0
                        });

                    case 5:
                    case "end":
                        return _context79.stop();
                }
            }
        }, _callee79, this);
    }));

    return function getReport(_x191, _x192, _x193) {
        return _ref79.apply(this, arguments);
    };
}();

var getUsersPerDate = function () {
    var _ref80 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee80(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee80$(_context80) {
            while (1) {
                switch (_context80.prev = _context80.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context80.next = 3;
                        return makeRequest({ name: "getUsersPerDate", args: args, progress: progress });

                    case 3:
                        ret = _context80.sent;
                        return _context80.abrupt("return", ret.map(function (e) {
                            return {
                                date: new Date(parseInt(e.date.split("-")[0], 10), parseInt(e.date.split("-")[1], 10) - 1, parseInt(e.date.split("-")[2], 10)),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context80.stop();
                }
            }
        }, _callee80, this);
    }));

    return function getUsersPerDate(_x194, _x195, _x196) {
        return _ref80.apply(this, arguments);
    };
}();

var getUsersPerDateHour = function () {
    var _ref81 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee81(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee81$(_context81) {
            while (1) {
                switch (_context81.prev = _context81.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context81.next = 3;
                        return makeRequest({ name: "getUsersPerDateHour", args: args, progress: progress });

                    case 3:
                        ret = _context81.sent;
                        return _context81.abrupt("return", ret.map(function (e) {
                            return {
                                dateHour: new Date(e.dateHour + "Z"),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context81.stop();
                }
            }
        }, _callee81, this);
    }));

    return function getUsersPerDateHour(_x197, _x198, _x199) {
        return _ref81.apply(this, arguments);
    };
}();

var getUsersPerHour = function () {
    var _ref82 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee82(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee82$(_context82) {
            while (1) {
                switch (_context82.prev = _context82.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context82.next = 3;
                        return makeRequest({ name: "getUsersPerHour", args: args, progress: progress });

                    case 3:
                        ret = _context82.sent;
                        return _context82.abrupt("return", ret.map(function (e) {
                            return {
                                hour: e.hour || 0,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context82.stop();
                }
            }
        }, _callee82, this);
    }));

    return function getUsersPerHour(_x200, _x201, _x202) {
        return _ref82.apply(this, arguments);
    };
}();

var getItemsPerDate = function () {
    var _ref83 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee83(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee83$(_context83) {
            while (1) {
                switch (_context83.prev = _context83.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context83.next = 3;
                        return makeRequest({ name: "getItemsPerDate", args: args, progress: progress });

                    case 3:
                        ret = _context83.sent;
                        return _context83.abrupt("return", ret.map(function (e) {
                            return {
                                date: new Date(parseInt(e.date.split("-")[0], 10), parseInt(e.date.split("-")[1], 10) - 1, parseInt(e.date.split("-")[2], 10)),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context83.stop();
                }
            }
        }, _callee83, this);
    }));

    return function getItemsPerDate(_x203, _x204, _x205) {
        return _ref83.apply(this, arguments);
    };
}();

var getItemsPerDateHour = function () {
    var _ref84 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee84(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee84$(_context84) {
            while (1) {
                switch (_context84.prev = _context84.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context84.next = 3;
                        return makeRequest({ name: "getItemsPerDateHour", args: args, progress: progress });

                    case 3:
                        ret = _context84.sent;
                        return _context84.abrupt("return", ret.map(function (e) {
                            return {
                                dateHour: new Date(e.dateHour + "Z"),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context84.stop();
                }
            }
        }, _callee84, this);
    }));

    return function getItemsPerDateHour(_x206, _x207, _x208) {
        return _ref84.apply(this, arguments);
    };
}();

var getItemsPerHour = function () {
    var _ref85 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee85(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee85$(_context85) {
            while (1) {
                switch (_context85.prev = _context85.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context85.next = 3;
                        return makeRequest({ name: "getItemsPerHour", args: args, progress: progress });

                    case 3:
                        ret = _context85.sent;
                        return _context85.abrupt("return", ret.map(function (e) {
                            return {
                                hour: e.hour || 0,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context85.stop();
                }
            }
        }, _callee85, this);
    }));

    return function getItemsPerHour(_x209, _x210, _x211) {
        return _ref85.apply(this, arguments);
    };
}();

var getItemsPerCategory = function () {
    var _ref86 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee86(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee86$(_context86) {
            while (1) {
                switch (_context86.prev = _context86.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context86.next = 3;
                        return makeRequest({ name: "getItemsPerCategory", args: args, progress: progress });

                    case 3:
                        ret = _context86.sent;
                        return _context86.abrupt("return", ret.map(function (e) {
                            return {
                                category: e.category,
                                number: e.number || 0,
                                originalPrice: e.originalPrice || 0,
                                rentPrice: e.rentPrice || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context86.stop();
                }
            }
        }, _callee86, this);
    }));

    return function getItemsPerCategory(_x212, _x213, _x214) {
        return _ref86.apply(this, arguments);
    };
}();

var getItemsPerColor = function () {
    var _ref87 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee87(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee87$(_context87) {
            while (1) {
                switch (_context87.prev = _context87.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context87.next = 3;
                        return makeRequest({ name: "getItemsPerColor", args: args, progress: progress });

                    case 3:
                        ret = _context87.sent;
                        return _context87.abrupt("return", ret.map(function (e) {
                            return {
                                color: e.color,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context87.stop();
                }
            }
        }, _callee87, this);
    }));

    return function getItemsPerColor(_x215, _x216, _x217) {
        return _ref87.apply(this, arguments);
    };
}();

var getItemsPerDepartment = function () {
    var _ref88 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee88(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee88$(_context88) {
            while (1) {
                switch (_context88.prev = _context88.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context88.next = 3;
                        return makeRequest({ name: "getItemsPerDepartment", args: args, progress: progress });

                    case 3:
                        ret = _context88.sent;
                        return _context88.abrupt("return", ret.map(function (e) {
                            return {
                                department: e.department,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context88.stop();
                }
            }
        }, _callee88, this);
    }));

    return function getItemsPerDepartment(_x218, _x219, _x220) {
        return _ref88.apply(this, arguments);
    };
}();

var getItemsPerSize = function () {
    var _ref89 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee89(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee89$(_context89) {
            while (1) {
                switch (_context89.prev = _context89.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context89.next = 3;
                        return makeRequest({ name: "getItemsPerSize", args: args, progress: progress });

                    case 3:
                        ret = _context89.sent;
                        return _context89.abrupt("return", ret.map(function (e) {
                            return {
                                size: e.size,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context89.stop();
                }
            }
        }, _callee89, this);
    }));

    return function getItemsPerSize(_x221, _x222, _x223) {
        return _ref89.apply(this, arguments);
    };
}();

var getItemsPerBrand = function () {
    var _ref90 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee90(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee90$(_context90) {
            while (1) {
                switch (_context90.prev = _context90.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context90.next = 3;
                        return makeRequest({ name: "getItemsPerBrand", args: args, progress: progress });

                    case 3:
                        ret = _context90.sent;
                        return _context90.abrupt("return", ret.map(function (e) {
                            return {
                                label: e.label,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context90.stop();
                }
            }
        }, _callee90, this);
    }));

    return function getItemsPerBrand(_x224, _x225, _x226) {
        return _ref90.apply(this, arguments);
    };
}();

var getRentsPerDate = function () {
    var _ref91 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee91(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee91$(_context91) {
            while (1) {
                switch (_context91.prev = _context91.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context91.next = 3;
                        return makeRequest({ name: "getRentsPerDate", args: args, progress: progress });

                    case 3:
                        ret = _context91.sent;
                        return _context91.abrupt("return", ret.map(function (e) {
                            return {
                                date: new Date(parseInt(e.date.split("-")[0], 10), parseInt(e.date.split("-")[1], 10) - 1, parseInt(e.date.split("-")[2], 10)),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context91.stop();
                }
            }
        }, _callee91, this);
    }));

    return function getRentsPerDate(_x227, _x228, _x229) {
        return _ref91.apply(this, arguments);
    };
}();

var getRentsPerDateHour = function () {
    var _ref92 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee92(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee92$(_context92) {
            while (1) {
                switch (_context92.prev = _context92.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context92.next = 3;
                        return makeRequest({ name: "getRentsPerDateHour", args: args, progress: progress });

                    case 3:
                        ret = _context92.sent;
                        return _context92.abrupt("return", ret.map(function (e) {
                            return {
                                dateHour: new Date(e.dateHour + "Z"),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context92.stop();
                }
            }
        }, _callee92, this);
    }));

    return function getRentsPerDateHour(_x230, _x231, _x232) {
        return _ref92.apply(this, arguments);
    };
}();

var getRentsPerHour = function () {
    var _ref93 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee93(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee93$(_context93) {
            while (1) {
                switch (_context93.prev = _context93.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context93.next = 3;
                        return makeRequest({ name: "getRentsPerHour", args: args, progress: progress });

                    case 3:
                        ret = _context93.sent;
                        return _context93.abrupt("return", ret.map(function (e) {
                            return {
                                hour: e.hour || 0,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context93.stop();
                }
            }
        }, _callee93, this);
    }));

    return function getRentsPerHour(_x233, _x234, _x235) {
        return _ref93.apply(this, arguments);
    };
}();

var getSalesPerDate = function () {
    var _ref94 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee94(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee94$(_context94) {
            while (1) {
                switch (_context94.prev = _context94.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context94.next = 3;
                        return makeRequest({ name: "getSalesPerDate", args: args, progress: progress });

                    case 3:
                        ret = _context94.sent;
                        return _context94.abrupt("return", ret.map(function (e) {
                            return {
                                date: new Date(parseInt(e.date.split("-")[0], 10), parseInt(e.date.split("-")[1], 10) - 1, parseInt(e.date.split("-")[2], 10)),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context94.stop();
                }
            }
        }, _callee94, this);
    }));

    return function getSalesPerDate(_x236, _x237, _x238) {
        return _ref94.apply(this, arguments);
    };
}();

var getSalesPerDateHour = function () {
    var _ref95 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee95(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee95$(_context95) {
            while (1) {
                switch (_context95.prev = _context95.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context95.next = 3;
                        return makeRequest({ name: "getSalesPerDateHour", args: args, progress: progress });

                    case 3:
                        ret = _context95.sent;
                        return _context95.abrupt("return", ret.map(function (e) {
                            return {
                                dateHour: new Date(e.dateHour + "Z"),
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context95.stop();
                }
            }
        }, _callee95, this);
    }));

    return function getSalesPerDateHour(_x239, _x240, _x241) {
        return _ref95.apply(this, arguments);
    };
}();

var getSalesPerHour = function () {
    var _ref96 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee96(startDate, endDate, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee96$(_context96) {
            while (1) {
                switch (_context96.prev = _context96.next) {
                    case 0:
                        args = {
                            startDate: startDate === null || startDate === undefined ? null : typeof startDate === "string" ? new Date(new Date(startDate).getTime() - new Date(startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                            endDate: endDate === null || endDate === undefined ? null : typeof endDate === "string" ? new Date(new Date(endDate).getTime() - new Date(endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                        };
                        _context96.next = 3;
                        return makeRequest({ name: "getSalesPerHour", args: args, progress: progress });

                    case 3:
                        ret = _context96.sent;
                        return _context96.abrupt("return", ret.map(function (e) {
                            return {
                                hour: e.hour || 0,
                                number: e.number || 0
                            };
                        }));

                    case 5:
                    case "end":
                        return _context96.stop();
                }
            }
        }, _callee96, this);
    }));

    return function getSalesPerHour(_x242, _x243, _x244) {
        return _ref96.apply(this, arguments);
    };
}();

var getSale = function () {
    var _ref97 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee97(saleId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee97$(_context97) {
            while (1) {
                switch (_context97.prev = _context97.next) {
                    case 0:
                        args = {
                            saleId: saleId
                        };
                        _context97.next = 3;
                        return makeRequest({ name: "getSale", args: args, progress: progress });

                    case 3:
                        ret = _context97.sent;
                        return _context97.abrupt("return", {
                            id: ret.id,
                            simpleId: ret.simpleId,
                            price: ret.price || 0,
                            item: {
                                id: ret.item.id,
                                owner: {
                                    id: ret.item.owner.id,
                                    gender: ret.item.owner.gender === null || ret.item.owner.gender === undefined ? null : ret.item.owner.gender,
                                    birthday: ret.item.owner.birthday === null || ret.item.owner.birthday === undefined ? null : new Date(parseInt(ret.item.owner.birthday.split("-")[0], 10), parseInt(ret.item.owner.birthday.split("-")[1], 10) - 1, parseInt(ret.item.owner.birthday.split("-")[2], 10)),
                                    name: ret.item.owner.name,
                                    nick: ret.item.owner.nick,
                                    cpf: ret.item.owner.cpf,
                                    email: ret.item.owner.email,
                                    phone: {
                                        ddd: ret.item.owner.phone.ddd,
                                        ddi: ret.item.owner.phone.ddi,
                                        number: ret.item.owner.phone.number
                                    },
                                    avatar: ret.item.owner.avatar === null || ret.item.owner.avatar === undefined ? null : {
                                        width: ret.item.owner.avatar.width || 0,
                                        height: ret.item.owner.avatar.height || 0,
                                        url: ret.item.owner.avatar.url
                                    },
                                    address: ret.item.owner.address === null || ret.item.owner.address === undefined ? null : {
                                        street: ret.item.owner.address.street,
                                        neighborhood: ret.item.owner.address.neighborhood,
                                        city: ret.item.owner.address.city,
                                        uf: ret.item.owner.address.uf,
                                        country: ret.item.owner.address.country,
                                        number: ret.item.owner.address.number,
                                        zip: ret.item.owner.address.zip,
                                        adicionalInfo: ret.item.owner.address.adicionalInfo,
                                        reference: ret.item.owner.address.reference,
                                        location: {
                                            lat: ret.item.owner.address.location.lat,
                                            lon: ret.item.owner.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(ret.item.owner.createdAt + "Z"),
                                    deletedAt: ret.item.owner.deletedAt === null || ret.item.owner.deletedAt === undefined ? null : new Date(ret.item.owner.deletedAt + "Z")
                                },
                                calendar: ret.item.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                createdAt: new Date(ret.item.createdAt + "Z"),
                                department: ret.item.department,
                                adjustment: !!ret.item.adjustment,
                                category: ret.item.category === null || ret.item.category === undefined ? null : ret.item.category,
                                color: ret.item.color === null || ret.item.color === undefined ? null : ret.item.color,
                                details: ret.item.details,
                                gender: ret.item.gender,
                                thumbImage: {
                                    width: ret.item.thumbImage.width || 0,
                                    height: ret.item.thumbImage.height || 0,
                                    url: ret.item.thumbImage.url
                                },
                                images: ret.item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: ret.item.brand === null || ret.item.brand === undefined ? null : ret.item.brand,
                                ocasions: ret.item.ocasions.map(function (e) {
                                    return e === null || e === undefined ? null : e;
                                }),
                                size: ret.item.size === null || ret.item.size === undefined ? null : ret.item.size,
                                rentPrice: ret.item.rentPrice === null || ret.item.rentPrice === undefined ? null : ret.item.rentPrice || 0,
                                salePrice: ret.item.salePrice === null || ret.item.salePrice === undefined ? null : ret.item.salePrice || 0,
                                originalPrice: ret.item.originalPrice || 0
                            },
                            seller: {
                                id: ret.seller.id,
                                gender: ret.seller.gender === null || ret.seller.gender === undefined ? null : ret.seller.gender,
                                birthday: ret.seller.birthday === null || ret.seller.birthday === undefined ? null : new Date(parseInt(ret.seller.birthday.split("-")[0], 10), parseInt(ret.seller.birthday.split("-")[1], 10) - 1, parseInt(ret.seller.birthday.split("-")[2], 10)),
                                name: ret.seller.name,
                                nick: ret.seller.nick,
                                cpf: ret.seller.cpf,
                                email: ret.seller.email,
                                phone: {
                                    ddd: ret.seller.phone.ddd,
                                    ddi: ret.seller.phone.ddi,
                                    number: ret.seller.phone.number
                                },
                                avatar: ret.seller.avatar === null || ret.seller.avatar === undefined ? null : {
                                    width: ret.seller.avatar.width || 0,
                                    height: ret.seller.avatar.height || 0,
                                    url: ret.seller.avatar.url
                                },
                                address: ret.seller.address === null || ret.seller.address === undefined ? null : {
                                    street: ret.seller.address.street,
                                    neighborhood: ret.seller.address.neighborhood,
                                    city: ret.seller.address.city,
                                    uf: ret.seller.address.uf,
                                    country: ret.seller.address.country,
                                    number: ret.seller.address.number,
                                    zip: ret.seller.address.zip,
                                    adicionalInfo: ret.seller.address.adicionalInfo,
                                    reference: ret.seller.address.reference,
                                    location: {
                                        lat: ret.seller.address.location.lat,
                                        lon: ret.seller.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.seller.createdAt + "Z"),
                                deletedAt: ret.seller.deletedAt === null || ret.seller.deletedAt === undefined ? null : new Date(ret.seller.deletedAt + "Z")
                            },
                            buyer: {
                                id: ret.buyer.id,
                                gender: ret.buyer.gender === null || ret.buyer.gender === undefined ? null : ret.buyer.gender,
                                birthday: ret.buyer.birthday === null || ret.buyer.birthday === undefined ? null : new Date(parseInt(ret.buyer.birthday.split("-")[0], 10), parseInt(ret.buyer.birthday.split("-")[1], 10) - 1, parseInt(ret.buyer.birthday.split("-")[2], 10)),
                                name: ret.buyer.name,
                                nick: ret.buyer.nick,
                                cpf: ret.buyer.cpf,
                                email: ret.buyer.email,
                                phone: {
                                    ddd: ret.buyer.phone.ddd,
                                    ddi: ret.buyer.phone.ddi,
                                    number: ret.buyer.phone.number
                                },
                                avatar: ret.buyer.avatar === null || ret.buyer.avatar === undefined ? null : {
                                    width: ret.buyer.avatar.width || 0,
                                    height: ret.buyer.avatar.height || 0,
                                    url: ret.buyer.avatar.url
                                },
                                address: ret.buyer.address === null || ret.buyer.address === undefined ? null : {
                                    street: ret.buyer.address.street,
                                    neighborhood: ret.buyer.address.neighborhood,
                                    city: ret.buyer.address.city,
                                    uf: ret.buyer.address.uf,
                                    country: ret.buyer.address.country,
                                    number: ret.buyer.address.number,
                                    zip: ret.buyer.address.zip,
                                    adicionalInfo: ret.buyer.address.adicionalInfo,
                                    reference: ret.buyer.address.reference,
                                    location: {
                                        lat: ret.buyer.address.location.lat,
                                        lon: ret.buyer.address.location.lon
                                    }
                                },
                                createdAt: new Date(ret.buyer.createdAt + "Z"),
                                deletedAt: ret.buyer.deletedAt === null || ret.buyer.deletedAt === undefined ? null : new Date(ret.buyer.deletedAt + "Z")
                            },
                            currentStatus: {
                                status: ret.currentStatus.status,
                                actionBy: ret.currentStatus.actionBy === null || ret.currentStatus.actionBy === undefined ? null : ret.currentStatus.actionBy,
                                createdAt: new Date(ret.currentStatus.createdAt + "Z")
                            },
                            statusList: ret.statusList.map(function (e) {
                                return {
                                    status: e.status,
                                    actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                    createdAt: new Date(e.createdAt + "Z")
                                };
                            }),
                            promotion: ret.promotion === null || ret.promotion === undefined ? null : {
                                promotionId: ret.promotion.promotionId,
                                type: ret.promotion.type,
                                total: ret.promotion.total || 0
                            },
                            createdAt: new Date(ret.createdAt + "Z"),
                            editedAt: new Date(ret.editedAt + "Z")
                        });

                    case 5:
                    case "end":
                        return _context97.stop();
                }
            }
        }, _callee97, this);
    }));

    return function getSale(_x245, _x246) {
        return _ref97.apply(this, arguments);
    };
}();

var getSales = function () {
    var _ref98 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee98(pageOffset, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee98$(_context98) {
            while (1) {
                switch (_context98.prev = _context98.next) {
                    case 0:
                        args = {
                            pageOffset: pageOffset === null || pageOffset === undefined ? null : pageOffset || 0,
                            filter: filter === null || filter === undefined ? null : {
                                createdAtSaleDate: filter.createdAtSaleDate === null || filter.createdAtSaleDate === undefined ? null : filter.createdAtSaleDate === null || filter.createdAtSaleDate === undefined ? null : {
                                    startDate: filter.createdAtSaleDate.startDate === null || filter.createdAtSaleDate.startDate === undefined ? null : typeof filter.createdAtSaleDate.startDate === "string" ? new Date(new Date(filter.createdAtSaleDate.startDate).getTime() - new Date(filter.createdAtSaleDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtSaleDate.startDate.getTime() - filter.createdAtSaleDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtSaleDate.endDate === null || filter.createdAtSaleDate.endDate === undefined ? null : typeof filter.createdAtSaleDate.endDate === "string" ? new Date(new Date(filter.createdAtSaleDate.endDate).getTime() - new Date(filter.createdAtSaleDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtSaleDate.endDate.getTime() - filter.createdAtSaleDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                })
                            }
                        };
                        _context98.next = 3;
                        return makeRequest({ name: "getSales", args: args, progress: progress });

                    case 3:
                        ret = _context98.sent;
                        return _context98.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                simpleId: e.simpleId,
                                price: e.price || 0,
                                item: {
                                    id: e.item.id,
                                    owner: {
                                        id: e.item.owner.id,
                                        gender: e.item.owner.gender === null || e.item.owner.gender === undefined ? null : e.item.owner.gender,
                                        birthday: e.item.owner.birthday === null || e.item.owner.birthday === undefined ? null : new Date(parseInt(e.item.owner.birthday.split("-")[0], 10), parseInt(e.item.owner.birthday.split("-")[1], 10) - 1, parseInt(e.item.owner.birthday.split("-")[2], 10)),
                                        name: e.item.owner.name,
                                        nick: e.item.owner.nick,
                                        cpf: e.item.owner.cpf,
                                        email: e.item.owner.email,
                                        phone: {
                                            ddd: e.item.owner.phone.ddd,
                                            ddi: e.item.owner.phone.ddi,
                                            number: e.item.owner.phone.number
                                        },
                                        avatar: e.item.owner.avatar === null || e.item.owner.avatar === undefined ? null : {
                                            width: e.item.owner.avatar.width || 0,
                                            height: e.item.owner.avatar.height || 0,
                                            url: e.item.owner.avatar.url
                                        },
                                        address: e.item.owner.address === null || e.item.owner.address === undefined ? null : {
                                            street: e.item.owner.address.street,
                                            neighborhood: e.item.owner.address.neighborhood,
                                            city: e.item.owner.address.city,
                                            uf: e.item.owner.address.uf,
                                            country: e.item.owner.address.country,
                                            number: e.item.owner.address.number,
                                            zip: e.item.owner.address.zip,
                                            adicionalInfo: e.item.owner.address.adicionalInfo,
                                            reference: e.item.owner.address.reference,
                                            location: {
                                                lat: e.item.owner.address.location.lat,
                                                lon: e.item.owner.address.location.lon
                                            }
                                        },
                                        createdAt: new Date(e.item.owner.createdAt + "Z"),
                                        deletedAt: e.item.owner.deletedAt === null || e.item.owner.deletedAt === undefined ? null : new Date(e.item.owner.deletedAt + "Z")
                                    },
                                    calendar: e.item.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    createdAt: new Date(e.item.createdAt + "Z"),
                                    department: e.item.department,
                                    adjustment: !!e.item.adjustment,
                                    category: e.item.category === null || e.item.category === undefined ? null : e.item.category,
                                    color: e.item.color === null || e.item.color === undefined ? null : e.item.color,
                                    details: e.item.details,
                                    gender: e.item.gender,
                                    thumbImage: {
                                        width: e.item.thumbImage.width || 0,
                                        height: e.item.thumbImage.height || 0,
                                        url: e.item.thumbImage.url
                                    },
                                    images: e.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.item.brand === null || e.item.brand === undefined ? null : e.item.brand,
                                    ocasions: e.item.ocasions.map(function (e) {
                                        return e === null || e === undefined ? null : e;
                                    }),
                                    size: e.item.size === null || e.item.size === undefined ? null : e.item.size,
                                    rentPrice: e.item.rentPrice === null || e.item.rentPrice === undefined ? null : e.item.rentPrice || 0,
                                    salePrice: e.item.salePrice === null || e.item.salePrice === undefined ? null : e.item.salePrice || 0,
                                    originalPrice: e.item.originalPrice || 0
                                },
                                seller: {
                                    id: e.seller.id,
                                    gender: e.seller.gender === null || e.seller.gender === undefined ? null : e.seller.gender,
                                    birthday: e.seller.birthday === null || e.seller.birthday === undefined ? null : new Date(parseInt(e.seller.birthday.split("-")[0], 10), parseInt(e.seller.birthday.split("-")[1], 10) - 1, parseInt(e.seller.birthday.split("-")[2], 10)),
                                    name: e.seller.name,
                                    nick: e.seller.nick,
                                    cpf: e.seller.cpf,
                                    email: e.seller.email,
                                    phone: {
                                        ddd: e.seller.phone.ddd,
                                        ddi: e.seller.phone.ddi,
                                        number: e.seller.phone.number
                                    },
                                    avatar: e.seller.avatar === null || e.seller.avatar === undefined ? null : {
                                        width: e.seller.avatar.width || 0,
                                        height: e.seller.avatar.height || 0,
                                        url: e.seller.avatar.url
                                    },
                                    address: e.seller.address === null || e.seller.address === undefined ? null : {
                                        street: e.seller.address.street,
                                        neighborhood: e.seller.address.neighborhood,
                                        city: e.seller.address.city,
                                        uf: e.seller.address.uf,
                                        country: e.seller.address.country,
                                        number: e.seller.address.number,
                                        zip: e.seller.address.zip,
                                        adicionalInfo: e.seller.address.adicionalInfo,
                                        reference: e.seller.address.reference,
                                        location: {
                                            lat: e.seller.address.location.lat,
                                            lon: e.seller.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.seller.createdAt + "Z"),
                                    deletedAt: e.seller.deletedAt === null || e.seller.deletedAt === undefined ? null : new Date(e.seller.deletedAt + "Z")
                                },
                                buyer: {
                                    id: e.buyer.id,
                                    gender: e.buyer.gender === null || e.buyer.gender === undefined ? null : e.buyer.gender,
                                    birthday: e.buyer.birthday === null || e.buyer.birthday === undefined ? null : new Date(parseInt(e.buyer.birthday.split("-")[0], 10), parseInt(e.buyer.birthday.split("-")[1], 10) - 1, parseInt(e.buyer.birthday.split("-")[2], 10)),
                                    name: e.buyer.name,
                                    nick: e.buyer.nick,
                                    cpf: e.buyer.cpf,
                                    email: e.buyer.email,
                                    phone: {
                                        ddd: e.buyer.phone.ddd,
                                        ddi: e.buyer.phone.ddi,
                                        number: e.buyer.phone.number
                                    },
                                    avatar: e.buyer.avatar === null || e.buyer.avatar === undefined ? null : {
                                        width: e.buyer.avatar.width || 0,
                                        height: e.buyer.avatar.height || 0,
                                        url: e.buyer.avatar.url
                                    },
                                    address: e.buyer.address === null || e.buyer.address === undefined ? null : {
                                        street: e.buyer.address.street,
                                        neighborhood: e.buyer.address.neighborhood,
                                        city: e.buyer.address.city,
                                        uf: e.buyer.address.uf,
                                        country: e.buyer.address.country,
                                        number: e.buyer.address.number,
                                        zip: e.buyer.address.zip,
                                        adicionalInfo: e.buyer.address.adicionalInfo,
                                        reference: e.buyer.address.reference,
                                        location: {
                                            lat: e.buyer.address.location.lat,
                                            lon: e.buyer.address.location.lon
                                        }
                                    },
                                    createdAt: new Date(e.buyer.createdAt + "Z"),
                                    deletedAt: e.buyer.deletedAt === null || e.buyer.deletedAt === undefined ? null : new Date(e.buyer.deletedAt + "Z")
                                },
                                currentStatus: {
                                    status: e.currentStatus.status,
                                    actionBy: e.currentStatus.actionBy === null || e.currentStatus.actionBy === undefined ? null : e.currentStatus.actionBy,
                                    createdAt: new Date(e.currentStatus.createdAt + "Z")
                                },
                                statusList: e.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        createdAt: new Date(e.createdAt + "Z")
                                    };
                                }),
                                promotion: e.promotion === null || e.promotion === undefined ? null : {
                                    promotionId: e.promotion.promotionId,
                                    type: e.promotion.type,
                                    total: e.promotion.total || 0
                                },
                                createdAt: new Date(e.createdAt + "Z"),
                                editedAt: new Date(e.editedAt + "Z")
                            };
                        }));

                    case 5:
                    case "end":
                        return _context98.stop();
                }
            }
        }, _callee98, this);
    }));

    return function getSales(_x247, _x248, _x249) {
        return _ref98.apply(this, arguments);
    };
}();

var getSalesStats = function () {
    var _ref99 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee99(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee99$(_context99) {
            while (1) {
                switch (_context99.prev = _context99.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                createdAtSaleDate: filter.createdAtSaleDate === null || filter.createdAtSaleDate === undefined ? null : filter.createdAtSaleDate === null || filter.createdAtSaleDate === undefined ? null : {
                                    startDate: filter.createdAtSaleDate.startDate === null || filter.createdAtSaleDate.startDate === undefined ? null : typeof filter.createdAtSaleDate.startDate === "string" ? new Date(new Date(filter.createdAtSaleDate.startDate).getTime() - new Date(filter.createdAtSaleDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtSaleDate.startDate.getTime() - filter.createdAtSaleDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtSaleDate.endDate === null || filter.createdAtSaleDate.endDate === undefined ? null : typeof filter.createdAtSaleDate.endDate === "string" ? new Date(new Date(filter.createdAtSaleDate.endDate).getTime() - new Date(filter.createdAtSaleDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtSaleDate.endDate.getTime() - filter.createdAtSaleDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                })
                            }
                        };
                        _context99.next = 3;
                        return makeRequest({ name: "getSalesStats", args: args, progress: progress });

                    case 3:
                        ret = _context99.sent;
                        return _context99.abrupt("return", {
                            totalAmount: ret.totalAmount || 0,
                            averageTicked: ret.averageTicked || 0,
                            totalPrice: ret.totalPrice || 0
                        });

                    case 5:
                    case "end":
                        return _context99.stop();
                }
            }
        }, _callee99, this);
    }));

    return function getSalesStats(_x250, _x251) {
        return _ref99.apply(this, arguments);
    };
}();

var getSalesReportForAdmin = function () {
    var _ref100 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee100(filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee100$(_context100) {
            while (1) {
                switch (_context100.prev = _context100.next) {
                    case 0:
                        args = {
                            filter: filter === null || filter === undefined ? null : {
                                createdAtSaleDate: filter.createdAtSaleDate === null || filter.createdAtSaleDate === undefined ? null : filter.createdAtSaleDate === null || filter.createdAtSaleDate === undefined ? null : {
                                    startDate: filter.createdAtSaleDate.startDate === null || filter.createdAtSaleDate.startDate === undefined ? null : typeof filter.createdAtSaleDate.startDate === "string" ? new Date(new Date(filter.createdAtSaleDate.startDate).getTime() - new Date(filter.createdAtSaleDate.startDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtSaleDate.startDate.getTime() - filter.createdAtSaleDate.startDate.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                    endDate: filter.createdAtSaleDate.endDate === null || filter.createdAtSaleDate.endDate === undefined ? null : typeof filter.createdAtSaleDate.endDate === "string" ? new Date(new Date(filter.createdAtSaleDate.endDate).getTime() - new Date(filter.createdAtSaleDate.endDate).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(filter.createdAtSaleDate.endDate.getTime() - filter.createdAtSaleDate.endDate.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                },
                                orderBy: filter.orderBy === null || filter.orderBy === undefined ? null : {
                                    field: filter.orderBy.field,
                                    order: filter.orderBy.order
                                },
                                status: filter.status.map(function (e) {
                                    return e;
                                })
                            }
                        };
                        _context100.next = 3;
                        return makeRequest({ name: "getSalesReportForAdmin", args: args, progress: progress });

                    case 3:
                        ret = _context100.sent;
                        return _context100.abrupt("return", ret);

                    case 5:
                    case "end":
                        return _context100.stop();
                }
            }
        }, _callee100, this);
    }));

    return function getSalesReportForAdmin(_x252, _x253) {
        return _ref100.apply(this, arguments);
    };
}();

var ping = function () {
    var _ref101 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee101(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee101$(_context101) {
            while (1) {
                switch (_context101.prev = _context101.next) {
                    case 0:
                        _context101.next = 2;
                        return makeRequest({ name: "ping", args: {}, progress: progress });

                    case 2:
                        ret = _context101.sent;
                        return _context101.abrupt("return", ret);

                    case 4:
                    case "end":
                        return _context101.stop();
                }
            }
        }, _callee101, this);
    }));

    return function ping(_x254) {
        return _ref101.apply(this, arguments);
    };
}();

var setPushToken = function () {
    var _ref102 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee102(token, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee102$(_context102) {
            while (1) {
                switch (_context102.prev = _context102.next) {
                    case 0:
                        args = {
                            token: token
                        };
                        _context102.next = 3;
                        return makeRequest({ name: "setPushToken", args: args, progress: progress });

                    case 3:
                        return _context102.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context102.stop();
                }
            }
        }, _callee102, this);
    }));

    return function setPushToken(_x255, _x256) {
        return _ref102.apply(this, arguments);
    };
}();

var device = function () {
    var _ref103 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee103() {
        var parser, agent, me, device, deviceId;
        return _regenerator2.default.wrap(function _callee103$(_context103) {
            while (1) {
                switch (_context103.prev = _context103.next) {
                    case 0:
                        parser = new ua_parser_js_1.UAParser();

                        parser.setUA(navigator.userAgent);
                        agent = parser.getResult();
                        me = document.currentScript;
                        device = {
                            type: "web",
                            platform: {
                                browser: agent.browser.name,
                                browserVersion: agent.browser.version,
                                os: agent.os.name,
                                osVersion: agent.os.version
                            },
                            screen: {
                                width: screen.width,
                                height: screen.height
                            },
                            version: me ? me.src : "",
                            language: navigator.language
                        };
                        deviceId = getDeviceId();

                        if (deviceId) device.id = deviceId;
                        return _context103.abrupt("return", device);

                    case 8:
                    case "end":
                        return _context103.stop();
                }
            }
        }, _callee103, this);
    }));

    return function device() {
        return _ref103.apply(this, arguments);
    };
}();

var makeRequest = function () {
    var _ref104 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee104(_ref105) {
        var name = _ref105.name,
            args = _ref105.args,
            progress = _ref105.progress;
        var deviceData;
        return _regenerator2.default.wrap(function _callee104$(_context104) {
            while (1) {
                switch (_context104.prev = _context104.next) {
                    case 0:
                        _context104.next = 2;
                        return device();

                    case 2:
                        deviceData = _context104.sent;
                        return _context104.abrupt("return", new _promise2.default(function (resolve, reject) {
                            var req = new XMLHttpRequest();
                            req.open("POST", "" + (baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ? "" : "https://") + baseUrl + "/" + name);
                            var body = {
                                id: randomBytesHex(8),
                                device: deviceData,
                                name: name,
                                args: args
                            };
                            function roughSizeOfObject(object) {
                                var objectList = [];
                                var stack = [object];
                                var bytes = 0;
                                while (stack.length) {
                                    var value = stack.pop();
                                    if (typeof value === "boolean") {
                                        bytes += 4;
                                    } else if (typeof value === "string") {
                                        bytes += value.length * 2;
                                    } else if (typeof value === "number") {
                                        bytes += 8;
                                    } else if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && objectList.indexOf(value) === -1) {
                                        objectList.push(value);
                                        for (var i in value) {
                                            stack.push(value[i]);
                                        }
                                    }
                                }
                                return bytes;
                            }
                            req.upload.onprogress = function (event) {
                                if (event.lengthComputable && progress) {
                                    progress(Math.ceil(event.loaded / event.total * 100));
                                }
                            };
                            req.onreadystatechange = function () {
                                if (req.readyState !== 4) return;
                                try {
                                    var response = JSON.parse(req.responseText);
                                    try {
                                        setDeviceId(response.deviceId);
                                        if (response.ok) {
                                            resolve(response.result);
                                            listenersDict["success"].forEach(function (hook) {
                                                return hook(response.result, name, args);
                                            });
                                        } else {
                                            var error = (0, _typeof3.default)(response.error) === "object" ? response.error : { type: "Fatal", message: response.toString() };
                                            reject(error);
                                            listenersDict["fail"].forEach(function (hook) {
                                                return hook(error, name, args);
                                            });
                                        }
                                    } catch (e) {
                                        console.error(e);
                                        reject({ type: "Fatal", message: "[" + name + "] " + e.toString() });
                                        listenersDict["fatal"].forEach(function (hook) {
                                            return hook(e, name, args);
                                        });
                                    }
                                } catch (e) {
                                    console.error(e);
                                    reject({ type: "BadFormattedResponse", message: "Response couldn't be parsed as JSON (" + req.responseText + "):\n" + e.toString() });
                                    listenersDict["fatal"].forEach(function (hook) {
                                        return hook(e, name, args);
                                    });
                                }
                            };
                            req.send((0, _stringify2.default)(body));
                        }));

                    case 4:
                    case "end":
                        return _context104.stop();
                }
            }
        }, _callee104, this);
    }));

    return function makeRequest(_x257) {
        return _ref104.apply(this, arguments);
    };
}();
//# sourceMappingURL=api.js.map


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var ua_parser_js_1 = require("ua-parser-js");
var baseUrl = "localhost:8000";
var strings = null;
function setUrl(url) {
    baseUrl = url;
}
exports.setUrl = setUrl;
function setStrings(newStrings) {
    strings = newStrings;
}
exports.setStrings = setStrings;
var Department;
(function (Department) {
    Department["clothes"] = "clothes";
    Department["accessory"] = "accessory";
})(Department = exports.Department || (exports.Department = {}));
function translateDepartment(enumDepartment) {
    switch (enumDepartment) {
        case Department.clothes:
            {
                return strings ? strings["enum"]["Department"]["clothes"] || Department.clothes : Department.clothes;
            }
        case Department.accessory:
            {
                return strings ? strings["enum"]["Department"]["accessory"] || Department.accessory : Department.accessory;
            }
    }
    return "";
}
exports.translateDepartment = translateDepartment;
function allValuesDepartment() {
    return [Department.clothes, Department.accessory];
}
exports.allValuesDepartment = allValuesDepartment;
function allTranslatedValuesDepartment() {
    return [translateDepartment(Department.clothes), translateDepartment(Department.accessory)];
}
exports.allTranslatedValuesDepartment = allTranslatedValuesDepartment;
function allDisplayableValuesDepartment() {
    return allTranslatedValuesDepartment().sort();
}
exports.allDisplayableValuesDepartment = allDisplayableValuesDepartment;
function valueFromTranslationDepartment(translation) {
    var index = allTranslatedValuesDepartment().indexOf(translation);
    return allValuesDepartment()[index] || Department.clothes;
}
exports.valueFromTranslationDepartment = valueFromTranslationDepartment;
var Category;
(function (Category) {
    Category["rompers"] = "rompers";
    Category["conjunct"] = "conjunct";
    Category["body"] = "body";
    Category["top"] = "top";
    Category["blouse"] = "blouse";
    Category["pants"] = "pants";
    Category["shorts"] = "shorts";
    Category["longShorts"] = "longShorts";
    Category["skirt"] = "skirt";
    Category["dress"] = "dress";
    Category["overlap"] = "overlap";
    Category["overall"] = "overall";
    Category["suit"] = "suit";
    Category["purse"] = "purse";
    Category["shoes"] = "shoes";
    Category["winter"] = "winter";
    Category["accessory"] = "accessory";
    Category["other"] = "other";
})(Category = exports.Category || (exports.Category = {}));
function translateCategory(enumCategory) {
    switch (enumCategory) {
        case Category.rompers:
            {
                return strings ? strings["enum"]["Category"]["rompers"] || Category.rompers : Category.rompers;
            }
        case Category.conjunct:
            {
                return strings ? strings["enum"]["Category"]["conjunct"] || Category.conjunct : Category.conjunct;
            }
        case Category.body:
            {
                return strings ? strings["enum"]["Category"]["body"] || Category.body : Category.body;
            }
        case Category.top:
            {
                return strings ? strings["enum"]["Category"]["top"] || Category.top : Category.top;
            }
        case Category.blouse:
            {
                return strings ? strings["enum"]["Category"]["blouse"] || Category.blouse : Category.blouse;
            }
        case Category.pants:
            {
                return strings ? strings["enum"]["Category"]["pants"] || Category.pants : Category.pants;
            }
        case Category.shorts:
            {
                return strings ? strings["enum"]["Category"]["shorts"] || Category.shorts : Category.shorts;
            }
        case Category.longShorts:
            {
                return strings ? strings["enum"]["Category"]["longShorts"] || Category.longShorts : Category.longShorts;
            }
        case Category.skirt:
            {
                return strings ? strings["enum"]["Category"]["skirt"] || Category.skirt : Category.skirt;
            }
        case Category.dress:
            {
                return strings ? strings["enum"]["Category"]["dress"] || Category.dress : Category.dress;
            }
        case Category.overlap:
            {
                return strings ? strings["enum"]["Category"]["overlap"] || Category.overlap : Category.overlap;
            }
        case Category.overall:
            {
                return strings ? strings["enum"]["Category"]["overall"] || Category.overall : Category.overall;
            }
        case Category.suit:
            {
                return strings ? strings["enum"]["Category"]["suit"] || Category.suit : Category.suit;
            }
        case Category.purse:
            {
                return strings ? strings["enum"]["Category"]["purse"] || Category.purse : Category.purse;
            }
        case Category.shoes:
            {
                return strings ? strings["enum"]["Category"]["shoes"] || Category.shoes : Category.shoes;
            }
        case Category.winter:
            {
                return strings ? strings["enum"]["Category"]["winter"] || Category.winter : Category.winter;
            }
        case Category.accessory:
            {
                return strings ? strings["enum"]["Category"]["accessory"] || Category.accessory : Category.accessory;
            }
        case Category.other:
            {
                return strings ? strings["enum"]["Category"]["other"] || Category.other : Category.other;
            }
    }
    return "";
}
exports.translateCategory = translateCategory;
function allValuesCategory() {
    return [Category.rompers, Category.conjunct, Category.body, Category.top, Category.blouse, Category.pants, Category.shorts, Category.longShorts, Category.skirt, Category.dress, Category.overlap, Category.overall, Category.suit, Category.purse, Category.shoes, Category.winter, Category.accessory, Category.other];
}
exports.allValuesCategory = allValuesCategory;
function allTranslatedValuesCategory() {
    return [translateCategory(Category.rompers), translateCategory(Category.conjunct), translateCategory(Category.body), translateCategory(Category.top), translateCategory(Category.blouse), translateCategory(Category.pants), translateCategory(Category.shorts), translateCategory(Category.longShorts), translateCategory(Category.skirt), translateCategory(Category.dress), translateCategory(Category.overlap), translateCategory(Category.overall), translateCategory(Category.suit), translateCategory(Category.purse), translateCategory(Category.shoes), translateCategory(Category.winter), translateCategory(Category.accessory), translateCategory(Category.other)];
}
exports.allTranslatedValuesCategory = allTranslatedValuesCategory;
function allDisplayableValuesCategory() {
    return allTranslatedValuesCategory().sort();
}
exports.allDisplayableValuesCategory = allDisplayableValuesCategory;
function valueFromTranslationCategory(translation) {
    var index = allTranslatedValuesCategory().indexOf(translation);
    return allValuesCategory()[index] || Category.rompers;
}
exports.valueFromTranslationCategory = valueFromTranslationCategory;
var Ocasion;
(function (Ocasion) {
    Ocasion["formalParty"] = "formalParty";
    Ocasion["party"] = "party";
    Ocasion["casual"] = "casual";
    Ocasion["winter"] = "winter";
    Ocasion["costume"] = "costume";
    Ocasion["beach"] = "beach";
    Ocasion["work"] = "work";
    Ocasion["pregnant"] = "pregnant";
})(Ocasion = exports.Ocasion || (exports.Ocasion = {}));
function translateOcasion(enumOcasion) {
    switch (enumOcasion) {
        case Ocasion.formalParty:
            {
                return strings ? strings["enum"]["Ocasion"]["formalParty"] || Ocasion.formalParty : Ocasion.formalParty;
            }
        case Ocasion.party:
            {
                return strings ? strings["enum"]["Ocasion"]["party"] || Ocasion.party : Ocasion.party;
            }
        case Ocasion.casual:
            {
                return strings ? strings["enum"]["Ocasion"]["casual"] || Ocasion.casual : Ocasion.casual;
            }
        case Ocasion.winter:
            {
                return strings ? strings["enum"]["Ocasion"]["winter"] || Ocasion.winter : Ocasion.winter;
            }
        case Ocasion.costume:
            {
                return strings ? strings["enum"]["Ocasion"]["costume"] || Ocasion.costume : Ocasion.costume;
            }
        case Ocasion.beach:
            {
                return strings ? strings["enum"]["Ocasion"]["beach"] || Ocasion.beach : Ocasion.beach;
            }
        case Ocasion.work:
            {
                return strings ? strings["enum"]["Ocasion"]["work"] || Ocasion.work : Ocasion.work;
            }
        case Ocasion.pregnant:
            {
                return strings ? strings["enum"]["Ocasion"]["pregnant"] || Ocasion.pregnant : Ocasion.pregnant;
            }
    }
    return "";
}
exports.translateOcasion = translateOcasion;
function allValuesOcasion() {
    return [Ocasion.formalParty, Ocasion.party, Ocasion.casual, Ocasion.winter, Ocasion.costume, Ocasion.beach, Ocasion.work, Ocasion.pregnant];
}
exports.allValuesOcasion = allValuesOcasion;
function allTranslatedValuesOcasion() {
    return [translateOcasion(Ocasion.formalParty), translateOcasion(Ocasion.party), translateOcasion(Ocasion.casual), translateOcasion(Ocasion.winter), translateOcasion(Ocasion.costume), translateOcasion(Ocasion.beach), translateOcasion(Ocasion.work), translateOcasion(Ocasion.pregnant)];
}
exports.allTranslatedValuesOcasion = allTranslatedValuesOcasion;
function allDisplayableValuesOcasion() {
    return allTranslatedValuesOcasion().sort();
}
exports.allDisplayableValuesOcasion = allDisplayableValuesOcasion;
function valueFromTranslationOcasion(translation) {
    var index = allTranslatedValuesOcasion().indexOf(translation);
    return allValuesOcasion()[index] || Ocasion.formalParty;
}
exports.valueFromTranslationOcasion = valueFromTranslationOcasion;
var Color;
(function (Color) {
    Color["striped"] = "striped";
    Color["grid"] = "grid";
    Color["yellow"] = "yellow";
    Color["blue"] = "blue";
    Color["beige"] = "beige";
    Color["white"] = "white";
    Color["gray"] = "gray";
    Color["gold"] = "gold";
    Color["jeans"] = "jeans";
    Color["orange"] = "orange";
    Color["brown"] = "brown";
    Color["nude"] = "nude";
    Color["offWhite"] = "offWhite";
    Color["silver"] = "silver";
    Color["black"] = "black";
    Color["pink"] = "pink";
    Color["purple"] = "purple";
    Color["green"] = "green";
    Color["red"] = "red";
    Color["wine"] = "wine";
    Color["stamped"] = "stamped";
})(Color = exports.Color || (exports.Color = {}));
function translateColor(enumColor) {
    switch (enumColor) {
        case Color.striped:
            {
                return strings ? strings["enum"]["Color"]["striped"] || Color.striped : Color.striped;
            }
        case Color.grid:
            {
                return strings ? strings["enum"]["Color"]["grid"] || Color.grid : Color.grid;
            }
        case Color.yellow:
            {
                return strings ? strings["enum"]["Color"]["yellow"] || Color.yellow : Color.yellow;
            }
        case Color.blue:
            {
                return strings ? strings["enum"]["Color"]["blue"] || Color.blue : Color.blue;
            }
        case Color.beige:
            {
                return strings ? strings["enum"]["Color"]["beige"] || Color.beige : Color.beige;
            }
        case Color.white:
            {
                return strings ? strings["enum"]["Color"]["white"] || Color.white : Color.white;
            }
        case Color.gray:
            {
                return strings ? strings["enum"]["Color"]["gray"] || Color.gray : Color.gray;
            }
        case Color.gold:
            {
                return strings ? strings["enum"]["Color"]["gold"] || Color.gold : Color.gold;
            }
        case Color.jeans:
            {
                return strings ? strings["enum"]["Color"]["jeans"] || Color.jeans : Color.jeans;
            }
        case Color.orange:
            {
                return strings ? strings["enum"]["Color"]["orange"] || Color.orange : Color.orange;
            }
        case Color.brown:
            {
                return strings ? strings["enum"]["Color"]["brown"] || Color.brown : Color.brown;
            }
        case Color.nude:
            {
                return strings ? strings["enum"]["Color"]["nude"] || Color.nude : Color.nude;
            }
        case Color.offWhite:
            {
                return strings ? strings["enum"]["Color"]["offWhite"] || Color.offWhite : Color.offWhite;
            }
        case Color.silver:
            {
                return strings ? strings["enum"]["Color"]["silver"] || Color.silver : Color.silver;
            }
        case Color.black:
            {
                return strings ? strings["enum"]["Color"]["black"] || Color.black : Color.black;
            }
        case Color.pink:
            {
                return strings ? strings["enum"]["Color"]["pink"] || Color.pink : Color.pink;
            }
        case Color.purple:
            {
                return strings ? strings["enum"]["Color"]["purple"] || Color.purple : Color.purple;
            }
        case Color.green:
            {
                return strings ? strings["enum"]["Color"]["green"] || Color.green : Color.green;
            }
        case Color.red:
            {
                return strings ? strings["enum"]["Color"]["red"] || Color.red : Color.red;
            }
        case Color.wine:
            {
                return strings ? strings["enum"]["Color"]["wine"] || Color.wine : Color.wine;
            }
        case Color.stamped:
            {
                return strings ? strings["enum"]["Color"]["stamped"] || Color.stamped : Color.stamped;
            }
    }
    return "";
}
exports.translateColor = translateColor;
function allValuesColor() {
    return [Color.striped, Color.grid, Color.yellow, Color.blue, Color.beige, Color.white, Color.gray, Color.gold, Color.jeans, Color.orange, Color.brown, Color.nude, Color.offWhite, Color.silver, Color.black, Color.pink, Color.purple, Color.green, Color.red, Color.wine, Color.stamped];
}
exports.allValuesColor = allValuesColor;
function allTranslatedValuesColor() {
    return [translateColor(Color.striped), translateColor(Color.grid), translateColor(Color.yellow), translateColor(Color.blue), translateColor(Color.beige), translateColor(Color.white), translateColor(Color.gray), translateColor(Color.gold), translateColor(Color.jeans), translateColor(Color.orange), translateColor(Color.brown), translateColor(Color.nude), translateColor(Color.offWhite), translateColor(Color.silver), translateColor(Color.black), translateColor(Color.pink), translateColor(Color.purple), translateColor(Color.green), translateColor(Color.red), translateColor(Color.wine), translateColor(Color.stamped)];
}
exports.allTranslatedValuesColor = allTranslatedValuesColor;
function allDisplayableValuesColor() {
    return allTranslatedValuesColor().sort();
}
exports.allDisplayableValuesColor = allDisplayableValuesColor;
function valueFromTranslationColor(translation) {
    var index = allTranslatedValuesColor().indexOf(translation);
    return allValuesColor()[index] || Color.striped;
}
exports.valueFromTranslationColor = valueFromTranslationColor;
var Size;
(function (Size) {
    Size["sSingle"] = "sSingle";
    Size["sXS"] = "sXS";
    Size["sS"] = "sS";
    Size["sM"] = "sM";
    Size["sL"] = "sL";
    Size["sXL"] = "sXL";
    Size["sXXL"] = "sXXL";
    Size["s33"] = "s33";
    Size["s34"] = "s34";
    Size["s35"] = "s35";
    Size["s36"] = "s36";
    Size["s37"] = "s37";
    Size["s38"] = "s38";
    Size["s39"] = "s39";
    Size["s40"] = "s40";
    Size["s41"] = "s41";
    Size["s42"] = "s42";
    Size["s43"] = "s43";
    Size["s44"] = "s44";
    Size["s45"] = "s45";
    Size["s46"] = "s46";
    Size["s48"] = "s48";
    Size["s50"] = "s50";
    Size["s50Plus"] = "s50Plus";
})(Size = exports.Size || (exports.Size = {}));
function translateSize(enumSize) {
    switch (enumSize) {
        case Size.sSingle:
            {
                return strings ? strings["enum"]["Size"]["sSingle"] || Size.sSingle : Size.sSingle;
            }
        case Size.sXS:
            {
                return strings ? strings["enum"]["Size"]["sXS"] || Size.sXS : Size.sXS;
            }
        case Size.sS:
            {
                return strings ? strings["enum"]["Size"]["sS"] || Size.sS : Size.sS;
            }
        case Size.sM:
            {
                return strings ? strings["enum"]["Size"]["sM"] || Size.sM : Size.sM;
            }
        case Size.sL:
            {
                return strings ? strings["enum"]["Size"]["sL"] || Size.sL : Size.sL;
            }
        case Size.sXL:
            {
                return strings ? strings["enum"]["Size"]["sXL"] || Size.sXL : Size.sXL;
            }
        case Size.sXXL:
            {
                return strings ? strings["enum"]["Size"]["sXXL"] || Size.sXXL : Size.sXXL;
            }
        case Size.s33:
            {
                return strings ? strings["enum"]["Size"]["s33"] || Size.s33 : Size.s33;
            }
        case Size.s34:
            {
                return strings ? strings["enum"]["Size"]["s34"] || Size.s34 : Size.s34;
            }
        case Size.s35:
            {
                return strings ? strings["enum"]["Size"]["s35"] || Size.s35 : Size.s35;
            }
        case Size.s36:
            {
                return strings ? strings["enum"]["Size"]["s36"] || Size.s36 : Size.s36;
            }
        case Size.s37:
            {
                return strings ? strings["enum"]["Size"]["s37"] || Size.s37 : Size.s37;
            }
        case Size.s38:
            {
                return strings ? strings["enum"]["Size"]["s38"] || Size.s38 : Size.s38;
            }
        case Size.s39:
            {
                return strings ? strings["enum"]["Size"]["s39"] || Size.s39 : Size.s39;
            }
        case Size.s40:
            {
                return strings ? strings["enum"]["Size"]["s40"] || Size.s40 : Size.s40;
            }
        case Size.s41:
            {
                return strings ? strings["enum"]["Size"]["s41"] || Size.s41 : Size.s41;
            }
        case Size.s42:
            {
                return strings ? strings["enum"]["Size"]["s42"] || Size.s42 : Size.s42;
            }
        case Size.s43:
            {
                return strings ? strings["enum"]["Size"]["s43"] || Size.s43 : Size.s43;
            }
        case Size.s44:
            {
                return strings ? strings["enum"]["Size"]["s44"] || Size.s44 : Size.s44;
            }
        case Size.s45:
            {
                return strings ? strings["enum"]["Size"]["s45"] || Size.s45 : Size.s45;
            }
        case Size.s46:
            {
                return strings ? strings["enum"]["Size"]["s46"] || Size.s46 : Size.s46;
            }
        case Size.s48:
            {
                return strings ? strings["enum"]["Size"]["s48"] || Size.s48 : Size.s48;
            }
        case Size.s50:
            {
                return strings ? strings["enum"]["Size"]["s50"] || Size.s50 : Size.s50;
            }
        case Size.s50Plus:
            {
                return strings ? strings["enum"]["Size"]["s50Plus"] || Size.s50Plus : Size.s50Plus;
            }
    }
    return "";
}
exports.translateSize = translateSize;
function allValuesSize() {
    return [Size.sSingle, Size.sXS, Size.sS, Size.sM, Size.sL, Size.sXL, Size.sXXL, Size.s33, Size.s34, Size.s35, Size.s36, Size.s37, Size.s38, Size.s39, Size.s40, Size.s41, Size.s42, Size.s43, Size.s44, Size.s45, Size.s46, Size.s48, Size.s50, Size.s50Plus];
}
exports.allValuesSize = allValuesSize;
function allTranslatedValuesSize() {
    return [translateSize(Size.sSingle), translateSize(Size.sXS), translateSize(Size.sS), translateSize(Size.sM), translateSize(Size.sL), translateSize(Size.sXL), translateSize(Size.sXXL), translateSize(Size.s33), translateSize(Size.s34), translateSize(Size.s35), translateSize(Size.s36), translateSize(Size.s37), translateSize(Size.s38), translateSize(Size.s39), translateSize(Size.s40), translateSize(Size.s41), translateSize(Size.s42), translateSize(Size.s43), translateSize(Size.s44), translateSize(Size.s45), translateSize(Size.s46), translateSize(Size.s48), translateSize(Size.s50), translateSize(Size.s50Plus)];
}
exports.allTranslatedValuesSize = allTranslatedValuesSize;
function allDisplayableValuesSize() {
    return allTranslatedValuesSize().sort();
}
exports.allDisplayableValuesSize = allDisplayableValuesSize;
function valueFromTranslationSize(translation) {
    var index = allTranslatedValuesSize().indexOf(translation);
    return allValuesSize()[index] || Size.sSingle;
}
exports.valueFromTranslationSize = valueFromTranslationSize;
var LocStatus;
(function (LocStatus) {
    LocStatus["pendingApproval"] = "pendingApproval";
    LocStatus["approved"] = "approved";
    LocStatus["notApproved"] = "notApproved";
    LocStatus["canceled"] = "canceled";
    LocStatus["deliveredToRequester"] = "deliveredToRequester";
    LocStatus["receivedByRequester"] = "receivedByRequester";
    LocStatus["deliveredToOwner"] = "deliveredToOwner";
    LocStatus["receivedByOwner"] = "receivedByOwner";
})(LocStatus = exports.LocStatus || (exports.LocStatus = {}));
function translateLocStatus(enumLocStatus) {
    switch (enumLocStatus) {
        case LocStatus.pendingApproval:
            {
                return strings ? strings["enum"]["LocStatus"]["pendingApproval"] || LocStatus.pendingApproval : LocStatus.pendingApproval;
            }
        case LocStatus.approved:
            {
                return strings ? strings["enum"]["LocStatus"]["approved"] || LocStatus.approved : LocStatus.approved;
            }
        case LocStatus.notApproved:
            {
                return strings ? strings["enum"]["LocStatus"]["notApproved"] || LocStatus.notApproved : LocStatus.notApproved;
            }
        case LocStatus.canceled:
            {
                return strings ? strings["enum"]["LocStatus"]["canceled"] || LocStatus.canceled : LocStatus.canceled;
            }
        case LocStatus.deliveredToRequester:
            {
                return strings ? strings["enum"]["LocStatus"]["deliveredToRequester"] || LocStatus.deliveredToRequester : LocStatus.deliveredToRequester;
            }
        case LocStatus.receivedByRequester:
            {
                return strings ? strings["enum"]["LocStatus"]["receivedByRequester"] || LocStatus.receivedByRequester : LocStatus.receivedByRequester;
            }
        case LocStatus.deliveredToOwner:
            {
                return strings ? strings["enum"]["LocStatus"]["deliveredToOwner"] || LocStatus.deliveredToOwner : LocStatus.deliveredToOwner;
            }
        case LocStatus.receivedByOwner:
            {
                return strings ? strings["enum"]["LocStatus"]["receivedByOwner"] || LocStatus.receivedByOwner : LocStatus.receivedByOwner;
            }
    }
    return "";
}
exports.translateLocStatus = translateLocStatus;
function allValuesLocStatus() {
    return [LocStatus.pendingApproval, LocStatus.approved, LocStatus.notApproved, LocStatus.canceled, LocStatus.deliveredToRequester, LocStatus.receivedByRequester, LocStatus.deliveredToOwner, LocStatus.receivedByOwner];
}
exports.allValuesLocStatus = allValuesLocStatus;
function allTranslatedValuesLocStatus() {
    return [translateLocStatus(LocStatus.pendingApproval), translateLocStatus(LocStatus.approved), translateLocStatus(LocStatus.notApproved), translateLocStatus(LocStatus.canceled), translateLocStatus(LocStatus.deliveredToRequester), translateLocStatus(LocStatus.receivedByRequester), translateLocStatus(LocStatus.deliveredToOwner), translateLocStatus(LocStatus.receivedByOwner)];
}
exports.allTranslatedValuesLocStatus = allTranslatedValuesLocStatus;
function allDisplayableValuesLocStatus() {
    return allTranslatedValuesLocStatus().sort();
}
exports.allDisplayableValuesLocStatus = allDisplayableValuesLocStatus;
function valueFromTranslationLocStatus(translation) {
    var index = allTranslatedValuesLocStatus().indexOf(translation);
    return allValuesLocStatus()[index] || LocStatus.pendingApproval;
}
exports.valueFromTranslationLocStatus = valueFromTranslationLocStatus;
var LocRequestActions;
(function (LocRequestActions) {
    LocRequestActions["approve"] = "approve";
    LocRequestActions["disapprove"] = "disapprove";
    LocRequestActions["deliverToRequester"] = "deliverToRequester";
    LocRequestActions["receiveFromRequester"] = "receiveFromRequester";
    LocRequestActions["deliverToOwner"] = "deliverToOwner";
    LocRequestActions["receiveFromOwner"] = "receiveFromOwner";
    LocRequestActions["cancel"] = "cancel";
    LocRequestActions["cancelWithPrejudice"] = "cancelWithPrejudice";
})(LocRequestActions = exports.LocRequestActions || (exports.LocRequestActions = {}));
function translateLocRequestActions(enumLocRequestActions) {
    switch (enumLocRequestActions) {
        case LocRequestActions.approve:
            {
                return strings ? strings["enum"]["LocRequestActions"]["approve"] || LocRequestActions.approve : LocRequestActions.approve;
            }
        case LocRequestActions.disapprove:
            {
                return strings ? strings["enum"]["LocRequestActions"]["disapprove"] || LocRequestActions.disapprove : LocRequestActions.disapprove;
            }
        case LocRequestActions.deliverToRequester:
            {
                return strings ? strings["enum"]["LocRequestActions"]["deliverToRequester"] || LocRequestActions.deliverToRequester : LocRequestActions.deliverToRequester;
            }
        case LocRequestActions.receiveFromRequester:
            {
                return strings ? strings["enum"]["LocRequestActions"]["receiveFromRequester"] || LocRequestActions.receiveFromRequester : LocRequestActions.receiveFromRequester;
            }
        case LocRequestActions.deliverToOwner:
            {
                return strings ? strings["enum"]["LocRequestActions"]["deliverToOwner"] || LocRequestActions.deliverToOwner : LocRequestActions.deliverToOwner;
            }
        case LocRequestActions.receiveFromOwner:
            {
                return strings ? strings["enum"]["LocRequestActions"]["receiveFromOwner"] || LocRequestActions.receiveFromOwner : LocRequestActions.receiveFromOwner;
            }
        case LocRequestActions.cancel:
            {
                return strings ? strings["enum"]["LocRequestActions"]["cancel"] || LocRequestActions.cancel : LocRequestActions.cancel;
            }
        case LocRequestActions.cancelWithPrejudice:
            {
                return strings ? strings["enum"]["LocRequestActions"]["cancelWithPrejudice"] || LocRequestActions.cancelWithPrejudice : LocRequestActions.cancelWithPrejudice;
            }
    }
    return "";
}
exports.translateLocRequestActions = translateLocRequestActions;
function allValuesLocRequestActions() {
    return [LocRequestActions.approve, LocRequestActions.disapprove, LocRequestActions.deliverToRequester, LocRequestActions.receiveFromRequester, LocRequestActions.deliverToOwner, LocRequestActions.receiveFromOwner, LocRequestActions.cancel, LocRequestActions.cancelWithPrejudice];
}
exports.allValuesLocRequestActions = allValuesLocRequestActions;
function allTranslatedValuesLocRequestActions() {
    return [translateLocRequestActions(LocRequestActions.approve), translateLocRequestActions(LocRequestActions.disapprove), translateLocRequestActions(LocRequestActions.deliverToRequester), translateLocRequestActions(LocRequestActions.receiveFromRequester), translateLocRequestActions(LocRequestActions.deliverToOwner), translateLocRequestActions(LocRequestActions.receiveFromOwner), translateLocRequestActions(LocRequestActions.cancel), translateLocRequestActions(LocRequestActions.cancelWithPrejudice)];
}
exports.allTranslatedValuesLocRequestActions = allTranslatedValuesLocRequestActions;
function allDisplayableValuesLocRequestActions() {
    return allTranslatedValuesLocRequestActions().sort();
}
exports.allDisplayableValuesLocRequestActions = allDisplayableValuesLocRequestActions;
function valueFromTranslationLocRequestActions(translation) {
    var index = allTranslatedValuesLocRequestActions().indexOf(translation);
    return allValuesLocRequestActions()[index] || LocRequestActions.approve;
}
exports.valueFromTranslationLocRequestActions = valueFromTranslationLocRequestActions;
var PromotionType;
(function (PromotionType) {
    PromotionType["percentage"] = "percentage";
    PromotionType["value"] = "value";
})(PromotionType = exports.PromotionType || (exports.PromotionType = {}));
function translatePromotionType(enumPromotionType) {
    switch (enumPromotionType) {
        case PromotionType.percentage:
            {
                return strings ? strings["enum"]["PromotionType"]["percentage"] || PromotionType.percentage : PromotionType.percentage;
            }
        case PromotionType.value:
            {
                return strings ? strings["enum"]["PromotionType"]["value"] || PromotionType.value : PromotionType.value;
            }
    }
    return "";
}
exports.translatePromotionType = translatePromotionType;
function allValuesPromotionType() {
    return [PromotionType.percentage, PromotionType.value];
}
exports.allValuesPromotionType = allValuesPromotionType;
function allTranslatedValuesPromotionType() {
    return [translatePromotionType(PromotionType.percentage), translatePromotionType(PromotionType.value)];
}
exports.allTranslatedValuesPromotionType = allTranslatedValuesPromotionType;
function allDisplayableValuesPromotionType() {
    return allTranslatedValuesPromotionType().sort();
}
exports.allDisplayableValuesPromotionType = allDisplayableValuesPromotionType;
function valueFromTranslationPromotionType(translation) {
    var index = allTranslatedValuesPromotionType().indexOf(translation);
    return allValuesPromotionType()[index] || PromotionType.percentage;
}
exports.valueFromTranslationPromotionType = valueFromTranslationPromotionType;
var NotificationType;
(function (NotificationType) {
    NotificationType["chat"] = "chat";
    NotificationType["locRequest"] = "locRequest";
    NotificationType["card"] = "card";
    NotificationType["bank"] = "bank";
    NotificationType["display"] = "display";
    NotificationType["item"] = "item";
    NotificationType["locker"] = "locker";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
function translateNotificationType(enumNotificationType) {
    switch (enumNotificationType) {
        case NotificationType.chat:
            {
                return strings ? strings["enum"]["NotificationType"]["chat"] || NotificationType.chat : NotificationType.chat;
            }
        case NotificationType.locRequest:
            {
                return strings ? strings["enum"]["NotificationType"]["locRequest"] || NotificationType.locRequest : NotificationType.locRequest;
            }
        case NotificationType.card:
            {
                return strings ? strings["enum"]["NotificationType"]["card"] || NotificationType.card : NotificationType.card;
            }
        case NotificationType.bank:
            {
                return strings ? strings["enum"]["NotificationType"]["bank"] || NotificationType.bank : NotificationType.bank;
            }
        case NotificationType.display:
            {
                return strings ? strings["enum"]["NotificationType"]["display"] || NotificationType.display : NotificationType.display;
            }
        case NotificationType.item:
            {
                return strings ? strings["enum"]["NotificationType"]["item"] || NotificationType.item : NotificationType.item;
            }
        case NotificationType.locker:
            {
                return strings ? strings["enum"]["NotificationType"]["locker"] || NotificationType.locker : NotificationType.locker;
            }
    }
    return "";
}
exports.translateNotificationType = translateNotificationType;
function allValuesNotificationType() {
    return [NotificationType.chat, NotificationType.locRequest, NotificationType.card, NotificationType.bank, NotificationType.display, NotificationType.item, NotificationType.locker];
}
exports.allValuesNotificationType = allValuesNotificationType;
function allTranslatedValuesNotificationType() {
    return [translateNotificationType(NotificationType.chat), translateNotificationType(NotificationType.locRequest), translateNotificationType(NotificationType.card), translateNotificationType(NotificationType.bank), translateNotificationType(NotificationType.display), translateNotificationType(NotificationType.item), translateNotificationType(NotificationType.locker)];
}
exports.allTranslatedValuesNotificationType = allTranslatedValuesNotificationType;
function allDisplayableValuesNotificationType() {
    return allTranslatedValuesNotificationType().sort();
}
exports.allDisplayableValuesNotificationType = allDisplayableValuesNotificationType;
function valueFromTranslationNotificationType(translation) {
    var index = allTranslatedValuesNotificationType().indexOf(translation);
    return allValuesNotificationType()[index] || NotificationType.chat;
}
exports.valueFromTranslationNotificationType = valueFromTranslationNotificationType;
var Providers;
(function (Providers) {
    Providers["apple"] = "apple";
    Providers["google"] = "google";
    Providers["facebook"] = "facebook";
})(Providers = exports.Providers || (exports.Providers = {}));
function translateProviders(enumProviders) {
    switch (enumProviders) {
        case Providers.apple:
            {
                return strings ? strings["enum"]["Providers"]["apple"] || Providers.apple : Providers.apple;
            }
        case Providers.google:
            {
                return strings ? strings["enum"]["Providers"]["google"] || Providers.google : Providers.google;
            }
        case Providers.facebook:
            {
                return strings ? strings["enum"]["Providers"]["facebook"] || Providers.facebook : Providers.facebook;
            }
    }
    return "";
}
exports.translateProviders = translateProviders;
function allValuesProviders() {
    return [Providers.apple, Providers.google, Providers.facebook];
}
exports.allValuesProviders = allValuesProviders;
function allTranslatedValuesProviders() {
    return [translateProviders(Providers.apple), translateProviders(Providers.google), translateProviders(Providers.facebook)];
}
exports.allTranslatedValuesProviders = allTranslatedValuesProviders;
function allDisplayableValuesProviders() {
    return allTranslatedValuesProviders().sort();
}
exports.allDisplayableValuesProviders = allDisplayableValuesProviders;
function valueFromTranslationProviders(translation) {
    var index = allTranslatedValuesProviders().indexOf(translation);
    return allValuesProviders()[index] || Providers.apple;
}
exports.valueFromTranslationProviders = valueFromTranslationProviders;
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["contaCorrente"] = "contaCorrente";
    BankAccountType["contaPoupanca"] = "contaPoupanca";
    BankAccountType["contaCorrenteConjunta"] = "contaCorrenteConjunta";
    BankAccountType["contaPoupancaConjunta"] = "contaPoupancaConjunta";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
function translateBankAccountType(enumBankAccountType) {
    switch (enumBankAccountType) {
        case BankAccountType.contaCorrente:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaCorrente"] || BankAccountType.contaCorrente : BankAccountType.contaCorrente;
            }
        case BankAccountType.contaPoupanca:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaPoupanca"] || BankAccountType.contaPoupanca : BankAccountType.contaPoupanca;
            }
        case BankAccountType.contaCorrenteConjunta:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaCorrenteConjunta"] || BankAccountType.contaCorrenteConjunta : BankAccountType.contaCorrenteConjunta;
            }
        case BankAccountType.contaPoupancaConjunta:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaPoupancaConjunta"] || BankAccountType.contaPoupancaConjunta : BankAccountType.contaPoupancaConjunta;
            }
    }
    return "";
}
exports.translateBankAccountType = translateBankAccountType;
function allValuesBankAccountType() {
    return [BankAccountType.contaCorrente, BankAccountType.contaPoupanca, BankAccountType.contaCorrenteConjunta, BankAccountType.contaPoupancaConjunta];
}
exports.allValuesBankAccountType = allValuesBankAccountType;
function allTranslatedValuesBankAccountType() {
    return [translateBankAccountType(BankAccountType.contaCorrente), translateBankAccountType(BankAccountType.contaPoupanca), translateBankAccountType(BankAccountType.contaCorrenteConjunta), translateBankAccountType(BankAccountType.contaPoupancaConjunta)];
}
exports.allTranslatedValuesBankAccountType = allTranslatedValuesBankAccountType;
function allDisplayableValuesBankAccountType() {
    return allTranslatedValuesBankAccountType().sort();
}
exports.allDisplayableValuesBankAccountType = allDisplayableValuesBankAccountType;
function valueFromTranslationBankAccountType(translation) {
    var index = allTranslatedValuesBankAccountType().indexOf(translation);
    return allValuesBankAccountType()[index] || BankAccountType.contaCorrente;
}
exports.valueFromTranslationBankAccountType = valueFromTranslationBankAccountType;
var NFeStatus;
(function (NFeStatus) {
    NFeStatus["Issued"] = "Issued";
    NFeStatus["Created"] = "Created";
    NFeStatus["Error"] = "Error";
    NFeStatus["None"] = "None";
})(NFeStatus = exports.NFeStatus || (exports.NFeStatus = {}));
function translateNFeStatus(enumNFeStatus) {
    switch (enumNFeStatus) {
        case NFeStatus.Issued:
            {
                return strings ? strings["enum"]["NFeStatus"]["Issued"] || NFeStatus.Issued : NFeStatus.Issued;
            }
        case NFeStatus.Created:
            {
                return strings ? strings["enum"]["NFeStatus"]["Created"] || NFeStatus.Created : NFeStatus.Created;
            }
        case NFeStatus.Error:
            {
                return strings ? strings["enum"]["NFeStatus"]["Error"] || NFeStatus.Error : NFeStatus.Error;
            }
        case NFeStatus.None:
            {
                return strings ? strings["enum"]["NFeStatus"]["None"] || NFeStatus.None : NFeStatus.None;
            }
    }
    return "";
}
exports.translateNFeStatus = translateNFeStatus;
function allValuesNFeStatus() {
    return [NFeStatus.Issued, NFeStatus.Created, NFeStatus.Error, NFeStatus.None];
}
exports.allValuesNFeStatus = allValuesNFeStatus;
function allTranslatedValuesNFeStatus() {
    return [translateNFeStatus(NFeStatus.Issued), translateNFeStatus(NFeStatus.Created), translateNFeStatus(NFeStatus.Error), translateNFeStatus(NFeStatus.None)];
}
exports.allTranslatedValuesNFeStatus = allTranslatedValuesNFeStatus;
function allDisplayableValuesNFeStatus() {
    return allTranslatedValuesNFeStatus().sort();
}
exports.allDisplayableValuesNFeStatus = allDisplayableValuesNFeStatus;
function valueFromTranslationNFeStatus(translation) {
    var index = allTranslatedValuesNFeStatus().indexOf(translation);
    return allValuesNFeStatus()[index] || NFeStatus.Issued;
}
exports.valueFromTranslationNFeStatus = valueFromTranslationNFeStatus;
var Gender;
(function (Gender) {
    Gender["female"] = "female";
    Gender["male"] = "male";
})(Gender = exports.Gender || (exports.Gender = {}));
function translateGender(enumGender) {
    switch (enumGender) {
        case Gender.female:
            {
                return strings ? strings["enum"]["Gender"]["female"] || Gender.female : Gender.female;
            }
        case Gender.male:
            {
                return strings ? strings["enum"]["Gender"]["male"] || Gender.male : Gender.male;
            }
    }
    return "";
}
exports.translateGender = translateGender;
function allValuesGender() {
    return [Gender.female, Gender.male];
}
exports.allValuesGender = allValuesGender;
function allTranslatedValuesGender() {
    return [translateGender(Gender.female), translateGender(Gender.male)];
}
exports.allTranslatedValuesGender = allTranslatedValuesGender;
function allDisplayableValuesGender() {
    return allTranslatedValuesGender().sort();
}
exports.allDisplayableValuesGender = allDisplayableValuesGender;
function valueFromTranslationGender(translation) {
    var index = allTranslatedValuesGender().indexOf(translation);
    return allValuesGender()[index] || Gender.female;
}
exports.valueFromTranslationGender = valueFromTranslationGender;
var StateUF;
(function (StateUF) {
    StateUF["AC"] = "AC";
    StateUF["AL"] = "AL";
    StateUF["AP"] = "AP";
    StateUF["AM"] = "AM";
    StateUF["BA"] = "BA";
    StateUF["CE"] = "CE";
    StateUF["DF"] = "DF";
    StateUF["ES"] = "ES";
    StateUF["GO"] = "GO";
    StateUF["MA"] = "MA";
    StateUF["MT"] = "MT";
    StateUF["MS"] = "MS";
    StateUF["MG"] = "MG";
    StateUF["PA"] = "PA";
    StateUF["PB"] = "PB";
    StateUF["PR"] = "PR";
    StateUF["PE"] = "PE";
    StateUF["PI"] = "PI";
    StateUF["RJ"] = "RJ";
    StateUF["RN"] = "RN";
    StateUF["RS"] = "RS";
    StateUF["RO"] = "RO";
    StateUF["RR"] = "RR";
    StateUF["SC"] = "SC";
    StateUF["SP"] = "SP";
    StateUF["SE"] = "SE";
    StateUF["TO"] = "TO";
})(StateUF = exports.StateUF || (exports.StateUF = {}));
function translateStateUF(enumStateUF) {
    switch (enumStateUF) {
        case StateUF.AC:
            {
                return strings ? strings["enum"]["StateUF"]["AC"] || StateUF.AC : StateUF.AC;
            }
        case StateUF.AL:
            {
                return strings ? strings["enum"]["StateUF"]["AL"] || StateUF.AL : StateUF.AL;
            }
        case StateUF.AP:
            {
                return strings ? strings["enum"]["StateUF"]["AP"] || StateUF.AP : StateUF.AP;
            }
        case StateUF.AM:
            {
                return strings ? strings["enum"]["StateUF"]["AM"] || StateUF.AM : StateUF.AM;
            }
        case StateUF.BA:
            {
                return strings ? strings["enum"]["StateUF"]["BA"] || StateUF.BA : StateUF.BA;
            }
        case StateUF.CE:
            {
                return strings ? strings["enum"]["StateUF"]["CE"] || StateUF.CE : StateUF.CE;
            }
        case StateUF.DF:
            {
                return strings ? strings["enum"]["StateUF"]["DF"] || StateUF.DF : StateUF.DF;
            }
        case StateUF.ES:
            {
                return strings ? strings["enum"]["StateUF"]["ES"] || StateUF.ES : StateUF.ES;
            }
        case StateUF.GO:
            {
                return strings ? strings["enum"]["StateUF"]["GO"] || StateUF.GO : StateUF.GO;
            }
        case StateUF.MA:
            {
                return strings ? strings["enum"]["StateUF"]["MA"] || StateUF.MA : StateUF.MA;
            }
        case StateUF.MT:
            {
                return strings ? strings["enum"]["StateUF"]["MT"] || StateUF.MT : StateUF.MT;
            }
        case StateUF.MS:
            {
                return strings ? strings["enum"]["StateUF"]["MS"] || StateUF.MS : StateUF.MS;
            }
        case StateUF.MG:
            {
                return strings ? strings["enum"]["StateUF"]["MG"] || StateUF.MG : StateUF.MG;
            }
        case StateUF.PA:
            {
                return strings ? strings["enum"]["StateUF"]["PA"] || StateUF.PA : StateUF.PA;
            }
        case StateUF.PB:
            {
                return strings ? strings["enum"]["StateUF"]["PB"] || StateUF.PB : StateUF.PB;
            }
        case StateUF.PR:
            {
                return strings ? strings["enum"]["StateUF"]["PR"] || StateUF.PR : StateUF.PR;
            }
        case StateUF.PE:
            {
                return strings ? strings["enum"]["StateUF"]["PE"] || StateUF.PE : StateUF.PE;
            }
        case StateUF.PI:
            {
                return strings ? strings["enum"]["StateUF"]["PI"] || StateUF.PI : StateUF.PI;
            }
        case StateUF.RJ:
            {
                return strings ? strings["enum"]["StateUF"]["RJ"] || StateUF.RJ : StateUF.RJ;
            }
        case StateUF.RN:
            {
                return strings ? strings["enum"]["StateUF"]["RN"] || StateUF.RN : StateUF.RN;
            }
        case StateUF.RS:
            {
                return strings ? strings["enum"]["StateUF"]["RS"] || StateUF.RS : StateUF.RS;
            }
        case StateUF.RO:
            {
                return strings ? strings["enum"]["StateUF"]["RO"] || StateUF.RO : StateUF.RO;
            }
        case StateUF.RR:
            {
                return strings ? strings["enum"]["StateUF"]["RR"] || StateUF.RR : StateUF.RR;
            }
        case StateUF.SC:
            {
                return strings ? strings["enum"]["StateUF"]["SC"] || StateUF.SC : StateUF.SC;
            }
        case StateUF.SP:
            {
                return strings ? strings["enum"]["StateUF"]["SP"] || StateUF.SP : StateUF.SP;
            }
        case StateUF.SE:
            {
                return strings ? strings["enum"]["StateUF"]["SE"] || StateUF.SE : StateUF.SE;
            }
        case StateUF.TO:
            {
                return strings ? strings["enum"]["StateUF"]["TO"] || StateUF.TO : StateUF.TO;
            }
    }
    return "";
}
exports.translateStateUF = translateStateUF;
function allValuesStateUF() {
    return [StateUF.AC, StateUF.AL, StateUF.AP, StateUF.AM, StateUF.BA, StateUF.CE, StateUF.DF, StateUF.ES, StateUF.GO, StateUF.MA, StateUF.MT, StateUF.MS, StateUF.MG, StateUF.PA, StateUF.PB, StateUF.PR, StateUF.PE, StateUF.PI, StateUF.RJ, StateUF.RN, StateUF.RS, StateUF.RO, StateUF.RR, StateUF.SC, StateUF.SP, StateUF.SE, StateUF.TO];
}
exports.allValuesStateUF = allValuesStateUF;
function allTranslatedValuesStateUF() {
    return [translateStateUF(StateUF.AC), translateStateUF(StateUF.AL), translateStateUF(StateUF.AP), translateStateUF(StateUF.AM), translateStateUF(StateUF.BA), translateStateUF(StateUF.CE), translateStateUF(StateUF.DF), translateStateUF(StateUF.ES), translateStateUF(StateUF.GO), translateStateUF(StateUF.MA), translateStateUF(StateUF.MT), translateStateUF(StateUF.MS), translateStateUF(StateUF.MG), translateStateUF(StateUF.PA), translateStateUF(StateUF.PB), translateStateUF(StateUF.PR), translateStateUF(StateUF.PE), translateStateUF(StateUF.PI), translateStateUF(StateUF.RJ), translateStateUF(StateUF.RN), translateStateUF(StateUF.RS), translateStateUF(StateUF.RO), translateStateUF(StateUF.RR), translateStateUF(StateUF.SC), translateStateUF(StateUF.SP), translateStateUF(StateUF.SE), translateStateUF(StateUF.TO)];
}
exports.allTranslatedValuesStateUF = allTranslatedValuesStateUF;
function allDisplayableValuesStateUF() {
    return allTranslatedValuesStateUF().sort();
}
exports.allDisplayableValuesStateUF = allDisplayableValuesStateUF;
function valueFromTranslationStateUF(translation) {
    var index = allTranslatedValuesStateUF().indexOf(translation);
    return allValuesStateUF()[index] || StateUF.AC;
}
exports.valueFromTranslationStateUF = valueFromTranslationStateUF;
var TableOrderBy;
(function (TableOrderBy) {
    TableOrderBy["desc"] = "desc";
    TableOrderBy["asc"] = "asc";
})(TableOrderBy = exports.TableOrderBy || (exports.TableOrderBy = {}));
function translateTableOrderBy(enumTableOrderBy) {
    switch (enumTableOrderBy) {
        case TableOrderBy.desc:
            {
                return strings ? strings["enum"]["TableOrderBy"]["desc"] || TableOrderBy.desc : TableOrderBy.desc;
            }
        case TableOrderBy.asc:
            {
                return strings ? strings["enum"]["TableOrderBy"]["asc"] || TableOrderBy.asc : TableOrderBy.asc;
            }
    }
    return "";
}
exports.translateTableOrderBy = translateTableOrderBy;
function allValuesTableOrderBy() {
    return [TableOrderBy.desc, TableOrderBy.asc];
}
exports.allValuesTableOrderBy = allValuesTableOrderBy;
function allTranslatedValuesTableOrderBy() {
    return [translateTableOrderBy(TableOrderBy.desc), translateTableOrderBy(TableOrderBy.asc)];
}
exports.allTranslatedValuesTableOrderBy = allTranslatedValuesTableOrderBy;
function allDisplayableValuesTableOrderBy() {
    return allTranslatedValuesTableOrderBy().sort();
}
exports.allDisplayableValuesTableOrderBy = allDisplayableValuesTableOrderBy;
function valueFromTranslationTableOrderBy(translation) {
    var index = allTranslatedValuesTableOrderBy().indexOf(translation);
    return allValuesTableOrderBy()[index] || TableOrderBy.desc;
}
exports.valueFromTranslationTableOrderBy = valueFromTranslationTableOrderBy;
var AdminUserType;
(function (AdminUserType) {
    AdminUserType["admin"] = "admin";
    AdminUserType["licensed"] = "licensed";
})(AdminUserType = exports.AdminUserType || (exports.AdminUserType = {}));
function translateAdminUserType(enumAdminUserType) {
    switch (enumAdminUserType) {
        case AdminUserType.admin:
            {
                return strings ? strings["enum"]["AdminUserType"]["admin"] || AdminUserType.admin : AdminUserType.admin;
            }
        case AdminUserType.licensed:
            {
                return strings ? strings["enum"]["AdminUserType"]["licensed"] || AdminUserType.licensed : AdminUserType.licensed;
            }
    }
    return "";
}
exports.translateAdminUserType = translateAdminUserType;
function allValuesAdminUserType() {
    return [AdminUserType.admin, AdminUserType.licensed];
}
exports.allValuesAdminUserType = allValuesAdminUserType;
function allTranslatedValuesAdminUserType() {
    return [translateAdminUserType(AdminUserType.admin), translateAdminUserType(AdminUserType.licensed)];
}
exports.allTranslatedValuesAdminUserType = allTranslatedValuesAdminUserType;
function allDisplayableValuesAdminUserType() {
    return allTranslatedValuesAdminUserType().sort();
}
exports.allDisplayableValuesAdminUserType = allDisplayableValuesAdminUserType;
function valueFromTranslationAdminUserType(translation) {
    var index = allTranslatedValuesAdminUserType().indexOf(translation);
    return allValuesAdminUserType()[index] || AdminUserType.admin;
}
exports.valueFromTranslationAdminUserType = valueFromTranslationAdminUserType;
var ItemOfferType;
(function (ItemOfferType) {
    ItemOfferType["rent"] = "rent";
    ItemOfferType["sale"] = "sale";
    ItemOfferType["rentAndSale"] = "rentAndSale";
    ItemOfferType["all"] = "all";
})(ItemOfferType = exports.ItemOfferType || (exports.ItemOfferType = {}));
function translateItemOfferType(enumItemOfferType) {
    switch (enumItemOfferType) {
        case ItemOfferType.rent:
            {
                return strings ? strings["enum"]["ItemOfferType"]["rent"] || ItemOfferType.rent : ItemOfferType.rent;
            }
        case ItemOfferType.sale:
            {
                return strings ? strings["enum"]["ItemOfferType"]["sale"] || ItemOfferType.sale : ItemOfferType.sale;
            }
        case ItemOfferType.rentAndSale:
            {
                return strings ? strings["enum"]["ItemOfferType"]["rentAndSale"] || ItemOfferType.rentAndSale : ItemOfferType.rentAndSale;
            }
        case ItemOfferType.all:
            {
                return strings ? strings["enum"]["ItemOfferType"]["all"] || ItemOfferType.all : ItemOfferType.all;
            }
    }
    return "";
}
exports.translateItemOfferType = translateItemOfferType;
function allValuesItemOfferType() {
    return [ItemOfferType.rent, ItemOfferType.sale, ItemOfferType.rentAndSale, ItemOfferType.all];
}
exports.allValuesItemOfferType = allValuesItemOfferType;
function allTranslatedValuesItemOfferType() {
    return [translateItemOfferType(ItemOfferType.rent), translateItemOfferType(ItemOfferType.sale), translateItemOfferType(ItemOfferType.rentAndSale), translateItemOfferType(ItemOfferType.all)];
}
exports.allTranslatedValuesItemOfferType = allTranslatedValuesItemOfferType;
function allDisplayableValuesItemOfferType() {
    return allTranslatedValuesItemOfferType().sort();
}
exports.allDisplayableValuesItemOfferType = allDisplayableValuesItemOfferType;
function valueFromTranslationItemOfferType(translation) {
    var index = allTranslatedValuesItemOfferType().indexOf(translation);
    return allValuesItemOfferType()[index] || ItemOfferType.rent;
}
exports.valueFromTranslationItemOfferType = valueFromTranslationItemOfferType;
var OrderBy;
(function (OrderBy) {
    OrderBy["popular"] = "popular";
    OrderBy["relevant"] = "relevant";
    OrderBy["lowestPrice"] = "lowestPrice";
    OrderBy["highestPrice"] = "highestPrice";
})(OrderBy = exports.OrderBy || (exports.OrderBy = {}));
function translateOrderBy(enumOrderBy) {
    switch (enumOrderBy) {
        case OrderBy.popular:
            {
                return strings ? strings["enum"]["OrderBy"]["popular"] || OrderBy.popular : OrderBy.popular;
            }
        case OrderBy.relevant:
            {
                return strings ? strings["enum"]["OrderBy"]["relevant"] || OrderBy.relevant : OrderBy.relevant;
            }
        case OrderBy.lowestPrice:
            {
                return strings ? strings["enum"]["OrderBy"]["lowestPrice"] || OrderBy.lowestPrice : OrderBy.lowestPrice;
            }
        case OrderBy.highestPrice:
            {
                return strings ? strings["enum"]["OrderBy"]["highestPrice"] || OrderBy.highestPrice : OrderBy.highestPrice;
            }
    }
    return "";
}
exports.translateOrderBy = translateOrderBy;
function allValuesOrderBy() {
    return [OrderBy.popular, OrderBy.relevant, OrderBy.lowestPrice, OrderBy.highestPrice];
}
exports.allValuesOrderBy = allValuesOrderBy;
function allTranslatedValuesOrderBy() {
    return [translateOrderBy(OrderBy.popular), translateOrderBy(OrderBy.relevant), translateOrderBy(OrderBy.lowestPrice), translateOrderBy(OrderBy.highestPrice)];
}
exports.allTranslatedValuesOrderBy = allTranslatedValuesOrderBy;
function allDisplayableValuesOrderBy() {
    return allTranslatedValuesOrderBy().sort();
}
exports.allDisplayableValuesOrderBy = allDisplayableValuesOrderBy;
function valueFromTranslationOrderBy(translation) {
    var index = allTranslatedValuesOrderBy().indexOf(translation);
    return allValuesOrderBy()[index] || OrderBy.popular;
}
exports.valueFromTranslationOrderBy = valueFromTranslationOrderBy;
var BannerType;
(function (BannerType) {
    BannerType["banner"] = "banner";
    BannerType["card"] = "card";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
function translateBannerType(enumBannerType) {
    switch (enumBannerType) {
        case BannerType.banner:
            {
                return strings ? strings["enum"]["BannerType"]["banner"] || BannerType.banner : BannerType.banner;
            }
        case BannerType.card:
            {
                return strings ? strings["enum"]["BannerType"]["card"] || BannerType.card : BannerType.card;
            }
    }
    return "";
}
exports.translateBannerType = translateBannerType;
function allValuesBannerType() {
    return [BannerType.banner, BannerType.card];
}
exports.allValuesBannerType = allValuesBannerType;
function allTranslatedValuesBannerType() {
    return [translateBannerType(BannerType.banner), translateBannerType(BannerType.card)];
}
exports.allTranslatedValuesBannerType = allTranslatedValuesBannerType;
function allDisplayableValuesBannerType() {
    return allTranslatedValuesBannerType().sort();
}
exports.allDisplayableValuesBannerType = allDisplayableValuesBannerType;
function valueFromTranslationBannerType(translation) {
    var index = allTranslatedValuesBannerType().indexOf(translation);
    return allValuesBannerType()[index] || BannerType.banner;
}
exports.valueFromTranslationBannerType = valueFromTranslationBannerType;
var BannerContentType;
(function (BannerContentType) {
    BannerContentType["group"] = "group";
    BannerContentType["query"] = "query";
    BannerContentType["url"] = "url";
})(BannerContentType = exports.BannerContentType || (exports.BannerContentType = {}));
function translateBannerContentType(enumBannerContentType) {
    switch (enumBannerContentType) {
        case BannerContentType.group:
            {
                return strings ? strings["enum"]["BannerContentType"]["group"] || BannerContentType.group : BannerContentType.group;
            }
        case BannerContentType.query:
            {
                return strings ? strings["enum"]["BannerContentType"]["query"] || BannerContentType.query : BannerContentType.query;
            }
        case BannerContentType.url:
            {
                return strings ? strings["enum"]["BannerContentType"]["url"] || BannerContentType.url : BannerContentType.url;
            }
    }
    return "";
}
exports.translateBannerContentType = translateBannerContentType;
function allValuesBannerContentType() {
    return [BannerContentType.group, BannerContentType.query, BannerContentType.url];
}
exports.allValuesBannerContentType = allValuesBannerContentType;
function allTranslatedValuesBannerContentType() {
    return [translateBannerContentType(BannerContentType.group), translateBannerContentType(BannerContentType.query), translateBannerContentType(BannerContentType.url)];
}
exports.allTranslatedValuesBannerContentType = allTranslatedValuesBannerContentType;
function allDisplayableValuesBannerContentType() {
    return allTranslatedValuesBannerContentType().sort();
}
exports.allDisplayableValuesBannerContentType = allDisplayableValuesBannerContentType;
function valueFromTranslationBannerContentType(translation) {
    var index = allTranslatedValuesBannerContentType().indexOf(translation);
    return allValuesBannerContentType()[index] || BannerContentType.group;
}
exports.valueFromTranslationBannerContentType = valueFromTranslationBannerContentType;
var HomeGraphicType;
(function (HomeGraphicType) {
    HomeGraphicType["value"] = "value";
    HomeGraphicType["amount"] = "amount";
})(HomeGraphicType = exports.HomeGraphicType || (exports.HomeGraphicType = {}));
function translateHomeGraphicType(enumHomeGraphicType) {
    switch (enumHomeGraphicType) {
        case HomeGraphicType.value:
            {
                return strings ? strings["enum"]["HomeGraphicType"]["value"] || HomeGraphicType.value : HomeGraphicType.value;
            }
        case HomeGraphicType.amount:
            {
                return strings ? strings["enum"]["HomeGraphicType"]["amount"] || HomeGraphicType.amount : HomeGraphicType.amount;
            }
    }
    return "";
}
exports.translateHomeGraphicType = translateHomeGraphicType;
function allValuesHomeGraphicType() {
    return [HomeGraphicType.value, HomeGraphicType.amount];
}
exports.allValuesHomeGraphicType = allValuesHomeGraphicType;
function allTranslatedValuesHomeGraphicType() {
    return [translateHomeGraphicType(HomeGraphicType.value), translateHomeGraphicType(HomeGraphicType.amount)];
}
exports.allTranslatedValuesHomeGraphicType = allTranslatedValuesHomeGraphicType;
function allDisplayableValuesHomeGraphicType() {
    return allTranslatedValuesHomeGraphicType().sort();
}
exports.allDisplayableValuesHomeGraphicType = allDisplayableValuesHomeGraphicType;
function valueFromTranslationHomeGraphicType(translation) {
    var index = allTranslatedValuesHomeGraphicType().indexOf(translation);
    return allValuesHomeGraphicType()[index] || HomeGraphicType.value;
}
exports.valueFromTranslationHomeGraphicType = valueFromTranslationHomeGraphicType;
var UserFieldsOrderBy;
(function (UserFieldsOrderBy) {
    UserFieldsOrderBy["name"] = "name";
    UserFieldsOrderBy["nick"] = "nick";
    UserFieldsOrderBy["email"] = "email";
    UserFieldsOrderBy["cpf"] = "cpf";
    UserFieldsOrderBy["createdAt"] = "createdAt";
})(UserFieldsOrderBy = exports.UserFieldsOrderBy || (exports.UserFieldsOrderBy = {}));
function translateUserFieldsOrderBy(enumUserFieldsOrderBy) {
    switch (enumUserFieldsOrderBy) {
        case UserFieldsOrderBy.name:
            {
                return strings ? strings["enum"]["UserFieldsOrderBy"]["name"] || UserFieldsOrderBy.name : UserFieldsOrderBy.name;
            }
        case UserFieldsOrderBy.nick:
            {
                return strings ? strings["enum"]["UserFieldsOrderBy"]["nick"] || UserFieldsOrderBy.nick : UserFieldsOrderBy.nick;
            }
        case UserFieldsOrderBy.email:
            {
                return strings ? strings["enum"]["UserFieldsOrderBy"]["email"] || UserFieldsOrderBy.email : UserFieldsOrderBy.email;
            }
        case UserFieldsOrderBy.cpf:
            {
                return strings ? strings["enum"]["UserFieldsOrderBy"]["cpf"] || UserFieldsOrderBy.cpf : UserFieldsOrderBy.cpf;
            }
        case UserFieldsOrderBy.createdAt:
            {
                return strings ? strings["enum"]["UserFieldsOrderBy"]["createdAt"] || UserFieldsOrderBy.createdAt : UserFieldsOrderBy.createdAt;
            }
    }
    return "";
}
exports.translateUserFieldsOrderBy = translateUserFieldsOrderBy;
function allValuesUserFieldsOrderBy() {
    return [UserFieldsOrderBy.name, UserFieldsOrderBy.nick, UserFieldsOrderBy.email, UserFieldsOrderBy.cpf, UserFieldsOrderBy.createdAt];
}
exports.allValuesUserFieldsOrderBy = allValuesUserFieldsOrderBy;
function allTranslatedValuesUserFieldsOrderBy() {
    return [translateUserFieldsOrderBy(UserFieldsOrderBy.name), translateUserFieldsOrderBy(UserFieldsOrderBy.nick), translateUserFieldsOrderBy(UserFieldsOrderBy.email), translateUserFieldsOrderBy(UserFieldsOrderBy.cpf), translateUserFieldsOrderBy(UserFieldsOrderBy.createdAt)];
}
exports.allTranslatedValuesUserFieldsOrderBy = allTranslatedValuesUserFieldsOrderBy;
function allDisplayableValuesUserFieldsOrderBy() {
    return allTranslatedValuesUserFieldsOrderBy().sort();
}
exports.allDisplayableValuesUserFieldsOrderBy = allDisplayableValuesUserFieldsOrderBy;
function valueFromTranslationUserFieldsOrderBy(translation) {
    var index = allTranslatedValuesUserFieldsOrderBy().indexOf(translation);
    return allValuesUserFieldsOrderBy()[index] || UserFieldsOrderBy.name;
}
exports.valueFromTranslationUserFieldsOrderBy = valueFromTranslationUserFieldsOrderBy;
var ItemFieldsOrderBy;
(function (ItemFieldsOrderBy) {
    ItemFieldsOrderBy["rentPrice"] = "rentPrice";
    ItemFieldsOrderBy["originalPrice"] = "originalPrice";
    ItemFieldsOrderBy["salePrice"] = "salePrice";
    ItemFieldsOrderBy["createdAt"] = "createdAt";
})(ItemFieldsOrderBy = exports.ItemFieldsOrderBy || (exports.ItemFieldsOrderBy = {}));
function translateItemFieldsOrderBy(enumItemFieldsOrderBy) {
    switch (enumItemFieldsOrderBy) {
        case ItemFieldsOrderBy.rentPrice:
            {
                return strings ? strings["enum"]["ItemFieldsOrderBy"]["rentPrice"] || ItemFieldsOrderBy.rentPrice : ItemFieldsOrderBy.rentPrice;
            }
        case ItemFieldsOrderBy.originalPrice:
            {
                return strings ? strings["enum"]["ItemFieldsOrderBy"]["originalPrice"] || ItemFieldsOrderBy.originalPrice : ItemFieldsOrderBy.originalPrice;
            }
        case ItemFieldsOrderBy.salePrice:
            {
                return strings ? strings["enum"]["ItemFieldsOrderBy"]["salePrice"] || ItemFieldsOrderBy.salePrice : ItemFieldsOrderBy.salePrice;
            }
        case ItemFieldsOrderBy.createdAt:
            {
                return strings ? strings["enum"]["ItemFieldsOrderBy"]["createdAt"] || ItemFieldsOrderBy.createdAt : ItemFieldsOrderBy.createdAt;
            }
    }
    return "";
}
exports.translateItemFieldsOrderBy = translateItemFieldsOrderBy;
function allValuesItemFieldsOrderBy() {
    return [ItemFieldsOrderBy.rentPrice, ItemFieldsOrderBy.originalPrice, ItemFieldsOrderBy.salePrice, ItemFieldsOrderBy.createdAt];
}
exports.allValuesItemFieldsOrderBy = allValuesItemFieldsOrderBy;
function allTranslatedValuesItemFieldsOrderBy() {
    return [translateItemFieldsOrderBy(ItemFieldsOrderBy.rentPrice), translateItemFieldsOrderBy(ItemFieldsOrderBy.originalPrice), translateItemFieldsOrderBy(ItemFieldsOrderBy.salePrice), translateItemFieldsOrderBy(ItemFieldsOrderBy.createdAt)];
}
exports.allTranslatedValuesItemFieldsOrderBy = allTranslatedValuesItemFieldsOrderBy;
function allDisplayableValuesItemFieldsOrderBy() {
    return allTranslatedValuesItemFieldsOrderBy().sort();
}
exports.allDisplayableValuesItemFieldsOrderBy = allDisplayableValuesItemFieldsOrderBy;
function valueFromTranslationItemFieldsOrderBy(translation) {
    var index = allTranslatedValuesItemFieldsOrderBy().indexOf(translation);
    return allValuesItemFieldsOrderBy()[index] || ItemFieldsOrderBy.rentPrice;
}
exports.valueFromTranslationItemFieldsOrderBy = valueFromTranslationItemFieldsOrderBy;
var DeviceType;
(function (DeviceType) {
    DeviceType["ios"] = "ios";
    DeviceType["android"] = "android";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
function translateDeviceType(enumDeviceType) {
    switch (enumDeviceType) {
        case DeviceType.ios:
            {
                return strings ? strings["enum"]["DeviceType"]["ios"] || DeviceType.ios : DeviceType.ios;
            }
        case DeviceType.android:
            {
                return strings ? strings["enum"]["DeviceType"]["android"] || DeviceType.android : DeviceType.android;
            }
    }
    return "";
}
exports.translateDeviceType = translateDeviceType;
function allValuesDeviceType() {
    return [DeviceType.ios, DeviceType.android];
}
exports.allValuesDeviceType = allValuesDeviceType;
function allTranslatedValuesDeviceType() {
    return [translateDeviceType(DeviceType.ios), translateDeviceType(DeviceType.android)];
}
exports.allTranslatedValuesDeviceType = allTranslatedValuesDeviceType;
function allDisplayableValuesDeviceType() {
    return allTranslatedValuesDeviceType().sort();
}
exports.allDisplayableValuesDeviceType = allDisplayableValuesDeviceType;
function valueFromTranslationDeviceType(translation) {
    var index = allTranslatedValuesDeviceType().indexOf(translation);
    return allValuesDeviceType()[index] || DeviceType.ios;
}
exports.valueFromTranslationDeviceType = valueFromTranslationDeviceType;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["processing"] = "processing";
    PaymentStatus["authorized"] = "authorized";
    PaymentStatus["paid"] = "paid";
    PaymentStatus["refunded"] = "refunded";
    PaymentStatus["waitingPayment"] = "waitingPayment";
    PaymentStatus["pendingRefund"] = "pendingRefund";
    PaymentStatus["refused"] = "refused";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
function translatePaymentStatus(enumPaymentStatus) {
    switch (enumPaymentStatus) {
        case PaymentStatus.processing:
            {
                return strings ? strings["enum"]["PaymentStatus"]["processing"] || PaymentStatus.processing : PaymentStatus.processing;
            }
        case PaymentStatus.authorized:
            {
                return strings ? strings["enum"]["PaymentStatus"]["authorized"] || PaymentStatus.authorized : PaymentStatus.authorized;
            }
        case PaymentStatus.paid:
            {
                return strings ? strings["enum"]["PaymentStatus"]["paid"] || PaymentStatus.paid : PaymentStatus.paid;
            }
        case PaymentStatus.refunded:
            {
                return strings ? strings["enum"]["PaymentStatus"]["refunded"] || PaymentStatus.refunded : PaymentStatus.refunded;
            }
        case PaymentStatus.waitingPayment:
            {
                return strings ? strings["enum"]["PaymentStatus"]["waitingPayment"] || PaymentStatus.waitingPayment : PaymentStatus.waitingPayment;
            }
        case PaymentStatus.pendingRefund:
            {
                return strings ? strings["enum"]["PaymentStatus"]["pendingRefund"] || PaymentStatus.pendingRefund : PaymentStatus.pendingRefund;
            }
        case PaymentStatus.refused:
            {
                return strings ? strings["enum"]["PaymentStatus"]["refused"] || PaymentStatus.refused : PaymentStatus.refused;
            }
    }
    return "";
}
exports.translatePaymentStatus = translatePaymentStatus;
function allValuesPaymentStatus() {
    return [PaymentStatus.processing, PaymentStatus.authorized, PaymentStatus.paid, PaymentStatus.refunded, PaymentStatus.waitingPayment, PaymentStatus.pendingRefund, PaymentStatus.refused];
}
exports.allValuesPaymentStatus = allValuesPaymentStatus;
function allTranslatedValuesPaymentStatus() {
    return [translatePaymentStatus(PaymentStatus.processing), translatePaymentStatus(PaymentStatus.authorized), translatePaymentStatus(PaymentStatus.paid), translatePaymentStatus(PaymentStatus.refunded), translatePaymentStatus(PaymentStatus.waitingPayment), translatePaymentStatus(PaymentStatus.pendingRefund), translatePaymentStatus(PaymentStatus.refused)];
}
exports.allTranslatedValuesPaymentStatus = allTranslatedValuesPaymentStatus;
function allDisplayableValuesPaymentStatus() {
    return allTranslatedValuesPaymentStatus().sort();
}
exports.allDisplayableValuesPaymentStatus = allDisplayableValuesPaymentStatus;
function valueFromTranslationPaymentStatus(translation) {
    var index = allTranslatedValuesPaymentStatus().indexOf(translation);
    return allValuesPaymentStatus()[index] || PaymentStatus.processing;
}
exports.valueFromTranslationPaymentStatus = valueFromTranslationPaymentStatus;
var ReportType;
(function (ReportType) {
    ReportType["all"] = "all";
    ReportType["users"] = "users";
    ReportType["requests"] = "requests";
    ReportType["items"] = "items";
    ReportType["likes"] = "likes";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
function translateReportType(enumReportType) {
    switch (enumReportType) {
        case ReportType.all:
            {
                return strings ? strings["enum"]["ReportType"]["all"] || ReportType.all : ReportType.all;
            }
        case ReportType.users:
            {
                return strings ? strings["enum"]["ReportType"]["users"] || ReportType.users : ReportType.users;
            }
        case ReportType.requests:
            {
                return strings ? strings["enum"]["ReportType"]["requests"] || ReportType.requests : ReportType.requests;
            }
        case ReportType.items:
            {
                return strings ? strings["enum"]["ReportType"]["items"] || ReportType.items : ReportType.items;
            }
        case ReportType.likes:
            {
                return strings ? strings["enum"]["ReportType"]["likes"] || ReportType.likes : ReportType.likes;
            }
    }
    return "";
}
exports.translateReportType = translateReportType;
function allValuesReportType() {
    return [ReportType.all, ReportType.users, ReportType.requests, ReportType.items, ReportType.likes];
}
exports.allValuesReportType = allValuesReportType;
function allTranslatedValuesReportType() {
    return [translateReportType(ReportType.all), translateReportType(ReportType.users), translateReportType(ReportType.requests), translateReportType(ReportType.items), translateReportType(ReportType.likes)];
}
exports.allTranslatedValuesReportType = allTranslatedValuesReportType;
function allDisplayableValuesReportType() {
    return allTranslatedValuesReportType().sort();
}
exports.allDisplayableValuesReportType = allDisplayableValuesReportType;
function valueFromTranslationReportType(translation) {
    var index = allTranslatedValuesReportType().indexOf(translation);
    return allValuesReportType()[index] || ReportType.all;
}
exports.valueFromTranslationReportType = valueFromTranslationReportType;
var OwnerOrRequester;
(function (OwnerOrRequester) {
    OwnerOrRequester["owner"] = "owner";
    OwnerOrRequester["requester"] = "requester";
})(OwnerOrRequester = exports.OwnerOrRequester || (exports.OwnerOrRequester = {}));
function translateOwnerOrRequester(enumOwnerOrRequester) {
    switch (enumOwnerOrRequester) {
        case OwnerOrRequester.owner:
            {
                return strings ? strings["enum"]["OwnerOrRequester"]["owner"] || OwnerOrRequester.owner : OwnerOrRequester.owner;
            }
        case OwnerOrRequester.requester:
            {
                return strings ? strings["enum"]["OwnerOrRequester"]["requester"] || OwnerOrRequester.requester : OwnerOrRequester.requester;
            }
    }
    return "";
}
exports.translateOwnerOrRequester = translateOwnerOrRequester;
function allValuesOwnerOrRequester() {
    return [OwnerOrRequester.owner, OwnerOrRequester.requester];
}
exports.allValuesOwnerOrRequester = allValuesOwnerOrRequester;
function allTranslatedValuesOwnerOrRequester() {
    return [translateOwnerOrRequester(OwnerOrRequester.owner), translateOwnerOrRequester(OwnerOrRequester.requester)];
}
exports.allTranslatedValuesOwnerOrRequester = allTranslatedValuesOwnerOrRequester;
function allDisplayableValuesOwnerOrRequester() {
    return allTranslatedValuesOwnerOrRequester().sort();
}
exports.allDisplayableValuesOwnerOrRequester = allDisplayableValuesOwnerOrRequester;
function valueFromTranslationOwnerOrRequester(translation) {
    var index = allTranslatedValuesOwnerOrRequester().indexOf(translation);
    return allValuesOwnerOrRequester()[index] || OwnerOrRequester.owner;
}
exports.valueFromTranslationOwnerOrRequester = valueFromTranslationOwnerOrRequester;
var RequestFieldsOrderBy;
(function (RequestFieldsOrderBy) {
    RequestFieldsOrderBy["rentPrice"] = "rentPrice";
    RequestFieldsOrderBy["createdAt"] = "createdAt";
})(RequestFieldsOrderBy = exports.RequestFieldsOrderBy || (exports.RequestFieldsOrderBy = {}));
function translateRequestFieldsOrderBy(enumRequestFieldsOrderBy) {
    switch (enumRequestFieldsOrderBy) {
        case RequestFieldsOrderBy.rentPrice:
            {
                return strings ? strings["enum"]["RequestFieldsOrderBy"]["rentPrice"] || RequestFieldsOrderBy.rentPrice : RequestFieldsOrderBy.rentPrice;
            }
        case RequestFieldsOrderBy.createdAt:
            {
                return strings ? strings["enum"]["RequestFieldsOrderBy"]["createdAt"] || RequestFieldsOrderBy.createdAt : RequestFieldsOrderBy.createdAt;
            }
    }
    return "";
}
exports.translateRequestFieldsOrderBy = translateRequestFieldsOrderBy;
function allValuesRequestFieldsOrderBy() {
    return [RequestFieldsOrderBy.rentPrice, RequestFieldsOrderBy.createdAt];
}
exports.allValuesRequestFieldsOrderBy = allValuesRequestFieldsOrderBy;
function allTranslatedValuesRequestFieldsOrderBy() {
    return [translateRequestFieldsOrderBy(RequestFieldsOrderBy.rentPrice), translateRequestFieldsOrderBy(RequestFieldsOrderBy.createdAt)];
}
exports.allTranslatedValuesRequestFieldsOrderBy = allTranslatedValuesRequestFieldsOrderBy;
function allDisplayableValuesRequestFieldsOrderBy() {
    return allTranslatedValuesRequestFieldsOrderBy().sort();
}
exports.allDisplayableValuesRequestFieldsOrderBy = allDisplayableValuesRequestFieldsOrderBy;
function valueFromTranslationRequestFieldsOrderBy(translation) {
    var index = allTranslatedValuesRequestFieldsOrderBy().indexOf(translation);
    return allValuesRequestFieldsOrderBy()[index] || RequestFieldsOrderBy.rentPrice;
}
exports.valueFromTranslationRequestFieldsOrderBy = valueFromTranslationRequestFieldsOrderBy;
var PromotionUsageType;
(function (PromotionUsageType) {
    PromotionUsageType["firstRentOnly"] = "firstRentOnly";
    PromotionUsageType["infinite"] = "infinite";
    PromotionUsageType["multiple"] = "multiple";
})(PromotionUsageType = exports.PromotionUsageType || (exports.PromotionUsageType = {}));
function translatePromotionUsageType(enumPromotionUsageType) {
    switch (enumPromotionUsageType) {
        case PromotionUsageType.firstRentOnly:
            {
                return strings ? strings["enum"]["PromotionUsageType"]["firstRentOnly"] || PromotionUsageType.firstRentOnly : PromotionUsageType.firstRentOnly;
            }
        case PromotionUsageType.infinite:
            {
                return strings ? strings["enum"]["PromotionUsageType"]["infinite"] || PromotionUsageType.infinite : PromotionUsageType.infinite;
            }
        case PromotionUsageType.multiple:
            {
                return strings ? strings["enum"]["PromotionUsageType"]["multiple"] || PromotionUsageType.multiple : PromotionUsageType.multiple;
            }
    }
    return "";
}
exports.translatePromotionUsageType = translatePromotionUsageType;
function allValuesPromotionUsageType() {
    return [PromotionUsageType.firstRentOnly, PromotionUsageType.infinite, PromotionUsageType.multiple];
}
exports.allValuesPromotionUsageType = allValuesPromotionUsageType;
function allTranslatedValuesPromotionUsageType() {
    return [translatePromotionUsageType(PromotionUsageType.firstRentOnly), translatePromotionUsageType(PromotionUsageType.infinite), translatePromotionUsageType(PromotionUsageType.multiple)];
}
exports.allTranslatedValuesPromotionUsageType = allTranslatedValuesPromotionUsageType;
function allDisplayableValuesPromotionUsageType() {
    return allTranslatedValuesPromotionUsageType().sort();
}
exports.allDisplayableValuesPromotionUsageType = allDisplayableValuesPromotionUsageType;
function valueFromTranslationPromotionUsageType(translation) {
    var index = allTranslatedValuesPromotionUsageType().indexOf(translation);
    return allValuesPromotionUsageType()[index] || PromotionUsageType.firstRentOnly;
}
exports.valueFromTranslationPromotionUsageType = valueFromTranslationPromotionUsageType;
var PromotionFieldOrderBy;
(function (PromotionFieldOrderBy) {
    PromotionFieldOrderBy["expirationDate"] = "expirationDate";
    PromotionFieldOrderBy["createdAt"] = "createdAt";
    PromotionFieldOrderBy["id"] = "id";
})(PromotionFieldOrderBy = exports.PromotionFieldOrderBy || (exports.PromotionFieldOrderBy = {}));
function translatePromotionFieldOrderBy(enumPromotionFieldOrderBy) {
    switch (enumPromotionFieldOrderBy) {
        case PromotionFieldOrderBy.expirationDate:
            {
                return strings ? strings["enum"]["PromotionFieldOrderBy"]["expirationDate"] || PromotionFieldOrderBy.expirationDate : PromotionFieldOrderBy.expirationDate;
            }
        case PromotionFieldOrderBy.createdAt:
            {
                return strings ? strings["enum"]["PromotionFieldOrderBy"]["createdAt"] || PromotionFieldOrderBy.createdAt : PromotionFieldOrderBy.createdAt;
            }
        case PromotionFieldOrderBy.id:
            {
                return strings ? strings["enum"]["PromotionFieldOrderBy"]["id"] || PromotionFieldOrderBy.id : PromotionFieldOrderBy.id;
            }
    }
    return "";
}
exports.translatePromotionFieldOrderBy = translatePromotionFieldOrderBy;
function allValuesPromotionFieldOrderBy() {
    return [PromotionFieldOrderBy.expirationDate, PromotionFieldOrderBy.createdAt, PromotionFieldOrderBy.id];
}
exports.allValuesPromotionFieldOrderBy = allValuesPromotionFieldOrderBy;
function allTranslatedValuesPromotionFieldOrderBy() {
    return [translatePromotionFieldOrderBy(PromotionFieldOrderBy.expirationDate), translatePromotionFieldOrderBy(PromotionFieldOrderBy.createdAt), translatePromotionFieldOrderBy(PromotionFieldOrderBy.id)];
}
exports.allTranslatedValuesPromotionFieldOrderBy = allTranslatedValuesPromotionFieldOrderBy;
function allDisplayableValuesPromotionFieldOrderBy() {
    return allTranslatedValuesPromotionFieldOrderBy().sort();
}
exports.allDisplayableValuesPromotionFieldOrderBy = allDisplayableValuesPromotionFieldOrderBy;
function valueFromTranslationPromotionFieldOrderBy(translation) {
    var index = allTranslatedValuesPromotionFieldOrderBy().indexOf(translation);
    return allValuesPromotionFieldOrderBy()[index] || PromotionFieldOrderBy.expirationDate;
}
exports.valueFromTranslationPromotionFieldOrderBy = valueFromTranslationPromotionFieldOrderBy;
var ReportGroupType;
(function (ReportGroupType) {
    ReportGroupType["date"] = "date";
    ReportGroupType["dateHour"] = "dateHour";
    ReportGroupType["hour"] = "hour";
})(ReportGroupType = exports.ReportGroupType || (exports.ReportGroupType = {}));
function translateReportGroupType(enumReportGroupType) {
    switch (enumReportGroupType) {
        case ReportGroupType.date:
            {
                return strings ? strings["enum"]["ReportGroupType"]["date"] || ReportGroupType.date : ReportGroupType.date;
            }
        case ReportGroupType.dateHour:
            {
                return strings ? strings["enum"]["ReportGroupType"]["dateHour"] || ReportGroupType.dateHour : ReportGroupType.dateHour;
            }
        case ReportGroupType.hour:
            {
                return strings ? strings["enum"]["ReportGroupType"]["hour"] || ReportGroupType.hour : ReportGroupType.hour;
            }
    }
    return "";
}
exports.translateReportGroupType = translateReportGroupType;
function allValuesReportGroupType() {
    return [ReportGroupType.date, ReportGroupType.dateHour, ReportGroupType.hour];
}
exports.allValuesReportGroupType = allValuesReportGroupType;
function allTranslatedValuesReportGroupType() {
    return [translateReportGroupType(ReportGroupType.date), translateReportGroupType(ReportGroupType.dateHour), translateReportGroupType(ReportGroupType.hour)];
}
exports.allTranslatedValuesReportGroupType = allTranslatedValuesReportGroupType;
function allDisplayableValuesReportGroupType() {
    return allTranslatedValuesReportGroupType().sort();
}
exports.allDisplayableValuesReportGroupType = allDisplayableValuesReportGroupType;
function valueFromTranslationReportGroupType(translation) {
    var index = allTranslatedValuesReportGroupType().indexOf(translation);
    return allValuesReportGroupType()[index] || ReportGroupType.date;
}
exports.valueFromTranslationReportGroupType = valueFromTranslationReportGroupType;
var SaleStatusType;
(function (SaleStatusType) {
    SaleStatusType["pendingApproval"] = "pendingApproval";
    SaleStatusType["approved"] = "approved";
    SaleStatusType["notApproved"] = "notApproved";
    SaleStatusType["deliveredToRequester"] = "deliveredToRequester";
    SaleStatusType["receivedByRequester"] = "receivedByRequester";
    SaleStatusType["canceled"] = "canceled";
})(SaleStatusType = exports.SaleStatusType || (exports.SaleStatusType = {}));
function translateSaleStatusType(enumSaleStatusType) {
    switch (enumSaleStatusType) {
        case SaleStatusType.pendingApproval:
            {
                return strings ? strings["enum"]["SaleStatusType"]["pendingApproval"] || SaleStatusType.pendingApproval : SaleStatusType.pendingApproval;
            }
        case SaleStatusType.approved:
            {
                return strings ? strings["enum"]["SaleStatusType"]["approved"] || SaleStatusType.approved : SaleStatusType.approved;
            }
        case SaleStatusType.notApproved:
            {
                return strings ? strings["enum"]["SaleStatusType"]["notApproved"] || SaleStatusType.notApproved : SaleStatusType.notApproved;
            }
        case SaleStatusType.deliveredToRequester:
            {
                return strings ? strings["enum"]["SaleStatusType"]["deliveredToRequester"] || SaleStatusType.deliveredToRequester : SaleStatusType.deliveredToRequester;
            }
        case SaleStatusType.receivedByRequester:
            {
                return strings ? strings["enum"]["SaleStatusType"]["receivedByRequester"] || SaleStatusType.receivedByRequester : SaleStatusType.receivedByRequester;
            }
        case SaleStatusType.canceled:
            {
                return strings ? strings["enum"]["SaleStatusType"]["canceled"] || SaleStatusType.canceled : SaleStatusType.canceled;
            }
    }
    return "";
}
exports.translateSaleStatusType = translateSaleStatusType;
function allValuesSaleStatusType() {
    return [SaleStatusType.pendingApproval, SaleStatusType.approved, SaleStatusType.notApproved, SaleStatusType.deliveredToRequester, SaleStatusType.receivedByRequester, SaleStatusType.canceled];
}
exports.allValuesSaleStatusType = allValuesSaleStatusType;
function allTranslatedValuesSaleStatusType() {
    return [translateSaleStatusType(SaleStatusType.pendingApproval), translateSaleStatusType(SaleStatusType.approved), translateSaleStatusType(SaleStatusType.notApproved), translateSaleStatusType(SaleStatusType.deliveredToRequester), translateSaleStatusType(SaleStatusType.receivedByRequester), translateSaleStatusType(SaleStatusType.canceled)];
}
exports.allTranslatedValuesSaleStatusType = allTranslatedValuesSaleStatusType;
function allDisplayableValuesSaleStatusType() {
    return allTranslatedValuesSaleStatusType().sort();
}
exports.allDisplayableValuesSaleStatusType = allDisplayableValuesSaleStatusType;
function valueFromTranslationSaleStatusType(translation) {
    var index = allTranslatedValuesSaleStatusType().indexOf(translation);
    return allValuesSaleStatusType()[index] || SaleStatusType.pendingApproval;
}
exports.valueFromTranslationSaleStatusType = valueFromTranslationSaleStatusType;
var SaleFieldsOrderBy;
(function (SaleFieldsOrderBy) {
    SaleFieldsOrderBy["price"] = "price";
    SaleFieldsOrderBy["createdAt"] = "createdAt";
})(SaleFieldsOrderBy = exports.SaleFieldsOrderBy || (exports.SaleFieldsOrderBy = {}));
function translateSaleFieldsOrderBy(enumSaleFieldsOrderBy) {
    switch (enumSaleFieldsOrderBy) {
        case SaleFieldsOrderBy.price:
            {
                return strings ? strings["enum"]["SaleFieldsOrderBy"]["price"] || SaleFieldsOrderBy.price : SaleFieldsOrderBy.price;
            }
        case SaleFieldsOrderBy.createdAt:
            {
                return strings ? strings["enum"]["SaleFieldsOrderBy"]["createdAt"] || SaleFieldsOrderBy.createdAt : SaleFieldsOrderBy.createdAt;
            }
    }
    return "";
}
exports.translateSaleFieldsOrderBy = translateSaleFieldsOrderBy;
function allValuesSaleFieldsOrderBy() {
    return [SaleFieldsOrderBy.price, SaleFieldsOrderBy.createdAt];
}
exports.allValuesSaleFieldsOrderBy = allValuesSaleFieldsOrderBy;
function allTranslatedValuesSaleFieldsOrderBy() {
    return [translateSaleFieldsOrderBy(SaleFieldsOrderBy.price), translateSaleFieldsOrderBy(SaleFieldsOrderBy.createdAt)];
}
exports.allTranslatedValuesSaleFieldsOrderBy = allTranslatedValuesSaleFieldsOrderBy;
function allDisplayableValuesSaleFieldsOrderBy() {
    return allTranslatedValuesSaleFieldsOrderBy().sort();
}
exports.allDisplayableValuesSaleFieldsOrderBy = allDisplayableValuesSaleFieldsOrderBy;
function valueFromTranslationSaleFieldsOrderBy(translation) {
    var index = allTranslatedValuesSaleFieldsOrderBy().indexOf(translation);
    return allValuesSaleFieldsOrderBy()[index] || SaleFieldsOrderBy.price;
}
exports.valueFromTranslationSaleFieldsOrderBy = valueFromTranslationSaleFieldsOrderBy;
var ErrorType;
(function (ErrorType) {
    ErrorType["PaymentRefused"] = "PaymentRefused";
    ErrorType["InternalError"] = "InternalError";
    ErrorType["TransferValueTooLow"] = "TransferValueTooLow";
    ErrorType["FailedToRefund"] = "FailedToRefund";
    ErrorType["InvalidAccountDv"] = "InvalidAccountDv";
    ErrorType["InvalidAgencyDv"] = "InvalidAgencyDv";
    ErrorType["InvalidAccountNumber"] = "InvalidAccountNumber";
    ErrorType["InvalidAgencyNumber"] = "InvalidAgencyNumber";
    ErrorType["InvalidBankCode"] = "InvalidBankCode";
    ErrorType["InvalidBankAccount"] = "InvalidBankAccount";
    ErrorType["NotFound"] = "NotFound";
    ErrorType["NotLoggedIn"] = "NotLoggedIn";
    ErrorType["MissingParameter"] = "MissingParameter";
    ErrorType["AccessNotAllowed"] = "AccessNotAllowed";
    ErrorType["ValueISEmpty"] = "ValueISEmpty";
    ErrorType["ValueTooLarge"] = "ValueTooLarge";
    ErrorType["ValueTooSmall"] = "ValueTooSmall";
    ErrorType["InvalidEmail"] = "InvalidEmail";
    ErrorType["InvalidArgument"] = "InvalidArgument";
    ErrorType["InvalidUrl"] = "InvalidUrl";
    ErrorType["InvalidSlug"] = "InvalidSlug";
    ErrorType["SlugAlreadyInUse"] = "SlugAlreadyInUse";
    ErrorType["DateUnavaiable"] = "DateUnavaiable";
    ErrorType["PeriodTooSmall"] = "PeriodTooSmall";
    ErrorType["NotForRent"] = "NotForRent";
    ErrorType["CardWalletEmpty"] = "CardWalletEmpty";
    ErrorType["DeletedCard"] = "DeletedCard";
    ErrorType["UserDoesntExist"] = "UserDoesntExist";
    ErrorType["ShouldUseThirdParty"] = "ShouldUseThirdParty";
    ErrorType["WrongPassword"] = "WrongPassword";
    ErrorType["LoginError"] = "LoginError";
    ErrorType["ThirdPartyAuthError"] = "ThirdPartyAuthError";
    ErrorType["WrongCredentials"] = "WrongCredentials";
    ErrorType["EmailDoesntExist"] = "EmailDoesntExist";
    ErrorType["PasswordToSmall"] = "PasswordToSmall";
    ErrorType["InvalidDocumentNumber"] = "InvalidDocumentNumber";
    ErrorType["InvalidZipCode"] = "InvalidZipCode";
    ErrorType["AddresNotSet"] = "AddresNotSet";
    ErrorType["InvalidLocation"] = "InvalidLocation";
    ErrorType["CityNotFound"] = "CityNotFound";
    ErrorType["ShippingDateNotAvaiable"] = "ShippingDateNotAvaiable";
    ErrorType["ShippingDistanceTooLarge"] = "ShippingDistanceTooLarge";
    ErrorType["ShippingCityNotAvaiable"] = "ShippingCityNotAvaiable";
    ErrorType["DeletedItem"] = "DeletedItem";
    ErrorType["BadFormattedResponse"] = "BadFormattedResponse";
    ErrorType["InvalidPercentege"] = "InvalidPercentege";
    ErrorType["CityAlreadyInUse"] = "CityAlreadyInUse";
    ErrorType["RecipientAlreadyExists"] = "RecipientAlreadyExists";
    ErrorType["SaleStatusChange"] = "SaleStatusChange";
    ErrorType["ItemAlreadySold"] = "ItemAlreadySold";
    ErrorType["InvalidInstallment"] = "InvalidInstallment";
    ErrorType["NotForSale"] = "NotForSale";
    ErrorType["InvalidRentPrice"] = "InvalidRentPrice";
    ErrorType["InvalidOriginalPrice"] = "InvalidOriginalPrice";
    ErrorType["Fatal"] = "Fatal";
    ErrorType["Connection"] = "Connection";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
function translateErrorType(enumErrorType) {
    switch (enumErrorType) {
        case ErrorType.PaymentRefused:
            {
                return strings ? strings["enum"]["ErrorType"]["PaymentRefused"] || ErrorType.PaymentRefused : ErrorType.PaymentRefused;
            }
        case ErrorType.InternalError:
            {
                return strings ? strings["enum"]["ErrorType"]["InternalError"] || ErrorType.InternalError : ErrorType.InternalError;
            }
        case ErrorType.TransferValueTooLow:
            {
                return strings ? strings["enum"]["ErrorType"]["TransferValueTooLow"] || ErrorType.TransferValueTooLow : ErrorType.TransferValueTooLow;
            }
        case ErrorType.FailedToRefund:
            {
                return strings ? strings["enum"]["ErrorType"]["FailedToRefund"] || ErrorType.FailedToRefund : ErrorType.FailedToRefund;
            }
        case ErrorType.InvalidAccountDv:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAccountDv"] || ErrorType.InvalidAccountDv : ErrorType.InvalidAccountDv;
            }
        case ErrorType.InvalidAgencyDv:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAgencyDv"] || ErrorType.InvalidAgencyDv : ErrorType.InvalidAgencyDv;
            }
        case ErrorType.InvalidAccountNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAccountNumber"] || ErrorType.InvalidAccountNumber : ErrorType.InvalidAccountNumber;
            }
        case ErrorType.InvalidAgencyNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAgencyNumber"] || ErrorType.InvalidAgencyNumber : ErrorType.InvalidAgencyNumber;
            }
        case ErrorType.InvalidBankCode:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidBankCode"] || ErrorType.InvalidBankCode : ErrorType.InvalidBankCode;
            }
        case ErrorType.InvalidBankAccount:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidBankAccount"] || ErrorType.InvalidBankAccount : ErrorType.InvalidBankAccount;
            }
        case ErrorType.NotFound:
            {
                return strings ? strings["enum"]["ErrorType"]["NotFound"] || ErrorType.NotFound : ErrorType.NotFound;
            }
        case ErrorType.NotLoggedIn:
            {
                return strings ? strings["enum"]["ErrorType"]["NotLoggedIn"] || ErrorType.NotLoggedIn : ErrorType.NotLoggedIn;
            }
        case ErrorType.MissingParameter:
            {
                return strings ? strings["enum"]["ErrorType"]["MissingParameter"] || ErrorType.MissingParameter : ErrorType.MissingParameter;
            }
        case ErrorType.AccessNotAllowed:
            {
                return strings ? strings["enum"]["ErrorType"]["AccessNotAllowed"] || ErrorType.AccessNotAllowed : ErrorType.AccessNotAllowed;
            }
        case ErrorType.ValueISEmpty:
            {
                return strings ? strings["enum"]["ErrorType"]["ValueISEmpty"] || ErrorType.ValueISEmpty : ErrorType.ValueISEmpty;
            }
        case ErrorType.ValueTooLarge:
            {
                return strings ? strings["enum"]["ErrorType"]["ValueTooLarge"] || ErrorType.ValueTooLarge : ErrorType.ValueTooLarge;
            }
        case ErrorType.ValueTooSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["ValueTooSmall"] || ErrorType.ValueTooSmall : ErrorType.ValueTooSmall;
            }
        case ErrorType.InvalidEmail:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidEmail"] || ErrorType.InvalidEmail : ErrorType.InvalidEmail;
            }
        case ErrorType.InvalidArgument:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidArgument"] || ErrorType.InvalidArgument : ErrorType.InvalidArgument;
            }
        case ErrorType.InvalidUrl:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidUrl"] || ErrorType.InvalidUrl : ErrorType.InvalidUrl;
            }
        case ErrorType.InvalidSlug:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidSlug"] || ErrorType.InvalidSlug : ErrorType.InvalidSlug;
            }
        case ErrorType.SlugAlreadyInUse:
            {
                return strings ? strings["enum"]["ErrorType"]["SlugAlreadyInUse"] || ErrorType.SlugAlreadyInUse : ErrorType.SlugAlreadyInUse;
            }
        case ErrorType.DateUnavaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["DateUnavaiable"] || ErrorType.DateUnavaiable : ErrorType.DateUnavaiable;
            }
        case ErrorType.PeriodTooSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["PeriodTooSmall"] || ErrorType.PeriodTooSmall : ErrorType.PeriodTooSmall;
            }
        case ErrorType.NotForRent:
            {
                return strings ? strings["enum"]["ErrorType"]["NotForRent"] || ErrorType.NotForRent : ErrorType.NotForRent;
            }
        case ErrorType.CardWalletEmpty:
            {
                return strings ? strings["enum"]["ErrorType"]["CardWalletEmpty"] || ErrorType.CardWalletEmpty : ErrorType.CardWalletEmpty;
            }
        case ErrorType.DeletedCard:
            {
                return strings ? strings["enum"]["ErrorType"]["DeletedCard"] || ErrorType.DeletedCard : ErrorType.DeletedCard;
            }
        case ErrorType.UserDoesntExist:
            {
                return strings ? strings["enum"]["ErrorType"]["UserDoesntExist"] || ErrorType.UserDoesntExist : ErrorType.UserDoesntExist;
            }
        case ErrorType.ShouldUseThirdParty:
            {
                return strings ? strings["enum"]["ErrorType"]["ShouldUseThirdParty"] || ErrorType.ShouldUseThirdParty : ErrorType.ShouldUseThirdParty;
            }
        case ErrorType.WrongPassword:
            {
                return strings ? strings["enum"]["ErrorType"]["WrongPassword"] || ErrorType.WrongPassword : ErrorType.WrongPassword;
            }
        case ErrorType.LoginError:
            {
                return strings ? strings["enum"]["ErrorType"]["LoginError"] || ErrorType.LoginError : ErrorType.LoginError;
            }
        case ErrorType.ThirdPartyAuthError:
            {
                return strings ? strings["enum"]["ErrorType"]["ThirdPartyAuthError"] || ErrorType.ThirdPartyAuthError : ErrorType.ThirdPartyAuthError;
            }
        case ErrorType.WrongCredentials:
            {
                return strings ? strings["enum"]["ErrorType"]["WrongCredentials"] || ErrorType.WrongCredentials : ErrorType.WrongCredentials;
            }
        case ErrorType.EmailDoesntExist:
            {
                return strings ? strings["enum"]["ErrorType"]["EmailDoesntExist"] || ErrorType.EmailDoesntExist : ErrorType.EmailDoesntExist;
            }
        case ErrorType.PasswordToSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["PasswordToSmall"] || ErrorType.PasswordToSmall : ErrorType.PasswordToSmall;
            }
        case ErrorType.InvalidDocumentNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidDocumentNumber"] || ErrorType.InvalidDocumentNumber : ErrorType.InvalidDocumentNumber;
            }
        case ErrorType.InvalidZipCode:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidZipCode"] || ErrorType.InvalidZipCode : ErrorType.InvalidZipCode;
            }
        case ErrorType.AddresNotSet:
            {
                return strings ? strings["enum"]["ErrorType"]["AddresNotSet"] || ErrorType.AddresNotSet : ErrorType.AddresNotSet;
            }
        case ErrorType.InvalidLocation:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidLocation"] || ErrorType.InvalidLocation : ErrorType.InvalidLocation;
            }
        case ErrorType.CityNotFound:
            {
                return strings ? strings["enum"]["ErrorType"]["CityNotFound"] || ErrorType.CityNotFound : ErrorType.CityNotFound;
            }
        case ErrorType.ShippingDateNotAvaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["ShippingDateNotAvaiable"] || ErrorType.ShippingDateNotAvaiable : ErrorType.ShippingDateNotAvaiable;
            }
        case ErrorType.ShippingDistanceTooLarge:
            {
                return strings ? strings["enum"]["ErrorType"]["ShippingDistanceTooLarge"] || ErrorType.ShippingDistanceTooLarge : ErrorType.ShippingDistanceTooLarge;
            }
        case ErrorType.ShippingCityNotAvaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["ShippingCityNotAvaiable"] || ErrorType.ShippingCityNotAvaiable : ErrorType.ShippingCityNotAvaiable;
            }
        case ErrorType.DeletedItem:
            {
                return strings ? strings["enum"]["ErrorType"]["DeletedItem"] || ErrorType.DeletedItem : ErrorType.DeletedItem;
            }
        case ErrorType.BadFormattedResponse:
            {
                return strings ? strings["enum"]["ErrorType"]["BadFormattedResponse"] || ErrorType.BadFormattedResponse : ErrorType.BadFormattedResponse;
            }
        case ErrorType.InvalidPercentege:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidPercentege"] || ErrorType.InvalidPercentege : ErrorType.InvalidPercentege;
            }
        case ErrorType.CityAlreadyInUse:
            {
                return strings ? strings["enum"]["ErrorType"]["CityAlreadyInUse"] || ErrorType.CityAlreadyInUse : ErrorType.CityAlreadyInUse;
            }
        case ErrorType.RecipientAlreadyExists:
            {
                return strings ? strings["enum"]["ErrorType"]["RecipientAlreadyExists"] || ErrorType.RecipientAlreadyExists : ErrorType.RecipientAlreadyExists;
            }
        case ErrorType.SaleStatusChange:
            {
                return strings ? strings["enum"]["ErrorType"]["SaleStatusChange"] || ErrorType.SaleStatusChange : ErrorType.SaleStatusChange;
            }
        case ErrorType.ItemAlreadySold:
            {
                return strings ? strings["enum"]["ErrorType"]["ItemAlreadySold"] || ErrorType.ItemAlreadySold : ErrorType.ItemAlreadySold;
            }
        case ErrorType.InvalidInstallment:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidInstallment"] || ErrorType.InvalidInstallment : ErrorType.InvalidInstallment;
            }
        case ErrorType.NotForSale:
            {
                return strings ? strings["enum"]["ErrorType"]["NotForSale"] || ErrorType.NotForSale : ErrorType.NotForSale;
            }
        case ErrorType.InvalidRentPrice:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidRentPrice"] || ErrorType.InvalidRentPrice : ErrorType.InvalidRentPrice;
            }
        case ErrorType.InvalidOriginalPrice:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidOriginalPrice"] || ErrorType.InvalidOriginalPrice : ErrorType.InvalidOriginalPrice;
            }
        case ErrorType.Fatal:
            {
                return strings ? strings["enum"]["ErrorType"]["Fatal"] || ErrorType.Fatal : ErrorType.Fatal;
            }
        case ErrorType.Connection:
            {
                return strings ? strings["enum"]["ErrorType"]["Connection"] || ErrorType.Connection : ErrorType.Connection;
            }
    }
    return "";
}
exports.translateErrorType = translateErrorType;
function allValuesErrorType() {
    return [ErrorType.PaymentRefused, ErrorType.InternalError, ErrorType.TransferValueTooLow, ErrorType.FailedToRefund, ErrorType.InvalidAccountDv, ErrorType.InvalidAgencyDv, ErrorType.InvalidAccountNumber, ErrorType.InvalidAgencyNumber, ErrorType.InvalidBankCode, ErrorType.InvalidBankAccount, ErrorType.NotFound, ErrorType.NotLoggedIn, ErrorType.MissingParameter, ErrorType.AccessNotAllowed, ErrorType.ValueISEmpty, ErrorType.ValueTooLarge, ErrorType.ValueTooSmall, ErrorType.InvalidEmail, ErrorType.InvalidArgument, ErrorType.InvalidUrl, ErrorType.InvalidSlug, ErrorType.SlugAlreadyInUse, ErrorType.DateUnavaiable, ErrorType.PeriodTooSmall, ErrorType.NotForRent, ErrorType.CardWalletEmpty, ErrorType.DeletedCard, ErrorType.UserDoesntExist, ErrorType.ShouldUseThirdParty, ErrorType.WrongPassword, ErrorType.LoginError, ErrorType.ThirdPartyAuthError, ErrorType.WrongCredentials, ErrorType.EmailDoesntExist, ErrorType.PasswordToSmall, ErrorType.InvalidDocumentNumber, ErrorType.InvalidZipCode, ErrorType.AddresNotSet, ErrorType.InvalidLocation, ErrorType.CityNotFound, ErrorType.ShippingDateNotAvaiable, ErrorType.ShippingDistanceTooLarge, ErrorType.ShippingCityNotAvaiable, ErrorType.DeletedItem, ErrorType.BadFormattedResponse, ErrorType.InvalidPercentege, ErrorType.CityAlreadyInUse, ErrorType.RecipientAlreadyExists, ErrorType.SaleStatusChange, ErrorType.ItemAlreadySold, ErrorType.InvalidInstallment, ErrorType.NotForSale, ErrorType.InvalidRentPrice, ErrorType.InvalidOriginalPrice, ErrorType.Fatal, ErrorType.Connection];
}
exports.allValuesErrorType = allValuesErrorType;
function allTranslatedValuesErrorType() {
    return [translateErrorType(ErrorType.PaymentRefused), translateErrorType(ErrorType.InternalError), translateErrorType(ErrorType.TransferValueTooLow), translateErrorType(ErrorType.FailedToRefund), translateErrorType(ErrorType.InvalidAccountDv), translateErrorType(ErrorType.InvalidAgencyDv), translateErrorType(ErrorType.InvalidAccountNumber), translateErrorType(ErrorType.InvalidAgencyNumber), translateErrorType(ErrorType.InvalidBankCode), translateErrorType(ErrorType.InvalidBankAccount), translateErrorType(ErrorType.NotFound), translateErrorType(ErrorType.NotLoggedIn), translateErrorType(ErrorType.MissingParameter), translateErrorType(ErrorType.AccessNotAllowed), translateErrorType(ErrorType.ValueISEmpty), translateErrorType(ErrorType.ValueTooLarge), translateErrorType(ErrorType.ValueTooSmall), translateErrorType(ErrorType.InvalidEmail), translateErrorType(ErrorType.InvalidArgument), translateErrorType(ErrorType.InvalidUrl), translateErrorType(ErrorType.InvalidSlug), translateErrorType(ErrorType.SlugAlreadyInUse), translateErrorType(ErrorType.DateUnavaiable), translateErrorType(ErrorType.PeriodTooSmall), translateErrorType(ErrorType.NotForRent), translateErrorType(ErrorType.CardWalletEmpty), translateErrorType(ErrorType.DeletedCard), translateErrorType(ErrorType.UserDoesntExist), translateErrorType(ErrorType.ShouldUseThirdParty), translateErrorType(ErrorType.WrongPassword), translateErrorType(ErrorType.LoginError), translateErrorType(ErrorType.ThirdPartyAuthError), translateErrorType(ErrorType.WrongCredentials), translateErrorType(ErrorType.EmailDoesntExist), translateErrorType(ErrorType.PasswordToSmall), translateErrorType(ErrorType.InvalidDocumentNumber), translateErrorType(ErrorType.InvalidZipCode), translateErrorType(ErrorType.AddresNotSet), translateErrorType(ErrorType.InvalidLocation), translateErrorType(ErrorType.CityNotFound), translateErrorType(ErrorType.ShippingDateNotAvaiable), translateErrorType(ErrorType.ShippingDistanceTooLarge), translateErrorType(ErrorType.ShippingCityNotAvaiable), translateErrorType(ErrorType.DeletedItem), translateErrorType(ErrorType.BadFormattedResponse), translateErrorType(ErrorType.InvalidPercentege), translateErrorType(ErrorType.CityAlreadyInUse), translateErrorType(ErrorType.RecipientAlreadyExists), translateErrorType(ErrorType.SaleStatusChange), translateErrorType(ErrorType.ItemAlreadySold), translateErrorType(ErrorType.InvalidInstallment), translateErrorType(ErrorType.NotForSale), translateErrorType(ErrorType.InvalidRentPrice), translateErrorType(ErrorType.InvalidOriginalPrice), translateErrorType(ErrorType.Fatal), translateErrorType(ErrorType.Connection)];
}
exports.allTranslatedValuesErrorType = allTranslatedValuesErrorType;
function allDisplayableValuesErrorType() {
    return allTranslatedValuesErrorType().sort();
}
exports.allDisplayableValuesErrorType = allDisplayableValuesErrorType;
function valueFromTranslationErrorType(translation) {
    var index = allTranslatedValuesErrorType().indexOf(translation);
    return allValuesErrorType()[index] || ErrorType.PaymentRefused;
}
exports.valueFromTranslationErrorType = valueFromTranslationErrorType;

exports.uploadUncertainImageWith = uploadUncertainImageWith;

exports.getProfileStats = getProfileStats;

exports.uploadImage = uploadImage;

exports.uploadThumb = uploadThumb;

exports.getAddressFromCep = getAddressFromCep;

exports.getCpfValidate = getCpfValidate;

exports.getMyLocation = getMyLocation;

exports.getCity = getCity;

exports.getStateCities = getStateCities;

exports.getCityFromSlug = getCityFromSlug;

exports.createAdminUser = createAdminUser;

exports.editAdminUser = editAdminUser;

exports.getAdminUser = getAdminUser;

exports.getLicenseds = getLicenseds;

exports.getAvailableAdminFilterCities = getAvailableAdminFilterCities;

exports.createOrEditBankAccount = createOrEditBankAccount;

exports.getBalance = getBalance;

exports.withDraw = withDraw;

exports.resetPasswordAdminUser = resetPasswordAdminUser;

exports.getBanners = getBanners;

exports.getBanner = getBanner;

exports.createBanner = createBanner;

exports.editBanner = editBanner;

exports.deleteBanner = deleteBanner;

exports.getSlugOption = getSlugOption;

exports.createPost = createPost;

exports.editPost = editPost;

exports.deletePost = deletePost;

exports.getPost = getPost;

exports.getPosts = getPosts;

exports.setPostApproved = setPostApproved;

exports.sendEmailForFranchise = sendEmailForFranchise;

exports.getHomeData = getHomeData;

exports.getGraphicDataPerDate = getGraphicDataPerDate;

exports.getGraphicDataPerDateHour = getGraphicDataPerDateHour;

exports.getGraphicDataPerHour = getGraphicDataPerHour;

exports.getItem = getItem;

exports.getUser = getUser;

exports.getUsersReportForAdmin = getUsersReportForAdmin;

exports.getUsersForAdmin = getUsersForAdmin;

exports.getUsersStats = getUsersStats;

exports.getTopTeenUsers = getTopTeenUsers;

exports.getItems = getItems;

exports.getItemsStats = getItemsStats;

exports.getCurrentAdminUser = getCurrentAdminUser;

exports.login = login;

exports.logout = logout;

exports.getUsers = getUsers;

exports.getUsersForAdminUser = getUsersForAdminUser;

exports.getCurrentUser = getCurrentUser;

exports.deleteUser = deleteUser;

exports.verifyUser = verifyUser;

exports.getRequest = getRequest;

exports.getRequests = getRequests;

exports.changeDatesRequest = changeDatesRequest;

exports.cancelRequest = cancelRequest;

exports.getLocker = getLocker;

exports.editItem = editItem;

exports.deleteItem = deleteItem;

exports.sendNotification = sendNotification;

exports.sendNotificationToDeviceType = sendNotificationToDeviceType;

exports.sendReportEmail = sendReportEmail;

exports.getFine = getFine;

exports.getFines = getFines;

exports.getFinesForRequest = getFinesForRequest;

exports.getFinesPayedByUser = getFinesPayedByUser;

exports.getFinesPayedToUser = getFinesPayedToUser;

exports.createRequestFine = createRequestFine;

exports.createFine = createFine;

exports.sendMqttMessage = sendMqttMessage;

exports.editUser = editUser;

exports.sendResetPasswordEmailAdminUser = sendResetPasswordEmailAdminUser;

exports.getRents = getRents;

exports.getRentsReportForAdminUser = getRentsReportForAdminUser;

exports.getRentsStats = getRentsStats;

exports.getPromotion = getPromotion;

exports.getPromotions = getPromotions;

exports.createOrEditPromotion = createOrEditPromotion;

exports.getReport = getReport;

exports.getUsersPerDate = getUsersPerDate;

exports.getUsersPerDateHour = getUsersPerDateHour;

exports.getUsersPerHour = getUsersPerHour;

exports.getItemsPerDate = getItemsPerDate;

exports.getItemsPerDateHour = getItemsPerDateHour;

exports.getItemsPerHour = getItemsPerHour;

exports.getItemsPerCategory = getItemsPerCategory;

exports.getItemsPerColor = getItemsPerColor;

exports.getItemsPerDepartment = getItemsPerDepartment;

exports.getItemsPerSize = getItemsPerSize;

exports.getItemsPerBrand = getItemsPerBrand;

exports.getRentsPerDate = getRentsPerDate;

exports.getRentsPerDateHour = getRentsPerDateHour;

exports.getRentsPerHour = getRentsPerHour;

exports.getSalesPerDate = getSalesPerDate;

exports.getSalesPerDateHour = getSalesPerDateHour;

exports.getSalesPerHour = getSalesPerHour;

exports.getSale = getSale;

exports.getSales = getSales;

exports.getSalesStats = getSalesStats;

exports.getSalesReportForAdmin = getSalesReportForAdmin;

exports.ping = ping;

exports.setPushToken = setPushToken;
//////////////////////////////////////////////////////
var fallbackDeviceId = null;
function setDeviceId(deviceId) {
    fallbackDeviceId = deviceId;
    try {
        localStorage.setItem("deviceId", deviceId);
    } catch (e) {}
}
function getDeviceId() {
    try {
        return localStorage.getItem("deviceId") || fallbackDeviceId;
    } catch (e) {}
    return fallbackDeviceId;
}

function randomBytesHex(len) {
    var hex = "";
    for (var i = 0; i < 2 * len; ++i) {
        hex += "0123456789abcdef"[Math.floor(Math.random() * 16)];
    }
    return hex;
}
var listenersDict = {
    fail: [],
    fatal: [],
    success: []
};
function addEventListener(listenable, hook) {
    var listeners = listenersDict[listenable];
    listeners.push(hook);
}
exports.addEventListener = addEventListener;
function removeEventListener(listenable, hook) {
    var listeners = listenersDict[listenable];
    listenersDict[listenable] = listeners.filter(function (h) {
        return h !== hook;
    });
}
exports.removeEventListener = removeEventListener;
